import { j as s, $ as bi, a as xi, b as yi, c as _i, d as Ci, e as vi, g as wi, h as Si, i as Ii, n as L, O as Di, k as Hs, l as Ms, w as Wn, Z as ki, H as Ti, m as An, o as Ce, p as uo, r as _r, q as ji, t as zs, W as Ni, u as Fi, A as Pi, F as Ri, v as Cr, x as vr, y as Vs, z as wr, B as Hn, C as Ei, D as Li, E as Ai, G as $i, I as Oi, J as Bi, K as Sr, L as Wi, M as Hi } from "./vendor-B4O8kiwH.js";
import f from "classnames";
import { I as N, T as A, r as Fs, B as ie, a as sn, e as Mi } from "./emoji-DIN5LBCL.js";
import { E as HT, b as MT, d as zT, i as VT } from "./emoji-DIN5LBCL.js";
import { memo as qn, forwardRef as $, PureComponent as D, createContext as ve, useContext as He, useRef as q, useLayoutEffect as zi, useState as V, useCallback as P, useEffect as Z, cloneElement as cn, isValidElement as Te, Component as ge, Children as Le, createRef as B, useMemo as G, Fragment as Ze, useImperativeHandle as Ft, createElement as Vi, lazy as Ki, Suspense as Ui, useReducer as qi } from "react";
import { useKey as Ir, useMount as Pt, useUnmount as Je, useUpdateEffect as Xe, useToggle as Gi, useSetState as Yi, useClickAway as Dr, usePrevious as on, useDebounce as Qi } from "react-use";
import j from "moment-timezone";
import { v4 as rn } from "uuid";
import { noop as Xi } from "ts-essentials";
import Zi from "react-dom";
const Ji = "h-button--button__root", ea = "h-button--button__normal", ta = "h-button--button__large", na = "h-button--button__primary", sa = "h-button--button__active", oa = "h-button--button__label", ra = "h-button--button__secondary", ia = "h-button--button__tertiary", aa = "h-button--button__danger", la = "h-button--button__disabled", ca = "h-button--button__loading", da = "h-button--button__withLabel", ha = "h-button--button__slot", ua = "h-button--button__content", we = {
  root: Ji,
  normal: ea,
  large: ta,
  primary: na,
  active: sa,
  label: oa,
  secondary: ra,
  tertiary: ia,
  danger: aa,
  disabled: la,
  loading: ca,
  withLabel: da,
  slot: ha,
  content: ua
}, X = qn(
  $(function({
    children: e,
    className: t,
    type: n = "button",
    variant: o = "primary",
    size: r = "normal",
    icon: a,
    slotStart: l,
    slotEnd: c,
    active: d = !1,
    isLoading: h = !1,
    loadingIndicator: u = /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: "Loading..." }),
    label: p,
    styleText: m = !0,
    disabled: g = !1,
    onClick: b,
    ...x
  }, C) {
    const _ = f(
      {
        [we.root]: !0,
        [we[o]]: !0,
        [we[r]]: !0,
        [we.active]: d,
        [we.disabled]: g,
        [we.loading]: h,
        [we.withLabel]: !c && !!p
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...x,
        type: n,
        className: _,
        onClick: g ? void 0 : b,
        disabled: g,
        ref: C,
        children: h ? u : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          (l || a) && /* @__PURE__ */ s.jsx("span", { className: we.slot, children: a ? /* @__PURE__ */ s.jsx(N, { name: a }) : l }),
          (m || e) && /* @__PURE__ */ s.jsx("span", { className: we.content, children: m ? /* @__PURE__ */ s.jsx(
            A.Paragraph,
            {
              as: "span",
              variant: "3",
              wrap: "nowrap",
              color: "inherit",
              children: e
            }
          ) : e }),
          p && /* @__PURE__ */ s.jsx(
            A.Paragraph,
            {
              as: "span",
              variant: "4",
              wrap: "nowrap",
              color: "inherit",
              className: we.label,
              children: p
            }
          ),
          c && /* @__PURE__ */ s.jsx("span", { className: we.slot, children: c })
        ] })
      }
    );
  })
), pa = "h-button-navigationButton--navigationButton__root", ma = {
  root: pa
}, Rk = ({
  className: i,
  navigate: e,
  onClick: t,
  ...n
}) => {
  const o = (r) => {
    t?.(r), e();
  };
  return /* @__PURE__ */ s.jsx(
    X,
    {
      ...n,
      variant: n.variant ?? "tertiary",
      onClick: o,
      className: f(i, ma.root)
    }
  );
}, ga = "h-spinner--spinner__root", fa = {
  root: ga
};
class Gn extends D {
  render() {
    const { className: e, size: t, color: n, trackColor: o, bgColor: r, ...a } = this.props, l = f(
      {
        [fa.root]: !0
      },
      e
    ), c = typeof t == "number" ? t : 32, d = typeof t == "number" ? `${c}px` : "32px", h = `${Math.max(Math.floor(c / 8), 1)}px`, u = {
      height: d,
      width: d,
      borderWidth: h
    };
    return o && o.length && (u.borderColor = o), n && n.length && (u.borderTopColor = n), r && r.length && (u.backgroundColor = r), /* @__PURE__ */ s.jsx("div", { ...a, style: u, className: l });
  }
}
const ba = "h-iconButton--iconButton__root", xa = {
  root: ba
}, K = qn(
  $(function({
    children: e,
    className: t,
    icon: n,
    iconProps: o,
    iconSize: r,
    variant: a = "primary",
    ...l
  }, c) {
    return /* @__PURE__ */ s.jsx(
      X,
      {
        ref: c,
        "aria-label": n,
        ...l,
        variant: a,
        className: f(xa.root, t),
        loadingIndicator: /* @__PURE__ */ s.jsx(Gn, { size: 16 }),
        styleText: !1,
        slotStart: /* @__PURE__ */ s.jsx(N, { size: r || 16, name: n, ...o })
      }
    );
  })
);
function ya(i) {
  let e = i;
  const t = [];
  function n(r) {
    if (r !== e) {
      for (const { type: a, handler: l, options: c } of t)
        e.removeEventListener(a, l, c), r.addEventListener(a, l, c);
      e = r;
    }
  }
  return { proxy: new Proxy({}, {
    get(r, a) {
      if (a === "addEventListener")
        return (c, d, h) => {
          t.push({ type: c, handler: d, options: h }), e.addEventListener(c, d, h);
        };
      if (a === "removeEventListener")
        return (c, d, h) => {
          const u = typeof h == "boolean" ? h : h?.capture ?? !1, p = t.findIndex((m) => {
            const g = typeof m.options == "boolean" ? m.options : m.options?.capture ?? !1;
            return m.type === c && m.handler === d && g === u;
          });
          p !== -1 && t.splice(p, 1), e.removeEventListener(c, d, h);
        };
      const l = e[a];
      return typeof l != "function" ? l : new Proxy(l, {
        apply(c, d, h) {
          return l.apply(e, h);
        }
      });
    }
  }), setWindow: n };
}
const Yn = ve(
  typeof window < "u" ? window : {}
);
function Ek({
  value: i,
  children: e
}) {
  const t = q(null);
  return t.current || (t.current = ya(i)), zi(() => {
    t.current.setWindow(i);
  }, [i]), /* @__PURE__ */ s.jsx(Yn.Provider, { value: t.current.proxy, children: e });
}
function Ks() {
  return He(Yn);
}
const _a = "h-tooltip--tooltip__content", Ca = "h-tooltip--tooltip__contentLight", va = "h-tooltip--tooltip__contentHasHead", wa = "h-tooltip--tooltip__body", Sa = "h-tooltip--tooltip__head", Ia = "h-tooltip--tooltip__arrow", ht = {
  content: _a,
  contentLight: Ca,
  contentHasHead: va,
  body: wa,
  head: Sa,
  arrow: Ia
}, Da = 400;
function se({
  children: i,
  content: e,
  onOpenChange: t,
  side: n = "top",
  className: o,
  head: r,
  defaultOpen: a,
  alwaysShow: l,
  disabled: c,
  delayDuration: d = Da,
  align: h,
  "aria-label": u,
  wrap: p = "span",
  wrapProps: m,
  requireClick: g,
  light: b,
  ...x
}) {
  const C = Ks(), [_, S] = V(
    g ? !1 : void 0
  ), v = P(() => {
    S(!1), C.removeEventListener("click", v);
  }, [C]);
  Z(() => () => {
    C.removeEventListener("click", v);
  }, [v, C]);
  const y = bi();
  if (c || !e)
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const w = (T) => {
    T.stopPropagation(), C[_ ? "removeEventListener" : "addEventListener"](
      "click",
      v
    ), S(!_);
  }, I = f(
    ht.content,
    {
      [ht.contentHasHead]: !!r,
      [ht.contentLight]: b
    },
    o
  );
  return /* @__PURE__ */ s.jsx(xi, { children: /* @__PURE__ */ s.jsxs(
    yi,
    {
      open: _ ?? (l ? !0 : void 0),
      defaultOpen: a,
      delayDuration: d,
      "aria-label": u,
      onOpenChange: t,
      children: [
        /* @__PURE__ */ s.jsx(_i, { asChild: !0, children: p !== "none" ? /* @__PURE__ */ s.jsx(
          p,
          {
            onClick: g ? w : void 0,
            ...m,
            ...x,
            children: i
          }
        ) : g && Te(i) ? cn(i, { onClick: w }) : i }),
        /* @__PURE__ */ s.jsx(Ci, { container: C.document.body, children: /* @__PURE__ */ s.jsx(
          vi,
          {
            id: y,
            side: n,
            sideOffset: 4,
            align: h,
            className: I,
            style: { zIndex: 2147483647 },
            children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              r && /* @__PURE__ */ s.jsx("div", { className: ht.head, children: r }),
              /* @__PURE__ */ s.jsx("div", { className: ht.body, children: e }),
              /* @__PURE__ */ s.jsx(wi, { className: ht.arrow })
            ] })
          }
        ) })
      ]
    }
  ) });
}
const ka = "h-attachment--attachment__root", Ta = "h-attachment--attachment__icon", ja = "h-attachment--attachment__name", Na = "h-attachment--attachment__buttons", gn = {
  root: ka,
  icon: Ta,
  name: ja,
  buttons: Na
}, po = {
  /* images */
  jpg: "file-image",
  jpeg: "file-image",
  bmp: "file-image",
  gif: "file-image",
  tiff: "file-image",
  png: "file-image",
  /* video */
  mp4: "file-video",
  m4v: "file-video",
  mpeg: "file-video",
  mov: "file-video",
  avi: "file-video",
  wmv: "file-video",
  webm: "file-video",
  flv: "file-video",
  /* audio */
  wav: "file-audio",
  mp3: "file-audio",
  aiff: "file-audio",
  acc: "file-audio",
  ogg: "file-audio",
  wma: "file-audio",
  flac: "file-audio",
  alac: "file-audio",
  /* documents */
  pdf: "file-pdf",
  csv: "file-csv",
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  /* archives */
  zip: "file-archive",
  rar: "file-archive",
  arc: "file-archive",
  "7z": "file-archive",
  s7z: "file-archive",
  tar: "file-archive",
  bz2: "file-archive",
  gz: "file-archive"
};
function Fa(i) {
  const e = i.split(".").pop()?.toLowerCase();
  return !e || !po[e] ? "file" : po[e];
}
const Lk = (i) => {
  const {
    className: e,
    nameClassName: t,
    fileName: n,
    label: o,
    onDownload: r,
    onPreview: a,
    isPreviewLoading: l,
    isDownloadLoading: c,
    extraButtons: d,
    ...h
  } = i, u = f(
    {
      [gn.root]: !0
    },
    e
  );
  return /* @__PURE__ */ s.jsxs("div", { ...h, className: u, children: [
    /* @__PURE__ */ s.jsx(
      N,
      {
        className: gn.icon,
        name: Fa(n),
        size: 24,
        color: "neutral.700"
      }
    ),
    /* @__PURE__ */ s.jsx(
      se,
      {
        content: o || n,
        wrap: "div",
        wrapProps: { className: f(gn.name, t) },
        children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o || n })
      }
    ),
    /* @__PURE__ */ s.jsxs("div", { className: gn.buttons, children: [
      a && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: l,
          variant: "secondary",
          icon: "eye",
          onClick: l ? void 0 : a
        }
      ),
      r && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: c,
          variant: "secondary",
          icon: "download",
          onClick: c ? void 0 : r
        }
      ),
      d
    ] })
  ] });
}, Pa = {
  onError(i, e) {
    console.error(i, e);
  }
}, Ra = ve(Pa), mo = { error: null };
class Rt extends ge {
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  constructor(e) {
    super(e), this.state = mo, this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.resetInternally = this.resetInternally.bind(this);
  }
  componentDidCatch(e, t) {
    this.props.onError?.(e, t), this.context?.onError?.(e, t);
  }
  static contextType = Ra;
  resetErrorBoundary(...e) {
    this.props.onReset?.(...e), this.resetInternally();
  }
  resetInternally() {
    this.setState(mo);
  }
  hasError(e) {
    return e !== null;
  }
  ensureErrorHandlerExists() {
    const { fallback: e, fallbackRender: t } = this.props, n = this.hasFallbackElement(e), o = this.hasFallbackRenderer(t);
    if (!n && !o)
      throw new Error(
        `${Rt.name} requires either a fallback component or a fallback renderer`
      );
  }
  hasFallbackRenderer(e) {
    return typeof e == "function";
  }
  hasFallbackElement(e) {
    return e === null || typeof e == "string" || Te(e);
  }
  render() {
    const { error: e } = this.state, { fallbackRender: t, fallback: n } = this.props;
    if (this.ensureErrorHandlerExists(), !this.hasError(e))
      return this.props.children;
    if (this.hasFallbackElement(n))
      return n;
    if (this.hasFallbackRenderer(t))
      return t({
        error: e,
        resetErrorBoundary: this.resetErrorBoundary
      });
  }
}
function dn(i, e) {
  const t = i.displayName || i.name || "Unknown";
  return Si(
    class extends ge {
      static displayName = `withErrorBoundary(${t})`;
      static defaultProps = i.defaultProps;
      render() {
        const o = i;
        return /* @__PURE__ */ s.jsx(Rt, { ...e, children: /* @__PURE__ */ s.jsx(o, { ...this.props }) });
      }
    },
    i
  );
}
const Ea = "h-avatar--avatar__root", $n = {
  root: Ea,
  "avatar-24": "h-avatar--avatar__avatar-24",
  "avatar-32": "h-avatar--avatar__avatar-32",
  "avatar-40": "h-avatar--avatar__avatar-40"
}, La = {
  24: 16,
  32: 20,
  40: 24
}, Aa = ({
  icon: i,
  size: e,
  color: t = "inherit"
}) => /* @__PURE__ */ s.jsx(N, { name: i, size: La[e], color: t }), $a = "h-image--image__image", Oa = "h-image--image__error", Ba = "h-image--image__complete", as = {
  image: $a,
  error: Oa,
  complete: Ba
};
class Us extends ge {
  static defaultProps;
  mounted;
  constructor(e) {
    super(e), this.state = {
      imageSrc: "",
      loadingError: !1,
      loadingComplete: !1
    }, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { src: e } = this.props;
    this.handleSource(e);
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(e) {
    const { src: t } = this.props;
    e.src !== t && this.handleSource(e.src);
  }
  componentWillUnmount() {
    this.mounted = !1;
  }
  handleSource(e) {
    typeof e == "string" ? this.setState({
      imageSrc: e
    }) : e().then((t) => {
      this.mounted && typeof t == "string" && this.setState({
        imageSrc: t
      });
    }).catch(() => {
      this.mounted && this.setState({
        loadingError: !0
      });
    });
  }
  onLoad(e) {
    this.setState({
      loadingComplete: !0,
      loadingError: !1
    }), this.props.onLoad?.(e);
  }
  onError(e) {
    this.setState({
      loadingError: !0,
      loadingComplete: !1
    }), this.props.onError?.(e);
  }
  render() {
    const { className: e, src: t, alt: n, ...o } = this.props, { imageSrc: r } = this.state, { loadingError: a, loadingComplete: l } = this.state, c = f(
      {
        [as.image]: !0,
        [as.error]: !!a,
        [as.complete]: !!l
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "img",
      {
        ...o,
        className: c,
        onError: this.onError,
        onLoad: this.onLoad,
        src: r,
        alt: n || ""
      }
    );
  }
}
Us.defaultProps = {
  className: "",
  alt: ""
};
const Wa = "h-avatar--imageAvatar__root", Ha = {
  root: Wa
}, Ma = ({
  src: i,
  alt: e = "avatar"
}) => /* @__PURE__ */ s.jsx(Us, { src: i, alt: e, className: Ha.root }), za = "h-avatar--textAvatar__root", On = {
  root: za,
  "avatar-24": "h-avatar--textAvatar__avatar-24",
  "avatar-32": "h-avatar--textAvatar__avatar-32",
  "avatar-40": "h-avatar--textAvatar__avatar-40"
}, Va = {
  24: On["avatar-24"],
  32: On["avatar-32"],
  40: On["avatar-40"]
}, Ka = ({ text: i = "", size: e }) => /* @__PURE__ */ s.jsx("div", { className: f(On.root, Va[e]), children: i.trim().split(" ").map(
  (t, n, o) => o.length === 1 ? t : t[0]
).join("").slice(0, 2) }), Ua = [
  {
    contentColor: "var(--dixa-avatar-content-green)",
    backgroundColor: "var(--dixa-avatar-background-green)"
  },
  {
    contentColor: "var(--dixa-avatar-content-purple)",
    backgroundColor: "var(--dixa-avatar-background-purple)"
  },
  {
    contentColor: "var(--dixa-avatar-content-blue)",
    backgroundColor: "var(--dixa-avatar-background-blue)"
  },
  {
    contentColor: "var(--dixa-avatar-content-orange)",
    backgroundColor: "var(--dixa-avatar-background-orange)"
  },
  {
    contentColor: "var(--dixa-avatar-content-red)",
    backgroundColor: "var(--dixa-avatar-background-red)"
  }
];
class qa {
  constructor(e) {
    this.colors = e, this.colors = e;
  }
  colors;
  generate(e) {
    const t = this.getRandomIndex(e);
    return this.colors[t];
  }
  getRandomIndex(e) {
    const t = Ii(e);
    return Math.floor(t() * this.colors.length);
  }
}
var te = /* @__PURE__ */ ((i) => (i.Icon = "Icon", i.Image = "Image", i.Text = "Text", i))(te || {});
function ut(i) {
  return i.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
function Se(i) {
  return !!i && i.trim().length !== 0;
}
function Ga(i) {
  if (i.icon)
    return {
      type: te.Icon,
      icon: i.icon,
      backgroundColor: i.color?.backgroundColor,
      iconColor: i.color?.contentColor
    };
  const { user: e } = i;
  if (!e)
    return {
      type: te.Icon,
      icon: "user-slash"
    };
  if (Se(e.avatar_url))
    return {
      type: te.Image,
      src: e.avatar_url,
      alt: e.name || e.display_name || e.email || e.phone_number || e.given_name || e.family_name || ""
    };
  if (Se(e.name)) {
    const t = ut(e.name.trim()).split(" ");
    if (t.length === 1)
      return {
        type: te.Text,
        text: t[0]?.[0] ?? ""
      };
    const n = t[0], o = t[t.length - 1];
    return {
      type: te.Text,
      text: (n?.[0] ?? "") + (o?.[0] ?? "")
    };
  }
  if (Se(e.display_name))
    return {
      type: te.Text,
      text: ut(e.display_name.trim())
    };
  if (Se(e.given_name) && Se(e.family_name))
    return {
      type: te.Text,
      text: ut(e.given_name.trim())[0] + ut(e.family_name.trim())[0]
    };
  if (Se(e.given_name) && !Se(e.family_name))
    return {
      type: te.Text,
      text: ut(e.given_name.trim())[0]
    };
  if (!Se(e.given_name) && Se(e.family_name))
    return {
      type: te.Text,
      text: ut(e.family_name.trim())[0]
    };
  if (Se(e.email)) {
    const [t] = e.email.split("@");
    return {
      type: te.Text,
      text: t.trim()
    };
  }
  return Se(e.phone_number) ? {
    type: te.Text,
    text: e.phone_number.slice(-2)
  } : e.id ? {
    type: te.Icon,
    icon: "user-secret"
  } : {
    type: te.Icon,
    icon: "user-slash"
  };
}
const Ie = {
  backgroundColor: "var(--dixa-color-neutral-200)",
  contentColor: "var(--dixa-color-neutral-700)"
}, go = {
  shopify: {
    backgroundColor: "rgba(148, 190, 69, 0.1)",
    // this is the same as the content color but has opacity
    contentColor: "#94BE45"
  },
  agillic: {
    ...Ie,
    contentColor: "#000"
  },
  magento: {
    backgroundColor: "rgba(193, 72, 0, 0.1)",
    contentColor: "#C14800"
  },
  salesforce: {
    backgroundColor: "rgba(3, 161, 224, 0.1)",
    contentColor: "#03A1E0"
  },
  busylight: {
    backgroundColor: "rgba(27, 190, 246, 0.1)",
    contentColor: "#1BBEF6"
  },
  podio: {
    backgroundColor: "rgba(80, 145, 189, 0.1)",
    contentColor: "#5091BD"
  },
  "user-secret": Ie,
  "user-slash": Ie,
  "map-pin": Ie,
  "web-form": Ie,
  code: Ie,
  history: Ie,
  smile: Ie,
  key: Ie,
  webhooks: Ie,
  plug: Ie
}, Ya = {
  24: $n["avatar-24"],
  32: $n["avatar-32"],
  40: $n["avatar-40"]
};
class Qa extends D {
  static defaultProps = {
    size: "32",
    colorGenerator: new qa(Ua)
  };
  getAvatarChild(e, t) {
    if (e.type === te.Icon)
      return /* @__PURE__ */ s.jsx(
        Aa,
        {
          size: t,
          icon: e.icon,
          color: e.iconColor
        }
      );
    if (e.type === te.Image)
      return /* @__PURE__ */ s.jsx(Ma, { src: e.src, alt: e.alt });
    if (e.type === te.Text)
      return /* @__PURE__ */ s.jsx(Ka, { size: t, text: e.text });
  }
  calculateColor(e) {
    if (e.type === te.Icon) {
      if (e.backgroundColor && e.iconColor)
        return {
          backgroundColor: e.backgroundColor,
          contentColor: e.iconColor
        };
      if (go[e.icon])
        return go[e.icon];
    }
    return e.type === te.Image ? {
      backgroundColor: "transparent",
      contentColor: "initial"
    } : this.props.user?.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : e.type === te.Text ? this.props.colorGenerator.generate(e.text) : this.props.colorGenerator.generate();
  }
  render() {
    const { className: e, size: t } = this.props, n = Ga(this.props), o = this.getAvatarChild(n, t), r = this.calculateColor(n);
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        style: {
          backgroundColor: r.backgroundColor,
          color: r.contentColor
        },
        className: f(
          $n.root,
          Ya[t],
          e
        ),
        children: o
      }
    );
  }
}
const kr = dn(Qa, {
  fallback: null
}), Xa = "h-badge--badge__badge", Za = "h-badge--badge__badgeSmall", Ja = "h-badge--badge__badgeMedium", el = "h-badge--badge__badgePrimary", tl = "h-badge--badge__badgeSecondary", nl = "h-badge--badge__badgeSuccess", sl = "h-badge--badge__badgeInfo", ol = "h-badge--badge__badgeWarning", rl = "h-badge--badge__badgeError", We = {
  badge: Xa,
  badgeSmall: Za,
  badgeMedium: Ja,
  badgePrimary: el,
  badgeSecondary: tl,
  badgeSuccess: nl,
  badgeInfo: sl,
  badgeWarning: ol,
  badgeError: rl
}, il = {
  small: We.badgeSmall,
  medium: We.badgeMedium
}, al = {
  primary: We.badgePrimary,
  secondary: We.badgeSecondary,
  success: We.badgeSuccess,
  info: We.badgeInfo,
  warning: We.badgeWarning,
  error: We.badgeError
}, ll = "badge";
function $k(i) {
  const { className: e, size: t, variant: n, children: o, ...r } = i, a = f(
    We.badge,
    il[t],
    al[n],
    e
  );
  return /* @__PURE__ */ s.jsx("span", { className: a, ...r, "data-testid": ll, children: o });
}
const W = $(function({
  flexWrap: e,
  flexDirection: t,
  justifyItems: n,
  justifyContent: o,
  alignItems: r,
  alignContent: a,
  gap: l,
  style: c,
  children: d,
  ...h
}, u) {
  const p = {
    ...e && { flexWrap: e },
    ...t && { flexDirection: t },
    ...n && { justifyItems: n },
    ...o && { justifyContent: o },
    ...r && { alignItems: r },
    ...a && { alignContent: a },
    ...l && { gap: Fs(l) },
    display: "flex",
    ...c
  };
  return /* @__PURE__ */ s.jsx(ie, { ...h, style: p, ref: u, children: d });
}), cl = "h-banner--banner__root", dl = "h-banner--banner__rootWithClose", hl = "h-banner--banner__iconContainer", ul = "h-banner--banner__closeIcon", pl = "h-banner--banner__headline", ml = "h-banner--banner__rootInfo", gl = "h-banner--banner__icon", fl = "h-banner--banner__description", bl = "h-banner--banner__rootWarning", xl = "h-banner--banner__rootAnnouncement", yl = "h-banner--banner__rootSuccess", _l = "h-banner--banner__rootFail", _e = {
  root: cl,
  rootWithClose: dl,
  iconContainer: hl,
  closeIcon: ul,
  headline: pl,
  rootInfo: ml,
  icon: gl,
  description: fl,
  rootWarning: bl,
  rootAnnouncement: xl,
  rootSuccess: yl,
  rootFail: _l
}, Cl = (i, e) => {
  if (e !== void 0)
    return e;
  switch (i) {
    case "info":
    case "announcement":
      return "info";
    case "warning":
      return "exclamation-triangle-filled";
    case "success":
      return "check-circle-filled";
    default:
      return "close-circle-filled";
  }
}, Ok = ({
  actionSlot: i,
  className: e,
  description: t,
  headline: n,
  icon: o,
  variant: r,
  onClose: a
}) => {
  const l = f(_e.root, e, {
    [_e.rootInfo]: r === "info",
    [_e.rootAnnouncement]: r === "announcement",
    [_e.rootWarning]: r === "warning",
    [_e.rootSuccess]: r === "success",
    [_e.rootFail]: r === "fail",
    [_e.rootWithClose]: a
  }), c = Cl(r, o);
  return /* @__PURE__ */ s.jsxs("div", { className: l, children: [
    /* @__PURE__ */ s.jsxs(W, { justifyContent: "center", children: [
      c && /* @__PURE__ */ s.jsx("span", { className: _e.iconContainer, children: /* @__PURE__ */ s.jsx(N, { name: c, size: 16, className: _e.icon }) }),
      /* @__PURE__ */ s.jsxs(W, { flexDirection: "column", children: [
        n && /* @__PURE__ */ s.jsx(
          A.Heading,
          {
            as: "span",
            variant: "heading-3",
            className: _e.headline,
            children: n
          }
        ),
        cn(t, {
          className: _e.description
        })
      ] })
    ] }),
    i ? /* @__PURE__ */ s.jsx(W, { gap: "250", margin: "0 0 0 250", children: i }) : a && /* @__PURE__ */ s.jsx(
      K,
      {
        icon: "close",
        variant: "tertiary",
        className: _e.closeIcon,
        onClick: a
      }
    )
  ] });
}, vl = "h-buttonGroup--buttonGroup__root", wl = "h-buttonGroup--buttonGroup__button", Sl = "h-buttonGroup--buttonGroup__buttonWithBorder", Il = "h-buttonGroup--buttonGroup__buttonWithoutBorder", fn = {
  root: vl,
  button: wl,
  buttonWithBorder: Sl,
  buttonWithoutBorder: Il
}, Bk = ({
  className: i,
  children: e,
  variant: t,
  size: n,
  disabled: o
}) => {
  const r = f(fn.root, i);
  return /* @__PURE__ */ s.jsx("div", { className: r, role: "group", children: Le.map(e, (a) => {
    if (!Te(a))
      return null;
    const l = (t ?? a.props.variant) === "secondary", c = f(a.props.className, {
      [fn.button]: !0,
      [fn.buttonWithBorder]: l,
      [fn.buttonWithoutBorder]: !l
    });
    return cn(a, {
      className: c,
      disabled: o ?? a.props.disabled,
      variant: t ?? a.props.variant,
      size: n
    });
  }) });
}, Dl = "h-divider--divider__root", kl = "h-divider--divider__withChildren", Tl = "h-divider--divider__horizontal", jl = "h-divider--divider__vertical", ls = {
  root: Dl,
  withChildren: kl,
  horizontal: Tl,
  vertical: jl
}, Qn = $(function({
  className: e,
  children: t,
  as: n,
  orientation: o = "horizontal",
  color: r,
  margin: a,
  padding: l,
  ...c
}, d) {
  const h = n ?? (t ? "div" : "hr"), u = f(
    ls.root,
    ls[o],
    {
      [ls.withChildren]: !!t
    },
    e
  ), p = {
    ...c.style,
    ...r ? { "--divider-color": sn(r) } : {},
    ...a ? { margin: Fs(a) } : {},
    ...l ? { padding: Fs(l) } : {}
  };
  return /* @__PURE__ */ s.jsx(
    h,
    {
      ...c,
      ref: d,
      className: u,
      style: p,
      children: typeof t == "string" ? /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: t }) : t
    }
  );
}), Nl = "h-buttonList--buttonList__buttonList", Fl = "h-buttonList--buttonList__inner", fo = {
  buttonList: Nl,
  inner: Fl
};
let Pl = class extends D {
  render() {
    const { children: e, className: t, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Qn, { as: "li", color: "tertiary", padding: "200 250", ...n, children: e });
  }
};
const Rl = "h-buttonList--item__item", El = "h-buttonList--item__icon", Ll = "h-buttonList--item__button", Al = "h-buttonList--item__buttonDisabled", $l = "h-buttonList--item__buttonCentered", Ol = "h-buttonList--item__checkmark", Bl = "h-buttonList--item__buttonLoading", Wl = "h-buttonList--item__buttonContent", Me = {
  item: Rl,
  icon: El,
  button: Ll,
  buttonDisabled: Al,
  buttonCentered: $l,
  checkmark: Ol,
  buttonLoading: Bl,
  buttonContent: Wl
}, Hl = function({
  icon: e,
  children: t,
  className: n,
  isSelected: o,
  isCentered: r,
  isLoading: a,
  isDisabled: l,
  buttonClassName: c,
  buttonProps: d,
  onClick: h,
  ...u
}, p) {
  const m = f(
    {
      [Me.item]: !0
    },
    n
  ), g = f(
    Me.button,
    {
      [Me.buttonCentered]: r,
      [Me.buttonLoading]: a,
      [Me.buttonDisabled]: l
    },
    c
  ), b = l ? { tabIndex: -1 } : {};
  return /* @__PURE__ */ s.jsx("li", { ref: p, ...u, className: m, children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      ...b,
      ...d,
      className: g,
      onClick: h,
      children: [
        /* @__PURE__ */ s.jsxs("span", { className: Me.buttonContent, children: [
          e && /* @__PURE__ */ s.jsx(N, { className: Me.icon, name: e }),
          /* @__PURE__ */ s.jsx(A.Paragraph, { variant: o ? "1" : "2", children: t })
        ] }),
        o && /* @__PURE__ */ s.jsx(
          N,
          {
            name: "done",
            size: 20,
            color: "neutral.700",
            className: Me.checkmark
          }
        )
      ]
    }
  ) });
}, Ml = $(Hl);
class bo extends D {
  static get Item() {
    return Ml;
  }
  static get Header() {
    return Pl;
  }
  static get Divider() {
    return zl;
  }
  render() {
    const { children: e, className: t, ...n } = this.props, o = f(
      {
        [fo.buttonList]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: /* @__PURE__ */ s.jsx("ul", { className: fo.inner, children: e }) });
  }
}
const zl = () => /* @__PURE__ */ s.jsx(Qn, { as: "li", margin: "100 0" }), Vl = "h-checkbox--checkbox__root", Kl = "h-checkbox--checkbox__rootDisabled", Ul = "h-checkbox--checkbox__rootChecked", ql = "h-checkbox--checkbox__rootIndeterminate", Gl = "h-checkbox--checkbox__checkbox", Yl = "h-checkbox--checkbox__input", pt = {
  root: Vl,
  rootDisabled: Kl,
  rootChecked: Ul,
  rootIndeterminate: ql,
  checkbox: Gl,
  input: Yl
};
class hn extends D {
  inputRef;
  constructor(e) {
    super(e), this.inputRef = B();
  }
  componentDidMount() {
    const e = this.inputRef.current;
    e && (e.indeterminate = !!this.props.indeterminate);
  }
  componentDidUpdate(e) {
    const t = this.inputRef.current;
    t && e.indeterminate !== this.props.indeterminate && (t.indeterminate = !!this.props.indeterminate);
  }
  render() {
    const {
      className: e,
      onChange: t,
      id: n,
      name: o,
      checked: r,
      indeterminate: a,
      disabled: l,
      tabIndex: c,
      ...d
    } = this.props, h = f(
      {
        [pt.root]: !0,
        [pt.rootDisabled]: l,
        [pt.rootChecked]: r,
        [pt.rootIndeterminate]: a
      },
      e
    );
    return /* @__PURE__ */ s.jsxs("span", { className: h, "data-testid": "habla-checkbox", ...d, children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          role: "checkbox",
          "aria-checked": a ? "mixed" : r,
          className: pt.checkbox
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          id: n,
          type: "checkbox",
          "aria-hidden": "true",
          name: o,
          className: pt.input,
          onChange: t || L,
          checked: r,
          disabled: l,
          ref: this.inputRef,
          tabIndex: c
        }
      )
    ] });
  }
}
const Ql = "h-collapseCard--collapseCard__card", Xl = {
  card: Ql
}, qs = ve({
  isOpen: !1,
  onToggle: L
}), Zl = "h-collapseCard--content__content", Jl = "h-collapseCard--content__contentIsOpen", xo = {
  content: Zl,
  contentIsOpen: Jl
};
class ec extends D {
  static displayName = "CollapseCard.Content";
  getRootClassName(e) {
    return f(xo.content, this.props.className, {
      [xo.contentIsOpen]: e
    });
  }
  render() {
    const { children: e, className: t, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(qs.Consumer, { children: ({ isOpen: o }) => o ? /* @__PURE__ */ s.jsx(
      "ul",
      {
        ...n,
        className: this.getRootClassName(o),
        "data-testid": "content",
        children: e
      }
    ) : null });
  }
}
function Xn(i) {
  return {
    role: "button",
    onClick: i,
    onKeyDown: (e) => {
      e.key === "Enter" && i(e);
    }
  };
}
const tc = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  " "
], nc = ["Escape", "Esc"], Zn = (i) => tc.includes(i), Et = (i) => nc.includes(i), sc = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  '[tabindex]:not([tabindex="-1"]):not([disabled])'
], yo = sc.join(
  ':not([hidden]):not([tabindex="-1"]),'
), Tr = qn(function({
  containerRef: e,
  children: t,
  isActive: n,
  autoFocus: o,
  restoreFocus: r,
  onActiveStateChange: a,
  bringInFocusOnTab: l
}) {
  const c = n !== void 0, d = n === void 0 || n, h = q(null), u = q(
    // type null is needed to make ref mutable.
    d ? document.activeElement : null
  ), p = e || h;
  Ir(
    "Tab",
    (b) => {
      if (!d)
        return;
      const x = p.current?.querySelectorAll(yo), C = !p.current?.contains(
        b.target instanceof Element ? b.target : null
      );
      if (!x)
        return;
      const _ = x[0], S = x[x.length - 1];
      if (!b.shiftKey && document.activeElement === S || !b.shiftKey && l && C)
        return _?.focus(), b.preventDefault();
      (b.shiftKey && document.activeElement === _ || b.shiftKey && l && C) && (S?.focus(), b.preventDefault());
    },
    void 0,
    [d]
  );
  const m = () => {
    setTimeout(() => {
      o && (o === !0 ? p.current?.querySelector(yo)?.focus() : o.current && o.current.focus());
    });
  }, g = () => {
    document.activeElement !== document.body && !p.current?.contains(document.activeElement) || setTimeout(() => {
      r && (r === !0 ? u.current?.focus() : r.current && r.current.focus());
    });
  };
  return Pt(() => {
    c || (m(), a?.(!0));
  }), Je(() => {
    c || (g(), a?.(!1));
  }), Xe(() => {
    n === !0 ? (u.current = document.activeElement, m()) : n === !1 && g(), a?.(!!n);
  }, [n]), e ? /* @__PURE__ */ s.jsx(s.Fragment, { children: t }) : /* @__PURE__ */ s.jsx("div", { ref: h, children: t });
}), oc = "h-dropdown--dropdown__dropdown", rc = "h-dropdown--dropdown__dropdownOpen", ic = "h-dropdown--dropdown__dropdownFromRight", ac = "h-dropdown--dropdown__dropdownFromBottom", lc = "h-dropdown--dropdown__dropdownAnimating", cc = "h-dropdown--dropdown__dropdownFixed", dc = "h-dropdown--dropdown__loader", hc = "h-dropdown--dropdown__error", uc = "h-dropdown--dropdown__errorIcon", $e = {
  dropdown: oc,
  dropdownOpen: rc,
  dropdownFromRight: ic,
  dropdownFromBottom: ac,
  dropdownAnimating: lc,
  dropdownFixed: cc,
  loader: dc,
  error: hc,
  errorIcon: uc
};
class et extends D {
  dropdownRef;
  timeoutAnimationStart;
  timeoutAnimationEnd;
  win;
  static defaultProps = {
    onClose: () => {
    },
    closeOnBlur: !0
  };
  constructor(e) {
    super(e), this.state = {
      fromRight: !1,
      fromBottom: !1,
      fromTop: !1,
      width: null,
      height: null,
      animating: !1
    }, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = B(), this.win = window, this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }
  componentDidMount() {
    this.win = this.getWindow(), this.calculatePosition();
  }
  getSnapshotBeforeUpdate() {
    if (this.dropdownRef.current) {
      const e = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: e.width,
        oldHeight: e.height
      };
    }
    return null;
  }
  componentDidUpdate(e, t, n) {
    const { isOpen: o, isLoading: r, errorMessage: a, fixed: l, closeOnBlur: c } = this.props;
    if (n && (r !== e.isLoading || a !== e.errorMessage)) {
      const d = r !== e.isLoading && r;
      this.animate(n.oldWidth, n.oldHeight, d);
    }
    o && this.calculatePosition(), o !== e.isOpen && (this.win[o ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutsideDropdown
    ), c && this.win[o ? "addEventListener" : "removeEventListener"](
      "blur",
      this.handleOnClose
    ), l && this.win[o ? "addEventListener" : "removeEventListener"](
      "scroll",
      this.handleFixedScroll,
      !0
    ));
  }
  getWindow() {
    return this.dropdownRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentWillUnmount() {
    this.win.removeEventListener("click", this.handleClickOutsideDropdown), this.win.removeEventListener("scroll", this.handleFixedScroll), this.win.removeEventListener("blur", this.handleOnClose), this.win.clearInterval(this.timeoutAnimationStart), this.win.clearInterval(this.timeoutAnimationEnd);
  }
  handleOnClose() {
    const { onClose: e } = this.props;
    e();
  }
  animate(e, t, n) {
    if (this.dropdownRef.current) {
      const o = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: e,
        height: t,
        animating: !n
      }), this.timeoutAnimationStart = this.win.setTimeout(() => {
        this.setState({
          width: o.width,
          height: o.height
        }), this.timeoutAnimationEnd = this.win.setTimeout(() => {
          this.setState({
            width: null,
            height: null,
            animating: !1
          });
        }, 200);
      });
    }
  }
  handleClickOutsideDropdown(e) {
    if (!this.dropdownRef || !e.target) return;
    const t = e.target, { onClose: n } = this.props;
    this.dropdownRef.current && t !== this.dropdownRef.current && !this.dropdownRef.current.contains(t) && n();
  }
  handleDropdownClick(e) {
    e.stopPropagation();
  }
  handleFixedScroll() {
    this.forceUpdate();
  }
  calculatePosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const e = this.dropdownRef.current.parentElement.getBoundingClientRect(), t = e.left + e.width / 2, n = e.top + e.height / 2, o = this.getWindow(), r = o.innerWidth / 2, a = o.innerHeight / 2;
      this.setState({
        fromRight: t > r,
        fromBottom: n > a,
        fromTop: n <= a
      });
    }
  }
  getFixedPosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const { fromRight: e, fromBottom: t, fromTop: n } = this.state, o = this.dropdownRef.current.parentElement.getBoundingClientRect(), r = {}, a = this.getWindow();
      return e ? r.right = `${a.innerWidth - o.right}px` : r.left = `${o.left}px`, t && (r.bottom = `${a.innerHeight - o.top}px`), n && (r.top = `${o.top + o.height}px`), r;
    }
    return {};
  }
  render() {
    const {
      className: e,
      children: t,
      onClose: n,
      isOpen: o,
      isLoading: r,
      closeOnBlur: a,
      errorMessage: l,
      fixed: c,
      style: d,
      autoFocus: h,
      restoreFocus: u,
      bringInFocusOnTab: p,
      ...m
    } = this.props, { fromRight: g, fromBottom: b, animating: x, width: C, height: _ } = this.state, S = f(
      {
        [$e.dropdown]: !0,
        [$e.dropdownOpen]: o,
        [$e.dropdownFromRight]: g,
        [$e.dropdownFromBottom]: b,
        [$e.dropdownAnimating]: x,
        [$e.dropdownFixed]: c
      },
      e
    );
    let v = { ...d };
    C && _ && (v.width = `${C}px`, v.height = `${_}px`), c && (v = { ...v, ...this.getFixedPosition() });
    const y = !r && !l;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...m,
        className: S,
        ref: this.dropdownRef,
        style: v,
        onClick: this.handleDropdownClick,
        role: "menu",
        "aria-expanded": o,
        children: [
          r && /* @__PURE__ */ s.jsx("div", { className: $e.loader }),
          !!l && !r && /* @__PURE__ */ s.jsxs("div", { className: $e.error, children: [
            /* @__PURE__ */ s.jsx(N, { className: $e.errorIcon, name: "exclamation" }),
            /* @__PURE__ */ s.jsx("span", { children: l })
          ] }),
          y && /* @__PURE__ */ s.jsx(
            Tr,
            {
              containerRef: this.dropdownRef,
              isActive: o,
              autoFocus: h,
              restoreFocus: u,
              bringInFocusOnTab: p,
              children: t
            }
          )
        ]
      }
    );
  }
}
const pc = "h-dropdownButton--dropdownButton__root", mc = "h-dropdownButton--dropdownButton__wrapper", cs = {
  root: pc,
  wrapper: mc
}, un = ve({
  toggleDropdown: L,
  openDropdown: L,
  closeDropdown: L,
  dropdownOpen: !1
});
class dt extends ge {
  buttonWrapperRef;
  buttonRef;
  contextState;
  timeoutId;
  win;
  static defaultProps = {
    allowEscClose: !0
  };
  constructor(e) {
    super(e);
    const t = e.show ?? !1;
    this.state = {
      dropdownOpen: t,
      pristine: !0,
      fromBottom: !1
    }, this.timeoutId = null, this.win = window, this.buttonWrapperRef = B(), this.buttonRef = B(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
      toggleDropdown: this.toggle,
      openDropdown: this.open,
      closeDropdown: this.close,
      dropdownOpen: t
    };
  }
  getWindow() {
    return this.buttonWrapperRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentDidMount() {
    this.win = this.getWindow(), this.props.allowEscClose && this.props.show && this.win.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
  }
  componentDidUpdate(e) {
    this.toggleDropdownIfNeeded(e);
  }
  componentWillUnmount() {
    this.props.allowEscClose && this.win.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && this.win.clearTimeout(this.timeoutId);
  }
  shouldToggleDropdown(e) {
    return e.show !== this.props.show;
  }
  handleKeyDown(e) {
    Et(e.key) && this.state.dropdownOpen && (e.stopPropagation(), this.close());
  }
  toggleDropdownIfNeeded(e) {
    this.shouldToggleDropdown(e) && (this.props.show ? this.open() : this.close());
  }
  /**
   * HACK: To get around node and dom types not being compatible and both
   * overloading setTimeout
   *
   * @param callback
   * @param delay
   * @returns
   */
  setTimeout(e, t = 0) {
    return this.win.setTimeout(e, t);
  }
  handleDropdownToggle() {
    const { dropdownOpen: e } = this.state, t = () => {
      this.timeoutId = this.setTimeout(() => {
        this.toggle(!e);
      });
    }, n = this.shouldDropdownBeAboveButton();
    e ? t() : this.setState(
      { fromBottom: n },
      t
    );
  }
  close() {
    this.toggle(!1);
  }
  open() {
    this.toggle(!0);
  }
  toggle(e) {
    const { allowEscClose: t, onToggle: n } = this.props, { pristine: o, dropdownOpen: r } = this.state, a = e ?? !r;
    this.contextState = { ...this.contextState, dropdownOpen: a }, this.setState({ dropdownOpen: a, pristine: !1 }), t && (a ? this.win.addEventListener.bind(this.win) : this.win.removeEventListener.bind(this.win))("keydown", this.handleKeyDown, !0), n?.(a, o);
  }
  shouldDropdownBeAboveButton() {
    const e = this.buttonWrapperRef.current?.getBoundingClientRect();
    return e ? e.bottom > this.getWindow().innerHeight / 2 : !1;
  }
  renderTheTriggerButton() {
    const {
      icon: e,
      buttonProps: t,
      children: n,
      noArrow: o,
      noStyle: r,
      onMouseEnter: a,
      onMouseLeave: l
    } = this.props, { fromBottom: c } = this.state;
    return r ? /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: this.buttonRef,
        className: t?.className,
        ...t,
        onMouseEnter: a,
        onMouseLeave: l,
        ...Xn(this.handleDropdownToggle),
        children: n
      }
    ) : e && !n ? /* @__PURE__ */ s.jsx(
      K,
      {
        ref: this.buttonRef,
        icon: e,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...t,
        onClick: this.handleDropdownToggle
      }
    ) : /* @__PURE__ */ s.jsx(
      X,
      {
        ref: this.buttonRef,
        icon: e,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...t,
        onClick: this.handleDropdownToggle,
        slotEnd: o ? void 0 : /* @__PURE__ */ s.jsx(N, { name: c ? "angle-up" : "angle-down" }),
        children: n
      }
    );
  }
  render() {
    const {
      className: e,
      children: t,
      icon: n,
      dropdown: o,
      buttonProps: r,
      dropdownProps: a,
      noArrow: l,
      noStyle: c,
      show: d,
      onToggle: h,
      isLoading: u,
      errorMessage: p,
      fixed: m,
      onMouseEnter: g,
      onMouseLeave: b,
      allowEscClose: x,
      destroyOnClose: C,
      ..._
    } = this.props, { dropdownOpen: S, pristine: v } = this.state, y = f({ [cs.root]: cs.root }, e);
    return /* @__PURE__ */ s.jsx(un.Provider, { value: this.contextState, children: /* @__PURE__ */ s.jsx("div", { ..._, className: y, ref: this.buttonWrapperRef, children: /* @__PURE__ */ s.jsxs("div", { className: cs.wrapper, children: [
      this.renderTheTriggerButton(),
      /* @__PURE__ */ s.jsx(
        et,
        {
          restoreFocus: this.buttonRef,
          ...a,
          isOpen: S,
          onClose: this.close,
          isLoading: u,
          errorMessage: p,
          fixed: m,
          children: (S || !v && !C) && o
        }
      )
    ] }) }) });
  }
}
const gc = "h-collapseCard--header__header", fc = "h-collapseCard--header__headerOpen", bc = "h-collapseCard--header__headerHasDropdown", xc = "h-collapseCard--header__titleWrapper", yc = "h-collapseCard--header__title", mt = {
  header: gc,
  headerOpen: fc,
  headerHasDropdown: bc,
  titleWrapper: xc,
  title: yc
};
class _c extends D {
  // It's important to keep the displayName because it's used by the collapseCard
  // To determine the type of it's children
  static displayName = "CollapseCard.Header";
  static defaultProps = {
    title: ""
  };
  getRootClassName(e) {
    const { dropdown: t, className: n } = this.props;
    return f(
      mt.header,
      { [mt.headerOpen]: e, [mt.headerHasDropdown]: !!t },
      n
    );
  }
  render() {
    const {
      children: e,
      className: t,
      title: n,
      avatar: o,
      dropdown: r,
      onDropdownToggle: a,
      dropdownTrigger: l,
      slotBeforeTitle: c,
      slotAfterTitle: d,
      wrap: h = "nowrap",
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(qs.Consumer, { children: ({ isOpen: p, onToggle: m }) => {
      const g = this.getRootClassName(p);
      return /* @__PURE__ */ s.jsxs(
        "div",
        {
          ...u,
          onClick: m,
          className: g,
          "data-testid": "header",
          children: [
            /* @__PURE__ */ s.jsxs(
              W,
              {
                alignItems: "center",
                padding: "400 0",
                className: mt.titleWrapper,
                children: [
                  c,
                  o,
                  /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      className: mt.titleWrapper,
                      onMouseDown: (b) => b.stopPropagation(),
                      children: /* @__PURE__ */ s.jsx(
                        A.Paragraph,
                        {
                          variant: "1",
                          wrap: h,
                          className: mt.title,
                          children: e
                        }
                      )
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsxs(W, { alignItems: "center", children: [
              d,
              !!r && /* @__PURE__ */ s.jsx(
                dt,
                {
                  onClick: (b) => b.stopPropagation(),
                  icon: l ? void 0 : "dots-h",
                  dropdown: r,
                  buttonProps: { variant: "tertiary" },
                  onToggle: a,
                  children: l
                }
              ),
              /* @__PURE__ */ s.jsx(
                K,
                {
                  icon: p ? "angle-down" : "angle-right",
                  variant: "tertiary"
                }
              )
            ] })
          ]
        }
      );
    } });
  }
}
const Cc = "h-collapseCard--line__line", vc = "h-collapseCard--line__lineHasLabel", wc = "h-collapseCard--line__value", Sc = "h-collapseCard--line__lineHideOverflow", bn = {
  line: Cc,
  lineHasLabel: vc,
  value: wc,
  lineHideOverflow: Sc
};
class Ic extends D {
  render() {
    const { label: e, children: t, className: n, hideOverflow: o, ...r } = this.props, a = f(
      {
        [bn.line]: !0,
        [bn.lineHasLabel]: !!e,
        [bn.lineHideOverflow]: o
      },
      n
    );
    return /* @__PURE__ */ s.jsxs("li", { ...r, className: a, children: [
      e && /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", subdued: !0, wrap: "nowrap", children: e }),
      e ? /* @__PURE__ */ s.jsx("span", { className: bn.value, children: t }) : t
    ] });
  }
}
const Dc = "h-collapseCard--readMore__readMore", kc = {
  readMore: Dc
};
class Tc extends D {
  render() {
    const { onClick: e, url: t, children: n, className: o, ...r } = this.props, a = f({ [kc.readMore]: !0 }, o);
    return t ? /* @__PURE__ */ s.jsx(A.ExternalLink, { ...r, href: t, className: a, children: n }) : /* @__PURE__ */ s.jsx(
      X,
      {
        variant: "secondary",
        ...r,
        onClick: e,
        className: a,
        children: n
      }
    );
  }
}
const jc = "h-collapseCard--status__status", Nc = {
  status: jc
};
class Fc extends D {
  render() {
    const { children: e, className: t, ...n } = this.props, o = f({ [Nc.status]: !0 }, t);
    return /* @__PURE__ */ s.jsx("li", { ...n, className: o, children: e });
  }
}
class Pc extends D {
  static defaultProps = {
    isOpen: !1
  };
  constructor(e) {
    super(e), this.handleToggle = this.handleToggle.bind(this);
  }
  static Line = Ic;
  static Header = _c;
  static Content = ec;
  static ReadMore = Tc;
  static Status = Fc;
  handleToggle() {
    this.props.onToggle(!this.props.isOpen);
  }
  isHeader(e) {
    return e?.type?.displayName === "CollapseCard.Header" && Te(e);
  }
  isContent(e) {
    return e?.type?.displayName === "CollapseCard.Content" && Te(e);
  }
  getHeaderChildren() {
    return Le.toArray(this.props.children).filter(this.isHeader);
  }
  getContentChildren() {
    return Le.toArray(this.props.children).filter(this.isContent);
  }
  getRootClassName() {
    const { className: e } = this.props;
    return f(Xl.card, e);
  }
  render() {
    const {
      className: e,
      onToggle: t,
      isOpen: n,
      children: o,
      containerRef: r,
      ...a
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      qs.Provider,
      {
        value: { isOpen: n, onToggle: this.handleToggle },
        children: /* @__PURE__ */ s.jsxs(
          "div",
          {
            ...a,
            ref: r,
            className: this.getRootClassName(),
            children: [
              this.getHeaderChildren(),
              this.getContentChildren()
            ]
          }
        )
      }
    );
  }
}
const Hk = dn(Pc, {
  fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong" }) })
}), Rc = "h-collapsible--collapsible__root", Ec = "h-collapsible--collapsible__collapsible", Lc = "h-collapsible--collapsible__children", ds = {
  root: Rc,
  collapsible: Ec,
  children: Lc
};
class Mk extends D {
  childrenRef;
  resizeObserver = null;
  constructor(e) {
    super(e), this.childrenRef = B(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = {
      childrenHeight: e.isOpen ? "auto" : 0
    };
  }
  componentDidMount() {
    this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentDidUpdate(e) {
    e.isOpen !== this.props.isOpen && this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentWillUnmount() {
    this.disconnectResizeObserver();
  }
  setupResizeObserver() {
    this.childrenRef.current && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(() => {
      this.measureChildrenHeight();
    }), this.resizeObserver.observe(this.childrenRef.current));
  }
  disconnectResizeObserver() {
    this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  measureChildrenHeight() {
    const e = this.childrenRef.current;
    e && this.setState({
      childrenHeight: e.offsetHeight
    });
  }
  render() {
    const { className: e, header: t, isOpen: n, children: o, ...r } = this.props, { childrenHeight: a } = this.state, l = f(
      {
        [ds.root]: !0
      },
      e
    ), c = {
      maxHeight: n ? a : 0
    };
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("div", { children: t }) }),
      !!o && /* @__PURE__ */ s.jsx("div", { style: c, className: ds.collapsible, children: /* @__PURE__ */ s.jsx("span", { className: ds.children, ref: this.childrenRef, children: o }) })
    ] });
  }
}
const Ac = "h-colorPicker--colorPicker__root", $c = {
  root: Ac
}, Oc = "h-inputWrapper--inputWrapper__root", Bc = "h-inputWrapper--inputWrapper__rootDisabled", Wc = "h-inputWrapper--inputWrapper__rootActive", Hc = "h-inputWrapper--inputWrapper__rootHasError", Mc = "h-inputWrapper--inputWrapper__rootHasWarning", zc = "h-inputWrapper--inputWrapper__rootHasSuccess", Vc = "h-inputWrapper--inputWrapper__inputWrapper", Kc = "h-inputWrapper--inputWrapper__rootWithPrefix", Uc = "h-inputWrapper--inputWrapper__rootWithSuffix", qc = "h-inputWrapper--inputWrapper__suffixesContainer", Gc = "h-inputWrapper--inputWrapper__prefix", Yc = "h-inputWrapper--inputWrapper__suffix", Qc = "h-inputWrapper--inputWrapper__prefixDropdownButton", Xc = "h-inputWrapper--inputWrapper__suffixDropdownButton", Zc = "h-inputWrapper--inputWrapper__prefixButton", Jc = "h-inputWrapper--inputWrapper__suffixButton", ed = "h-inputWrapper--inputWrapper__icon", ae = {
  root: Oc,
  rootDisabled: Bc,
  rootActive: Wc,
  rootHasError: Hc,
  rootHasWarning: Mc,
  rootHasSuccess: zc,
  inputWrapper: Vc,
  rootWithPrefix: Kc,
  rootWithSuffix: Uc,
  suffixesContainer: qc,
  prefix: Gc,
  suffix: Yc,
  prefixDropdownButton: Qc,
  suffixDropdownButton: Xc,
  prefixButton: Zc,
  suffixButton: Jc,
  icon: ed
}, Ps = ve({
  position: null,
  disabled: !1,
  active: !1,
  status: "success"
}), td = "inputWrapper";
class nd extends D {
  renderIcon() {
    const { icon: e } = this.props;
    return e ? /* @__PURE__ */ s.jsx(N, { className: ae.icon, name: e }) : null;
  }
  isButtonAddon(e) {
    return !!e && "type" in e && e.type === "button";
  }
  isCustomAddon(e) {
    return !!e && "type" in e && (!e.type || e.type === "custom");
  }
  renderAddon(e) {
    const t = this.props[e], { disabled: n } = this.props;
    if (!t)
      return null;
    let o;
    if (typeof t != "object" || !("type" in t))
      o = /* @__PURE__ */ s.jsx("div", { className: f(ae[e]), children: t });
    else if (this.isCustomAddon(t))
      o = t.noWrap ? t.value : /* @__PURE__ */ s.jsx("div", { className: ae[e], children: t.value });
    else if (this.isButtonAddon(t)) {
      const {
        className: r,
        disabled: a,
        ...l
      } = t.button;
      o = /* @__PURE__ */ s.jsx(
        K,
        {
          className: f(
            {
              [ae[e]]: !t.noStyle,
              [ae[`${e}Button`]]: !t.noStyle
            },
            r
          ),
          disabled: n || a,
          ...l
        }
      );
    }
    return o;
  }
  getContextValue(e) {
    const { disabled: t, active: n, status: o } = this.props;
    return {
      position: e,
      disabled: !!t,
      active: !!n,
      status: o || "success"
    };
  }
  render() {
    const {
      className: e,
      disabled: t,
      active: n,
      status: o,
      prefix: r,
      suffix: a,
      icon: l,
      children: c,
      innerRef: d,
      ...h
    } = this.props, u = f(
      ae.root,
      {
        [ae.rootActive]: n,
        [ae.rootDisabled]: t,
        [ae.rootHasError]: o === "error",
        [ae.rootHasWarning]: o === "warning",
        [ae.rootHasSuccess]: o === "success",
        [ae.rootWithPrefix]: !!r,
        [ae.rootWithSuffix]: !!a
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": td,
        className: u,
        ref: d,
        ...h,
        children: [
          /* @__PURE__ */ s.jsx(Ps.Provider, { value: this.getContextValue("prefix"), children: this.renderAddon("prefix") }),
          /* @__PURE__ */ s.jsx("div", { className: ae.inputWrapper, children: c }),
          /* @__PURE__ */ s.jsxs("span", { className: ae.suffixesContainer, children: [
            this.renderIcon(),
            /* @__PURE__ */ s.jsx(Ps.Provider, { value: this.getContextValue("suffix"), children: this.renderAddon("suffix") })
          ] })
        ]
      }
    );
  }
}
const Ae = $(function(e, t) {
  return /* @__PURE__ */ s.jsx(nd, { innerRef: t, ...e, children: e.children });
}), sd = "h-colorPicker-input--colorPickerInput__input", od = {
  input: sd
}, rd = ({
  className: i,
  ...e
}) => /* @__PURE__ */ s.jsx(Ae, { prefix: "#", children: /* @__PURE__ */ s.jsx(
  Di,
  {
    className: f(od.input, i),
    "aria-label": "Enter hex value",
    placeholder: "Hex value",
    ...e
  }
) }), id = "h-colorPicker-presets--colorPickerPresets__root", ad = {
  root: id
}, ld = "h-colorPicker-presets-preset--colorPickerPreset__root", cd = "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected", dd = "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha", hd = "h-colorPicker-presets-preset--colorPickerPreset__preset", xn = {
  root: ld,
  rootIsSelected: cd,
  rootAlpha: dd,
  preset: hd
}, ud = ({
  color: i,
  onSelect: e,
  isSelected: t,
  alpha: n,
  className: o
}) => /* @__PURE__ */ s.jsx(
  "li",
  {
    className: f(xn.root, o, {
      [xn.rootIsSelected]: t,
      [xn.rootAlpha]: n
    }),
    children: /* @__PURE__ */ s.jsx(
      "button",
      {
        type: "button",
        "aria-label": i,
        className: xn.preset,
        style: { backgroundColor: i },
        onClick: () => {
          e?.(i);
        }
      }
    )
  }
);
Hs([Ms]);
const pd = ({
  presets: i,
  className: e,
  onChange: t,
  color: n,
  alpha: o,
  ...r
}) => /* @__PURE__ */ s.jsx(
  W,
  {
    as: "ul",
    gap: "200",
    flexWrap: "wrap",
    className: f(ad.root, e),
    ...r,
    children: i.map((a) => /* @__PURE__ */ s.jsx(
      ud,
      {
        onSelect: t,
        color: a,
        isSelected: n === (a.startsWith("#") ? a : Wn(a).toHex()),
        alpha: o
      },
      a
    ))
  }
);
Hs([Ms]);
const md = ({
  onChange: i,
  color: e,
  alpha: t,
  className: n,
  ...o
}) => {
  const r = P((a) => {
    setTimeout(() => {
      i?.(Wn(a).toHex());
    });
  }, []);
  return t ? /* @__PURE__ */ s.jsx(
    Ti,
    {
      className: n,
      color: Wn(e ?? "").toRgbString(),
      onChange: r,
      ...o
    }
  ) : /* @__PURE__ */ s.jsx(
    ki,
    {
      className: n,
      color: e,
      onChange: i,
      ...o
    }
  );
};
Hs([Ms]);
const gd = "colorPickerTestId", Jn = ({
  className: i,
  color: e,
  onChange: t,
  alpha: n,
  children: o,
  ...r
}) => {
  const [a, l] = V();
  return G(() => {
    const c = e?.startsWith("#") ? e : Wn(e ?? "").toHex();
    l(c);
  }, [e]), /* @__PURE__ */ s.jsx(
    W,
    {
      flexDirection: "column",
      gap: "250",
      className: f($c.root, i),
      "data-testid": gd,
      ...r,
      children: Le.map(
        o,
        (c) => Te(c) && cn(c, {
          onChange: t,
          color: a,
          alpha: n,
          ...c.props
        })
      )
    }
  );
};
Jn.Input = rd;
Jn.Sliders = md;
Jn.Presets = pd;
const fd = "h-columns--columns__root", bd = {
  root: fd
}, xd = "1fr", yd = $(function({ as: e = "div", children: t, className: n, style: o, ...r }, a) {
  const c = Le.toArray(t).map((d) => d.props.size ?? xd).join(" ");
  return /* @__PURE__ */ s.jsx(
    e,
    {
      ...r,
      ref: a,
      className: f(bd.root, n),
      style: { ...o, gridTemplateColumns: c },
      children: t
    }
  );
}), _d = "h-columns-column--column__root", Cd = {
  root: _d
}, vd = "h-columns-column-row--columnRow__root", wd = "h-columns-column-row--columnRow__noMinHeight", Sd = "h-columns-column-row--columnRow__noVerticalPadding", Id = "h-columns-column-row--columnRow__noHorizontalPadding", Dd = "h-columns-column-row--columnRow__borderTop", kd = "h-columns-column-row--columnRow__borderBottom", Td = "h-columns-column-row--columnRow__scrollable", jd = "h-columns-column-row--columnRow__slottable", ze = {
  root: vd,
  noMinHeight: wd,
  noVerticalPadding: Sd,
  noHorizontalPadding: Id,
  borderTop: Dd,
  borderBottom: kd,
  scrollable: Td,
  slottable: jd
}, Nd = 1, Fd = $(function({
  as: e = "div",
  children: t,
  className: n,
  noVerticalPadding: o,
  noHorizontalPadding: r,
  noMinHeight: a,
  borderTop: l,
  borderBottom: c,
  scrollable: d,
  size: h,
  slottable: u,
  style: p,
  ...m
}, g) {
  const b = f(n, ze.root, {
    [ze.slottable]: u,
    [ze.noVerticalPadding]: u ?? o,
    [ze.noHorizontalPadding]: r,
    [ze.borderTop]: l,
    [ze.borderBottom]: c,
    [ze.scrollable]: d,
    [ze.noMinHeight]: a
  });
  return /* @__PURE__ */ s.jsx(
    e,
    {
      ...m,
      ref: g,
      className: b,
      style: {
        ...p,
        flexGrow: h ?? d ? Nd : void 0
      },
      children: t
    }
  );
}), Pd = "h-columns-column-slot--columnSlot__root", Rd = "h-columns-column-slot--columnSlot__noVerticalPadding", _o = {
  root: Pd,
  noVerticalPadding: Rd
}, Ed = ({
  children: i,
  className: e,
  noVerticalPadding: t,
  placement: n = "start"
}) => {
  const o = f(_o.root, e, {
    [_o.noVerticalPadding]: t
  });
  return /* @__PURE__ */ s.jsx(
    W,
    {
      alignItems: "center",
      alignSelf: "stretch",
      justifySelf: n,
      className: o,
      children: i
    }
  );
}, pe = ({
  as: i,
  children: e,
  className: t
}) => /* @__PURE__ */ s.jsx(
  W,
  {
    as: i,
    flexDirection: "column",
    className: f(Cd.root, t),
    children: e
  }
);
pe.Row = Fd;
pe.Slot = Ed;
const Ld = "h-copyToClipboard--copyToClipboard__copyToClipboard", Ad = "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip", Co = {
  copyToClipboard: Ld,
  copyToClipboardTooltip: Ad
};
class $d extends ge {
  timerHandle;
  static defaultProps = {
    tooltip: !0,
    disabled: !1,
    transitionDuration: 2e3,
    clickedProps: {}
  };
  constructor(e) {
    super(e), this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
  }
  componentWillUnmount() {
    this.timerHandle && clearTimeout(this.timerHandle);
  }
  executeCopy(e) {
    const t = document.body;
    if (!e || !document.body)
      return;
    const n = document.createElement("textarea");
    n.value = e, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", t.appendChild(n), n.select(), document.execCommand("copy"), t.removeChild(n);
  }
  handleClick(e) {
    const { disabled: t, textToCopy: n, transitionDuration: o, onClick: r } = this.props;
    t || (typeof r == "function" && r(e), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
      this.timerHandle = setTimeout(() => {
        this.setState({ clicked: !1 });
      }, o);
    }));
  }
  render() {
    const { className: e, children: t, clickedProps: n, tooltip: o } = this.props, { clicked: r } = this.state, a = f(
      Co.copyToClipboard,
      { [Co.copyToClipboardTooltip]: r && o },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { className: a, children: Le.map(t, (l) => Te(l) ? cn(l, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onClick: this.handleClick.bind(this),
      ...r ? n : {}
    }) : l) });
  }
}
class zk extends D {
  render() {
    const { buttonProps: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx($d, { ...t, children: /* @__PURE__ */ s.jsx(K, { icon: "copy", variant: "secondary", ...e }) });
  }
}
const Od = "h-simplePagination--simplePagination__paginationButton", vo = {
  paginationButton: Od
}, Bd = "simplePaginationTestId", Wd = ({
  nextButtonClick: i = L,
  previousButtonClick: e = L,
  nextButtonText: t = "Next page",
  previousButtonText: n = "Previous page",
  nextButtonDisabled: o = !1,
  previousButtonDisabled: r = !1,
  nextButtonHidden: a = !1,
  previousButtonHidden: l = !1,
  nextButtonExtraProps: c,
  previousButtonExtraProps: d,
  loading: h = !1,
  loadingText: u = "Loading...",
  ...p
}) => /* @__PURE__ */ s.jsxs("div", { "data-testid": Bd, ...p, children: [
  !l && /* @__PURE__ */ s.jsx(
    X,
    {
      disabled: r || h,
      onClick: e,
      variant: "secondary",
      ...d,
      className: f(
        vo.paginationButton,
        d?.className
      ),
      children: h ? u : n
    }
  ),
  !a && /* @__PURE__ */ s.jsx(
    X,
    {
      disabled: o || h,
      onClick: i,
      variant: "secondary",
      ...c,
      className: f(
        vo.paginationButton,
        c?.className
      ),
      children: h ? u : t
    }
  )
] }), es = ve(
  void 0
);
var ce = /* @__PURE__ */ ((i) => (i.Foot = "table-foot", i.Body = "table-body", i.Head = "table-head", i.Row = "table-row", i.PaginationRow = "table-pagination-row", i.Td = "table-body-cell", i.Th = "table-header-cell", i.RowExpansionTrigger = "table-row-expansion-trigger", i.LoadingRow = "table-loading-row", i.LoadingFailedRow = "table-loading-failed-row", i.EmptyRow = "table-empty-row", i))(ce || {});
const Hd = "h-table-tfoot--tfoot__root", Md = "h-table-tfoot--tfoot__rootIsLoading", wo = {
  root: Hd,
  rootIsLoading: Md
}, jr = ve(
  void 0
), So = ({ className: i, children: e, ...t }, n) => /* @__PURE__ */ s.jsx(es.Consumer, { children: (o) => o?.status.loading && ["spinner"].includes(o?.loading.loadingStrategy) ? null : /* @__PURE__ */ s.jsx(jr.Provider, { value: { isTableFoot: !0 }, children: /* @__PURE__ */ s.jsx(
  "tfoot",
  {
    ...t,
    ref: n,
    className: f(
      {
        [wo.rootIsLoading]: o?.status.loading
      },
      wo.root,
      i
    ),
    "data-testid": ce.Foot,
    children: e
  }
) }) }), zd = Object.assign($(So), { name: So.name }), Vd = "h-table-thead--thead__root", Kd = "h-table-thead--thead__rootIsLoading", Io = {
  root: Vd,
  rootIsLoading: Kd
}, Nr = ve(
  void 0
), Do = ({ className: i, ...e }, t) => /* @__PURE__ */ s.jsx(es.Consumer, { children: (n) => {
  const o = f(Io.root, i, {
    [Io.rootIsLoading]: n?.status.loading
  });
  return /* @__PURE__ */ s.jsx(Nr.Provider, { value: { isTableHead: !0 }, children: /* @__PURE__ */ s.jsx(
    "thead",
    {
      ...e,
      ref: t,
      className: o,
      "data-testid": ce.Head
    }
  ) });
} }), Ud = Object.assign($(Do), { name: Do.name }), Lt = (i) => {
  const e = He(es);
  if (!e)
    throw new Error(
      "TableContext not accessible. Make sure <TableContextReader> is a child of <Table>"
    );
  const t = He(Nr) || {
    isTableHead: !1
  }, n = He(jr) || {
    isTableFoot: !1
  };
  return i.children({
    ...e,
    ...t,
    ...n
  });
}, qd = "h-table-tableFooter--tableFooter__root", Gd = "h-table-tableFooter--tableFooter__rootIsLoading", ko = {
  root: qd,
  rootIsLoading: Gd
}, To = ({ children: i, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(Lt, { children: ({ status: o }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: n,
    className: f(
      {
        [ko.rootIsLoading]: o.loading
      },
      ko.root,
      e
    ),
    ...t,
    children: i
  }
) }), Gs = Object.assign($(To), {
  name: To.name
});
function Yd(i) {
  return Le.toArray(i).reduce(
    (e, t) => {
      const n = t;
      return n.type === Gs ? e.footers.push(n) : e.children.push(n), e;
    },
    { children: [], footers: [] }
  );
}
var Mn = /* @__PURE__ */ ((i) => (i.PageNumber = "page-number", i.PrevPageButton = "prev-page-button", i.NextPageButton = "next-page-button", i))(Mn || {});
const Qd = "h-pagination--pageNumber__button", Xd = "h-pagination--pageNumber__text", Zd = "h-pagination--pageNumber__textSelected", hs = {
  button: Qd,
  text: Xd,
  textSelected: Zd
}, Jd = ({
  number: i,
  isSelected: e = !1,
  onClick: t
}) => {
  const n = f(hs.text, {
    [hs.textSelected]: e
  });
  return /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
    X,
    {
      styleText: !1,
      variant: "tertiary",
      onClick: () => t(i),
      "data-testid": Mn.PageNumber,
      className: hs.button,
      children: /* @__PURE__ */ s.jsx("span", { className: n, children: i })
    }
  ) });
}, eh = "h-pagination--pagination__root", th = "h-pagination--pagination__pageNumberSeparatorWrapper", jo = {
  root: eh,
  pageNumberSeparatorWrapper: th
};
class nh extends ge {
  static defaultProps = {
    pageRangeDisplayed: 6
  };
  constructor(e) {
    super(e), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
  }
  arePropsValid() {
    const { currentPage: e, pageCount: t, pageRangeDisplayed: n } = this.props, o = (r) => !Number.isNaN(r) && Number.isInteger(r) && r > 0;
    return [e, t, n].every(
      o
    );
  }
  thereIsEnoughPagesToRender() {
    return this.props.pageCount > 1;
  }
  getBoundaries() {
    return {
      canGoToPrevPage: this.props.currentPage > 1,
      canGoToNextPage: this.props.currentPage < this.props.pageCount
    };
  }
  goToPrevPage() {
    this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
  }
  goToNextPage() {
    this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
  }
  handlePageSelect(e) {
    const { currentPage: t, onPageChange: n } = this.props;
    e !== t && n(e);
  }
  areAllPagedDisplayable() {
    const { pageCount: e, pageRangeDisplayed: t } = this.props;
    return t >= e;
  }
  leadingTruncationIsNeeded() {
    const { start: t } = this.calculateMiddlePagesRange();
    return t - 1 > 1;
  }
  trailingTruncationIsNeeded() {
    const { pageCount: e } = this.props, { start: t, length: n } = this.calculateMiddlePagesRange(), o = t - 1 + n;
    return e - o > 1;
  }
  getMiddlePagesLength() {
    const { pageRangeDisplayed: e } = this.props;
    return e - 2;
  }
  calculateMiddlePagesRange(e) {
    const { pageCount: t, currentPage: n } = this.props, o = Math.max(
      this.getMiddlePagesLength() - (e?.extraPadding ?? 0),
      1
    ), r = o % 2 === 0 ? o / 2 - 1 : Math.floor(o / 2);
    return { start: An(
      n - r,
      2,
      t - o
    ), length: o };
  }
  createPageNumbers(e, t = 1) {
    return Array.from({ length: e }, (n, o) => o + t);
  }
  renderPageNumbers(e, t = 1) {
    return this.createPageNumbers(e, t).map(
      (n) => this.renderSinglePageNumber(n)
    );
  }
  renderSinglePageNumber(e) {
    const { currentPage: t } = this.props, n = e === t;
    return /* @__PURE__ */ s.jsx(
      Jd,
      {
        number: e,
        isSelected: n,
        onClick: this.handlePageSelect
      },
      e
    );
  }
  renderAllPages() {
    return this.renderPageNumbers(this.props.pageCount);
  }
  renderGap(e = 0) {
    return /* @__PURE__ */ s.jsx("li", { className: jo.pageNumberSeparatorWrapper, children: /* @__PURE__ */ s.jsx(N, { name: "dots-h" }) }, `gap-${e}`);
  }
  renderLeadingTruncation() {
    return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
  }
  renderTrailingTruncation() {
    const { pageCount: e } = this.props;
    return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(e)] : this.renderSinglePageNumber(e);
  }
  renderMiddlePageNumbers() {
    if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
      const { start: n, length: o } = this.calculateMiddlePagesRange({
        extraPadding: 1
      });
      return this.renderPageNumbers(o, n);
    }
    const { start: e, length: t } = this.calculateMiddlePagesRange();
    return this.renderPageNumbers(t, e);
  }
  renderPages() {
    return this.areAllPagedDisplayable() ? this.renderAllPages() : [
      this.renderLeadingTruncation(),
      this.renderMiddlePageNumbers(),
      this.renderTrailingTruncation()
    ];
  }
  warnAboutBadProps() {
    console.error("Pagination can not render due to bad props", this.props);
  }
  render() {
    const { className: e } = this.props;
    return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ s.jsxs("ul", { className: f(jo.root, e), children: [
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-left",
          variant: "tertiary",
          onClick: this.goToPrevPage,
          disabled: !this.getBoundaries().canGoToPrevPage,
          "data-testid": Mn.PrevPageButton
        }
      ) }),
      this.renderPages(),
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-right",
          variant: "tertiary",
          onClick: this.goToNextPage,
          disabled: !this.getBoundaries().canGoToNextPage,
          "data-testid": Mn.NextPageButton
        }
      ) })
    ] }) : (this.warnAboutBadProps(), null) : null;
  }
}
const No = ({ children: i, ...e }, t) => /* @__PURE__ */ s.jsx(Lt, { children: ({ pagination: n }) => !n.paginated || n.pageCount <= 1 ? null : /* @__PURE__ */ s.jsx(Gs, { children: /* @__PURE__ */ s.jsx("div", { ref: t, ...e, "data-testid": ce.PaginationRow, children: /* @__PURE__ */ s.jsx(W, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
  nh,
  {
    currentPage: n.selectedPage,
    pageCount: n.pageCount,
    onPageChange: n.onPageChange,
    pageRangeDisplayed: n.pageRangeDisplayed
  }
) }) }) }) }), sh = Object.assign($(No), {
  name: No.name
}), oh = "h-table-tbody--tbody__root", rh = "h-table-tbody--tbody__rootIsLoading", ih = "h-table-tbody--tbody__rootIsLoadingFade", us = {
  root: oh,
  rootIsLoading: rh,
  rootIsLoadingFade: ih
}, ah = "h-emptyState--emptyState__textWrapper", lh = "h-emptyState--emptyState__rootSmall", ch = "h-emptyState--emptyState__rootLarge", ps = {
  textWrapper: ah,
  rootSmall: lh,
  rootLarge: ch
}, dh = ({
  className: i,
  title: e,
  description: t,
  icon: n = "info",
  iconColor: o = "neutral.500",
  size: r = "large",
  buttonProps: a
}) => {
  const l = f(
    {
      [ps.rootSmall]: r === "small",
      [ps.rootLarge]: r === "large"
    },
    i
  );
  return /* @__PURE__ */ s.jsxs(
    W,
    {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      className: l,
      children: [
        n && /* @__PURE__ */ s.jsx(N, { name: n, size: 20, color: sn(o) }),
        /* @__PURE__ */ s.jsxs(
          W,
          {
            flexDirection: "column",
            alignItems: "center",
            gap: "100",
            className: ps.textWrapper,
            children: [
              /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", children: e }),
              /* @__PURE__ */ s.jsx(
                A.Paragraph,
                {
                  variant: "2",
                  as: typeof t == "string" ? "p" : "div",
                  children: t
                }
              )
            ]
          }
        ),
        a?.children && /* @__PURE__ */ s.jsx(X, { ...a })
      ]
    }
  );
};
function hh(i) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ce.EmptyRow, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsx(W, { justifyContent: "center", alignItems: "center", padding: "500", children: /* @__PURE__ */ s.jsx(dh, { ...i }) }) }) });
}
function uh({
  onRetry: i,
  ...e
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ce.LoadingFailedRow, ...e, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    W,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong..." }),
        i && /* @__PURE__ */ s.jsx(X, { variant: "tertiary", onClick: i, children: "Try again" })
      ]
    }
  ) }) });
}
function ph({
  ...i
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ce.LoadingRow, ...i, children: /* @__PURE__ */ s.jsx("td", { align: "center", colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    W,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(Gn, {}),
        /* @__PURE__ */ s.jsx(ie, { margin: "300", children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Loading..." }) })
      ]
    }
  ) }) });
}
const Fo = ({ children: i, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(Lt, { children: ({
  status: { loading: o, loadingFailed: r, onLoadingRetry: a, emptyState: l },
  loading: { loadingStrategy: c }
}) => {
  const d = r && !o, h = ["spinner"].includes(c) ? !o && !d : !d;
  return /* @__PURE__ */ s.jsxs(
    "tbody",
    {
      ...t,
      "data-testid": ce.Body,
      ref: n,
      className: f(
        {
          [us.rootIsLoading]: o,
          [us.rootIsLoadingFade]: o && c === "fade"
        },
        us.root,
        e
      ),
      children: [
        c === "spinner" && o && /* @__PURE__ */ s.jsx(ph, {}),
        d && /* @__PURE__ */ s.jsx(uh, { onRetry: a }),
        l && /* @__PURE__ */ s.jsx(hh, { ...l }),
        h && i
      ]
    }
  );
} }), mh = Object.assign($(Fo), { name: Fo.name }), gh = "h-table-td--td__root", fh = "h-table-td--td__rootExtraPaddingForFirstChild", bh = "h-table-td--td__rootStickyFooterTd", ms = {
  root: gh,
  rootExtraPaddingForFirstChild: fh,
  rootStickyFooterTd: bh
}, Po = ({ className: i, children: e, ...t }, n) => /* @__PURE__ */ s.jsx(Lt, { children: ({ rows: o, presentation: r, isTableFoot: a }) => {
  const l = f(
    ms.root,
    {
      [ms.rootExtraPaddingForFirstChild]: !o.expandableRows,
      [ms.rootStickyFooterTd]: r.stickyFooter === !0 && a === !0
    },
    i
  );
  return /* @__PURE__ */ s.jsx(
    ie,
    {
      as: "td",
      ref: n,
      className: l,
      ...t,
      "data-testid": ce.Td,
      children: e
    }
  );
} }), at = Object.assign($(Po), { name: Po.name }), xh = "h-table-th--th__root", yh = "h-table-th--th__rootSticky", _h = "h-table-th--th__rootShowBG", Ch = "h-table-th--th__rootClickable", vh = "h-table-th--th__icon", wh = "h-table-th--th__contentWrapper", Sh = "h-table-th--th__tooltip", nt = {
  root: xh,
  rootSticky: yh,
  rootShowBG: _h,
  rootClickable: Ch,
  icon: vh,
  contentWrapper: wh,
  tooltip: Sh
};
class Ro extends D {
  context = void 0;
  columnIsInSortableColumns() {
    return this.context?.sorting.sortableColumns?.some(
      (e) => e === this.props.columnId
    ) ?? !0;
  }
  getContextualInfo() {
    const { columnId: e } = this.props, { context: t } = this;
    return {
      sortByThisColumn: t?.sorting.sortStatus?.sortBy === e,
      sortDirection: t?.sorting.sortStatus?.direction,
      columnIsSortable: t?.sorting.sortable && !Ce(e) ? this.columnIsInSortableColumns() : !1
    };
  }
  getTheNewSortDirection(e) {
    const { sortByThisColumn: t, sortDirection: n } = this.getContextualInfo(), o = {
      sortBy: e,
      direction: "asc"
    };
    if (!t)
      return o;
    switch (n) {
      // not sorted => make it asc
      case void 0:
        return o;
      // desc sorted => not sorted
      case "desc":
        return null;
      // asc sorted => make it desc
      case "asc":
        return {
          sortBy: e,
          direction: "desc"
        };
      default:
        return o;
    }
  }
  getClickHandler() {
    const { onClick: e } = this.props, { context: t } = this;
    return (n) => {
      const { columnIsSortable: o } = this.getContextualInfo(), { columnId: r } = this.props;
      e?.(n), o && !Ce(r) && t?.sorting.onSortChange(this.getTheNewSortDirection(r));
    };
  }
  renderIcon(e) {
    return e ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: nt.icon,
        name: e === "asc" ? "sort-up" : "sort-down"
      }
    ) : null;
  }
  warnAboutNoColumnIdProps() {
    console.error(`
      <Table.Th> needs a 'columnId' prop when table is sortable.
      Pass 'columndId: null' prop if you want that column not to be sortable.
    `);
  }
  render() {
    return /* @__PURE__ */ s.jsx(Lt, { children: (e) => {
      this.context = e;
      const { sorting: t, presentation: n } = e;
      t.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
      const {
        className: o,
        children: r,
        tooltip: a,
        columnId: l,
        thRef: c,
        ...d
      } = this.props, { sortByThisColumn: h, columnIsSortable: u, sortDirection: p } = this.getContextualInfo(), m = f(
        nt.root,
        {
          [nt.rootClickable]: u,
          [nt.rootSticky]: n.stickyHeader,
          [nt.rootShowBG]: n.headerWithBackground
        },
        o
      ), g = f({
        [nt.tooltip]: a
      });
      return /* @__PURE__ */ s.jsx(
        ie,
        {
          as: "th",
          ...d,
          ref: c,
          className: m,
          onClick: this.getClickHandler(),
          "data-testid": ce.Th,
          children: /* @__PURE__ */ s.jsxs("span", { className: nt.contentWrapper, children: [
            /* @__PURE__ */ s.jsx(se, { content: a, disabled: !a, children: /* @__PURE__ */ s.jsx("span", { className: g, children: r }) }),
            h && this.renderIcon(p)
          ] })
        }
      );
    } });
  }
}
const Rs = Object.assign(
  $(
    function(e, t) {
      return /* @__PURE__ */ s.jsx(Ro, { ...e, thRef: t });
    }
  ),
  { name: Ro.name }
), Ih = (i) => i === !1, Dh = "h-table-tr--tr__trHoverable", kh = "h-table-tr--tr__expansionTriggerWrapper", Th = "h-table-tr--tr__expansionTriggerWrapperExpanded", jh = "h-table-tr--tr__checkboxCell", Nh = "h-table-tr--tr__checkboxCellExpanded", Fh = "h-table-tr--tr__expandedRowContentWrapper", De = {
  trHoverable: Dh,
  expansionTriggerWrapper: kh,
  expansionTriggerWrapperExpanded: Th,
  checkboxCell: jh,
  checkboxCellExpanded: Nh,
  expandedRowContentWrapper: Fh
}, Ph = ({
  rowId: i,
  isExpandable: e,
  isExpanded: t,
  onExpansionToggle: n,
  expandableContent: o,
  isSelectable: r,
  isSelected: a,
  onSelect: l,
  isHoverable: c,
  children: d,
  trRef: h,
  ...u
}) => {
  const p = f(u.className, {
    [De.trHoverable]: c
  }) || void 0;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "tr",
      {
        ...u,
        ref: h,
        className: p,
        "data-testid": ce.Row,
        children: [
          e && /* @__PURE__ */ s.jsx(
            at,
            {
              className: f(De.expansionTriggerWrapper, {
                [De.expansionTriggerWrapperExpanded]: t
              }),
              children: o && /* @__PURE__ */ s.jsx(
                K,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right",
                  "data-testid": ce.RowExpansionTrigger,
                  onClick: () => {
                    Ce(i) || n(i);
                  }
                }
              )
            }
          ),
          r && /* @__PURE__ */ s.jsx(
            at,
            {
              className: f(De.checkboxCell, {
                [De.checkboxCellExpanded]: t
              }),
              children: /* @__PURE__ */ s.jsx(W, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
                hn,
                {
                  checked: a,
                  name: `selection-trigger-${i}`,
                  id: `selection-trigger-${i}`,
                  onChange: () => {
                    Ce(i) || l(i);
                  }
                }
              ) })
            }
          ),
          d
        ]
      }
    ),
    e && t && /* @__PURE__ */ s.jsxs("tr", { "data-testid": ce.Row, children: [
      /* @__PURE__ */ s.jsx(at, { className: De.expansionTriggerWrapper }),
      r && /* @__PURE__ */ s.jsx(at, { className: De.checkboxCell }),
      /* @__PURE__ */ s.jsx(
        at,
        {
          colSpan: Number.MAX_SAFE_INTEGER,
          className: De.expandedRowContentWrapper,
          children: o
        }
      )
    ] })
  ] });
}, Rh = ({
  isExpandable: i,
  children: e,
  trRef: t,
  ...n
}) => /* @__PURE__ */ s.jsxs("tr", { ...n, ref: t, "data-testid": ce.Row, children: [
  i && /* @__PURE__ */ s.jsx(at, { className: De.expansionTriggerWrapper, children: /* @__PURE__ */ s.jsx("span", {}) }),
  e
] }), Eh = ({
  isExpandable: i,
  isSelectable: e,
  allRowsSelected: t,
  allRowsSelectedIndeterminate: n,
  onAllRowsSelect: o,
  children: r,
  trRef: a,
  ...l
}) => /* @__PURE__ */ s.jsxs("tr", { ...l, ref: a, "data-testid": ce.Row, children: [
  i && /* @__PURE__ */ s.jsx(Rs, { className: De.expansionTriggerWrapper, columnId: null, children: /* @__PURE__ */ s.jsx("span", {}) }),
  e && /* @__PURE__ */ s.jsx(Rs, { className: De.checkboxCell, columnId: null, children: /* @__PURE__ */ s.jsx(W, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
    hn,
    {
      checked: t,
      indeterminate: n,
      onChange: o,
      name: "all-rows-selector",
      id: "all-rows-selector"
    }
  ) }) }),
  r
] });
class Eo extends D {
  context = void 0;
  isRowExpanded(e, t) {
    return e.includes(t);
  }
  hasSelectableRow() {
    const { rowId: e } = this.props;
    return this.context?.rows.selectableRows === !0 && !Ce(e);
  }
  hasExpandableRow() {
    const { expandableContent: e, rowId: t } = this.props;
    return this.context?.rows.expandableRows === !0 && !Ce(e) && !Ce(t);
  }
  shouldRenderRegularTr() {
    return [this.hasExpandableRow(), this.hasSelectableRow()].every(Ih);
  }
  rowIdIsPresent(e) {
    return !Ce(e);
  }
  render() {
    const { children: e, expandableContent: t, rowId: n, ...o } = this.props;
    return /* @__PURE__ */ s.jsx(Lt, { children: (r) => {
      this.context = r;
      const { rows: a } = r;
      if (r.isTableHead)
        return /* @__PURE__ */ s.jsx(
          Eh,
          {
            ...o,
            isExpandable: a.expandableRows,
            isSelectable: a.selectableRows,
            allRowsSelected: a.allRowsSelected,
            allRowsSelectedIndeterminate: a.allRowsSelectedIndeterminate,
            onAllRowsSelect: a.onAllRowsSelect,
            children: e
          }
        );
      if (r.isTableFoot)
        return /* @__PURE__ */ s.jsx(Rh, { ...o, isExpandable: a.expandableRows, children: e });
      const l = Ce(n) ? !1 : this.isRowExpanded(a.expandedRows, n), c = Ce(n) ? !1 : a.selectedRowIds.includes(n);
      return /* @__PURE__ */ s.jsx(
        Ph,
        {
          ...o,
          rowId: n,
          isExpanded: l,
          isSelected: c,
          onSelect: a.onRowSelect,
          isExpandable: a.expandableRows,
          expandableContent: t,
          isSelectable: a.selectableRows,
          onExpansionToggle: a.onExpansionToggle,
          isHoverable: r.presentation.hoverable,
          children: e
        }
      );
    } });
  }
}
const Lh = Object.assign(
  $(function(e, t) {
    return /* @__PURE__ */ s.jsx(Eo, { ...e, trRef: t });
  }),
  { name: Eo.name }
), Ah = "h-table--table__wrapper", $h = "h-table--table__wrapperIsFramed", Oh = "h-table--table__wrapperIsLoading", Bh = "h-table--table__innerWrapper", Wh = "h-table--table__wrapperIsDisabled", Hh = "h-table--table__table", gt = {
  wrapper: Ah,
  wrapperIsFramed: $h,
  wrapperIsLoading: Oh,
  innerWrapper: Bh,
  wrapperIsDisabled: Wh,
  table: Hh
};
class zn extends D {
  static defaultProps = {
    headerWithBackground: !0,
    stickyHeader: !1,
    stickyFooter: !1,
    framed: !0,
    hoverable: !1,
    loadingStrategy: "spinner"
  };
  constructor(e) {
    super(e), this.state = {
      expandedRows: e.expandableRowsProps?.initiallyExpandedRows ?? []
    }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }
  static fallback = /* @__PURE__ */ s.jsx(
    W,
    {
      justifyContent: "center",
      alignItems: "center",
      style: { minHeight: "10vh" },
      children: /* @__PURE__ */ s.jsx(A.Paragraph, { children: "Oops! something went wrong..." })
    }
  );
  handleExpansionToggle(e) {
    this.state.expandedRows.includes(e) ? this.setState(({ expandedRows: t }) => ({
      expandedRows: t.filter((n) => n !== e)
    })) : this.setState(({ expandedRows: t }) => ({
      expandedRows: [...t, e]
    }));
  }
  getContextValue() {
    const {
      props: {
        headerWithBackground: e,
        stickyHeader: t,
        stickyFooter: n,
        sortingProps: o,
        paginationProps: r,
        selectableRowsProps: a,
        expandableRowsProps: l,
        loading: c,
        loadingFailed: d,
        onLoadingRetry: h,
        emptyState: u,
        loadingStrategy: p,
        hoverable: m
      }
    } = this;
    return {
      status: {
        loading: c ?? !1,
        loadingFailed: d ?? !1,
        onLoadingRetry: h,
        emptyState: u
      },
      presentation: {
        headerWithBackground: !!e,
        stickyHeader: !!t,
        stickyFooter: !!n,
        hoverable: !!m
      },
      sorting: {
        sortable: !!o,
        sortableColumns: o?.sortableColumns,
        sortStatus: o?.sortStatus ?? null,
        onSortChange: o?.onSortChange ?? L
      },
      pagination: {
        paginated: !!r,
        selectedPage: r?.selectedPage ?? 1,
        pageCount: r?.pageCount ?? 1,
        onPageChange: r?.onPageChange ?? L,
        pageRangeDisplayed: r?.pageRangeDisplayed
      },
      rows: {
        expandableRows: l?.expandableRows ?? !1,
        expandedRows: this.state.expandedRows,
        onExpansionToggle: this.handleExpansionToggle,
        selectableRows: !!a,
        selectedRowIds: a?.selectedRowIds ?? [],
        onRowSelect: a?.onRowSelect ?? L,
        onAllRowsSelect: a?.onAllRowsSelect ?? L,
        allRowsSelected: a?.allRowsSelected ?? !1,
        allRowsSelectedIndeterminate: a?.allRowsSelectedIndeterminate ?? !1
      },
      loading: {
        loadingStrategy: p ?? "spinner"
      }
    };
  }
  render() {
    const {
      framed: e,
      className: t,
      children: n,
      wrapperProps: o,
      wrapperRef: r,
      innerWrapperClassName: a,
      nativeProps: l,
      tableRef: c
    } = this.props, d = Yd(n), h = f(gt.wrapper, o?.className, {
      [gt.wrapperIsFramed]: e,
      [gt.wrapperIsLoading]: this.props.loading,
      [gt.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
    }), u = f(
      {
        [gt.innerWrapper]: !0
      },
      a
    ), p = f(gt.table, t), m = this.getContextValue();
    return /* @__PURE__ */ s.jsx(Rt, { fallback: zn.fallback, children: /* @__PURE__ */ s.jsx(es.Provider, { value: m, children: /* @__PURE__ */ s.jsxs("div", { ...o, className: h, children: [
      /* @__PURE__ */ s.jsx("div", { className: u, ref: r, children: /* @__PURE__ */ s.jsx("table", { ...l, ref: c, className: p, children: d.children }) }),
      m.pagination.paginated && /* @__PURE__ */ s.jsx(sh, {}),
      !m.pagination.paginated && d.footers
    ] }) }) });
  }
}
const me = Object.assign(
  $(
    function(e, t) {
      return /* @__PURE__ */ s.jsx(zn, { ...e, tableRef: t });
    }
  ),
  {
    name: zn.name,
    Thead: Ud,
    Tbody: mh,
    Tfoot: zd,
    Tr: Lh,
    Th: Rs,
    Td: at,
    Footer: Gs
  }
), Mh = "h-helpIcon--helpIcon__infoIcon", zh = {
  infoIcon: Mh
};
class Ys extends D {
  render() {
    const {
      side: e,
      text: t,
      title: n,
      disabled: o,
      requireClick: r,
      className: a,
      alwaysShow: l,
      tooltipClassName: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      se,
      {
        head: n,
        content: t,
        disabled: o,
        side: e,
        requireClick: r,
        alwaysShow: l,
        className: c,
        wrap: "none",
        ...d,
        children: /* @__PURE__ */ s.jsx("span", { className: f(zh.infoIcon, a), children: /* @__PURE__ */ s.jsx(N, { name: "info" }) })
      }
    );
  }
}
const Fr = ({
  columns: i
}) => /* @__PURE__ */ s.jsx(s.Fragment, { children: i.map(({ label: e, style: t, helpIcon: n, columnId: o }, r) => /* @__PURE__ */ s.jsxs(me.Th, { columnId: o || e, style: t, children: [
  e,
  n?.title && n?.text && /* @__PURE__ */ s.jsx(Ys, { side: "bottom", ...n })
] }, e || r)) }), Vh = ({
  columns: i,
  data: e
}) => /* @__PURE__ */ s.jsxs(me, { headerWithBackground: !1, framed: !1, children: [
  /* @__PURE__ */ s.jsx(me.Thead, { children: /* @__PURE__ */ s.jsx(me.Tr, { children: /* @__PURE__ */ s.jsx(Fr, { columns: i }) }) }),
  /* @__PURE__ */ s.jsx(me.Tbody, { children: e.map((t, n) => /* @__PURE__ */ s.jsx(me.Tr, { children: i.map(({ selector: o }, r) => /* @__PURE__ */ s.jsx(me.Td, { children: o(t) }, r)) }, n)) })
] }), Kh = ({
  data: i,
  rowId: e,
  columns: t,
  subTableColumns: n,
  subTableDataSelector: o
}) => /* @__PURE__ */ s.jsx(
  me.Tr,
  {
    expandableContent: !!(n && o) && /* @__PURE__ */ s.jsx(
      Vh,
      {
        data: o(i),
        columns: n
      }
    ),
    rowId: e,
    children: t.map(({ selector: r }, a) => /* @__PURE__ */ s.jsx(me.Td, { children: r(i) }, a))
  }
), Vk = ({
  columns: i,
  subTableColumns: e,
  data: t,
  subTableDataSelector: n,
  tableWrapperProps: o,
  tableInnerWrapperClassName: r,
  paginationProps: a,
  sortingProps: l,
  selectableRowsProps: c,
  tableStyleProps: d,
  tableStatusProps: h,
  tableRowIdSelector: u,
  tableLoadingStrategy: p,
  tableWrapperRef: m
}) => {
  const g = i.filter((b) => b.sortable).reduce(
    (b, x) => x.columnId ? [...b, x.columnId] : b,
    []
  );
  return g.length && l && (l.sortableColumns = g), /* @__PURE__ */ s.jsxs(
    me,
    {
      stickyHeader: !0,
      wrapperProps: o,
      innerWrapperClassName: r,
      expandableRowsProps: {
        expandableRows: !!(e && n)
      },
      sortingProps: l,
      selectableRowsProps: c,
      loadingStrategy: p,
      wrapperRef: m,
      ...d,
      ...h,
      children: [
        /* @__PURE__ */ s.jsx(me.Thead, { children: /* @__PURE__ */ s.jsx(me.Tr, { children: /* @__PURE__ */ s.jsx(Fr, { columns: i }) }) }),
        /* @__PURE__ */ s.jsx(me.Tbody, { children: t.map((b, x) => /* @__PURE__ */ s.jsx(
          Kh,
          {
            rowId: u ? u(b) : x,
            data: b,
            columns: i,
            subTableDataSelector: n,
            subTableColumns: e
          },
          x
        )) }),
        a && /* @__PURE__ */ s.jsx(me.Footer, { children: /* @__PURE__ */ s.jsx(Wd, { ...a }) })
      ]
    }
  );
}, Uh = "h-datePickerOld--datePickerDay__root", qh = "h-datePickerOld--datePickerDay__rootActive", Gh = "h-datePickerOld--datePickerDay__rootDisabled", Yh = "h-datePickerOld--datePickerDay__rootDim", Qh = "h-datePickerOld--datePickerDay__label", Ht = {
  root: Uh,
  rootActive: qh,
  rootDisabled: Gh,
  rootDim: Yh,
  label: Qh
};
class Xh extends D {
  render() {
    const {
      className: e,
      dim: t,
      active: n,
      disabled: o,
      children: r,
      onClick: a,
      ...l
    } = this.props, c = f(
      {
        [Ht.root]: !0,
        [Ht.rootDim]: t,
        [Ht.rootActive]: n,
        [Ht.rootDisabled]: !n && o
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...l,
        onClick: a,
        className: c,
        disabled: o,
        children: /* @__PURE__ */ s.jsx("span", { className: Ht.label, children: r })
      }
    );
  }
}
const Zh = "h-datePickerOld--datePickerOld__grid", Jh = "h-datePickerOld--datePickerOld__gridItem", eu = "h-datePickerOld--datePickerOld__day", tu = "h-datePickerOld--datePickerOld__month", nu = "h-datePickerOld--datePickerOld__timeButtonContainerLeft", su = "h-datePickerOld--datePickerOld__timeButtonContainerRight", ou = "h-datePickerOld--datePickerOld__arrowTime", ru = "h-datePickerOld--datePickerOld__arrow", iu = "h-datePickerOld--datePickerOld__dayNames", au = "h-datePickerOld--datePickerOld__dayName", lu = "h-datePickerOld--datePickerOld__time", cu = "h-datePickerOld--datePickerOld__timeDisplay", Q = {
  grid: Zh,
  gridItem: Jh,
  day: eu,
  month: tu,
  timeButtonContainerLeft: nu,
  timeButtonContainerRight: su,
  arrowTime: ou,
  arrow: ru,
  dayNames: iu,
  dayName: au,
  time: lu,
  timeDisplay: cu
}, Kk = (i) => [0, 6].indexOf(i.getDay()) !== -1;
class tn extends D {
  static defaultProps;
  static getDateValue(e) {
    const t = e.value instanceof Date ? e.value : /* @__PURE__ */ new Date();
    return new Date(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes()
    );
  }
  constructor(e) {
    super(e);
    const t = tn.getDateValue(e.input);
    this.state = {
      selectedDate: t,
      showDate: t
    };
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(e) {
    const { input: t } = this.props;
    e.input !== t && this.setState({
      selectedDate: tn.getDateValue(e.input)
    });
  }
  generateGrid() {
    const { selectedDate: e, showDate: t } = this.state, { input: n, disabled: o, minDate: r, maxDate: a } = this.props, l = [], c = new Date(
      t.getFullYear(),
      t.getMonth(),
      1,
      e.getHours(),
      e.getMinutes()
    ), d = c.getDay() || 7, h = new Date(
      c.getFullYear(),
      c.getMonth() + 1,
      1
    );
    d < 3 && c.setDate(c.getDate() - 7), c.setDate(c.getDate() - (d - 1));
    const u = tn.getDateValue(n).getTime();
    let p = 0;
    for (; c < h || c.getDay() !== 1 || p < 6; ) {
      const m = c.getTime(), g = new Date(m);
      l.push({
        date: g,
        label: c.getDate().toString(),
        isThisMonth: c.getMonth() === t.getMonth(),
        selected: m === u,
        disabled: o(c) || !!(a && g > a) || !!(r && g < r)
      }), c.getDay() === 1 && (p += 1), c.setDate(c.getDate() + 1);
    }
    return l;
  }
  goToMonth(e) {
    const { showDate: t } = this.state, n = new Date(t.getTime());
    n.setMonth(t.getMonth() + e), this.setState({
      showDate: n
    });
  }
  nextMonth = (e) => {
    e.preventDefault(), this.goToMonth(1);
  };
  prevMonth = (e) => {
    e.preventDefault(), this.goToMonth(-1);
  };
  handleDateClick(e, t) {
    e.preventDefault();
    const {
      input: { onChange: n }
    } = this.props, { showDate: o } = this.state, r = {
      ...this.state,
      selectedDate: t
    };
    o.getMonth() !== t.getMonth() && (r.showDate = t), this.setState(r), n(t);
  }
  goToTime(e, t, n = "hours") {
    const o = n === "minutes" ? "setMinutes" : "setHours", r = n === "minutes" ? "getMinutes" : "getHours", {
      input: { onChange: a }
    } = this.props, { selectedDate: l } = this.state, c = new Date(l.getTime());
    c[o](c[r]() + t), this.setState({
      selectedDate: c
    }), a(c);
  }
  nextMinutes = (e) => {
    e.preventDefault(), this.goToTime(e, 15, "minutes");
  };
  prevMinutes = (e) => {
    e.preventDefault(), this.goToTime(e, -15, "minutes");
  };
  nextHour = (e) => {
    e.preventDefault(), this.goToTime(e, 1);
  };
  prevHour = (e) => {
    e.preventDefault(), this.goToTime(e, -1);
  };
  canGoPrevMonth() {
    const { minDate: e } = this.props, { showDate: t } = this.state;
    if (e === null) return !0;
    const n = new Date(
      t.getFullYear(),
      t.getMonth(),
      1
    );
    return e < n;
  }
  canGoNextMonth() {
    const { maxDate: e } = this.props, { showDate: t } = this.state;
    if (e === null) return !0;
    const n = new Date(
      t.getFullYear(),
      t.getMonth() + 1,
      1,
      0,
      0,
      0,
      -1
    );
    return e > n;
  }
  canGoDirection(e = "hours", t) {
    const n = e === "minutes" ? "setMinutes" : "setHours", o = e === "minutes" ? "getMinutes" : "getHours", { maxDate: r } = this.props, { selectedDate: a } = this.state, l = new Date(a.getTime());
    return l[n](l[o]() + t), !(l.getDate() !== a.getDate()) && (r === null || r >= l);
  }
  render() {
    const {
      className: e,
      input: t,
      hasTime: n,
      disabled: o,
      minDate: r,
      maxDate: a,
      ...l
    } = this.props, { selectedDate: c, showDate: d } = this.state, h = f({}, e), u = this.generateGrid(), p = {
      month: "long",
      year: "numeric"
    };
    let m = null;
    try {
      m = d.toLocaleDateString("en-US", p);
    } catch (g) {
      m = `${d.getMonth() + 1} / ${d.getFullYear()}`, console.warn("toLocaleDateString exception", g);
    }
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsxs("div", { className: Q.month, children: [
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: Q.arrow,
            disabled: !this.canGoPrevMonth(),
            onClick: this.prevMonth,
            "aria-label": "Previous month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
          }
        ),
        m,
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: Q.arrow,
            disabled: !this.canGoNextMonth(),
            onClick: this.nextMonth,
            "aria-label": "Next month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: Q.dayNames, children: [
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Mon" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Tue" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Wed" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Thu" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Fri" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Sat" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Sun" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: Q.grid, children: u.map((g) => /* @__PURE__ */ s.jsx("div", { className: Q.gridItem, children: /* @__PURE__ */ s.jsx(
        Xh,
        {
          onClick: (b) => this.handleDateClick(b, g.date),
          dim: !g.isThisMonth,
          active: g.selected,
          disabled: g.disabled,
          className: Q.day,
          children: g.label
        }
      ) }, g.date.getTime())) }),
      n && /* @__PURE__ */ s.jsxs("div", { className: Q.time, children: [
        /* @__PURE__ */ s.jsxs("div", { className: Q.timeButtonContainerLeft, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("hours", -1),
              onClick: this.prevHour,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-left", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("minutes", -15),
              onClick: this.prevMinutes,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: Q.timeDisplay, children: `${uo(
          c.getHours().toString(),
          2,
          "0"
        )}:${uo(c.getMinutes().toString(), 2, "0")}` }),
        /* @__PURE__ */ s.jsxs("div", { className: Q.timeButtonContainerRight, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("minutes", 15),
              onClick: this.nextMinutes,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("hours", 1),
              onClick: this.nextHour,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-right", className: "icon-vertical-fix" })
            }
          )
        ] })
      ] })
    ] });
  }
}
tn.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: () => !1,
  minDate: null,
  maxDate: null,
  hasTime: !1
};
function du(i) {
  return Math.abs(i.diff(j())) < 25e3 ? "just now" : i.fromNow();
}
function Es(i) {
  return j(i, j.ISO_8601).isValid();
}
function Tt(i) {
  return !!j.tz.zone(i ?? "");
}
const Re = "HH:mm", Pr = _r(24), Rr = _r(0, 60, 15), Er = (i) => j("1995-12-25").format(i);
function Lr(i) {
  if (i < 0 || i > 23)
    throw new Error("Hour must be between 0 and 23.");
}
function Ar(i) {
  if (i < 0 || i > 59)
    throw new Error("Minute must be between 0 and 59.");
}
function $r({
  hour: i,
  minute: e,
  timeFormat: t
}) {
  const n = j({ hour: i, minute: e });
  return {
    id: n.format(Re),
    name: n.format(t)
  };
}
function hu(i, e) {
  return e?.map(({ hour: t, minute: n }) => (Lr(t), Ar(n), $r({ hour: t, minute: n, timeFormat: i }))) || [];
}
function Or({
  hours: i,
  minutes: e,
  overrides: t,
  timeFormat: n
}) {
  return ji(
    i.reduce(
      (o, r, a) => [
        ...o,
        ...e.map((l, c) => (c === 0 && Lr(r), a === 0 && Ar(l), $r({ hour: r, minute: l, timeFormat: n })))
      ],
      []
    ).concat(hu(n, t)),
    ["id"]
  );
}
const uu = "h-datePicker--datePicker__root", pu = "h-datePicker--datePicker__navigationButton", mu = "h-datePicker--datePicker__nextMonthButton", gu = "h-datePicker--datePicker__prevMonthButton", kt = {
  root: uu,
  navigationButton: pu,
  nextMonthButton: mu,
  prevMonthButton: gu
}, Vn = {
  previousMonth({ ariaLabel: i, ...e }) {
    const t = f(
      kt.navigationButton,
      kt.prevMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: t, children: /* @__PURE__ */ s.jsx(N, { ...e, "aria-label": i, size: 24, name: "angle-left" }) });
  },
  nextMonth({ ariaLabel: i, ...e }) {
    const t = f(
      kt.navigationButton,
      kt.nextMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: t, children: /* @__PURE__ */ s.jsx(N, { ...e, "aria-label": i, size: 24, name: "angle-right" }) });
  }
}, Br = (i) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx("span", { className: "date-number-container", children: i.date() }),
  /* @__PURE__ */ s.jsx("span", { className: "day-complimentary-highlight" })
] }), Wr = ({ month: i }) => /* @__PURE__ */ s.jsx("span", { children: i.format("MMMM YYYY") }), Hr = (i) => {
  const { value: e, presets: t, onSelect: n } = i, o = P(
    (r) => {
      n(r.key === e ? null : r);
    },
    [n, e]
  );
  return /* @__PURE__ */ s.jsxs(Ze, { children: [
    /* @__PURE__ */ s.jsx(Qn, { orientation: "vertical" }),
    /* @__PURE__ */ s.jsx(bo, { children: t.map((r) => /* @__PURE__ */ s.jsx(
      bo.Item,
      {
        isSelected: r.key === e,
        onClick: () => o(r),
        children: r.label
      },
      r.key
    )) })
  ] });
}, fu = "h-fieldLabel--fieldLabel__root", bu = "h-fieldLabel--fieldLabel__label", xu = "h-fieldLabel--fieldLabel__labelChildren", yu = "h-fieldLabel--fieldLabel__rootRequired", _u = "h-fieldLabel--fieldLabel__helpIcon", Mt = {
  root: fu,
  label: bu,
  labelChildren: xu,
  rootRequired: yu,
  helpIcon: _u
}, Cu = "fieldLabel";
class Qs extends D {
  render() {
    const { required: e, helpIcon: t, className: n, children: o, ...r } = this.props, a = f(Mt.root, n, {
      [Mt.rootRequired]: e
    });
    return /* @__PURE__ */ s.jsxs("div", { className: a, "data-testid": Cu, children: [
      /* @__PURE__ */ s.jsx("label", { className: Mt.label, ...r, children: /* @__PURE__ */ s.jsx("div", { className: Mt.labelChildren, children: o }) }),
      !!t?.text && /* @__PURE__ */ s.jsx(
        Ys,
        {
          ...t,
          className: f(Mt.helpIcon, t.className)
        }
      )
    ] });
  }
}
const vu = "h-dropdownSelect--dropdownInfinite__item", wu = "h-dropdownSelect--dropdownInfinite__list", Lo = {
  item: vu,
  list: wu
};
class Ao extends D {
  render() {
    const {
      item: e,
      itemComponent: t,
      tooltip: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      checked: c,
      disabled: d,
      isLoading: h,
      active: u,
      id: p
    } = this.props, m = /* @__PURE__ */ s.jsx(
      t,
      {
        item: e,
        onSelect: o,
        onChange: r,
        onKeyDown: a,
        clearSearch: l,
        checked: c,
        disabled: d,
        isLoading: h,
        active: u,
        tabIndex: u ? 0 : -1,
        id: p,
        role: "option",
        "aria-disabled": d,
        "aria-selected": c
      }
    );
    return n ? /* @__PURE__ */ s.jsx(se, { ...n, children: m }, e.id) : m;
  }
}
const Su = 6, Iu = 48;
class Xs extends D {
  listRef;
  infiniteListRef;
  static defaultProps = {
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  constructor(e) {
    super(e), this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = B(), this.infiniteListRef = B();
  }
  componentDidUpdate(e) {
    const { activeItem: t, items: n, pagination: o } = this.props, r = typeof e.activeItem == "object" && e.activeItem ? e.activeItem.id : e.activeItem, a = typeof t == "object" && t ? t.id : t;
    if (r !== a && a !== null) {
      const l = n.findIndex(
        (c) => c.id === a
      );
      if (l >= 0) {
        if (typeof o == "object" && o.infinite && this.infiniteListRef.current)
          this.infiniteListRef.current.scrollToItem(l, "smart");
        else if (this.listRef.current) {
          const c = this.listRef.current.children[l];
          c && c.scrollIntoView({ block: "nearest" });
        }
      }
    }
  }
  isItemLoaded(e) {
    const { items: t } = this.props;
    return e < t.length;
  }
  isItemActive(e) {
    if (!e) return !1;
    const { activeItem: t } = this.props;
    return t ? typeof t == "object" && "id" in t ? e.id === t.id : e.id === t : !1;
  }
  isItemChecked(e) {
    if (!e) return !1;
    const { selectedItems: t } = this.props;
    return (t?.findIndex((o) => typeof o == "object" ? o.id === e.id : o === e.id) ?? -1) > -1;
  }
  isItemDisabled(e) {
    return e ? (this.props.disabledItems?.indexOf(e.id) ?? -1) >= 0 : !0;
  }
  getTooltip(e) {
    const { tooltipItems: t } = this.props;
    return !e || zs(t?.[e.id]) ? null : t?.[e.id] ?? null;
  }
  goToTop() {
    this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
  }
  focusActiveItem() {
    const { items: e, activeItem: t } = this.props;
    if (!t || !this.listRef.current) return;
    const n = typeof t == "object" && "id" in t ? t.id : t, o = e.findIndex((r) => r.id === n);
    if (o >= 0 && this.listRef.current.children[o]) {
      const r = this.listRef.current.children[o];
      (r.querySelector('[tabindex="0"]') || r)?.focus();
    }
  }
  getItemId(e) {
    const { id: t } = this.props;
    return t ? `${t}-option-${e}` : void 0;
  }
  /**
   * This attribute is supposed to be a React component. The FixedSizeList
   * component expects a component is a child.
   *
   * @see https://react-window.vercel.app/#/examples/list/fixed-size
   */
  ListItem = ({
    index: e,
    style: t
  }) => {
    const { items: n, itemComponent: o, onSelect: r, onChange: a, clearSearch: l } = this.props, c = this.isItemLoaded(e), d = e === n.length - 1, h = c ? n[e] : { id: rn(), name: "Loading..." }, u = this.props.pagination ? this.props.pagination.nextEnable : !1;
    return /* @__PURE__ */ s.jsxs("div", { style: t, className: Lo.item, children: [
      /* @__PURE__ */ s.jsx(
        Ao,
        {
          id: this.getItemId(e),
          checked: this.isItemChecked(h),
          clearSearch: l,
          disabled: this.isItemDisabled(h),
          isLoading: !c,
          item: h,
          itemComponent: o,
          onChange: a,
          onSelect: r,
          tooltip: this.getTooltip(h),
          active: this.isItemActive(h)
        }
      ),
      d && u && c && /* @__PURE__ */ s.jsx(Ni, { onEnter: this.loadMoreItems })
    ] });
  };
  loadMoreItems = async () => {
    this.props.pagination && await this.props.pagination.onNext?.();
  };
  render() {
    const {
      items: e,
      pagination: t,
      itemComponent: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      itemsDisplayCount: c = Su,
      itemHeight: d = Iu,
      id: h,
      ariaLabelledby: u
    } = this.props;
    if (!t || !t.infinite || !t.onNext)
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          style: { maxHeight: `${c * d}px` },
          className: Lo.list,
          ref: this.listRef,
          role: "listbox",
          id: h,
          "aria-labelledby": u,
          children: e.map((C, _) => {
            const S = Fi(C) ? C : C.id.toString() || C.name.toString() || C.toString();
            return /* @__PURE__ */ s.jsx(
              Ao,
              {
                id: this.getItemId(_),
                checked: this.isItemChecked(C),
                clearSearch: l,
                disabled: this.isItemDisabled(C),
                item: C,
                itemComponent: n,
                onChange: r,
                onSelect: o,
                onKeyDown: a,
                tooltip: this.getTooltip(C),
                active: this.isItemActive(C)
              },
              S
            );
          })
        }
      );
    const { nextEnable: p, itemCount: m } = t, g = m || (p ? e.length + c : e.length), b = {
      items: e,
      selectedItems: this.props.selectedItems,
      disabledItems: this.props.disabledItems,
      tooltipItems: this.props.tooltipItems,
      activeItem: this.props.activeItem,
      pagination: this.props.pagination
    }, x = Math.min(
      g * d,
      c * d
    );
    return /* @__PURE__ */ s.jsx(Pi, { disableHeight: !0, doNotBailOutOnEmptyChildren: !0, children: ({ width: C }) => /* @__PURE__ */ s.jsx(
      Ri,
      {
        ...b,
        ref: this.infiniteListRef,
        width: C,
        height: x,
        itemCount: g,
        itemSize: d,
        "aria-labelledby": u,
        children: this.ListItem
      }
    ) });
  }
}
const Du = "h-selectItems-checkableBaseItem--checkableBaseItem__root", ku = "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive", Tu = "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled", ju = "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox", Nu = "h-selectItems-checkableBaseItem--checkableBaseItem__content", zt = {
  root: Du,
  rootActive: ku,
  rootDisabled: Tu,
  checkbox: ju,
  content: Nu
};
class Zs extends D {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleChange() {
    const { onChange: e, item: t, checked: n } = this.props;
    typeof e == "function" && e(t, !n);
  }
  handleKeyDown(e) {
    const { disabled: t, onKeyDown: n } = this.props;
    (e.key === "Enter" || e.key === " ") && !t && (e.preventDefault(), this.handleChange()), n && n(e);
  }
  noop(e) {
    e.preventDefault();
  }
  render() {
    const {
      item: e,
      onChange: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      children: l,
      active: c,
      tabIndex: d,
      onKeyDown: h,
      ...u
    } = this.props, p = f(zt.root, {
      [zt.rootDisabled]: r,
      [zt.rootActive]: c
    }), m = r ? L : this.handleChange;
    return /* @__PURE__ */ s.jsxs(
      "label",
      {
        ...u,
        className: p,
        tabIndex: d,
        onKeyDown: this.handleKeyDown,
        children: [
          /* @__PURE__ */ s.jsx(
            hn,
            {
              id: e?.id,
              name: "",
              className: zt.checkbox,
              checked: o,
              onChange: m,
              tabIndex: -1
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: zt.content, children: l })
        ]
      }
    );
  }
}
const Fu = "h-selectItems-emptySelectItem--emptySelectItem__root", Pu = "h-selectItems-emptySelectItem--emptySelectItem__name", $o = {
  root: Fu,
  name: Pu
};
class pn extends D {
  render() {
    const { label: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx("div", { ...t, className: $o.root, children: /* @__PURE__ */ s.jsx("div", { className: $o.name, children: e }) });
  }
}
const Ru = "h-selectItems-selectItem--selectItem__root", Eu = "h-selectItems-selectItem--selectItem__rootActive", Lu = "h-selectItems-selectItem--selectItem__name", Au = "h-selectItems-selectItem--selectItem__nameBold", $u = "h-selectItems-selectItem--selectItem__nameWithDescription", Ou = "h-selectItems-selectItem--selectItem__description", Bu = "h-selectItems-selectItem--selectItem__icon", st = {
  root: Ru,
  rootActive: Eu,
  name: Lu,
  nameBold: Au,
  nameWithDescription: $u,
  description: Ou,
  icon: Bu
};
class Mr extends ge {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: e,
      onSelect: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      active: a,
      isLoading: l,
      ...c
    } = this.props, { description: d, name: h, icon: u, iconSize: p } = e, m = f(st.root, {
      [st.rootActive]: a
    }), g = f(st.name, {
      [st.nameBold]: o,
      [st.nameWithDescription]: !!d
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": a,
        className: m,
        disabled: r,
        onClick: () => {
          t(e);
        },
        children: [
          u ? /* @__PURE__ */ s.jsx(N, { className: st.icon, name: u, size: p ?? 16 }) : null,
          /* @__PURE__ */ s.jsxs(W, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
            /* @__PURE__ */ s.jsx("span", { className: g, "data-testid": "name", children: h }),
            d && /* @__PURE__ */ s.jsx("span", { className: st.description, "data-testid": "description", children: d })
          ] }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
const Wu = "h-selectItems-checkableSelectItem--checkableSelectItem__name", Hu = {
  name: Wu
};
class Uk extends D {
  render() {
    const { item: e, isLoading: t } = this.props, { name: n } = t ? { name: "Loading..." } : e;
    return /* @__PURE__ */ s.jsx(Zs, { ...this.props, children: /* @__PURE__ */ s.jsx("span", { className: Hu.name, children: n }) });
  }
}
const Mu = "h-selectItems-tagSelectItem--tagSelectItem__root", zu = "h-selectItems-tagSelectItem--tagSelectItem__rootActive", Vu = "h-selectItems-tagSelectItem--tagSelectItem__name", Ku = "h-selectItems-tagSelectItem--tagSelectItem__nameBold", Uu = "h-selectItems-tagSelectItem--tagSelectItem__dotContainer", qu = "h-selectItems-tagSelectItem--tagSelectItem__dot", ft = {
  root: Mu,
  rootActive: zu,
  name: Vu,
  nameBold: Ku,
  dotContainer: Uu,
  dot: qu
};
class qk extends D {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: e,
      onSelect: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      active: l,
      ...c
    } = this.props, { name: d, color: h = "#000" } = e, u = f(ft.root, {
      [ft.rootActive]: l
    }), p = f(ft.name, {
      [ft.nameBold]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": l,
        className: u,
        onClick: () => {
          t(e), n();
        },
        tabIndex: 0,
        title: typeof d == "string" ? d : d.toString(),
        disabled: r,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: ft.dotContainer, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: ft.dot,
              style: { backgroundColor: h ?? void 0 }
            }
          ) }),
          /* @__PURE__ */ s.jsx("div", { className: p, children: d }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" }),
          r && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ]
      }
    );
  }
}
const Gu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name", Yu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer", Qu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot", Xu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer", yn = {
  name: Gu,
  dotContainer: Yu,
  dot: Qu,
  nameContainer: Xu
};
class Gk extends D {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: e, item: t, checked: n } = this.props;
    typeof e == "function" && e(t, !n);
  }
  render() {
    const { item: e, isLoading: t, disabled: n } = this.props, { name: o, color: r } = t ? { name: "Loading...", color: "#000" } : e;
    return /* @__PURE__ */ s.jsx(
      Zs,
      {
        ...this.props,
        disabled: this.props.checked ? !1 : n,
        children: /* @__PURE__ */ s.jsxs("div", { className: yn.nameContainer, children: [
          r && /* @__PURE__ */ s.jsx("div", { className: yn.dotContainer, children: /* @__PURE__ */ s.jsx("div", { className: yn.dot, style: { backgroundColor: r } }) }),
          /* @__PURE__ */ s.jsx("span", { className: yn.name, children: o }),
          n && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ] })
      }
    );
  }
}
const Zu = "h-selectItems-avatarSelectItem--avatarSelectItem__root", Ju = "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive", ep = "h-selectItems-avatarSelectItem--avatarSelectItem__names", tp = "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName", np = "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName", sp = "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold", op = "h-selectItems-avatarSelectItem--avatarSelectItem__container", rp = "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable", Ve = {
  root: Zu,
  rootActive: Ju,
  names: ep,
  primaryName: tp,
  secondaryName: np,
  namesBold: sp,
  container: op,
  containerCheckable: rp
};
class ip extends D {
  static defaultProps = {
    checked: !1
  };
  getNames(e) {
    const t = /* @__PURE__ */ new Set();
    typeof e.name == "string" && t.add(e.name), typeof e.name != "string" && typeof e.display_name == "string" && t.add(e.display_name), typeof e.phone_number == "string" && t.add(e.phone_number), typeof e.email == "string" && t.add(e.email);
    const n = Array.from(t);
    return {
      primaryName: n.length > 0 ? n[0] : "No name",
      secondaryName: n.length > 1 ? n[1] : null
    };
  }
  getAvatar(e) {
    return typeof e.icon == "string" ? /* @__PURE__ */ s.jsx(N, { name: e.icon, size: 16 }) : /* @__PURE__ */ s.jsx(kr, { user: e });
  }
  renderContent() {
    const e = this.props.isLoading ? {
      id: "",
      name: "Loading..."
    } : this.props.item, t = this.getAvatar(e), n = this.getNames(e), o = f(Ve.container, {
      [Ve.containerCheckable]: this.props.checkable
    }), r = f(Ve.names, {
      [Ve.namesBold]: this.props.checked
    });
    return /* @__PURE__ */ s.jsxs("div", { className: o, children: [
      t,
      /* @__PURE__ */ s.jsxs("div", { className: r, children: [
        /* @__PURE__ */ s.jsx("div", { className: Ve.primaryName, children: n.primaryName }),
        n.secondaryName !== null && /* @__PURE__ */ s.jsx("div", { className: Ve.secondaryName, children: n.secondaryName })
      ] })
    ] });
  }
  render() {
    const e = this.renderContent(), { checkable: t, ...n } = this.props;
    if (t) {
      const m = n;
      return /* @__PURE__ */ s.jsx(Zs, { ...m, children: e });
    }
    const o = n, { item: r, disabled: a, onSelect: l, active: c, checked: d, isLoading: h, ...u } = o, p = f(Ve.root, {
      [Ve.rootActive]: c
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...u,
        type: "button",
        className: p,
        disabled: a,
        onClick: () => {
          l(r);
        },
        "aria-current": c,
        children: [
          e,
          d && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
class Yk extends D {
  render() {
    return /* @__PURE__ */ s.jsx(ip, { checkable: !0, ...this.props });
  }
}
const ap = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root", lp = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive", cp = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion", dp = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon", _n = {
  root: ap,
  rootActive: lp,
  suggestion: cp,
  icon: dp
};
class Qk extends ge {
  static defaultProps = {
    searchSuggestion: (e, t) => e.find((n) => n.name.toLowerCase() === t.toLowerCase()),
    renderSuggestion: (e) => `Add "${e}" tag`
  };
  constructor(e) {
    super(e), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(e) {
    const { searched: t, active: n } = this.props;
    t !== e.searched && this.searchItem(), n !== e.active && (n ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
  searchItem() {
    const { items: e, searched: t, searchSuggestion: n } = this.props;
    this.setState({ searching: !0 }, async () => {
      try {
        const o = await n?.(e, t);
        this.setState({ item: o });
      } catch (o) {
        console.error(o);
      } finally {
        this.setState({ searching: !1 });
      }
    });
  }
  onSuggest() {
    const { searched: e, onSuggest: t, clearSearch: n, triggerClose: o } = this.props;
    o?.(), t?.(e), n();
  }
  handleKeyDown(e) {
    this.props.active && e.key === "Enter" && this.onSuggest();
  }
  render() {
    const {
      className: e,
      triggerClose: t,
      onSuggest: n,
      searched: o,
      items: r,
      active: a,
      renderSuggestion: l,
      searchSuggestion: c,
      clearSearch: d,
      ...h
    } = this.props, { item: u, searching: p } = this.state;
    if (!o || p || u)
      return null;
    const m = f(e, _n.root, {
      [_n.rootActive]: a
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...h,
        type: "button",
        "aria-current": a,
        className: m,
        onClick: this.onSuggest,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: _n.suggestion, children: l?.(o) }),
          /* @__PURE__ */ s.jsx("div", { className: _n.icon, children: /* @__PURE__ */ s.jsx(N, { name: "plus" }) })
        ]
      }
    );
  }
}
const hp = "h-selectItems-deselectItem--deselectItem__root", up = "h-selectItems-deselectItem--deselectItem__rootDisabled", pp = "h-selectItems-deselectItem--deselectItem__name", mp = "h-selectItems-deselectItem--deselectItem__icon", Cn = {
  root: hp,
  rootDisabled: up,
  name: pp,
  icon: mp
};
class gp extends D {
  render() {
    const { item: e, onSelect: t, clearSearch: n, disabled: o, ...r } = this.props, { name: a } = e, l = f(Cn.root, {
      [Cn.rootDisabled]: o
    });
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { className: Cn.name, children: a }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Cn.icon,
          onClick: () => {
            t(e);
          },
          disabled: o,
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const fp = "h-selectItems-tagDeselectItem--tagDeselectItem__root", bp = "h-selectItems-tagDeselectItem--tagDeselectItem__name", xp = "h-selectItems-tagDeselectItem--tagDeselectItem__icon", yp = "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer", _p = "h-selectItems-tagDeselectItem--tagDeselectItem__dot", Vt = {
  root: fp,
  name: bp,
  icon: xp,
  dotContainer: yp,
  dot: _p
};
class Xk extends D {
  render() {
    const { item: e, onSelect: t, clearSearch: n, disabled: o, isLoading: r, ...a } = this.props, { name: l, color: c } = e, d = f(Vt.root);
    return /* @__PURE__ */ s.jsxs("div", { ...a, className: d, children: [
      /* @__PURE__ */ s.jsx("div", { className: Vt.dotContainer, children: /* @__PURE__ */ s.jsx(
        "div",
        {
          className: Vt.dot,
          style: { backgroundColor: c ?? void 0 }
        }
      ) }),
      /* @__PURE__ */ s.jsx("div", { className: Vt.name, children: l }),
      o && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Vt.icon,
          onClick: () => {
            t(e);
          },
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const Cp = "h-chip--chip__root", vp = "h-chip--chip__rootLight", wp = "h-chip--chip__rootNoBorder", Sp = "h-chip--chip__rootDisabled", Ip = "h-chip--chip__rootInteractable", Kt = {
  root: Cp,
  rootLight: vp,
  rootNoBorder: wp,
  rootDisabled: Sp,
  rootInteractable: Ip
}, Dp = ({
  className: i,
  children: e,
  onClick: t,
  light: n,
  noBorder: o,
  disabled: r,
  ...a
}) => {
  const l = f(
    {
      [Kt.root]: !0,
      [Kt.rootLight]: n,
      [Kt.rootNoBorder]: o,
      [Kt.rootDisabled]: r,
      [Kt.rootInteractable]: typeof t == "function" && !r
    },
    i
  ), c = typeof t == "function" ? "button" : "div";
  return /* @__PURE__ */ s.jsx(ie, { ...a, as: c, className: l, onClick: t, children: e });
}, kp = "h-tag--tag__tagName", Tp = "h-tag--tag__tagNameTruncated", jp = "h-tag--tag__icon", Np = "h-tag--tag__deleteButton", Fp = "h-tag--tag__deleteButtonDisabled", Pp = "h-tag--tag__deleteIcon", bt = {
  tagName: kp,
  tagNameTruncated: Tp,
  icon: jp,
  deleteButton: Np,
  deleteButtonDisabled: Fp,
  deleteIcon: Pp
}, jt = ({
  className: i,
  tagNameClassName: e,
  children: t,
  onDelete: n,
  color: o,
  light: r,
  noBorder: a,
  noTruncation: l = !1,
  disabled: c,
  ...d
}) => {
  const h = f(
    {
      [bt.tagName]: !0,
      [bt.tagNameTruncated]: !l
    },
    e
  ), u = f(bt.deleteButton, {
    [bt.deleteButtonDisabled]: c
  });
  return /* @__PURE__ */ s.jsxs(
    Dp,
    {
      ...d,
      className: i,
      light: r,
      noBorder: a,
      disabled: c,
      children: [
        o && /* @__PURE__ */ s.jsx(
          "span",
          {
            className: bt.icon,
            style: { backgroundColor: sn(o) ?? void 0 }
          }
        ),
        /* @__PURE__ */ s.jsx("span", { className: h, children: t }),
        !!n && !c && /* @__PURE__ */ s.jsx("button", { className: u, type: "button", onClick: n, children: /* @__PURE__ */ s.jsx(N, { name: "close", className: bt.deleteIcon }) })
      ]
    }
  );
}, Rp = "h-select--select__root", Ep = "h-select--select__rootDisabled", Lp = "h-select--select__inputWrapper", Ap = "h-select--select__control", $p = "h-select--select__rootHasIcon", Op = "h-select--select__selection", Bp = "h-select--select__selectionItem", Wp = "h-select--select__tag", Hp = "h-select--select__tagName", Mp = "h-select--select__tagLimiter", zp = "h-select--select__text", Vp = "h-select--select__rootSearchable", Kp = "h-select--select__rootDropdownOpen", Up = "h-select--select__rootIsSearching", qp = "h-select--select__search", Gp = "h-select--select__rootSingle", Yp = "h-select--select__indicators", Qp = "h-select--select__spinner", Xp = "h-select--select__clearIndicator", Zp = "h-select--select__dropdownIndicator", Jp = "h-select--select__dropdown", em = "h-select--select__dropdownFixed", tm = "h-select--select__pagination", Y = {
  root: Rp,
  rootDisabled: Ep,
  inputWrapper: Lp,
  control: Ap,
  rootHasIcon: $p,
  selection: Op,
  selectionItem: Bp,
  tag: Wp,
  tagName: Hp,
  tagLimiter: Mp,
  text: zp,
  rootSearchable: Vp,
  rootDropdownOpen: Kp,
  rootIsSearching: Up,
  search: qp,
  rootSingle: Gp,
  indicators: Yp,
  spinner: Qp,
  clearIndicator: Xp,
  dropdownIndicator: Zp,
  dropdown: Jp,
  dropdownFixed: em,
  pagination: tm
};
class Nt extends D {
  static contextType = Yn;
  controlRef;
  searchRef;
  listRef;
  static defaultProps = {
    id: Cr("select"),
    selectedItems: [],
    disabledItems: [],
    itemComponent: Mr,
    emptyComponent: pn,
    emptyMessage: "No options",
    placeholder: "",
    disabled: !1,
    loading: !1,
    multiple: !1,
    searchable: !1,
    clearable: !1,
    keepOpen: !1,
    hideSelectedItems: !1,
    hasDropDownIndicator: !0
  };
  constructor(e) {
    super(e), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = B(), this.searchRef = B(), this.listRef = B();
    const t = this.initSelectedItems(), n = this.initHighlightedIndex(t);
    this.state = {
      dropdownOpen: !1,
      search: "",
      selectedItems: t,
      highlightedIndex: n
    }, !Nt.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn(
      "SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"
    ), Nt.isSuggestionComponentWarningShown = !0);
  }
  componentDidUpdate(e, t) {
    const { dropdownOpen: n } = this.state;
    if (n !== t.dropdownOpen)
      if ((this.context ?? window)[n ? "addEventListener" : "removeEventListener"]("click", this.handleClickOutside), n) {
        this.searchRef.current?.focus();
        const o = this.initHighlightedIndex();
        this.highlightIndex(o, "auto");
      } else
        this.searchRef.current?.blur();
    vr(e.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
  }
  componentWillUnmount() {
    const { dropdownOpen: e } = this.state;
    e && (this.context ?? window).removeEventListener(
      "click",
      this.handleClickOutside
    );
  }
  static isSuggestionComponentWarningShown = !1;
  get a11y() {
    const { id: e } = this.props, { highlightedIndex: t } = this.state, n = `${e}-label`, o = `${e}-dropdown`, r = t !== null ? `${o}-option-${t}` : "";
    return { label: n, dropdown: o, option: r };
  }
  isItemIdType(e) {
    return typeof e == "string" || typeof e == "number";
  }
  initSelectedItems() {
    const { selectedItems: e = [] } = this.props;
    return e.map(this.resolveItem).filter(Boolean);
  }
  initHighlightedIndex(e = this.state.selectedItems) {
    const { multiple: t, items: n, hideSelectedItems: o } = this.props;
    if (!t && !o && e.length) {
      const r = this.resolveItem(e[0]);
      return n.indexOf(r);
    }
    return null;
  }
  resolveItem(e) {
    return this.isItemIdType(e) ? this.props.items.find((n) => n.id === e) : e;
  }
  resetSearch() {
    this.state.search && (this.setState({ search: "" }), this.searchRef.current?.focus());
  }
  handleSearch(e) {
    const { onSearch: t } = this.props, { value: n } = e.target;
    this.setState({ search: n }, () => {
      t?.(n), n && (this.highlightIndex(this.hasSuggestionComponent() ? -1 : 0), this.listRef.current?.goToTop());
    });
  }
  handleDropdown(e = "toggle") {
    const { dropdownOpen: t } = this.state, { keepOpen: n, onToggle: o } = this.props;
    if (n)
      return this.setState({ dropdownOpen: !0 });
    if (e === "toggle")
      return o?.(!t), this.controlRef.current?.focus(), this.setState({ dropdownOpen: !t });
    if (e === "open")
      return o?.(!0), this.setState({ dropdownOpen: !0 });
    if (e === "close" && t)
      return o?.(!1), this.controlRef.current?.blur(), this.setState({
        dropdownOpen: !1,
        search: ""
      });
  }
  handleClickOutside(e) {
    if (!this.controlRef || !(e.target instanceof Node)) return;
    const t = this.controlRef.current, { target: n } = e;
    n && n !== t && !t?.contains(n) && this.handleDropdown("close");
  }
  highlightIndex(e, t = "smooth") {
    this.setState({ highlightedIndex: e }, () => {
      if (e === null || e === -1) return;
      (this.listRef.current?.listRef.current?.children ?? [])[e]?.scrollIntoView({
        behavior: t,
        block: "nearest",
        inline: "start"
      });
    });
  }
  handleKeyDown(e) {
    const { search: t, dropdownOpen: n, highlightedIndex: o, selectedItems: r } = this.state, { multiple: a, hideSelectedItems: l } = this.props, c = this.getAvailableItems(), d = e.key === "Escape", h = e.key === "Enter", u = e.key === "ArrowUp", p = e.key === "ArrowDown", m = e.key === "Backspace";
    if ((h || u || p) && e.preventDefault(), p && !n)
      return e.preventDefault(), this.handleDropdown("open");
    if (d && (n && e.stopPropagation(), this.handleDropdown("close")), m && a && !t) {
      const g = r[r.length - 1];
      g && this.handleRemove(g);
    }
    if (this.hasSuggestionComponent()) {
      if (p && (o === null || o === c.length - 1 || o === 0 && c.length === 0))
        return this.highlightIndex(-1);
      if (u && o === 0)
        return this.highlightIndex(-1);
      if (h && o === -1) {
        this.props.onSuggest?.(t), this.resetSearch();
        return;
      }
    }
    if (p && o === null)
      return this.highlightIndex(0);
    if (o !== null) {
      if (p && o === c.length - 1)
        return this.highlightIndex(0);
      if (p)
        return this.highlightIndex(o + 1);
      if (u && o > 0)
        return this.highlightIndex(o - 1);
      if (u && o <= 0)
        return this.highlightIndex(c.length - 1);
      if (h) {
        const g = c[o], b = g && this.isItemDisabled(g);
        if (g && !b) {
          this.handleSelect(g);
          const x = Math.min(
            l ? o : o + 1,
            c.length - 2
          );
          this.highlightIndex(x);
        }
      }
    }
  }
  handleSelect(e) {
    const { multiple: t, keepOpen: n, onSelect: o } = this.props;
    if (t) {
      const r = this.isItemSelected(e);
      this.handleChange(e, !r);
    } else
      this.setState({
        selectedItems: [e],
        dropdownOpen: n ?? !1
      }), this.resetSearch(), o?.(e);
  }
  handleChange(e, t) {
    const { onChange: n } = this.props, { selectedItems: o } = this.state;
    this.setState({
      selectedItems: t ? [...o, e] : o.filter((r) => r.id !== e.id)
    }), this.resetSearch(), n?.(e, t);
  }
  handleRemove(e, t) {
    t && (t.preventDefault(), t.stopPropagation()), this.handleChange(e, !1);
  }
  handleClear(e) {
    e.stopPropagation();
    const { onClear: t } = this.props;
    t?.(), this.setState({ selectedItems: [] });
  }
  handleDropdownClick(e) {
    e.stopPropagation();
  }
  getPlaceholder() {
    return this.state.selectedItems.length ? "" : this.props.placeholder;
  }
  getInputSize() {
    return this.state.search ? this.state.search.length : this.state.selectedItems?.length ? 5 : this.props.placeholder?.length || 5;
  }
  getItemName(e) {
    return e.name.toString().trim();
  }
  getAvailableItems() {
    const { search: e } = this.state, { items: t, hideSelectedItems: n, onSearch: o, searchBy: r } = this.props, a = new RegExp(Vs(e), "i");
    return t.filter((c) => {
      const d = [];
      return e && !o && (r && typeof r == "function" ? d.push(r(c, e)) : r && r instanceof Array ? d.push(
        r.some((h) => {
          const u = c[h];
          return (typeof u == "string" || typeof u == "number") && a.test(u.toString().trim());
        })
      ) : d.push(a.test(this.getItemName(c)))), n && d.push(!this.isItemSelected(c)), d.every((h) => h);
    });
  }
  isItemSelected(e) {
    return this.state.selectedItems.some(
      (t) => t.id === e.id
    );
  }
  isItemDisabled(e) {
    return this.props.disabledItems?.includes(e.id);
  }
  isEmpty() {
    return this.state.selectedItems.length === 0;
  }
  hasSuggestionComponent(e) {
    return !!this.state.search && typeof this.props.suggestionComponent == "function";
  }
  renderHiddenItems() {
    const { limit: e } = this.props, { selectedItems: t } = this.state;
    if (e && e > 0)
      return /* @__PURE__ */ s.jsx(W, { flexDirection: "column", children: t?.slice(e).map((n) => /* @__PURE__ */ s.jsxs(
        W,
        {
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item",
          children: [
            /* @__PURE__ */ s.jsx(ie, { margin: "0 400 0 0", children: this.getItemName(n) }),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "close",
                variant: "tertiary",
                onClick: (o) => this.handleRemove(n, o)
              }
            )
          ]
        },
        n.id
      )) });
  }
  renderSelection(e) {
    return this.props.renderSelection?.(e) ?? this.getItemName(e);
  }
  renderMultipleSelection() {
    const { selectedItems: e } = this.state, t = this.props.limit || e.length, n = t < e.length, o = e?.slice(0, t).map((r) => {
      const a = this.renderSelection(r);
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          onClick: (l) => l.stopPropagation(),
          "data-testid": "select-selection",
          className: Y.selectionItem,
          children: /* @__PURE__ */ s.jsx(
            jt,
            {
              className: Y.tag,
              tagNameClassName: Y.tagName,
              onDelete: (l) => this.handleRemove(r, l),
              color: r.color,
              noTruncation: !0,
              "data-testid": "select-tag",
              children: a
            }
          )
        },
        r.id
      );
    });
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      n && /* @__PURE__ */ s.jsx("div", { onClick: (r) => r.stopPropagation(), children: /* @__PURE__ */ s.jsx(
        se,
        {
          content: this.renderHiddenItems(),
          requireClick: !0,
          "data-testid": "select-limiter",
          light: !0,
          children: /* @__PURE__ */ s.jsxs(
            jt,
            {
              className: f(Y.tag, Y.tagLimiter),
              noTruncation: !0,
              children: [
                "+",
                e.length - t
              ]
            }
          )
        }
      ) })
    ] });
  }
  renderSingleSelection() {
    const { search: e, selectedItems: t } = this.state, n = t[0], o = /* @__PURE__ */ s.jsx("span", { style: { width: 0 }, "data-testid": "select-selection-empty", children: " " });
    return n ? /* @__PURE__ */ s.jsx(
      "span",
      {
        className: Y.text,
        "aria-hidden": !!e,
        "data-testid": "select-selection",
        children: this.renderSelection(n)
      }
    ) : o;
  }
  renderSearch() {
    const { searchable: e } = this.props;
    return !e && !this.isEmpty() ? null : /* @__PURE__ */ s.jsx(
      "input",
      {
        className: Y.search,
        ref: this.searchRef,
        tabIndex: -1,
        onFocus: (t) => t.stopPropagation(),
        value: this.state.search,
        size: this.getInputSize(),
        onChange: this.handleSearch,
        placeholder: this.getPlaceholder(),
        autoComplete: "off",
        readOnly: !e,
        "aria-autocomplete": "list",
        "aria-controls": this.a11y.dropdown,
        "aria-labelledby": this.a11y.label,
        "data-testid": "select-input"
      }
    );
  }
  renderDropdown() {
    const { dropdownOpen: e, highlightedIndex: t, search: n } = this.state, {
      disabledItems: o,
      tooltipItems: r,
      emptyComponent: a,
      suggestionComponent: l,
      emptyMessage: c,
      pagination: d,
      dropdownProps: h,
      searchSuggestion: u,
      renderSuggestion: p,
      onSuggest: m,
      multiple: g
    } = this.props, b = f(
      {
        [Y.dropdown]: !0,
        [Y.dropdownFixed]: h?.fixed ?? !1
      },
      h?.className
    ), x = this.getAvailableItems(), C = x[t ?? -1] ?? null, _ = !x.length;
    return /* @__PURE__ */ s.jsxs(
      et,
      {
        onClick: this.handleDropdownClick,
        ...h,
        className: b,
        isOpen: e,
        "data-testid": "select-dropdown",
        children: [
          _ && typeof a == "function" && /* @__PURE__ */ s.jsx(
            a,
            {
              label: c ?? "No options",
              "data-testid": "select-dropdown-empty"
            }
          ),
          this.hasSuggestionComponent(l) && /* @__PURE__ */ s.jsx(
            l,
            {
              searched: n,
              onSuggest: m,
              triggerClose: g ? void 0 : () => this.handleDropdown("close"),
              items: x,
              active: t === -1,
              clearSearch: this.resetSearch,
              searchSuggestion: u,
              renderSuggestion: p
            }
          ),
          !_ && /* @__PURE__ */ s.jsx(
            Xs,
            {
              id: this.a11y.dropdown,
              ariaLabelledby: this.a11y.label,
              ref: this.listRef,
              pagination: d,
              items: x,
              clearSearch: this.resetSearch,
              onSelect: this.handleSelect,
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              selectedItems: this.state.selectedItems,
              disabledItems: o,
              tooltipItems: r,
              activeItem: C,
              itemComponent: this.props.itemComponent
            }
          ),
          !!d && !d.infinite && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: Y.pagination,
              "data-testid": "select-dropdown-pagination",
              children: [
                /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: "secondary",
                    disabled: !d.previousEnable,
                    onClick: d.onPrevious,
                    children: "Prev page"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: "secondary",
                    disabled: !d.nextEnable,
                    onClick: d.onNext,
                    children: "Next page"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  render() {
    const {
      className: e,
      disabled: t,
      hasDropDownIndicator: n,
      loading: o,
      multiple: r,
      searchable: a,
      clearable: l,
      prefix: c,
      suffix: d,
      icon: h,
      status: u
    } = this.props, { search: p, dropdownOpen: m } = this.state, g = f(
      {
        [Y.root]: !0,
        [Y.rootSingle]: !r,
        [Y.rootDisabled]: t,
        [Y.rootSearchable]: a,
        [Y.rootDropdownOpen]: m,
        [Y.rootIsSearching]: !!p,
        [Y.rootHasIcon]: !!h
      },
      e
    ), b = p ? void 0 : () => this.handleDropdown("toggle");
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: g,
        role: "combobox",
        "aria-expanded": m,
        "aria-owns": this.a11y.dropdown,
        "aria-haspopup": "listbox",
        "data-testid": "select-root",
        children: [
          /* @__PURE__ */ s.jsx(
            Ae,
            {
              prefix: c,
              suffix: d,
              icon: h,
              status: u,
              active: m,
              disabled: t,
              className: Y.inputWrapper,
              children: /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: Y.control,
                  ref: this.controlRef,
                  onKeyDown: this.handleKeyDown,
                  onClick: b,
                  tabIndex: t ? -1 : 0,
                  "aria-activedescendant": this.a11y.option,
                  "data-testid": "select-control",
                  children: [
                    /* @__PURE__ */ s.jsxs("div", { className: Y.selection, children: [
                      r ? this.renderMultipleSelection() : this.renderSingleSelection(),
                      this.renderSearch()
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: Y.indicators, children: [
                      o && /* @__PURE__ */ s.jsx(
                        Gn,
                        {
                          className: Y.spinner,
                          size: 16,
                          "aria-label": "Loading",
                          "data-testid": "select-loading"
                        }
                      ),
                      !this.isEmpty() && l && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: Y.clearIndicator,
                          icon: "close",
                          variant: "tertiary",
                          onClick: this.handleClear,
                          "aria-label": "Clear",
                          "data-testid": "select-clear"
                        }
                      ),
                      n && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: Y.dropdownIndicator,
                          icon: m ? "angle-up" : "angle-down",
                          variant: "tertiary",
                          onClick: (x) => {
                            x.stopPropagation(), this.handleDropdown("toggle");
                          },
                          "aria-label": m ? "Close" : "Open",
                          "data-testid": "select-toggle"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          !t && m && this.renderDropdown()
        ]
      }
    );
  }
}
function nm(i) {
  return /* @__PURE__ */ s.jsx(
    Rt,
    {
      fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong" }) }),
      children: /* @__PURE__ */ s.jsx(Nt, { ...i })
    }
  );
}
const sm = "h-datePicker-timezoneSelector--timezoneSelector__root", om = "h-datePicker-timezoneSelector--timezoneSelector__label", Oo = {
  root: sm,
  label: om
}, zr = ({
  disabled: i,
  tooltipProps: e,
  selectedTimezone: t,
  onChange: n
}) => {
  const o = j.tz.guess(!0), r = P((h, u) => {
    const [p, m] = j.tz(h).format("Z").split(":"), [g, b] = j.tz(u).format("Z").split(":");
    return +parseInt(p) * 60 + parseInt(m) - (+parseInt(g) * 60 + parseInt(b));
  }, []), a = (h) => `(GMT${j.tz(h).format("Z")})`, l = (h) => `${a(h)} ${h}`, c = G(() => {
    const h = j.tz.names().filter((m) => m !== o), u = {
      id: o,
      name: `Default ${a(o)}`
    }, p = h.sort(r).map((m) => ({ id: m, name: l(m) }));
    return [u, ...p];
  }, [r]), d = ({ id: h }) => {
    n(h);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: Oo.root, children: [
    /* @__PURE__ */ s.jsx(Qs, { className: Oo.label, children: "Time zone" }),
    /* @__PURE__ */ s.jsx(se, { ...e, side: "top", children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
      nm,
      {
        disabled: i,
        items: c,
        onSelect: d,
        selectedItems: [
          Tt(t) ? t : o
        ],
        searchable: !0
      }
    ) }) })
  ] });
}, rm = "h-fieldAlert--fieldAlert__root", im = "h-fieldAlert--fieldAlert__alert", am = "h-fieldAlert--fieldAlert__icon", gs = {
  root: rm,
  alert: im,
  icon: am
}, lm = "h-fieldAlert-fieldAlertButton--fieldAlertButton__root", cm = {
  root: lm
};
function dm({
  className: i,
  variant: e = "tertiary",
  ...t
}) {
  return /* @__PURE__ */ s.jsx(
    X,
    {
      ...t,
      variant: e,
      className: f(i, cm.root)
    }
  );
}
const hm = {
  error: "exclamation-circle-filled",
  warning: "exclamation-triangle-filled",
  success: "check-circle-filled",
  title: null
};
function ts({
  children: i,
  className: e,
  ...t
}) {
  const n = t.variant || "title", o = f(gs.root, e), [r, a] = V(!1), l = hm[n], c = P(
    (d) => {
      if (!d) return;
      const { offsetWidth: h, scrollWidth: u } = d;
      a(h < u);
    },
    [i]
  );
  return /* @__PURE__ */ s.jsxs(A.Input, { ...t, variant: n, className: o, children: [
    !!l && /* @__PURE__ */ s.jsx(N, { className: gs.icon, name: l }),
    /* @__PURE__ */ s.jsx("div", { className: gs.alert, ref: c, children: r ? /* @__PURE__ */ s.jsx(se, { content: i, children: i }) : i })
  ] });
}
ts.Button = dm;
const vn = (i, e = 0) => {
  if (!i)
    return e;
  if (typeof i == "number")
    return i;
  const t = parseFloat(i);
  return isNaN(t) ? e : t;
}, um = "h-inputText-inputNumberArrows--inputNumberArrows__root", pm = "h-inputText-inputNumberArrows--inputNumberArrows__button", mm = "h-inputText-inputNumberArrows--inputNumberArrows__buttonUp", gm = "h-inputText-inputNumberArrows--inputNumberArrows__buttonDown", fm = "h-inputText-inputNumberArrows--inputNumberArrows__spacer", xt = {
  root: um,
  button: pm,
  buttonUp: mm,
  buttonDown: gm,
  spacer: fm
}, bm = 50, Bo = 300, xm = "inputNumberArrowsTestId";
class ym extends D {
  intervalId;
  timeoutId;
  constructor(e) {
    super(e), this.intervalId = null, this.timeoutId = null, this.increaseValue = this.increaseValue.bind(this), this.decreaseValue = this.decreaseValue.bind(this), this.startIncreaseValue = this.startIncreaseValue.bind(this), this.startDecreaseValue = this.startDecreaseValue.bind(this), this.stopChangeValue = this.stopChangeValue.bind(this);
  }
  componentDidMount() {
    window.addEventListener("mouseup", this.stopChangeValue);
  }
  componentWillUnmount() {
    window.removeEventListener("mouseup", this.stopChangeValue);
  }
  getNewValue(e) {
    const {
      step: t,
      min: n,
      max: o,
      inputRef: { current: r }
    } = this.props;
    if (!r)
      return 0;
    const a = vn(r.value), l = vn(t, 1), c = vn(n, Number.MIN_SAFE_INTEGER), d = vn(o, Number.MAX_SAFE_INTEGER);
    return e == "decrease" ? Math.max(a - l, c) : Math.min(a + l, d);
  }
  startIncreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("increase"),
      Bo
    );
  }
  startDecreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("decrease"),
      Bo
    );
  }
  startChangeValue(e) {
    this.intervalId || (this.intervalId = setInterval(
      () => this.triggerInputChange(e),
      bm
    ));
  }
  stopChangeValue() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null), this.intervalId && (clearInterval(this.intervalId), this.intervalId = null);
  }
  increaseValue(e) {
    e.preventDefault(), this.triggerInputChange("increase");
  }
  decreaseValue(e) {
    e.preventDefault(), this.triggerInputChange("decrease");
  }
  triggerInputChange(e) {
    const {
      inputRef: { current: t },
      readOnly: n
    } = this.props;
    if (!t || n)
      return;
    const o = this.getNewValue(e), r = new Event("input", { bubbles: !0 }), a = Object.getPrototypeOf(t);
    Object.getOwnPropertyDescriptor(
      a,
      "value"
    )?.set?.call(t, o), t.dispatchEvent(r), t.focus();
  }
  render() {
    return /* @__PURE__ */ s.jsxs("div", { className: xt.root, "data-testid": xm, children: [
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(xt.button, xt.buttonUp),
          tabIndex: -1,
          onClick: this.increaseValue,
          onMouseDown: this.startIncreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-up" })
        }
      ),
      /* @__PURE__ */ s.jsx("span", { className: xt.spacer }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(xt.button, xt.buttonDown),
          tabIndex: -1,
          onClick: this.decreaseValue,
          onMouseDown: this.startDecreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-down" })
        }
      )
    ] });
  }
}
const _m = "h-inputText--inputText__rootReadOnly", Cm = "h-inputText--inputText__container", vm = "h-inputText--inputText__rootHasIcon", wm = "h-inputText--inputText__rootTypeNumber", Sm = "h-inputText--inputText__input", Ut = {
  rootReadOnly: _m,
  container: Cm,
  rootHasIcon: vm,
  rootTypeNumber: wm,
  input: Sm
}, Im = "inputText", Ye = $(function(e, t) {
  const n = q(null);
  Ft(t, () => n.current);
  const {
    className: o,
    disabled: r,
    readOnly: a,
    type: l = "text",
    name: c,
    prefix: d,
    suffix: h,
    icon: u,
    status: p,
    min: m,
    max: g,
    step: b,
    hideNumberArrows: x = !1,
    active: C = !1,
    ..._
  } = e, S = f(o, {
    [Ut.rootTypeNumber]: l === "number",
    [Ut.rootHasIcon]: !!u,
    [Ut.rootReadOnly]: a
  });
  return /* @__PURE__ */ s.jsx(
    Ae,
    {
      className: S,
      status: p,
      disabled: r,
      active: C,
      prefix: d,
      suffix: h,
      icon: u,
      children: /* @__PURE__ */ s.jsxs("div", { className: Ut.container, children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            "data-testid": Im,
            dir: "auto",
            id: c,
            name: c,
            ref: n,
            ..._,
            min: m,
            max: g,
            step: b,
            type: l,
            disabled: r,
            readOnly: a,
            className: Ut.input
          }
        ),
        l === "number" && !x && /* @__PURE__ */ s.jsx(
          ym,
          {
            min: m,
            max: g,
            step: b,
            inputRef: n,
            readOnly: a
          }
        )
      ] })
    }
  );
}), Dm = "hmm A", km = (i, e) => {
  const t = `${i}`.padStart(2, "0"), n = `${e}`.padStart(2, "0");
  return `${t}:${n}`;
}, Wo = (i, e) => {
  const t = i.hours(), n = i.minutes();
  return {
    id: km(t, n),
    name: i.format(e)
  };
}, an = ({
  hasDropDownIndicator: i = !0,
  allowCustomTimeInput: e = !1,
  timeOptions: t,
  overrides: n,
  selectedItems: o,
  selectableHours: r = Pr,
  selectableMinutes: a = Rr,
  timeFormat: l = j.localeData().longDateFormat("LT"),
  onSelect: c,
  onIsCustomTimeValid: d,
  ...h
}) => {
  const [u] = o || [], [p, m] = V(
    () => typeof u == "object" ? u?.id : u || null
  ), [g, b] = V(""), x = G(
    () => t || Or({
      hours: r,
      minutes: a,
      overrides: n,
      timeFormat: l
    }),
    [
      t,
      r,
      a,
      n,
      l
    ]
  ), C = G(() => {
    const v = j(
      g || (typeof u == "object" ? u.id : u) || p,
      [l, Dm]
    );
    if (!v.isValid())
      return null;
    const w = v.hours(), I = v.minutes();
    if (!d || d(w, I))
      return Wo(v, l);
    const T = w <= 12, F = w + 12, H = d(F, I);
    return T && H ? Wo(j({ hours: F, minutes: I }), l) : null;
  }, [u, g]), _ = G(() => {
    if (!e)
      return x;
    const v = p ? x.filter(({ name: w }) => w !== C?.name) : x.filter(
      ({ name: w }) => w.startsWith(g) && w !== C?.name
    );
    if (!C)
      return v;
    const y = p !== C.id ? 0 : v.findIndex(
      (w) => j(w.id, [l]) > j(C.id, [l])
    );
    return v.splice(
      // If it's -1 then there was no later time, so add it to the end.
      y === -1 ? v.length : y,
      0,
      C
    ), v;
  }, [C, g, p, x]), S = P(
    (v) => {
      v?.id !== C?.id && b(""), c(v?.id || null), m(v?.id || null);
    },
    [C]
  );
  return Z(() => {
    u ? (b(""), m(
      typeof u == "object" ? u.id : u
    )) : m(null);
  }, [u]), /* @__PURE__ */ s.jsx(
    Nt,
    {
      searchable: !0,
      placeholder: Er(l),
      ...h,
      selectedItems: o,
      hasDropDownIndicator: i,
      items: e ? _ : x,
      onChange: L,
      onClear: S,
      onSelect: S,
      ...e && { onSearch: b }
    }
  );
}, Tm = "h-timePicker-range--timeRangePicker__root", jm = "h-timePicker-range--timeRangePicker__timePickerFrom", Nm = "h-timePicker-range--timeRangePicker__timePickerTo", Fm = "h-timePicker-range--timeRangePicker__arrowContainer", Pm = "h-timePicker-range--timeRangePicker__arrowContainerHasError", Rm = "h-timePicker-range--timeRangePicker__arrowContainerHasWarning", Em = "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess", ot = {
  root: Tm,
  timePickerFrom: jm,
  timePickerTo: Nm,
  arrowContainer: Fm,
  arrowContainerHasError: Pm,
  arrowContainerHasWarning: Rm,
  arrowContainerHasSuccess: Em
}, Lm = ({
  className: i,
  disabled: e,
  endTime: t,
  onSelect: n,
  overrides: o,
  placeholder: r,
  selectableHours: a = Pr,
  selectableMinutes: l = Rr,
  status: c,
  startTime: d,
  allowCustomTimeInput: h = !1,
  timeFormat: u = j.localeData().longDateFormat("LT"),
  ...p
}) => {
  const [{ startTime: m, endTime: g }, b] = V({
    startTime: d || null,
    endTime: t || null
  }), x = G(
    () => Or({
      hours: a,
      minutes: l,
      overrides: o,
      timeFormat: u
    }),
    [a, l, o, u]
  ), C = G(() => {
    const y = x.map(
      ({ id: T }) => j(T, [u])
    ), w = j(m, [u]), I = m && y.findIndex(
      (T) => T > w
    ) || 0;
    return x.slice(I);
  }, [x, m, u]);
  Z(() => {
    const y = typeof d == "string", w = typeof d == "string";
    (y && d !== m || w && t !== g) && b((I) => ({
      ...I,
      ...y && { startTime: d },
      ...w && { endTime: t }
    }));
  });
  const _ = P(
    (y) => (w) => {
      b((I) => {
        const T = j(w, [u]), F = j(I.startTime, [u]), H = j(I.endTime, [u]), k = x.map(
          ({ id: ne }) => j(ne, [u])
        ), R = k.findIndex(
          (ne) => ne >= T
        ) || -1, O = y === "startTime" ? R : k.findIndex(
          (ne) => ne >= F
        ), U = y === "endTime" ? -1 : k.findIndex(
          (ne) => ne >= H
        ), oe = {
          ...I,
          [y]: w,
          ...I.endTime !== null && y !== "endTime" && O >= U && {
            endTime: x[R + 1]?.id || null
          }
        };
        return n(oe), oe;
      });
    },
    [n]
  ), S = P(
    (y, w) => {
      const I = j(m, [u]);
      if (!I.isValid())
        return !0;
      const F = I.hours(), H = I.minutes();
      return F < y || F === y && H < w;
    },
    [m, u]
  ), v = (y) => r?.[y] || r || Er(u);
  return /* @__PURE__ */ s.jsxs(ie, { className: f(ot.root, i), children: [
    /* @__PURE__ */ s.jsx(
      an,
      {
        className: ot.timePickerFrom,
        searchable: !0,
        ...p,
        disabled: e,
        hasDropDownIndicator: !1,
        timeOptions: x,
        onSelect: _("startTime"),
        placeholder: v("startTime"),
        allowCustomTimeInput: h,
        selectedItems: m ? [m] : [],
        status: c
      }
    ),
    /* @__PURE__ */ s.jsx(
      ie,
      {
        className: f(ot.arrowContainer, {
          [ot.arrowContainerHasError]: c === "error",
          [ot.arrowContainerHasWarning]: c === "warning",
          [ot.arrowContainerHasSuccess]: c === "success"
        }),
        children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" })
      }
    ),
    /* @__PURE__ */ s.jsx(
      an,
      {
        className: ot.timePickerTo,
        searchable: !0,
        disabled: e || !m,
        ...p,
        hasDropDownIndicator: !1,
        timeOptions: C,
        onSelect: _("endTime"),
        placeholder: v("endTime"),
        ...h && {
          allowCustomTimeInput: h,
          onIsCustomTimeValid: S
        },
        selectedItems: g ? [g] : [],
        status: c
      }
    )
  ] });
};
class Ge {
  constructor(e, t, n) {
    this.dateFormat = e, this.dateParser = t, this.dateRangeConstraint = n, this.dateFormat = e, this.dateParser = t, this.dateRangeConstraint = n;
  }
  dateFormat;
  dateParser;
  dateRangeConstraint;
  static validationOK = { isValid: !0, error: null };
  isValidDate(e) {
    try {
      return this.dateParser(e).isValid();
    } catch {
      return !1;
    }
  }
  isSingleDateValid(e) {
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "Date is not valid"
      };
    const { minDate: t, maxDate: n } = this.dateRangeConstraint, o = this.dateParser(e);
    return o.isBefore(t, "day") ? {
      isValid: !1,
      error: `Date must be after ${t.format(this.dateFormat)}`
    } : o.isAfter(n, "day") ? {
      isValid: !1,
      error: `Date must be before ${n.format(this.dateFormat)}`
    } : Ge.validationOK;
  }
  /**
   * Mind that this is dependant on end date as well because it's a range
   */
  isStartDateValid({
    startDateInputValue: e,
    endDateInputValue: t
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "From date is not valid"
      };
    const r = this.dateParser(e), a = this.dateParser(t);
    return r.isBefore(n, "day") ? {
      isValid: !1,
      error: `From date must be after ${n.format(this.dateFormat)}`
    } : t && this.isValidDate(t) && r.isAfter(a, "day") ? {
      isValid: !1,
      error: `From date must be before ${a.format(
        this.dateFormat
      )}`
    } : r.isAfter(o, "day") ? {
      isValid: !1,
      error: `From date must be before ${o.format(this.dateFormat)}`
    } : Ge.validationOK;
  }
  /**
   * Mind that this is dependant on start date as well because it's a range
   */
  isEndDateValid({
    startDateInputValue: e,
    endDateInputValue: t
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "To date is not valid"
      };
    const r = this.dateParser(e), a = this.dateParser(t);
    return a.isAfter(o, "day") ? {
      isValid: !1,
      error: `To date must be before ${o.format(this.dateFormat)}`
    } : e && this.isValidDate(e) && a.isBefore(r, "day") ? {
      isValid: !1,
      error: `To date must be after ${r.format(
        this.dateFormat
      )}`
    } : a.isBefore(n, "day") ? {
      isValid: !1,
      error: `To date must be after ${n.format(this.dateFormat)}`
    } : Ge.validationOK;
  }
  isTimeOrderValid({
    startDate: e,
    endDate: t
  }) {
    return !e || !t ? Ge.validationOK : e.isAfter(t) ? {
      isValid: !1,
      error: "From time should be before to time"
    } : Ge.validationOK;
  }
}
const Am = "h-datePicker-range-inputFields--dateRangePickerInputFields__root", $m = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop", Om = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector", Bm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom", Wm = "h-datePicker-range-inputFields--dateRangePickerInputFields__fields", Hm = "h-datePicker-range-inputFields--dateRangePickerInputFields__input", Mm = "h-datePicker-range-inputFields--dateRangePickerInputFields__alert", Ke = {
  root: Am,
  rootPlacementTop: $m,
  rootPlacementTopWithTimezoneSelector: Om,
  rootPlacementBottom: Bm,
  fields: Wm,
  input: Hm,
  alert: Mm
};
Array(24).fill(0).map((i, e) => e);
class Js extends D {
  dateRangeValidators;
  timeOptions;
  instanceId;
  constructor(e) {
    super(e);
    const { dateFormat: t } = e;
    this.state = {
      startDateInputValue: this.props.startDate?.format(t) ?? "",
      startDateError: null,
      endDateInputValue: this.props.endDate?.format(t) ?? "",
      endDateError: null,
      timeOrderError: null
    }, this.timeOptions = [], this.instanceId = Js.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new Ge(
      e.dateFormat,
      this.parseDateString,
      { maxDate: e.maxDate, minDate: e.minDate }
    );
  }
  componentDidUpdate(e) {
    this.syncStartDateWithProps(e), this.syncEndDateWithProps(e), this.validateTimesOrder();
  }
  static instanceCount = 0;
  validateTimesOrder() {
    const { startDate: e, endDate: t } = this.props, { isValid: n, error: o } = this.dateRangeValidators.isTimeOrderValid({
      startDate: e,
      endDate: t
    });
    n ? this.setState({ timeOrderError: null }) : this.setState({
      timeOrderError: o
    });
  }
  syncEndDateWithProps(e) {
    const { endDate: t, timeRoundingStrategy: n } = this.props;
    if (!(t === e.endDate || t?.isSame(e.endDate, n)))
      return this.props.endDate ? this.setState({
        endDateError: null,
        endDateInputValue: this.props.endDate.format(this.props.dateFormat)
      }) : this.setState({
        endDateError: null,
        endDateInputValue: ""
      });
  }
  syncStartDateWithProps(e) {
    const { startDate: t, timeRoundingStrategy: n } = this.props;
    if (!(t === e.startDate || t?.isSame(e.startDate, n)))
      return this.props.startDate ? this.setState({
        startDateError: null,
        startDateInputValue: this.props.startDate.format(this.props.dateFormat)
      }) : this.setState({
        startDateError: null,
        startDateInputValue: ""
      });
  }
  handleInputValueChange(e, t) {
    const n = e.target.value;
    switch (t) {
      case "startDate":
        this.setState(
          { startDateInputValue: this.ensureValidChars(n) },
          this.propagateStartDateChangeEvent
        );
        break;
      case "endDate":
        this.setState(
          { endDateInputValue: this.ensureValidChars(n) },
          this.propagateEndDateChangeEvent
        );
        break;
    }
  }
  propagateStartDateChangeEvent() {
    const { startDateInputValue: e, endDateInputValue: t } = this.state;
    if (e === "") {
      this.props.onStartDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    });
    if (!n) {
      this.setState({ startDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    }), l = t !== "" && !r ? a : null;
    this.setState(
      {
        startDateError: null,
        endDateError: l
      },
      () => this.props.onStartDateChange(this.parseDateString(e))
    );
  }
  propagateEndDateChangeEvent() {
    const { startDateInputValue: e, endDateInputValue: t } = this.state;
    if (t === "") {
      this.props.onEndDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    });
    if (!n) {
      this.setState({ endDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    }), l = e !== "" && !r ? a : null;
    this.setState(
      {
        endDateError: null,
        startDateError: l
      },
      () => this.props.onEndDateChange(this.parseDateString(t))
    );
  }
  parseDateString(e) {
    return j(e, this.props.dateFormat, !0);
  }
  ensureValidChars(e) {
    return e.replace(/[^0-9/]/g, "");
  }
  getOverrides(e) {
    if (e !== "startTime")
      return [
        {
          hour: 23,
          minute: 59
        }
      ];
  }
  renderFields(e, t, n, o, r, a, l) {
    const {
      dateFormat: c,
      disabled: d,
      focusedInput: h,
      onFocusChange: u,
      onTimeChange: p,
      timeFormat: m,
      withTimePicker: g,
      withDateInput: b
    } = this.props, { timeOrderError: x } = this.state;
    return /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx(Qs, { children: e === "startDate" ? "From" : "To" }),
      b && /* @__PURE__ */ s.jsx(
        Ye,
        {
          className: Ke.input,
          placeholder: c.toLowerCase(),
          name: `input__${e}__${this.instanceId}`,
          value: r,
          onChange: (C) => this.handleInputValueChange(C, e),
          onFocus: () => u(e),
          autoComplete: "off",
          status: a ? "error" : void 0,
          disabled: d,
          active: h === e
        }
      ),
      g && /* @__PURE__ */ s.jsx("div", { className: Ke.input, children: /* @__PURE__ */ s.jsx(
        se,
        {
          content: "Please select a date first.",
          disabled: !!n || d,
          side: "right",
          children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
            an,
            {
              disabled: !n,
              overrides: this.getOverrides(t),
              selectedItems: o ? [o] : void 0,
              status: x ? "error" : void 0,
              ...l,
              timeFormat: m,
              onSelect: (C) => p(t, C)
            }
          ) })
        }
      ) })
    ] });
  }
  getError() {
    const { startDateError: e, endDateError: t, timeOrderError: n } = this.state;
    return e || t || n || null;
  }
  renderErrors() {
    const e = this.getError();
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        className: Ke.alert,
        variant: e ? "error" : void 0,
        children: e
      }
    );
  }
  render() {
    const {
      startDate: e,
      startTime: t,
      endDate: n,
      endTime: o,
      timePickerProps: r = { start: {}, end: {} },
      hasTimezoneSelector: a
    } = this.props, {
      startDateInputValue: l,
      startDateError: c,
      endDateInputValue: d,
      endDateError: h
    } = this.state, { placement: u } = this.props, p = f(Ke.root, {
      [Ke.rootPlacementTop]: u === "top",
      [Ke.rootPlacementTopWithTimezoneSelector]: u === "top" && a,
      [Ke.rootPlacementBottom]: u === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: p, children: [
      /* @__PURE__ */ s.jsxs("div", { className: Ke.fields, children: [
        this.renderFields(
          "startDate",
          "startTime",
          e,
          t,
          l,
          c,
          r.start
        ),
        this.renderFields(
          "endDate",
          "endTime",
          n,
          o,
          d,
          h,
          r.end
        )
      ] }),
      this.renderErrors()
    ] });
  }
}
const zm = "dateRangePickerTestId";
class Vm extends D {
  static defaultProps = {
    withDateInput: !0,
    withTimePicker: !1,
    timePickerProps: { start: {}, end: {} },
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(e) {
    super(e);
    const {
      startDate: t,
      endDate: n,
      timezone: o,
      presetKey: r,
      presets: a,
      focusedInput: l = "startDate"
    } = e;
    this.state = {
      startTime: t ? j(t).format(Re) : null,
      endTime: n ? j(n).format(Re) : null,
      timezone: Tt(o) ? o : j.tz.guess(!0),
      presetKey: a?.find(({ key: c }) => c === r)?.key ?? null,
      focusedInput: l,
      dateRangePickerKey: 0
    }, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(e) {
    this.updateTimeOnDateChange(e), this.recalculateDatePickerKey(e), this.updateTimezoneFromProps(e), this.updatePresetKey(e);
  }
  visibleCalendarMonthRef = B();
  updatePresetKey(e) {
    const { presetKey: t } = this.props;
    e.presetKey !== t && this.setState({
      presetKey: this.props.presets?.find(({ key: n }) => n === t)?.key ?? null
    });
  }
  updateTimezoneFromProps(e) {
    const { timezone: t } = this.props;
    e.timezone !== t && Tt(t) && this.setState({ timezone: t });
  }
  getDateConstraints() {
    const { maxDate: e, minDate: t } = this.props, n = this.dateFormat;
    return {
      minDate: t ? j(t, n) : j("0001-01-01"),
      maxDate: e ? j(e, n) : j("9999-12-31")
    };
  }
  onTimezoneChange(e) {
    const { startDate: t, endDate: n } = this.props, { presetKey: o } = this.state;
    this.setState(
      { timezone: e },
      () => this.onDatesChange({ startDate: t, endDate: n }, o)
    );
  }
  onStartDateChange(e) {
    this.onDatesChange({ startDate: e, endDate: this.props.endDate });
  }
  onEndDateChange(e) {
    this.onDatesChange({ endDate: e, startDate: this.props.startDate });
  }
  onDatesChange(e, t = null) {
    const { startTime: n, endTime: o, timezone: r } = this.state, { timeRoundingStrategy: a } = this.props, l = this.addTimezoneToDate(
      e.startDate,
      r
    ), c = this.addTimezoneToDate(
      e.endDate,
      r
    );
    let d = l?.clone().startOf(a) || null, h = c?.clone().endOf(a) || null, u = e.startDate?.clone().startOf(a) || null, p = e.endDate?.clone().endOf(a) || null;
    if (this.setState({ presetKey: t }), t) {
      this.setState(
        {
          startTime: e.startDate?.clone().startOf(a).format(Re) ?? null,
          endTime: e.endDate?.clone().startOf(a).format(Re) ?? null
        },
        () => {
          this.props.onChange({
            startDate: d,
            localStartDate: u,
            endDate: h,
            localEndDate: p,
            timezone: r,
            localTimezone: j.tz.guess(!0),
            presetKey: t
          });
        }
      );
      return;
    }
    n && (d = this.addTimeToDate(
      l,
      n,
      "startDate"
    ), u = this.addTimeToDate(
      e.startDate,
      n,
      "startDate"
    )), o && (h = this.addTimeToDate(c, o, "endDate"), p = this.addTimeToDate(e.endDate, o, "endDate")), this.props.onChange({
      startDate: d,
      localStartDate: u,
      endDate: h,
      localEndDate: p,
      timezone: r,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(e) {
    if (!e)
      this.onDatesChange({ startDate: null, endDate: null });
    else {
      const { startDate: t, endDate: n, key: o } = e;
      this.onDatesChange({ startDate: t, endDate: n }, o);
    }
    this.handleFocusChange("startDate");
  }
  handleTimeChange(e, t) {
    const { startDate: n, endDate: o } = this.props;
    this.setState(
      (r) => ({
        ...r,
        [e]: t
      }),
      () => this.onDatesChange({ startDate: n, endDate: o })
    );
  }
  addTimezoneToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Tt(t) ? e.clone().tz(t, !0) : e.clone().startOf(n);
  }
  handleFocusChange(e) {
    this.setState({ focusedInput: e ?? "startDate" });
  }
  addTimeToDate(e, t, n) {
    if (!e)
      return null;
    const { timeRoundingStrategy: o } = this.props, [r, a] = t.split(":");
    return !r || !a ? n === "startDate" ? e.clone().startOf(o) : e.clone().endOf(o) : e.clone().set({
      hours: parseInt(r, 10),
      minutes: parseInt(a, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(e) {
    if (this.props.disabled)
      return !0;
    const { timeRoundingStrategy: t } = this.props, { minDate: n, maxDate: o } = this.getDateConstraints();
    return !e.isBetween(n, o, t);
  }
  updateTimeOnDateChange({
    startDate: e,
    endDate: t
  }) {
    const { startDate: n, endDate: o } = this.props;
    n?.isSame(e) || this.setState({
      startTime: n ? j(n).format(Re) : null
    }), o?.isSame(t) || this.setState({
      endTime: o ? j(o).format(Re) : null
    });
  }
  recalculateDatePickerKey({
    startDate: e,
    endDate: t
  }) {
    const { startDate: n, endDate: o } = this.props;
    if (t && e && !n && !o)
      return this.setState({ dateRangePickerKey: this.generateRandomKey() });
    if (!(!o && !t) && !(!o && t)) {
      if (o && !t) {
        const r = this.visibleCalendarMonthRef.current?.state.currentMonth;
        if (this.visibleCalendarMonthRef.current && o.isSame(r, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
      if (o && t) {
        if (o.isSame(t, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
    }
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  get dateFormat() {
    const { dateFormat: e } = this.props;
    return e || j.localeData().longDateFormat("L");
  }
  renderTimezoneSelector() {
    const {
      startDate: e,
      endDate: t,
      disabled: n,
      withTimezoneSelector: o,
      timezoneSelectorProps: r
    } = this.props, { timezone: a } = this.state;
    if (!o)
      return null;
    const l = !!e || !!t, c = !l && !n, d = !l || n || r?.disabled;
    return /* @__PURE__ */ s.jsx(
      zr,
      {
        disabled: d,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !c,
          ...r?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: a
      }
    );
  }
  renderInputFields(e) {
    const {
      withDateInput: t,
      withTimePicker: n,
      withTimezoneSelector: o,
      timePickerProps: r,
      disabled: a,
      startDate: l,
      endDate: c,
      selectableMinutes: d,
      selectableHours: h,
      inputsPlacement: u,
      timeFormat: p,
      timeRoundingStrategy: m
    } = this.props;
    if (u !== e || !t && !n)
      return null;
    const { startTime: g, endTime: b, focusedInput: x } = this.state, { minDate: C, maxDate: _ } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Js,
      {
        dateFormat: this.dateFormat,
        timeFormat: p,
        onStartDateChange: this.onStartDateChange,
        onEndDateChange: this.onEndDateChange,
        onTimeChange: this.handleTimeChange,
        onFocusChange: this.handleFocusChange,
        startDate: l,
        endDate: c,
        startTime: g,
        endTime: b,
        minDate: C,
        maxDate: _,
        disabled: a,
        withDateInput: t,
        withTimePicker: n,
        hasTimezoneSelector: o,
        timePickerProps: r,
        selectableMinutes: d,
        selectableHours: h,
        placement: e,
        timeRoundingStrategy: m,
        focusedInput: x
      }
    );
  }
  renderPresets() {
    const { presets: e } = this.props, { presetKey: t } = this.state;
    return e?.length ? /* @__PURE__ */ s.jsx(
      Hr,
      {
        value: t,
        presets: e,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: e, calendarProps: t, disabled: n, startDate: o, endDate: r } = this.props, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": zm,
        className: f(kt.root, e),
        children: [
          /* @__PURE__ */ s.jsxs(W, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              wr.DayPickerRangeController,
              {
                ref: this.visibleCalendarMonthRef,
                startDate: o,
                endDate: r,
                onDatesChange: this.onDatesChange,
                onFocusChange: this.handleFocusChange,
                focusedInput: this.state.focusedInput,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Br,
                daySize: 32,
                minimumNights: 0,
                disabled: n,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Wr,
                initialVisibleMonth: () => o || r || j(),
                transitionDuration: 0,
                ...t
              },
              this.state.dateRangePickerKey
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Km = "h-datePicker-single-inputFields--datePickerInputFields__root", Um = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop", qm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector", Gm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom", Ym = "h-datePicker-single-inputFields--datePickerInputFields__input", Qm = "h-datePicker-single-inputFields--datePickerInputFields__alert", rt = {
  root: Km,
  rootPlacementTop: Um,
  rootPlacementTopWithTimezoneSelector: qm,
  rootPlacementBottom: Gm,
  input: Ym,
  alert: Qm
};
class eo extends D {
  dateValidators;
  instanceId;
  constructor(e) {
    super(e);
    const { dateFormat: t } = e;
    this.state = {
      dateInputValue: this.props.date?.format(t) ?? "",
      dateError: null
    }, this.instanceId = eo.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new Ge(
      e.dateFormat,
      this.parseDateString,
      { maxDate: e.maxDate, minDate: e.minDate }
    );
  }
  componentDidUpdate(e) {
    this.syncDateWithProps(e);
  }
  static instanceCount = 0;
  syncDateWithProps(e) {
    const { date: t, timeRoundingStrategy: n } = this.props, o = j(t);
    if (!(t === e.date || o?.isSame(j(e.date), n)))
      return this.props.date ? this.setState({
        dateError: null,
        dateInputValue: o.format(this.props.dateFormat)
      }) : this.setState({
        dateError: null,
        dateInputValue: ""
      });
  }
  handleInputValueChange(e) {
    const t = this.ensureValidChars(e.target.value);
    this.setState({ dateInputValue: t }, this.propagateDateChangeEvent);
  }
  propagateDateChangeEvent() {
    const { dateInputValue: e } = this.state;
    if (e === "") {
      this.props.onDateChange(null);
      return;
    }
    const { isValid: t, error: n } = this.dateValidators.isSingleDateValid(e);
    if (!t) {
      this.setState({ dateError: n });
      return;
    }
    this.setState(
      {
        dateError: null
      },
      () => this.props.onDateChange(this.parseDateString(e))
    );
  }
  parseDateString(e) {
    return j(e, this.props.dateFormat, !0);
  }
  ensureValidChars(e) {
    return e.replace(/[^0-9/]/g, "");
  }
  renderDateInput() {
    const { disabled: e, dateFormat: t, withDateInput: n } = this.props, { dateInputValue: o, dateError: r } = this.state;
    return n ? /* @__PURE__ */ s.jsx(
      Ye,
      {
        className: rt.input,
        required: !0,
        name: `date__input__${this.instanceId}`,
        value: o,
        onChange: this.handleInputValueChange,
        autoComplete: "off",
        placeholder: t.toLowerCase(),
        disabled: e,
        status: r ? "error" : void 0
      }
    ) : null;
  }
  renderTimeInput() {
    const {
      date: e,
      time: t,
      withTimePicker: n,
      timePickerProps: o = {},
      disabled: r,
      onTimeChange: a,
      timeFormat: l
    } = this.props;
    if (!n)
      return null;
    const c = !e && !r, d = !e || r;
    return /* @__PURE__ */ s.jsx(
      se,
      {
        content: "Please select a date first.",
        disabled: !c,
        side: "right",
        children: /* @__PURE__ */ s.jsx("div", { className: rt.input, children: /* @__PURE__ */ s.jsx(
          an,
          {
            disabled: d,
            onSelect: a,
            selectedItems: t ? [t] : void 0,
            ...o,
            timeFormat: l
          }
        ) })
      }
    );
  }
  renderErrors() {
    const { dateError: e } = this.state;
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        className: rt.alert,
        variant: e ? "error" : void 0,
        children: this.state.dateError
      }
    );
  }
  render() {
    const { hasTimezoneSelector: e, placement: t } = this.props, n = f(rt.root, {
      [rt.rootPlacementTop]: t === "top",
      [rt.rootPlacementTopWithTimezoneSelector]: t === "top" && e,
      [rt.rootPlacementBottom]: t === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: n, children: [
      this.renderDateInput(),
      this.renderTimeInput(),
      this.renderErrors()
    ] });
  }
}
const Xm = "datePickerTestId";
class Zm extends D {
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    withDateInput: !1,
    withTimePicker: !1,
    timePickerProps: {},
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(e) {
    super(e);
    const { date: t, timezone: n, presets: o, presetKey: r } = e;
    this.state = {
      time: t ? j(t).format(Re) : null,
      timezone: Tt(n) ? n : j.tz.guess(!0),
      presetKey: o?.find(({ key: a }) => a === r)?.key ?? null,
      datePickerKey: 0
    }, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(e) {
    this.updateTimeOnDateChange(e), this.recalculateDatePickerKey();
  }
  visibleCalendarMonthRef = B();
  getDateConstraints() {
    const { maxDate: e, minDate: t } = this.props;
    return {
      minDate: t || j("0001-01-01"),
      maxDate: e || j("9999-12-31")
    };
  }
  onTimezoneChange(e) {
    const { date: t } = this.props, { presetKey: n } = this.state;
    this.setState({ timezone: e }, () => this.onDateChange(t, n));
  }
  onDateChange(e, t = null) {
    const { time: n, timezone: o } = this.state, { timeRoundingStrategy: r } = this.props, a = this.addTimezoneToDate(e, o);
    let l = a?.clone().startOf(r) || null, c = e?.clone().startOf(r) || null;
    if (this.setState({ presetKey: t }), t) {
      this.setState(
        {
          time: e?.clone().startOf(r).format(Re) ?? null
        },
        () => {
          this.props.onChange({
            date: l,
            localDate: c,
            timezone: o,
            localTimezone: j.tz.guess(!0),
            presetKey: t
          });
        }
      );
      return;
    }
    n && (l = this.addTimeToDate(a, n), c = this.addTimeToDate(e, n)), this.props.onChange({
      date: l,
      localDate: c,
      timezone: o,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(e) {
    e ? this.onDateChange(e.date, e.key) : this.onDateChange(null);
  }
  handleTimeChange(e) {
    const { date: t } = this.props;
    this.setState(
      (n) => ({
        ...n,
        time: e
      }),
      () => this.onDateChange(t)
    );
  }
  addTimezoneToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Tt(t) ? j(e).clone().tz(t, !0) : e.clone().startOf(n);
  }
  addTimeToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props, [o, r] = t.split(":");
    return !o || !r ? e.clone().startOf(n) : e.clone().set({
      hours: parseInt(o, 10),
      minutes: parseInt(r, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(e) {
    const { disabled: t, timeRoundingStrategy: n } = this.props;
    if (t)
      return !0;
    const { minDate: o, maxDate: r } = this.getDateConstraints();
    return !e.isBetween(o, r, n);
  }
  updateTimeOnDateChange(e) {
    const { date: t } = this.props;
    e.date?.isSame(t) || this.setState({
      time: t ? j(t).format(Re) : null
    });
  }
  recalculateDatePickerKey() {
    const { date: e } = this.props, t = this.visibleCalendarMonthRef.current?.state.currentMonth;
    if (t && e && !e.isSame(t, "month"))
      return this.setState({ datePickerKey: this.generateRandomKey() });
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  renderTimezoneSelector() {
    const { date: e, disabled: t, withTimezoneSelector: n, timezoneSelectorProps: o } = this.props, { timezone: r } = this.state;
    if (!n)
      return null;
    const a = !!e, l = !a && !t, c = !a || t || o?.disabled;
    return /* @__PURE__ */ s.jsx(
      zr,
      {
        disabled: c,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !l,
          ...o?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: r,
        ...o
      }
    );
  }
  renderInputFields(e) {
    const {
      dateFormat: t,
      timeFormat: n,
      withDateInput: o,
      withTimePicker: r,
      withTimezoneSelector: a,
      timePickerProps: l,
      selectableMinutes: c,
      selectableHours: d,
      disabled: h,
      date: u,
      inputsPlacement: p,
      timeRoundingStrategy: m
    } = this.props;
    if (p !== e || !o && !r)
      return null;
    const { time: g } = this.state, { minDate: b, maxDate: x } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      eo,
      {
        dateFormat: t,
        timeFormat: n,
        onDateChange: this.onDateChange,
        onTimeChange: this.handleTimeChange,
        time: g,
        date: u,
        minDate: b,
        maxDate: x,
        disabled: h,
        withDateInput: o,
        withTimePicker: r,
        hasTimezoneSelector: a,
        timePickerProps: l,
        selectableMinutes: c,
        selectableHours: d,
        placement: e,
        timeRoundingStrategy: m
      }
    );
  }
  renderPresets() {
    const { presets: e } = this.props, { presetKey: t } = this.state;
    return e?.length ? /* @__PURE__ */ s.jsx(
      Hr,
      {
        value: t,
        presets: e,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: e, calendarProps: t, disabled: n, date: o } = this.props, { datePickerKey: r } = this.state, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Xm,
        className: f(kt.root, e),
        children: [
          /* @__PURE__ */ s.jsxs(W, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              wr.DayPickerSingleDateController,
              {
                ref: this.visibleCalendarMonthRef,
                date: o,
                onDateChange: this.onDateChange,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Br,
                daySize: 32,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Wr,
                initialVisibleMonth: () => o || j(),
                onFocusChange: L,
                focused: !0,
                transitionDuration: 0,
                ...t
              },
              r
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Jm = "h-dialer--dialer__dialer", eg = "h-dialer--dialer__number", tg = "h-dialer--dialer__letters", ng = "h-dialer--dialer__asterisk", Bn = {
  dialer: Jm,
  number: eg,
  letters: tg,
  asterisk: ng
}, sg = [
  { value: "1", letters: " " },
  { value: "2", letters: "abc" },
  { value: "3", letters: "def" },
  { value: "4", letters: "ghi" },
  { value: "5", letters: "jkl" },
  { value: "6", letters: "mno" },
  { value: "7", letters: "pqrs" },
  { value: "8", letters: "tuv" },
  { value: "9", letters: "wxyz" },
  { value: "*", letters: null, classNames: Bn.asterisk },
  { value: "0", letters: null },
  { value: "#", letters: null }
];
class Zk extends D {
  render() {
    const { className: e, onInput: t, ...n } = this.props, o = f(Bn.dialer, e);
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: sg.map((r) => /* @__PURE__ */ Vi(
      "div",
      {
        className: f(Bn.number),
        ...Xn(() => t(r.value)),
        key: r.value
      },
      /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-1", color: "neutral.700", children: /* @__PURE__ */ s.jsx("span", { className: r.classNames ?? "", children: r.value }) }),
      /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", color: "neutral.700", children: !!r.letters && /* @__PURE__ */ s.jsx("span", { className: Bn.letters, children: r.letters }) })
    )) });
  }
}
const og = "h-fieldWrapper--fieldWrapper__root", rg = "h-fieldWrapper--fieldWrapper__rootDisabled", ig = "h-fieldWrapper--fieldWrapper__label", ag = "h-fieldWrapper--fieldWrapper__alert", wn = {
  root: og,
  rootDisabled: rg,
  label: ig,
  alert: ag
}, lg = "fieldWrapper";
class z extends D {
  static hasStatus(e, t) {
    return e?.[t] ? e?.touched === void 0 || e.touched === !0 : !1;
  }
  static getStatusMessage(e, t) {
    if (this.hasStatus(e, t))
      return e?.[t];
  }
  static getStatus(e) {
    return z.hasStatus(e, "error") ? "error" : z.hasStatus(e, "warning") ? "warning" : z.hasStatus(e, "success") ? "success" : void 0;
  }
  renderAlerts() {
    const { meta: e, description: t } = this.props;
    let n = t, o;
    return z.hasStatus(e, "error") ? (n = z.getStatusMessage(e, "error"), o = "error") : z.hasStatus(e, "warning") ? (n = z.getStatusMessage(e, "warning"), o = "warning") : z.hasStatus(e, "success") && (n = z.getStatusMessage(e, "success"), o = "success"), /* @__PURE__ */ s.jsx(ts, { variant: o, className: wn.alert, children: n });
  }
  render() {
    const {
      className: e,
      labelFor: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = f(
      wn.root,
      {
        [wn.rootDisabled]: a
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": lg,
        ...u,
        className: p,
        children: [
          !d && /* @__PURE__ */ s.jsx(
            Qs,
            {
              required: r,
              htmlFor: t,
              helpIcon: l,
              className: wn.label,
              children: n
            }
          ),
          h,
          !c && this.renderAlerts()
        ]
      }
    );
  }
}
class Ls extends D {
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noLabel: d,
      noAlert: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noLabel: d,
        noAlert: h,
        children: /* @__PURE__ */ s.jsx(
          Ye,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...t,
            ...u
          }
        )
      }
    );
  }
}
const cg = "h-dropdownSelect--dropdownSelectContainer__search", dg = "h-dropdownSelect--dropdownSelectContainer__pagination", hg = "h-dropdownSelect--dropdownSelectContainer__selectionActions", ug = "h-dropdownSelect--dropdownSelectContainer__extra", Sn = {
  search: cg,
  pagination: dg,
  selectionActions: hg,
  extra: ug
}, pg = "DROP_SEARCH_INPUT";
class Vr extends ge {
  listRef;
  searchRef;
  static getDerivedStateFromProps(e, t) {
    const { dropdownOpen: n } = e, o = { ...t };
    return n || (o.searchValue = "", o.activeItemIndex = 0), o;
  }
  constructor(e) {
    super(e), this.state = {
      searchValue: "",
      activeItemIndex: 0
    }, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.handleItemKeyDown = this.handleItemKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = B(), this.searchRef = B();
  }
  componentDidMount() {
    this.onOpen();
  }
  componentDidUpdate(e) {
    const { dropdownOpen: t } = this.props;
    !e.dropdownOpen && t && this.onOpen();
  }
  getInput() {
    const { searchValue: e } = this.state;
    return {
      name: pg,
      value: e,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: "off",
      "aria-label": "Search"
    };
  }
  searchKeyDown(e) {
    const { key: t } = e, { searchValue: n, activeItemIndex: o } = this.state, { triggerClose: r, items: a, disabledItems: l = [] } = this.props, c = a.map((h, u) => ({ item: h, index: u })).filter(({ item: h }) => !l.includes(h.id)).map(({ index: h }) => h), d = c.indexOf(o);
    if (t === "Escape")
      n === "" ? r() : this.clearSearch();
    else if (t === "ArrowDown") {
      if (e.preventDefault(), c.length > 0) {
        const h = d < c.length - 1 ? d + 1 : 0;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "ArrowUp") {
      if (e.preventDefault(), c.length > 0) {
        const h = d > 0 ? d - 1 : c.length - 1;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "Home")
      e.preventDefault(), c.length > 0 && this.setState(
        { activeItemIndex: c[0] },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (t === "End")
      e.preventDefault(), c.length > 0 && this.setState(
        {
          activeItemIndex: c[c.length - 1]
        },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (t === "Enter") {
      e.preventDefault();
      const h = a[o];
      if (h && !l.includes(h.id)) {
        const { onChange: u, selectedItems: p = [] } = this.props;
        if (u) {
          const m = p.some((g) => (typeof g == "object" ? g.id : g) === h.id);
          this.onChange(h, !m);
        } else
          this.onSelect(h);
      }
    }
  }
  handleItemKeyDown(e) {
    const { key: t } = e, { activeItemIndex: n } = this.state, { triggerClose: o, items: r, disabledItems: a = [] } = this.props, l = r.map((d, h) => ({ item: d, index: h })).filter(({ item: d }) => !a.includes(d.id)).map(({ index: d }) => d), c = l.indexOf(n);
    if (t === "Escape")
      o();
    else if (t === "ArrowDown") {
      if (e.preventDefault(), l.length > 0) {
        const d = c < l.length - 1 ? c + 1 : 0;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "ArrowUp") {
      if (e.preventDefault(), l.length > 0) {
        const d = c > 0 ? c - 1 : l.length - 1;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else t === "Home" ? (e.preventDefault(), l.length > 0 && this.setState(
      { activeItemIndex: l[0] },
      () => this.listRef.current?.focusActiveItem()
    )) : t === "End" && (e.preventDefault(), l.length > 0 && this.setState(
      {
        activeItemIndex: l[l.length - 1]
      },
      () => this.listRef.current?.focusActiveItem()
    ));
  }
  search(e) {
    const { onSearch: t } = this.props, { value: n } = e.target;
    typeof t == "function" && t(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
      searchValue: n,
      activeItemIndex: 0
    });
  }
  onSelect(e) {
    const { onSelect: t, keepOpen: n, triggerClose: o } = this.props;
    typeof t == "function" && t(e), n && this.focusSearch(), !n && typeof o == "function" && o();
  }
  onChange(e, t) {
    const { onChange: n, keepOpen: o, triggerClose: r } = this.props;
    typeof n == "function" && n(e, t), o && this.focusSearch(), !o && typeof r == "function" && r();
  }
  onOpen() {
    const { hasSearch: e } = this.props;
    e ? this.focusSearch() : setTimeout(() => {
      this.listRef.current?.focusActiveItem();
    }, 0);
  }
  focusSearch() {
    const { hasSearch: e } = this.props;
    if (e && this.searchRef.current) {
      const t = this.searchRef.current.querySelector("input");
      t && t.focus();
    }
  }
  clearSearch = () => {
    const { onSearch: e } = this.props, { searchValue: t } = this.state;
    t && (typeof e == "function" && e(""), this.setState({ searchValue: "" }));
  };
  render() {
    const {
      className: e,
      itemComponent: t,
      emptyComponent: n,
      suggestionComponent: o,
      optionComponent: r,
      items: a,
      hasSearch: l,
      searchPlaceholder: c,
      pagination: d,
      keepOpen: h,
      onSelect: u,
      onSearch: p,
      onSuggest: m,
      onChange: g,
      onClear: b,
      onClearText: x,
      triggerClose: C,
      dropdownOpen: _,
      emptyMessage: S,
      selectedItems: v,
      disabledItems: y,
      tooltipItems: w,
      activeItem: I,
      itemsDisplayCount: T,
      itemHeight: F,
      renderSuggestion: H,
      searchSuggestion: k,
      ...R
    } = this.props;
    if (!_)
      return null;
    const { searchValue: O, activeItemIndex: U } = this.state, oe = a.length === 0, ne = a[U] ?? I ?? a[0] ?? null, E = f(e);
    return /* @__PURE__ */ s.jsxs("div", { ...R, className: E, children: [
      l && /* @__PURE__ */ s.jsx("div", { className: Sn.search, ref: this.searchRef, children: /* @__PURE__ */ s.jsx(
        Ls,
        {
          input: this.getInput(),
          meta: { error: null, touched: !0 },
          icon: "search",
          noAlert: !0,
          noLabel: !0,
          placeholder: c
        }
      ) }),
      !!(l && o || r) && /* @__PURE__ */ s.jsxs("div", { className: Sn.extra, children: [
        r,
        l && typeof o == "function" && /* @__PURE__ */ s.jsx(
          o,
          {
            searched: O,
            onSuggest: m,
            triggerClose: h ? void 0 : C,
            clearSearch: this.clearSearch,
            items: a,
            searchSuggestion: k,
            renderSuggestion: H
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        !oe && /* @__PURE__ */ s.jsx(
          Xs,
          {
            ref: this.listRef,
            pagination: d,
            items: a,
            onSelect: this.onSelect,
            onChange: this.onChange,
            onKeyDown: this.handleItemKeyDown,
            clearSearch: this.clearSearch,
            selectedItems: v,
            disabledItems: y,
            itemComponent: t,
            tooltipItems: w,
            itemsDisplayCount: T,
            itemHeight: F,
            activeItem: ne
          }
        ),
        oe && typeof n == "function" && /* @__PURE__ */ s.jsx(n, { label: S || "" })
      ] }),
      typeof b == "function" && /* @__PURE__ */ s.jsx("div", { className: Sn.selectionActions, children: /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "secondary",
          disabled: v?.length === 0,
          onClick: b,
          children: x || "Clear"
        }
      ) }),
      !!d && !d.infinite && /* @__PURE__ */ s.jsxs("div", { className: Sn.pagination, children: [
        /* @__PURE__ */ s.jsx(
          X,
          {
            variant: "secondary",
            disabled: !d.previousEnable,
            onClick: d.onPrevious,
            children: "Prev page"
          }
        ),
        /* @__PURE__ */ s.jsx(
          X,
          {
            variant: "secondary",
            disabled: !d.nextEnable,
            onClick: d.onNext,
            children: "Next page"
          }
        )
      ] })
    ] });
  }
}
class to extends D {
  static defaultProps = {
    className: "",
    buttonProps: {},
    dropdownProps: {},
    containerProps: {},
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    pagination: !1,
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    onToggle: () => {
    },
    onKeyDown: () => {
    },
    emptyComponent: pn,
    emptyMessage: "No items found",
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  render() {
    const {
      className: e,
      items: t,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      onClearText: l,
      onKeyDown: c,
      hasSearch: d,
      searchPlaceholder: h = "Search...",
      onSuggest: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      children: b,
      buttonProps: x,
      dropdownProps: C,
      containerProps: _,
      pagination: S,
      emptyComponent: v,
      emptyMessage: y,
      selectedItems: w,
      disabledItems: I,
      tooltipItems: T,
      activeItem: F,
      itemsDisplayCount: H,
      itemHeight: k,
      optionComponent: R,
      renderSuggestion: O,
      searchSuggestion: U,
      ...oe
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      dt,
      {
        ...oe,
        className: e,
        buttonProps: { variant: "secondary", ...x },
        dropdownProps: C,
        dropdown: /* @__PURE__ */ s.jsx(un.Consumer, { children: ({ toggleDropdown: ne, dropdownOpen: E }) => /* @__PURE__ */ s.jsx(
          Vr,
          {
            ..._,
            items: t,
            itemComponent: m,
            hasSearch: d,
            searchPlaceholder: h,
            suggestionComponent: g,
            onSuggest: u,
            keepOpen: p,
            onSearch: r,
            onSelect: n,
            onChange: o,
            onClear: a,
            onClearText: l,
            onKeyDown: c,
            triggerClose: ne,
            dropdownOpen: E,
            pagination: S,
            emptyComponent: v,
            emptyMessage: y,
            selectedItems: w,
            disabledItems: I,
            tooltipItems: T,
            activeItem: F,
            itemsDisplayCount: H,
            itemHeight: k,
            optionComponent: R,
            renderSuggestion: O,
            searchSuggestion: U
          }
        ) }),
        children: b
      }
    );
  }
}
const mg = "h-dropdownSelectMultiple--dropdownSelectMultiple__items", gg = "h-dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown", fg = "h-dropdownSelectMultiple--dropdownSelectMultiple__tagName", fs = {
  items: mg,
  moreItemsDropdown: gg,
  tagName: fg
};
class bg extends ge {
  static defaultProps = {
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    emptyComponent: pn,
    emptyMessage: "No items found",
    buttonText: "+Select item",
    selectedItems: []
  };
  getItems() {
    const { items: e } = this.props;
    return e;
  }
  render() {
    const {
      items: e,
      itemComponent: t,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      hasSearch: l,
      searchPlaceholder: c,
      onSuggest: d,
      suggestionComponent: h,
      emptyComponent: u,
      emptyMessage: p,
      keepOpen: m,
      containerProps: g,
      buttonText: b,
      selectedItems: x,
      optionComponent: C,
      ..._
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      to,
      {
        ..._,
        containerProps: g,
        items: this.getItems(),
        itemComponent: t,
        hasSearch: l,
        searchPlaceholder: c,
        suggestionComponent: h,
        onSuggest: d,
        keepOpen: m,
        onSearch: r,
        onSelect: n,
        onChange: o,
        onClear: a,
        emptyComponent: u,
        emptyMessage: p,
        selectedItems: x,
        optionComponent: C,
        children: b
      }
    );
  }
}
class Jk extends ge {
  static defaultProps = {
    MoreItemsItemComponent: gp,
    hideSelectedItems: !1,
    disabledItems: [],
    tooltipItems: {}
  };
  constructor(e) {
    super(e), this.getListItem = this.getListItem.bind(this), this.getListMoreItem = this.getListMoreItem.bind(this);
  }
  resolveItem(e) {
    if (typeof e == "object")
      return e;
    const t = this.props.items.find((n) => n.id === e);
    return t || { id: Cr(), name: "Unknown" };
  }
  getItemName(e) {
    return e.name.toString().trim();
  }
  isItemDisabled(e) {
    return this.props.disabledItems ? this.props.disabledItems.indexOf(e.id) >= 0 : !1;
  }
  getTooltip(e) {
    const { tooltipItems: t } = this.props;
    return !t || zs(t[e.id]) ? null : t[e.id];
  }
  getListItem(e, t) {
    const { onRemove: n } = this.props, o = this.resolveItem(e), r = this.getItemName(o), a = this.getTooltip(o), l = /* @__PURE__ */ s.jsx(
      jt,
      {
        className: fs.tagName,
        onDelete: () => n(o),
        color: o.color,
        disabled: this.isItemDisabled(o),
        children: r
      },
      o.id
    );
    return a ? /* @__PURE__ */ s.jsx(se, { ...a, children: l }, t) : l;
  }
  getListMoreItem(e) {
    const { MoreItemsItemComponent: t, onRemove: n } = this.props, o = this.resolveItem(e), r = this.getTooltip(o), a = /* @__PURE__ */ s.jsx(
      t,
      {
        item: o,
        onSelect: n,
        disabled: this.isItemDisabled(o),
        clearSearch: L,
        isLoading: !1,
        checked: !1
      },
      o.id
    );
    return r ? /* @__PURE__ */ s.jsx(se, { ...r, children: a }, o.id) : a;
  }
  getPreviewItems() {
    const {
      selectedItems: e,
      previewItemsNumber: t,
      moreItemsDropdownProps: n = {}
    } = this.props;
    let o = [], r = [], a = "";
    if (t && e) {
      if (e.length > 0 && e.length < t)
        o = e.map(this.getListItem);
      else if (e.length >= t) {
        const h = e.slice(0, t), u = e.slice(
          t,
          e.length
        );
        o = h.map(this.getListItem), r = u.map(this.getListMoreItem), a = u.length.toString();
      }
    } else
      o = e.map(this.getListItem);
    const { className: l, ...c } = n, d = /* @__PURE__ */ s.jsx(
      "div",
      {
        ...c,
        className: f(fs.moreItemsDropdown, l),
        children: r
      }
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      t && e.length > t ? /* @__PURE__ */ s.jsxs(
        dt,
        {
          noArrow: !0,
          buttonProps: { variant: "tertiary" },
          dropdown: d,
          children: [
            "+ ",
            a,
            /* @__PURE__ */ s.jsx("span", { children: " selected" })
          ]
        }
      ) : null
    ] });
  }
  render() {
    const {
      items: e,
      selectedItems: t,
      previewItemsNumber: n,
      className: o,
      onSelect: r,
      onChange: a,
      onSearch: l,
      hasSearch: c,
      searchPlaceholder: d,
      onSuggest: h,
      onRemove: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      pagination: b,
      emptyComponent: x,
      emptyMessage: C,
      containerProps: _,
      moreItemsDropdownProps: S,
      MoreItemsItemComponent: v,
      hideSelectedItems: y,
      disabledItems: w,
      tooltipItems: I,
      optionComponent: T,
      ...F
    } = this.props, H = f(
      {
        [fs.items]: !0
      },
      o
    );
    return /* @__PURE__ */ s.jsxs("div", { className: H, children: [
      /* @__PURE__ */ s.jsx(
        bg,
        {
          items: e,
          itemComponent: m,
          hasSearch: c,
          searchPlaceholder: d,
          suggestionComponent: g,
          onSuggest: h,
          keepOpen: p,
          onSearch: l,
          onSelect: r,
          onChange: a,
          pagination: b,
          emptyComponent: x,
          emptyMessage: C,
          containerProps: _,
          selectedItems: t,
          disabledItems: w,
          tooltipItems: I,
          optionComponent: T,
          ...F
        }
      ),
      !y && this.getPreviewItems()
    ] });
  }
}
const xg = "h-fieldButton--fieldButton__button", yg = {
  button: xg
}, eT = $(
  function({
    className: e,
    buttonClassName: t,
    label: n,
    meta: o,
    disabled: r,
    helpIcon: a,
    description: l,
    noAlert: c,
    noLabel: d,
    children: h,
    ...u
  }, p) {
    const m = f(t, yg.button);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        meta: o,
        disabled: r,
        helpIcon: a,
        description: l,
        noAlert: c,
        noLabel: d,
        children: /* @__PURE__ */ s.jsx(
          X,
          {
            ref: p,
            disabled: r,
            ...u,
            className: m,
            children: h
          }
        )
      }
    );
  }
), _g = "h-inputDatePicker--inputDatePicker__root", Cg = "h-inputDatePicker--inputDatePicker__inputContainer", vg = "h-inputDatePicker--inputDatePicker__input", wg = "h-inputDatePicker--inputDatePicker__rootReadOnly", Sg = "h-inputDatePicker--inputDatePicker__iconsContainer", Ig = "h-inputDatePicker--inputDatePicker__rootHasClearIcon", Dg = "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon", kg = "h-inputDatePicker--inputDatePicker__calendarIcon", Tg = "h-inputDatePicker--inputDatePicker__clearIcon", Oe = {
  root: _g,
  inputContainer: Cg,
  input: vg,
  rootReadOnly: wg,
  iconsContainer: Sg,
  rootHasClearIcon: Ig,
  rootHasWrapperIcon: Dg,
  calendarIcon: kg,
  clearIcon: Tg
}, jg = "inputDatePickerTestId";
class Ng extends D {
  inputRef;
  rootRef;
  datePickerContainerRef;
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    name: Math.floor(Math.random() * 1e8).toString()
  };
  constructor(e) {
    super(e), this.inputRef = B(), this.rootRef = B(), this.datePickerContainerRef = B(), this.state = {
      isDropdownOpen: !1,
      shouldRerenderDatePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(e, t) {
    const { isDropdownOpen: n } = this.state;
    n !== t.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDatePickerInput() {
    this.datePickerContainerRef.current?.querySelector('input[type="text"]')?.focus();
  }
  handleWindowClick(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleWindowKeyDown(e) {
    Et(e.key) && this.state.isDropdownOpen && (e.stopPropagation(), this.hideDropdown());
  }
  handleDateChange(e) {
    const { onChange: t, value: n } = this.props;
    typeof t == "function" && t(e), (n ?? e !== null) && this.inputRef.current?.focus();
  }
  handleClearIconClick() {
    this.handleDateChange({
      date: null,
      localDate: null,
      timezone: null,
      localTimezone: null
    });
  }
  showDropdown() {
    this.setState({
      isDropdownOpen: !0,
      shouldRerenderDatePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus() {
    const { readOnly: e } = this.props;
    e || this.showDropdown();
  }
  handleInputBlur(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleInputClick(e) {
    const { readOnly: t } = this.props;
    t || (e.stopPropagation(), this.showDropdown());
  }
  handleInputKeydown({ key: e }) {
    Zn(e) && this.showDropdown();
  }
  handleCalendarIconClick(e) {
    const { readOnly: t } = this.props;
    t || (e.stopPropagation(), this.showDropdown());
  }
  renderInputAndIcons() {
    const {
      className: e,
      name: t,
      value: n,
      onChange: o,
      dateFormat: r,
      dropdownProps: a,
      prefix: l,
      suffix: c,
      icon: d,
      status: h,
      placeholder: u,
      disabled: p,
      datePickerProps: m,
      clearable: g,
      minDate: b,
      maxDate: x,
      readOnly: C,
      ..._
    } = this.props, { isDropdownOpen: S } = this.state;
    return /* @__PURE__ */ s.jsx(
      Ae,
      {
        prefix: l,
        suffix: c,
        disabled: p,
        icon: d,
        active: S,
        status: h,
        children: /* @__PURE__ */ s.jsxs("div", { className: Oe.inputContainer, children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ..._,
              id: t,
              name: t,
              className: Oe.input,
              ref: this.inputRef,
              onClick: this.handleInputClick,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onKeyDown: this.handleInputKeydown,
              disabled: p,
              placeholder: u || r?.toLowerCase(),
              autoComplete: "off",
              value: Hn(n) ? void 0 : n?.format(r) ?? "",
              onChange: Hn(n) ? void 0 : L,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: Oe.iconsContainer, children: [
            this.renderClearIcon(),
            this.renderCalendarIcon()
          ] })
        ] })
      }
    );
  }
  renderCalendarIcon() {
    const { disabled: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: Oe.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: this.handleCalendarIconClick,
        tabIndex: -1,
        disabled: e
      }
    );
  }
  renderClearIcon() {
    const { clearable: e, value: t, disabled: n } = this.props;
    return !e || !t ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: Oe.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: n,
        onClick: this.handleClearIconClick
      }
    );
  }
  renderDropdown() {
    const {
      value: e,
      minDate: t,
      maxDate: n,
      timezone: o,
      datePickerProps: r,
      disabled: a,
      dropdownProps: l,
      dateFormat: c
    } = this.props, { isDropdownOpen: d, shouldRerenderDatePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(et, { ...l, isOpen: d, children: /* @__PURE__ */ s.jsx("div", { ref: this.datePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Zm,
      {
        disabled: a,
        ...r,
        dateFormat: c,
        date: e ?? null,
        timezone: o,
        onChange: this.handleDateChange,
        minDate: t,
        maxDate: n
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: e, value: t, clearable: n, readOnly: o, icon: r } = this.props, a = f(Oe.root, e, {
      [Oe.rootHasClearIcon]: n && t,
      [Oe.rootHasWrapperIcon]: !!r,
      [Oe.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": jg,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputAndIcons(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class tT extends D {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const {
      input: { onChange: t }
    } = this.props;
    t?.({
      date: e?.date ? e.date.toISOString() : "",
      localDate: e?.localDate ? e.localDate.toISOString() : "",
      timezone: e?.timezone || "",
      localTimezone: e?.localTimezone || ""
    });
  }
  render() {
    const {
      className: e,
      input: { value: t, name: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      helpIcon: h,
      description: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: a,
        labelFor: n,
        meta: l,
        required: c,
        disabled: d,
        helpIcon: h,
        description: u,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          Ng,
          {
            name: n,
            value: Es(t?.localDate) ? j(t.localDate, j.ISO_8601) : null,
            timezone: t?.timezone,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Fg = "h-inputDateRangePicker--inputDateRangePicker__root", Pg = "h-inputDateRangePicker--inputDateRangePicker__inputsContainer", Rg = "h-inputDateRangePicker--inputDateRangePicker__arrowContainer", Eg = "h-inputDateRangePicker--inputDateRangePicker__inputContainer", Lg = "h-inputDateRangePicker--inputDateRangePicker__input", Ag = "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly", $g = "h-inputDateRangePicker--inputDateRangePicker__iconsContainer", Og = "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon", Bg = "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer", Wg = "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon", Hg = "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer", Mg = "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon", zg = "h-inputDateRangePicker--inputDateRangePicker__calendarIcon", Vg = "h-inputDateRangePicker--inputDateRangePicker__clearIcon", ue = {
  root: Fg,
  inputsContainer: Pg,
  arrowContainer: Rg,
  inputContainer: Eg,
  input: Lg,
  rootReadOnly: Ag,
  iconsContainer: $g,
  rootStartDateHasClearIcon: Og,
  startDateIconsContainer: Bg,
  rootEndDateHasClearIcon: Wg,
  endDateIconsContainer: Hg,
  rootHasWrapperIcon: Mg,
  calendarIcon: zg,
  clearIcon: Vg
}, Kg = "inputDateRangePickerTestId";
class ln extends D {
  inputsRef;
  rootRef;
  dateRangePickerContainerRef;
  static getInputName(e, t) {
    return e[t] || `${e}__${t}`;
  }
  static defaultProps = {
    name: {
      startDate: Math.floor(Math.random() * 1e8).toString(),
      endDate: Math.floor(Math.random() * 1e8).toString()
    }
  };
  constructor(e) {
    super(e), this.inputsRef = {
      startDate: B(),
      endDate: B()
    }, this.rootRef = B(), this.dateRangePickerContainerRef = B(), this.state = {
      isDropdownOpen: !1,
      focusedInput: "startDate",
      shouldRerenderDateRangePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(e, t) {
    const { isDropdownOpen: n, focusedInput: o } = this.state;
    n !== t.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== t.isDropdownOpen || o !== t.focusedInput) && this.focusDateRangePickerInput();
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDateRangePickerInput() {
    const { focusedInput: e } = this.state, t = this.dateRangePickerContainerRef.current?.querySelectorAll(
      'input[type="text"]'
    );
    e === "startDate" ? t?.[0]?.focus() : t?.[1]?.focus();
  }
  handleWindowClick(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleWindowKeyDown(e) {
    Et(e.key) && this.state.isDropdownOpen && (e.stopPropagation(), this.hideDropdown());
  }
  handleDatesChange(e) {
    const { onChange: t, value: n } = this.props, { focusedInput: o } = this.state;
    typeof t == "function" && t(e), (n?.[o] ?? e[o] !== null) && this.inputsRef[o].current?.focus();
  }
  handleClearIconClick(e, t) {
    const { value: n, timezone: o, localTimezone: r } = this.props, a = {
      startDate: t === "startDate" ? null : n?.startDate ?? null,
      localStartDate: t === "startDate" ? null : n?.localStartDate ?? null,
      endDate: t === "endDate" ? null : n?.endDate ?? null,
      localEndDate: t === "endDate" ? null : n?.localEndDate ?? null,
      timezone: o || null,
      localTimezone: r || null
    };
    this.handleDatesChange(a);
  }
  showDropdown(e) {
    this.setState({
      isDropdownOpen: !0,
      focusedInput: e,
      shouldRerenderDateRangePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus(e, t) {
    const { readOnly: n } = this.props;
    n || this.showDropdown(t);
  }
  handleInputBlur(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleInputKeydown({ key: e }, t) {
    Zn(e) && this.showDropdown(t);
  }
  handleInputClick(e, t) {
    const { readOnly: n } = this.props;
    n || (e.stopPropagation(), this.showDropdown(t));
  }
  handleCalendarIconClick(e, t) {
    const { readOnly: n } = this.props;
    n || (e.stopPropagation(), this.showDropdown(t));
  }
  get dateFormat() {
    const { dateFormat: e } = this.props;
    return e || j.localeData().longDateFormat("L");
  }
  renderInputLayout() {
    const { prefix: e, suffix: t, icon: n, status: o, disabled: r } = this.props, { isDropdownOpen: a } = this.state;
    return /* @__PURE__ */ s.jsx(
      Ae,
      {
        prefix: e,
        suffix: t,
        disabled: r,
        icon: n,
        active: a,
        status: o,
        children: /* @__PURE__ */ s.jsxs("div", { className: ue.inputsContainer, children: [
          this.renderInputAndIcons("startDate"),
          /* @__PURE__ */ s.jsx("div", { className: ue.arrowContainer, children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" }) }),
          this.renderInputAndIcons("endDate", -1)
        ] })
      }
    );
  }
  renderInputAndIcons(e, t) {
    const {
      className: n,
      clearable: o,
      dateFormat: r,
      dateRangePickerProps: a,
      disabled: l,
      dropdownProps: c,
      icon: d,
      localTimezone: h,
      maxDate: u,
      minDate: p,
      name: m,
      onChange: g,
      placeholder: b,
      prefix: x,
      readOnly: C,
      status: _,
      suffix: S,
      tabIndex: v,
      timezone: y,
      value: w,
      ...I
    } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: ue.inputContainer, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...I,
          id: ln.getInputName(m, e),
          name: ln.getInputName(m, e),
          className: ue.input,
          ref: this.inputsRef[e],
          onClick: (T) => this.handleInputClick(T, e),
          onFocus: (T) => this.handleInputFocus(T, e),
          onBlur: (T) => this.handleInputBlur(T),
          onKeyDown: (T) => this.handleInputKeydown(T, e),
          disabled: l,
          placeholder: b?.[e] || b || this.dateFormat?.toLowerCase(),
          autoComplete: "off",
          value: w && j(w[e]).isValid() ? j(w[e]).format(this.dateFormat) : "",
          onChange: Hn(w) ? void 0 : L,
          tabIndex: t ?? v,
          readOnly: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: f(ue.iconsContainer, {
            [ue.startDateIconsContainer]: e === "startDate",
            [ue.endDateIconsContainer]: e === "endDate"
          }),
          children: [
            this.renderClearIcon(e),
            this.renderCalendarIcon(e)
          ]
        }
      )
    ] });
  }
  renderCalendarIcon(e) {
    const { disabled: t } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: ue.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: (n) => this.handleCalendarIconClick(n, e),
        tabIndex: -1,
        disabled: t
      }
    );
  }
  renderClearIcon(e) {
    const { clearable: t, value: n, disabled: o } = this.props;
    return !t || !n?.[e] ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: ue.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: o,
        onClick: (r) => this.handleClearIconClick(r, e)
      }
    );
  }
  renderDropdown() {
    const {
      value: e,
      minDate: t,
      maxDate: n,
      timezone: o,
      dateRangePickerProps: r,
      disabled: a,
      dropdownProps: l
    } = this.props, { isDropdownOpen: c, focusedInput: d, shouldRerenderDateRangePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(et, { ...l, isOpen: c, children: /* @__PURE__ */ s.jsx("div", { ref: this.dateRangePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Vm,
      {
        disabled: a,
        ...r,
        dateFormat: this.dateFormat,
        onChange: this.handleDatesChange,
        startDate: e?.startDate ?? null,
        endDate: e?.endDate ?? null,
        timezone: o ?? null,
        minDate: t,
        maxDate: n,
        focusedInput: d
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: e, value: t, clearable: n, readOnly: o, icon: r } = this.props, a = f(ue.root, e, {
      [ue.rootStartDateHasClearIcon]: n && t?.startDate,
      [ue.rootEndDateHasClearIcon]: n && t?.endDate,
      [ue.rootHasWrapperIcon]: !!r,
      [ue.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Kg,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputLayout(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class nT extends D {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const {
      input: { onChange: t }
    } = this.props;
    t?.({
      startDate: e?.startDate ? e.startDate.toISOString() : "",
      localStartDate: e?.localStartDate ? e.localStartDate.toISOString() : "",
      endDate: e?.endDate ? e.endDate.toISOString() : "",
      localEndDate: e?.localEndDate ? e.localEndDate.toISOString() : "",
      timezone: e?.timezone ?? "",
      localTimezone: e?.localTimezone ?? ""
    });
  }
  getDateRange({
    localStartDate: e,
    localEndDate: t
  }) {
    const n = Es(e) ? j(e, j.ISO_8601) : null, o = Es(t) ? j(t, j.ISO_8601) : null;
    return {
      startDate: n,
      endDate: o
    };
  }
  render() {
    const {
      className: e,
      input: { name: t, value: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      description: h,
      helpIcon: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props, { timezone: b, localTimezone: x } = n;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: a,
        labelFor: ln.getInputName(t, "startDate"),
        meta: l,
        required: c,
        disabled: d,
        helpIcon: u,
        description: h,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          ln,
          {
            name: t,
            value: this.getDateRange(n),
            timezone: b,
            localTimezone: x,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Ug = [
  "link",
  "bold",
  "italic",
  "unorderedList",
  "orderedList",
  "format",
  "inlineCode",
  "blockquote"
], ct = (i) => Ei(i), no = (i, e = window) => e.getComputedStyle(i).display === "block", Qe = /(Mac|iPhone|iPod|iPad)/i.test(
  navigator.userAgent
);
function bs(i, e) {
  const t = {
    ctrlKey: [
      "Control",
      ...Qe ? ["$controlOrAlt"] : ["$metaOrCtrl"]
    ],
    shiftKey: ["Shift"],
    altKey: ["Alt", ...Qe ? [] : ["$controlOrAlt"]],
    metaKey: ["Meta", "OS", ...Qe ? ["$metaOrCtrl"] : []]
  };
  return i.some((n) => {
    if (e.code !== n[1])
      return !1;
    const o = n[0] ?? [];
    return Object.entries(t).every(
      ([r, a]) => {
        const l = Li(
          a,
          o
        ).length;
        return e[r] ? l > 0 : l === 0;
      }
    );
  });
}
const qg = (i, e, t) => {
  if (!i || e < 0 || t < 0) return !1;
  const n = i?.textContent?.length ?? 0;
  return !(e > n || t > n);
}, Gg = (i, e) => i.document.queryCommandState(e), Yg = (i) => i.document.queryCommandValue("formatBlock"), Qg = (i) => i.type.indexOf("image/") === 0, Ho = (i, e) => {
  const t = rn();
  return {
    src: (i.URL || i.webkitURL).createObjectURL(e),
    uid: t
  };
}, Xg = (i) => {
  i && i.querySelectorAll("td").forEach((e) => {
    e.style.border = "1px solid currentColor";
  });
}, As = (i) => {
  i.setAttribute("dir", "auto");
  const e = window.getComputedStyle(i).direction;
  i.setAttribute("dir", e);
}, Mo = (i) => {
  i && i.childNodes.forEach((e) => {
    e.nodeType !== Node.ELEMENT_NODE && e.nodeType !== Node.TEXT_NODE || ct(e) && no(e) && As(e);
  });
}, so = (i, e = !0) => {
  const t = document.createElement("div");
  return t.style.display = "none", t.innerHTML = i, document.body.appendChild(t), t.childNodes.forEach((n) => {
    if (!(n.nodeType !== Node.ELEMENT_NODE && n.nodeType !== Node.TEXT_NODE)) {
      if (ct(n) && no(n))
        n.innerHTML = so(n.innerHTML, !1), As(n);
      else if (e) {
        const o = document.createElement("div");
        o.appendChild(n.cloneNode(!0)), n.replaceWith(o), As(o);
      }
    }
  }), document.body.removeChild(t), t.innerHTML;
}, zo = (i, e = { side: "both" }) => {
  const { side: t } = e, n = i.split(""), o = " ", r = "&nbsp;";
  let a = 0, l = n.length - 1;
  if (t === "both" || t === "start")
    for (; n[a] === o; )
      n[a++] = r;
  if (t === "both" || t === "end")
    for (; n[l] === o; )
      n[l--] = r;
  return n.join("");
}, Kn = (i, e) => i.split(/\r\n|\r|\n/g).map((t, n) => t ? e.inline && n === 0 ? zo(t, { side: "end" }) : `<div>${zo(t)}</div>` : "<br />").join("");
function Zg(i) {
  const e = "&nbsp;", o = Jg(i.anchorNode), r = ef(i.anchorNode);
  if (i.anchorNode?.nodeType === Node.TEXT_NODE && o.endsWith(e)) {
    const { focusOffset: a, anchorOffset: l } = i, c = Array.prototype.indexOf.call(
      i.anchorNode.parentElement?.childNodes,
      i.anchorNode
    ), d = r.replaceAll(e, " ").replace(/.$/, " "), h = document.createTextNode(d);
    if (i.anchorNode.parentElement?.childNodes[c].replaceWith(h), i?.rangeCount && i?.rangeCount > 0 && qg(h, a, l)) {
      const u = i.getRangeAt(0);
      u.setStart(h, a), u.setEnd(h, l);
    }
  }
}
function Jg(i) {
  if (!i)
    return "";
  if (i instanceof Element)
    return i.innerHTML;
  const e = document.createElement("span");
  return e.appendChild(i.cloneNode()), e.innerHTML;
}
function ef(i) {
  return !i || !i.textContent ? "" : i.textContent;
}
const tf = "h-inputRichText-addonTrigger--addonTrigger__root", nf = {
  root: tf
};
function sf(i) {
  if (!i)
    return null;
  const { focusOffset: e, anchorOffset: t, anchorNode: n } = i;
  return e !== t || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, e) || null;
}
const In = (i, e) => {
  const t = Kr(i, e);
  return t && i.triggers.isAddonTrigger(t.matchedTrigger) ? t.matchedTrigger : null;
}, Dn = (i, e) => {
  const t = Kr(i, e);
  return t ? t.match : null;
}, Kr = (i, e) => e ? i.triggers.test(e) : null, Vo = "input-rich-text-addon-trigger", of = (i, e) => {
  const t = i.selection.recreate({ focus: !1 });
  if (!t || !e) return null;
  const n = t.getRangeAt(0).getBoundingClientRect();
  return i.ref.current && n && t?.rangeCount && t?.rangeCount > 0 ? t.getRangeAt(0).getBoundingClientRect() : null;
}, rf = (i, e) => {
  if (i.ref.current && e) {
    const t = i.ref.current.getBoundingClientRect();
    return {
      left: `${e.x - t.x}px`,
      top: `${e.y - t.y}px`,
      height: "0",
      width: `${e.width}px`,
      position: "absolute"
    };
  }
  return {};
}, Ue = (i) => sf(i.selection.recreate({ focus: !1 })) || "", xs = (i, e) => !!e && i.triggers.isAddonTrigger(e), ys = (i) => i?.nodeType === Node.ELEMENT_NODE, $s = (i, e) => i.dataset.testid === e ? i : i.parentElement ? $s(i.parentElement, e) : null, yt = {};
class af extends EventTarget {
  /**
   * A map of event listeners for each event type.
   *
   * Since it can be tricky to register/unregister event listeners as data
   * changes in the consumer, we store the event listeners in a map to be able
   * to clear them easily, in order to avoid memory leaks.
   */
  callbacks = {
    focus: [],
    insert: [],
    up: [],
    down: []
  };
  addEventListener(e, t, n) {
    super.addEventListener(e, t, n), t && this.callbacks[e].push(t);
  }
  /** Clear all event listeners for a given event type. */
  clearEventListeners(e) {
    this.callbacks[e].forEach((t) => {
      this.removeEventListener(e, t);
    }), this.callbacks[e] = [];
  }
}
const It = new af(), lf = ve({
  matchText: "",
  insertContent: () => {
  },
  eventEmitter: It
});
var cf = /* @__PURE__ */ ((i) => (i.FOCUS = "focus", i.INSERT = "insert", i.UP = "up", i.DOWN = "down", i))(cf || {});
const df = (i) => {
  const { editor: e } = i, [t, n] = V(null), [o, r] = V(null), [a, l] = V(null), [c, d] = V(!1), h = rf(e, a), [u] = V(rn()), { dismissText: p } = yt[u] ?? { dismissText: "" }, m = t?.[0] ?? "", g = p && /**
  * Replaces trailing spaces with regular spaces. If a text was dismissed
  * with trailing space, editor uses non-breaking space (U+00A0) instead of
  * regular ` ` space, which results in isDismissed being `false` where it
  * should be `true`.
  */
  m?.replace(/\s+$/, " ").startsWith(p.replace(/\s+$/, " ")) || !1, b = P(() => {
    const w = In(e, Ue(e)), I = Dn(e, Ue(e)), T = of(e, w);
    xs(e, w) && w?.shouldHandleSelectionChange?.() !== !1 ? (r(w), n(I), l(T)) : (r(null), n(null), l(null)), d(!0);
  }, [e]), x = P(() => {
    const w = In(e, Ue(e)), I = Dn(e, Ue(e))?.[0];
    return xs(e, w) && !!I;
  }, [e]), C = P(() => {
    const w = In(e, Ue(e)), I = Dn(e, Ue(e))?.[0], T = yt[u]?.dismissText || "", F = T ? I?.startsWith(T) : !1;
    return xs(e, w) && !!I && !F;
  }, [e, u]), _ = P(() => {
    e.hotkeys.add([
      {
        keybindings: [[[], "Tab"]],
        condition: C,
        callback: () => {
          It.dispatchEvent(new Event(
            "focus"
            /* FOCUS */
          ));
        }
      },
      {
        keybindings: [[[], "Enter"]],
        condition: C,
        callback: () => {
          It.dispatchEvent(new Event(
            "insert"
            /* INSERT */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowUp"]],
        condition: C,
        callback: () => {
          It.dispatchEvent(new Event(
            "up"
            /* UP */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: C,
        callback: () => {
          It.dispatchEvent(new Event(
            "down"
            /* DOWN */
          ));
        }
      },
      {
        keybindings: [[[], "Escape"]],
        condition: C,
        callback: (w, I) => {
          const T = Dn(e, Ue(e))?.[0];
          if (!T) {
            yt[u] = {
              dismissText: ""
            };
            return;
          }
          In(e, Ue(e))?.persistOnEsc === !1 && (I.stopPropagation(), r(null), n(null), l(null)), yt[u] = {
            dismissText: (T.trim().length === 1 ? "" : T) ?? ""
          };
        }
      }
    ]);
  }, [e, C, u]);
  Z(() => {
    x() && p !== m && // If persistOnEsc is non-false - preserve existing behavior and reset trigger if the match text changes.
    (g && o?.persistOnEsc !== !1 || // If trigger has been dismissed with Esc and persistOnEsc is false
    // reset dismissText when text is being removed, but preserve dismissText when characters are only added.
    !g && o?.persistOnEsc === !1) && (yt[u] = {
      dismissText: ""
    });
  }, [p, g, x, m, u, o]);
  const S = P((w) => {
    const I = w.nativeEvent.relatedTarget, T = ys(I) && $s(I, ei), F = ys(I) && $s(I, Vo);
    (!ys(I) || !T && !F) && d(!1);
  }, []), v = P(
    (w, { inline: I } = {}) => {
      const T = e.selection.recreate();
      if (!T || !o)
        return;
      const H = !!T.anchorNode?.textContent?.match(
        `^${o?.trigger.source}`
      ) && !I ? (
        // Adjust each lines direction if it's been added to a new line
        so(
          Kn(w, { inline: !1 })
        )
      ) : (
        // Or concatenate to the end of the current line without changing direction
        Kn(w, { inline: !0 })
      );
      T?.rangeCount && T?.rangeCount > 0 && e.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        T.getRangeAt(0).createContextualFragment(H),
        {
          getSelection: () => {
            const k = e.selection.recreate();
            if (!k)
              return null;
            const { focusOffset: R } = k, oe = o.trigger.exec(m)?.[1]?.length ?? 0, ne = m.length - oe, E = R - ne;
            if (k?.anchorNode && E >= 0)
              try {
                k.extend(k.anchorNode, E);
              } catch {
              }
            return k;
          }
        }
      );
    },
    [e, m, o]
  );
  if (Pt(() => {
    _(), e.selection.onUpdate(b), e.events.onBlur(S);
  }), Je(() => {
    delete yt[u];
  }), !o || !c || !m || g)
    return null;
  const y = o.customContainer?.current || e.ref.current?.ownerDocument?.body || window.document.body;
  return /* @__PURE__ */ s.jsx("div", { style: h, children: /* @__PURE__ */ s.jsxs(Ai, { open: !0, children: [
    /* @__PURE__ */ s.jsx($i, {}),
    /* @__PURE__ */ s.jsx(Oi, { container: y, children: /* @__PURE__ */ s.jsx(
      Bi,
      {
        onOpenAutoFocus: (w) => w.preventDefault(),
        "data-testid": Vo,
        className: nf.root,
        side: o.popoverContent?.side ?? "top",
        align: o.popoverContent?.align ?? "start",
        children: /* @__PURE__ */ s.jsx(
          lf.Provider,
          {
            value: { matchText: m, insertContent: v, eventEmitter: It },
            children: o.component
          }
        )
      }
    ) })
  ] }) });
}, hf = "h-inputRichText-toolbarButton--toolbarButton__root", uf = "h-inputRichText-toolbarButton--toolbarButton__rootDisabled", pf = "h-inputRichText-toolbarButton--toolbarButton__rootActive", mf = "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge", gf = "h-inputRichText-toolbarButton--toolbarButton__rootWithText", _t = {
  root: hf,
  rootDisabled: uf,
  rootActive: pf,
  rootWithBadge: mf,
  rootWithText: gf
};
function Ee({
  className: i,
  isActive: e,
  icon: t,
  disabled: n,
  showBadge: o,
  text: r,
  tooltip: a,
  tabIndex: l = -1,
  ...c
}) {
  const d = f(
    {
      [_t.root]: _t.root,
      [_t.rootActive]: e,
      [_t.rootDisabled]: n,
      [_t.rootWithBadge]: o,
      [_t.rootWithText]: r
    },
    i
  ), h = /* @__PURE__ */ s.jsx(
    "button",
    {
      tabIndex: l,
      type: "button",
      ...c,
      className: d,
      disabled: n,
      children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(N, { name: t }) }),
        r && /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: r }) })
      ] })
    }
  );
  return a ? /* @__PURE__ */ s.jsx(se, { content: a, side: "top", wrap: "none", children: h }) : h;
}
const ff = "h-inputRichText-attachmentButton--attachmentButton__dropzone", bf = "h-inputRichText-attachmentButton--attachmentButton__fileInput", xf = "h-inputRichText-attachmentButton--attachmentButton__dropdown", yf = "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon", kn = {
  dropzone: ff,
  fileInput: bf,
  dropdown: xf,
  dropzoneIcon: yf
};
let _f = class extends D {
  static displayName = "AttachmentButtonDropzone";
  constructor(e) {
    super(e), this.state = {
      fileHover: !1
    };
  }
  handleDragEnter = (e) => {
    e.preventDefault();
    const { allowAttachments: t } = this.props;
    !t || !e.dataTransfer?.types?.includes("Files") || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (e) => {
    e.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleAttachmentDrop = (e) => {
    e.preventDefault();
    const { onAddAttachment: t } = this.props;
    e.dataTransfer && t(e.dataTransfer.files), this.setState({
      fileHover: !1
    });
  };
  render() {
    const {
      className: e,
      children: t,
      isAttachmentsUploading: n,
      allowAttachments: o,
      allowInline: r,
      onAddAttachment: a,
      ...l
    } = this.props, { fileHover: c } = this.state, d = f(e), h = c || n;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...l,
        className: d,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragEnter,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleAttachmentDrop,
        children: [
          t,
          h && /* @__PURE__ */ s.jsx(Ze, { children: n ? "Uploading..." : "Drop to add an attachment" }),
          !h && "Drop the file or click to upload"
        ]
      }
    );
  }
};
const Cf = [
  {
    name: "addAttachment",
    label: "Add attachment",
    keybindings: [[["$metaOrCtrl"], "KeyU"]]
  }
];
class vf extends D {
  unsubscribeAddAttachment;
  fileInputRef;
  constructor(e) {
    super(e), this.fileInputRef = B(), this.unsubscribeAddAttachment = Xi;
  }
  componentDidMount() {
    this.unsubscribeAddAttachment = this.props.editor.events.subscribe(
      "addAttachment",
      () => {
        this.props.disabled || this.fileInputRef.current?.click();
      }
    );
  }
  componentWillUnmount() {
    this.unsubscribeAddAttachment?.();
  }
  openFileBrowser = (e) => {
    e.preventDefault();
    const { current: t } = this.fileInputRef;
    t && t.click();
  };
  handleFileChanged = (e) => {
    const { onAttachFiles: t, editorWindow: n } = this.props, o = e.target;
    o !== null && o instanceof n.HTMLInputElement && (t(o.files), o.value = "");
  };
  renderDropdown() {
    const { isAttachmentsUploading: e, attachments: t, onAttachFiles: n, children: o } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: kn.dropdown, children: [
      /* @__PURE__ */ s.jsx(
        _f,
        {
          className: kn.dropzone,
          onAddAttachment: n,
          attachments: t,
          isAttachmentsUploading: e,
          allowInline: !1,
          onClick: this.openFileBrowser,
          allowAttachments: !0,
          children: /* @__PURE__ */ s.jsx(N, { name: "paperclip", className: kn.dropzoneIcon })
        }
      ),
      o
    ] });
  }
  preventDefault = (e) => {
    e.preventDefault();
  };
  render() {
    const {
      className: e,
      attachments: t,
      onAttachFiles: n,
      onDetachFile: o,
      isAttachmentsUploading: r,
      dropdownRef: a,
      editorWindow: l,
      disabled: c,
      disabledTooltip: d,
      fixed: h,
      ...u
    } = this.props, p = /* @__PURE__ */ s.jsx(
      Ee,
      {
        onMouseDown: this.preventDefault,
        icon: "paperclip",
        showBadge: t.length > 0,
        disabled: c,
        tooltip: "Insert attachment"
      }
    );
    return c ? /* @__PURE__ */ s.jsx(se, { content: d, disabled: !d, children: p }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: this.fileInputRef,
          type: "file",
          className: kn.fileInput,
          onChange: this.handleFileChanged,
          multiple: !0
        }
      ),
      /* @__PURE__ */ s.jsx(
        dt,
        {
          ...u,
          className: e,
          noStyle: !0,
          fixed: h,
          ref: a,
          dropdown: this.renderDropdown(),
          children: p
        }
      )
    ] });
  }
}
const wf = "h-inputRichText-dropzone--dropzone__root", Sf = "h-inputRichText-dropzone--dropzone__inlineDropzone", If = "h-inputRichText-dropzone--dropzone__attachmentDropzone", Df = "h-inputRichText-dropzone--dropzone__rootDual", kf = "h-inputRichText-dropzone--dropzone__icon", Ct = {
  root: wf,
  inlineDropzone: Sf,
  attachmentDropzone: If,
  rootDual: Df,
  icon: kf
};
class Tf extends D {
  static displayName = "InputRichTextDropzone";
  internalDrag = !1;
  constructor(e) {
    super(e), this.state = {
      fileHover: !1,
      overDropzone: !1
    };
  }
  handleDragStart = () => {
    this.internalDrag = !0;
  };
  handleDragEnd = () => {
    this.internalDrag = !1;
  };
  handleDragEnter = (e) => {
    e.preventDefault();
    const { allowInlineAttachments: t, allowAttachments: n } = this.props;
    if (!t && !n || this.internalDrag) return;
    const o = e.dataTransfer?.types, r = o?.includes("Files"), a = o?.includes("text/uri-list");
    !r && !a || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (e) => {
    e.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleEnterDropzone = (e) => {
    e.preventDefault(), this.setState({
      overDropzone: !0
    });
  };
  handleLeaveDropzone = (e) => {
    e.preventDefault(), this.setState({
      overDropzone: !1
    });
  };
  async fetchDroppedUrl(e, t) {
    if (e.files.length > 0) {
      t(e.files);
      return;
    }
    const n = e.getData("text/uri-list");
    if (n) {
      try {
        const o = new URL(n);
        if (o.protocol !== "http:" && o.protocol !== "https:") return;
      } catch {
        return;
      }
      try {
        const o = await fetch(n);
        if (!o.ok) return;
        const r = await o.blob(), a = n.split("/").pop()?.split("?")[0] || "dropped-image", l = new File([r], a, { type: r.type }), c = new DataTransfer();
        c.items.add(l), t(c.files);
      } catch {
      }
    }
  }
  handleInlineDrop = (e) => {
    e.preventDefault();
    const { onAddInline: t } = this.props;
    e.dataTransfer && typeof t == "function" && this.fetchDroppedUrl(e.dataTransfer, t), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  handleAttachmentDrop = (e) => {
    e.preventDefault();
    const { onAddAttachment: t } = this.props;
    e.dataTransfer && typeof t == "function" && this.fetchDroppedUrl(e.dataTransfer, t), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  render() {
    const {
      className: e,
      children: t,
      allowInlineAttachments: n,
      allowAttachments: o,
      onAddInline: r,
      onMouseDown: a,
      attachments: l,
      onAddAttachment: c,
      ...d
    } = this.props, { fileHover: h, overDropzone: u } = this.state, p = f(
      {
        [Ct.root]: !0,
        [Ct.rootDual]: n && o
      },
      e
    ), m = n || o, g = {};
    return a && (g.onClick = a), m && (g.onDragStart = this.handleDragStart, g.onDragEnd = this.handleDragEnd, g.onDragEnter = this.handleDragEnter, g.onDragOver = this.handleDragEnter, g.onDragLeave = this.handleDragLeave), /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...d,
        tabIndex: -1,
        className: p,
        ...g,
        children: [
          t,
          (h || u) && /* @__PURE__ */ s.jsxs(Ze, { children: [
            n && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleInlineDrop,
                className: Ct.inlineDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "upload", size: 24, className: Ct.icon }),
                  "Drop to add inline"
                ]
              }
            ),
            o && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleAttachmentDrop,
                className: Ct.attachmentDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "paperclip", size: 24, className: Ct.icon }),
                  "Drop to add an attachment"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
}
const Ur = (i, e) => i.split(new RegExp(`(${Vs(e)})`, "gi")).map(
  (t, n) => t.toLowerCase() === e.toLowerCase() ? /* @__PURE__ */ s.jsx("span", { children: t }, n) : t
), jf = "h-inputRichText-emoji--emoji__root", Nf = "h-inputRichText-emoji--emoji__decorator", Ff = "h-inputRichText-emoji--emoji__suggestion", Pf = "h-inputRichText-emoji--emoji__suggestionActive", Rf = "h-inputRichText-emoji--emoji__suggestionName", nn = {
  root: jf,
  decorator: Nf,
  suggestion: Ff,
  suggestionActive: Pf,
  suggestionName: Rf
}, Ef = Ki(
  () => import("./emoji-DIN5LBCL.js").then((i) => i.c).then((i) => ({
    default: i.EmojiPicker
  }))
), Un = {};
Mi.emojis.forEach((i) => {
  i.forEach(
    (e) => {
      e.shortNames && e.shortNames.forEach((t) => {
        Un[t.replace(/:/g, "")] = e.emoji;
      });
    }
  );
});
const Lf = (i) => {
  const { active: e, item: t, match: n, onSelect: o } = i, r = n ? Ur(t, n) : t;
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: () => o(t),
      type: "button",
      "aria-current": e,
      className: f(nn.suggestion, {
        [nn.suggestionActive]: e
      }),
      children: [
        Un[t],
        /* @__PURE__ */ s.jsx("span", { className: nn.suggestionName, children: r })
      ]
    }
  );
};
class Af extends D {
  constructor(e) {
    super(e), this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.triggers.add({
      trigger: /(^|\s):/,
      minChars: 2,
      allowSpaces: !1,
      getSuggestions: this.getSuggestions,
      suggestionComponent: Lf,
      insertContent: this.insertContent
    });
  }
  insertContent(e, t = "", n) {
    this.insertEmoji(Un[e], t, n);
  }
  insertEmoji(e, t, n) {
    const { editor: o } = this.props, r = document.createElement("span");
    r.classList.add(nn.decorator), r.innerHTML = e, o.content.insert(r, {
      getSelection: () => {
        const a = o.selection.recreate();
        return t && a?.anchorNode && a.extend(a.anchorNode, n), a;
      }
    });
  }
  getSuggestions = (e) => Object.keys(Un).filter((n) => n.indexOf(e) !== -1);
  // eslint-disable-next-line no-undef
  preventDefault = (e) => {
    e.preventDefault();
  };
  renderDropdown = () => /* @__PURE__ */ s.jsx(Ui, { fallback: /* @__PURE__ */ s.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ s.jsx(un.Consumer, { children: ({ toggleDropdown: e }) => /* @__PURE__ */ s.jsx(
    Ef,
    {
      onSelect: (t) => {
        this.insertEmoji(t), e();
      }
    }
  ) }) });
  render() {
    const { className: e, fixed: t } = this.props, n = f(
      {
        [nn.root]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { className: n, children: /* @__PURE__ */ s.jsx(
      dt,
      {
        icon: "smile",
        dropdown: this.renderDropdown(),
        noStyle: !0,
        fixed: t,
        children: /* @__PURE__ */ s.jsx(
          Ee,
          {
            icon: "smile",
            tooltip: "Emojis",
            onMouseDown: this.preventDefault
          }
        )
      }
    ) });
  }
}
const $f = "h-inputRichText--inputRichText__inputWrapper", Of = "h-inputRichText--inputRichText__root", Bf = "h-inputRichText--inputRichText__toolbar", Wf = "h-inputRichText--inputRichText__toolbarHint", Hf = "h-inputRichText--inputRichText__toolbarHintVisible", Mf = "h-inputRichText--inputRichText__toolbarHintHidden", zf = "h-inputRichText--inputRichText__editorWrap", Vf = "h-inputRichText--inputRichText__placeholder", Kf = "h-inputRichText--inputRichText__editor", Uf = "h-inputRichText--inputRichText__editorDisabled", qf = "h-inputRichText--inputRichText__fileInput", Gf = "h-inputRichText--inputRichText__uiBlocker", fe = {
  inputWrapper: $f,
  root: Of,
  toolbar: Bf,
  toolbarHint: Wf,
  toolbarHintVisible: Hf,
  toolbarHintHidden: Mf,
  editorWrap: zf,
  placeholder: Vf,
  editor: Kf,
  editorDisabled: Uf,
  fileInput: qf,
  uiBlocker: Gf
};
function qr(i, e) {
  const t = (n) => n.replace(/&/g, "&amp;");
  return `<a href="${t(i)}">${t(e)}</a>`;
}
function oo(i) {
  if (!i || i.length === 0)
    return "";
  const [e = [], t = ""] = i[0];
  if (!t)
    return "";
  const n = e.map((r) => Yf(r)).filter(Boolean), o = Qf(t);
  return Qe ? [...n, o].join("") : [...n, o].join("+");
}
function Yf(i) {
  if (Qe)
    switch (i) {
      case "$metaOrCtrl":
      case "Meta":
        return "⌘";
      case "Control":
      case "$controlOrAlt":
        return "⌃";
      case "Shift":
        return "⇧";
      case "Alt":
        return "⌥";
      default:
        return i;
    }
  switch (i) {
    case "$metaOrCtrl":
    case "Control":
      return "Ctrl";
    case "$controlOrAlt":
    case "Alt":
      return "Alt";
    case "Shift":
      return "Shift";
    case "Meta":
      return "Win";
    default:
      return i;
  }
}
function Qf(i) {
  if (i.startsWith("Key"))
    return i.slice(3);
  if (i.startsWith("Digit"))
    return i.slice(5);
  switch (i) {
    case "Backslash":
      return "\\";
    case "Slash":
      return "/";
    case "Enter":
      return Qe ? "↵" : "Enter";
    case "Escape":
      return "Esc";
    case "Space":
      return "Space";
    case "Backspace":
      return Qe ? "⌫" : "Backspace";
    case "Delete":
      return Qe ? "⌦" : "Del";
    case "ArrowUp":
      return "↑";
    case "ArrowDown":
      return "↓";
    case "ArrowLeft":
      return "←";
    case "ArrowRight":
      return "→";
    default:
      return i;
  }
}
const Xf = "h-inputRichText-linkButton--linkButton__linkOpener", Zf = "h-inputRichText-linkButton--linkButton__dropdownContainer", Ko = {
  linkOpener: Xf,
  dropdownContainer: Zf
}, Jf = "h-inputRichText-linkButton--linkMenu__root", eb = "h-inputRichText-linkButton--linkMenu__field", _s = {
  root: Jf,
  field: eb
};
class tb extends D {
  constructor(e) {
    super(e);
    const { initialText: t, initialUrl: n } = e;
    this.state = {
      textValue: t,
      urlValue: n
    };
  }
  componentDidUpdate(e) {
    const { initialText: t, initialUrl: n } = this.props;
    (t !== e.initialText || n !== e.initialUrl) && this.setState({
      textValue: t,
      urlValue: n
    });
  }
  handleTextChange = (e) => {
    e && this.setState({
      textValue: e.target.value
    });
  };
  handleUrlChange = (e) => {
    e && this.setState({
      urlValue: e.target.value
    });
  };
  handleAddLink = (e) => {
    e?.preventDefault();
    const { onAddLink: t, toggleDropdown: n } = this.props, { textValue: o, urlValue: r } = this.state;
    r && (t(o || void 0, r), n());
  };
  handleUnlink = (e) => {
    e.preventDefault();
    const { onUnlink: t, toggleDropdown: n } = this.props;
    t(), n();
  };
  handleKeyDown = (e) => {
    e.key === "Enter" && (e.preventDefault(), this.handleAddLink());
  };
  render() {
    const {
      className: e,
      initialText: t,
      initialUrl: n,
      onAddLink: o,
      toggleDropdown: r,
      onUnlink: a,
      ...l
    } = this.props, { textValue: c, urlValue: d } = this.state, h = f({ [_s.root]: !0 }, e);
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsx(
        Ls,
        {
          label: "Link title",
          noAlert: !0,
          className: _s.field,
          input: {
            value: c,
            name: "pleasedontautofillthis",
            onChange: this.handleTextChange
          },
          onKeyDown: this.handleKeyDown
        }
      ),
      /* @__PURE__ */ s.jsx(
        Ls,
        {
          label: "Link URL",
          noAlert: !0,
          className: _s.field,
          input: {
            value: d,
            name: "link_url",
            onChange: this.handleUrlChange
          },
          onKeyDown: this.handleKeyDown,
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(W, { gap: "200", children: [
        /* @__PURE__ */ s.jsx(X, { variant: "primary", onClick: this.handleAddLink, children: "Add" }),
        !!d && /* @__PURE__ */ s.jsx(X, { variant: "secondary", onClick: this.handleUnlink, children: "Remove link" })
      ] })
    ] });
  }
}
const Gr = [
  {
    name: "hyperlink",
    label: "Link: insert",
    keybindings: [[["$metaOrCtrl", "Shift"], "KeyK"]]
  },
  {
    name: "removeHyperlink",
    label: "Link: remove",
    keybindings: [],
    callback: (i) => i.command.run("unlink")
  }
], nb = ({ editor: i }) => {
  const [e, t] = qi((_) => _ + 1, 0), [n, o] = Gi(!1), r = q(null), a = q(), [
    { hoverLinkBounds: l, hoverLinkHref: c, selectedLink: d, selectedText: h },
    u
  ] = Yi({
    selectedLink: "",
    selectedText: "",
    hoverLinkHref: null,
    hoverLinkBounds: null
  });
  Pt(() => {
    i.events.onMouseOver((_) => {
      m(_);
    }), a.current = i.events.subscribe("hyperlink", () => {
      o(!0);
    }), i.selection.onUpdate(() => {
      p();
    });
  }), Je(() => {
    a.current?.();
  });
  const p = () => {
    const _ = i.selection.recreate();
    if (!_)
      return;
    const { anchorNode: S, focusNode: v } = _;
    if (S && v === S && S.parentElement?.nodeName === "A") {
      const { href: y, innerText: w } = S.parentElement;
      u({
        selectedLink: y,
        selectedText: w
      });
    } else
      u({
        selectedLink: "",
        selectedText: _.toString()
      });
  }, m = P(
    (_) => {
      const { target: S } = _, { current: v } = i.ref;
      if (v && S && S instanceof HTMLAnchorElement) {
        const y = v.getBoundingClientRect(), w = S.getBoundingClientRect();
        u({
          hoverLinkHref: S.getAttribute("href"),
          hoverLinkBounds: {
            top: w.top - y.top,
            left: w.left - y.left,
            width: w.width
          }
        });
      } else
        u({
          hoverLinkHref: null,
          hoverLinkBounds: null
        });
    },
    [i.ref, u]
  ), g = P(() => {
    const _ = i.selection.recreate();
    if (!_)
      return;
    const { anchorNode: S, focusNode: v } = _;
    if (S && S === v && S.parentElement?.nodeName === "A") {
      const y = document.createRange();
      y.selectNodeContents(S.parentElement), _.removeAllRanges(), _.addRange(y);
    }
  }, [i.selection]), b = P(
    (_, S) => {
      S && (g(), i.command.run("insertHTML", qr(S, _ || S)), t());
    },
    [i.command, g]
  ), x = P(() => {
    g(), i.command.run("unlink");
  }, [i.command, g]), C = P((_) => {
    _.preventDefault();
  }, []);
  return Dr(r, () => {
    o(!1);
  }), Ir("Escape", () => {
    o(!1), g();
  }), /* @__PURE__ */ s.jsxs(Ze, { children: [
    /* @__PURE__ */ s.jsxs("div", { ref: r, className: Ko.dropdownContainer, children: [
      /* @__PURE__ */ s.jsx(
        Ee,
        {
          isActive: !!d,
          icon: "link",
          onMouseDown: C,
          onClick: () => o(),
          tooltip: `Insert link (${oo(Gr[0].keybindings)})`
        }
      ),
      n && /* @__PURE__ */ s.jsx(et, { isOpen: n, children: /* @__PURE__ */ s.jsx(
        tb,
        {
          onAddLink: b,
          toggleDropdown: o,
          initialUrl: d,
          initialText: h,
          onUnlink: x
        }
      ) })
    ] }),
    !!l && !!c && /* @__PURE__ */ s.jsx(
      "a",
      {
        className: Ko.linkOpener,
        href: c,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          top: `${l.top}px`,
          left: `${l.left + l.width}px`
        },
        children: /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "external-link" })
      }
    )
  ] });
}, sb = "h-tabs--tabs__root", ob = "h-tabs--tabs__tabs", rb = "h-tabs--tabs__tab", ib = "h-tabs--tabs__tabTop", ab = "h-tabs--tabs__tabTopActive", lb = "h-tabs--tabs__tabTopSelected", cb = "h-tabs--tabs__tabLeft", db = "h-tabs--tabs__tabLeftActive", hb = "h-tabs--tabs__tabLeftSelected", ub = "h-tabs--tabs__tabBottom", pb = "h-tabs--tabs__tabBottomActive", mb = "h-tabs--tabs__tabBottomSelected", gb = "h-tabs--tabs__tabRight", fb = "h-tabs--tabs__tabRightActive", bb = "h-tabs--tabs__tabRightSelected", xb = "h-tabs--tabs__tabDisabled", re = {
  root: sb,
  tabs: ob,
  tab: rb,
  tabTop: ib,
  tabTopActive: ab,
  tabTopSelected: lb,
  tabLeft: cb,
  tabLeftActive: db,
  tabLeftSelected: hb,
  tabBottom: ub,
  tabBottomActive: pb,
  tabBottomSelected: mb,
  tabRight: gb,
  tabRightActive: fb,
  tabRightSelected: bb,
  tabDisabled: xb
}, yb = 13;
class _b extends D {
  constructor(e) {
    super(e), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
  }
  handleOnClick() {
    const { id: e, onChange: t, disabled: n } = this.props;
    n || t(e);
  }
  handleOnKeyDown(e) {
    e.keyCode === yb && this.handleOnClick();
  }
  getClassName() {
    const {
      selected: e,
      placement: t,
      className: n,
      disabled: o,
      active: r,
      selectedClassName: a
    } = this.props;
    let l = f(re.tab, n, {
      [re.tabDisabled]: o,
      [re.tabTop]: t === "top",
      [re.tabRight]: t === "right",
      [re.tabLeft]: t === "left",
      [re.tabBottom]: t === "bottom",
      [re.tabTopSelected]: t === "top" && e,
      [re.tabRightSelected]: t === "right" && e,
      [re.tabLeftSelected]: t === "left" && e,
      [re.tabBottomSelected]: t === "bottom" && e,
      [re.tabTopActive]: t === "top" && r,
      [re.tabRightActive]: t === "right" && r,
      [re.tabLeftActive]: t === "left" && r,
      [re.tabBottomActive]: t === "bottom" && r
    });
    return a && (l = f(l, { [a]: e })), l;
  }
  render() {
    const { id: e, label: t, icon: n, disabled: o, slotEnd: r, slotStart: a } = this.props;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        role: "tab",
        className: this.getClassName(),
        onClick: this.handleOnClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: o ? -1 : 0,
        children: [
          a || !!n && /* @__PURE__ */ s.jsx(N, { name: n, className: "icon-vertical-fix" }),
          t,
          r
        ]
      },
      e
    );
  }
}
class ro extends D {
  containerRef;
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(e) {
    super(e), this.containerRef = B(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
  }
  renderTab({
    id: e,
    label: t,
    icon: n,
    disabled: o,
    slotEnd: r,
    slotStart: a
  }) {
    const {
      selectedId: l,
      activeId: c,
      onChange: d,
      tabsPlacement: h,
      tabClassName: u,
      tabSelectedClassName: p
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      _b,
      {
        selected: e === l,
        className: u,
        selectedClassName: p,
        id: e,
        label: t,
        icon: n,
        onChange: d,
        placement: h,
        disabled: o,
        active: e === c,
        slotEnd: r,
        slotStart: a
      },
      e
    );
  }
  renderTabs() {
    const { tabs: e } = this.props;
    return e.map(this.renderTab);
  }
  render() {
    const {
      className: e,
      tabClassName: t,
      tabSelectedClassName: n,
      tabs: o,
      selectedId: r,
      onChange: a,
      tabsPlacement: l,
      activeId: c,
      ...d
    } = this.props, h = f(re.root, e);
    return /* @__PURE__ */ s.jsx("div", { ref: this.containerRef, ...d, className: h, children: /* @__PURE__ */ s.jsx("div", { className: re.tabs, children: this.renderTabs() }) });
  }
}
const Cb = dn(ro, {
  fallback: null
}), vb = "h-inputRichText-quickResponseSelector--quickResponseItem__root", wb = "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive", Sb = "h-inputRichText-quickResponseSelector--quickResponseItem__name", qt = {
  root: vb,
  rootActive: wb,
  name: Sb
};
class Cs extends D {
  constructor(e) {
    super(e), this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect() {
    const { isLoading: e, onSelect: t, item: n } = this.props;
    e || t(n);
  }
  render() {
    const {
      className: e,
      item: t,
      isLoading: n,
      onSelect: o,
      active: r,
      searchValue: a,
      clearSearch: l,
      ...c
    } = this.props, { name: d, content: h, matched: u } = !n && t ? t : {
      name: "Loading...",
      content: "",
      matched: ""
    }, p = f(
      {
        [qt.root]: qt.root,
        [qt.rootActive]: r
      },
      e
    ), m = u ? Ur(d, u) : d;
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        "aria-current": r,
        ...c,
        className: p,
        onClick: this.handleSelect,
        title: d,
        children: [
          /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-3", className: qt.name, children: m }),
          /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "4", className: qt.name, subdued: !0, children: h })
        ]
      }
    );
  }
}
const Ib = "h-inputRichText-quickResponseSelector--quickResponseSelector__container", Db = "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer", kb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown", Tb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs", jb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent", Nb = "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown", vt = {
  container: Ib,
  dropdownButtonContainer: Db,
  tabbedDropdown: kb,
  tabbedDropdownTabs: Tb,
  tabbedDropdownTabsContent: jb,
  regularDropdown: Nb
}, Uo = /(^|\s)=/, vs = "Quick replies";
class Fb extends ge {
  constructor(e) {
    super(e), this.state = {
      searchTerm: "",
      selectedTab: e.languages[0]?.code
    }, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.triggers.add({
      trigger: Uo,
      minChars: 0,
      allowSpaces: !0,
      getSuggestions: this.handleSearchChange,
      suggestionComponent: Cs,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }
  normalizeSuggestion(e) {
    const { quickResponsesApi: t } = this.props;
    return {
      id: e.name,
      matched: t.params.search ?? "",
      ...e
    };
  }
  getTabDefinitions() {
    const { languages: e } = this.props;
    return e.map((t) => ({
      id: t.code,
      label: t.label
    }));
  }
  handleNextPage() {
    const { quickResponsesApi: e } = this.props;
    return new Promise((t) => e.getItemsAsyncStatus === "loading" ? t(e.items.map(this.normalizeSuggestion)) : t(
      e.nextPage().then((n) => n.map(this.normalizeSuggestion)).catch((n) => {
        console.error(n);
      })
    ));
  }
  preventDefault = (e) => {
    e.preventDefault();
  };
  handleSelect = (e, t) => {
    this.insertContent(e)?.then(() => {
      t && t();
    });
  };
  insertContent = (e, t, n) => {
    const { renderQuickResponse: o, sanitize: r, editor: a } = this.props;
    return o(e).then((l) => {
      const c = a.selection.recreate();
      if (!c)
        return;
      const d = !!t, h = d && !!c.anchorNode?.textContent?.match(
        `^${Uo.source}`
      ) || !d && !c.anchorNode?.textContent;
      let u;
      h ? u = so(
        Kn(r(l), { inline: !1 })
      ) : u = Kn(r(l), { inline: !0 }), c?.rangeCount && c?.rangeCount > 0 && a.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        c.getRangeAt(0).createContextualFragment(u),
        {
          getSelection: () => {
            const p = a.selection.recreate();
            return d && p?.anchorNode && p.extend(p.anchorNode, n), p;
          }
        }
      );
    });
  };
  handleToggle(e) {
    const { quickResponsesApi: t, languages: n } = this.props;
    e && (t.params.search !== "" || t.params.locale !== n[0]?.code) && this.setState({ searchTerm: "", selectedTab: n[0]?.code }, () => {
      const { searchTerm: o, selectedTab: r } = this.state;
      this.handleSearchChange(o, r, 0);
    });
  }
  getPagination() {
    const { quickResponsesApi: e } = this.props;
    return {
      nextEnable: e.hasNextPage,
      previousEnable: !1,
      infinite: !0,
      onNext: this.handleNextPage
    };
  }
  handleSearchChange(e, t, n) {
    const { quickResponsesApi: o } = this.props;
    return o.paramsChange({ search: e, locale: t }, n).then((r) => r.map(this.normalizeSuggestion));
  }
  handleTabbedSearchChange(e) {
    this.setState({ searchTerm: e }, () => {
      const { searchTerm: t, selectedTab: n } = this.state;
      this.handleSearchChange(t, n);
    });
  }
  handleTabChange(e) {
    this.setState({ selectedTab: e }, () => {
      const { searchTerm: t, selectedTab: n } = this.state;
      this.handleSearchChange(t, n, 0);
    });
  }
  renderIcon() {
    return /* @__PURE__ */ s.jsx(
      Ee,
      {
        icon: this.props.iconName ?? "bolt",
        onMouseDown: this.preventDefault
      }
    );
  }
  renderItemsWithoutTabs() {
    const { className: e, quickResponsesApi: t } = this.props;
    return /* @__PURE__ */ s.jsx(se, { content: `${vs} (=)`, children: /* @__PURE__ */ s.jsx(
      to,
      {
        className: e,
        dropdownProps: {
          className: vt.regularDropdown
        },
        containerProps: { className: vt.container },
        items: t.items.map(this.normalizeSuggestion),
        pagination: this.getPagination(),
        itemComponent: Cs,
        hasSearch: !0,
        noStyle: !0,
        onSearch: this.handleSearchChange,
        onSelect: this.handleSelect,
        onToggle: this.handleToggle,
        emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
        children: this.renderIcon()
      }
    ) });
  }
  renderItemsWithTabs() {
    const { className: e } = this.props, { selectedTab: t } = this.state;
    return /* @__PURE__ */ s.jsx("div", { className: vt.dropdownButtonContainer, children: /* @__PURE__ */ s.jsx(se, { content: `${vs} (=)`, children: /* @__PURE__ */ s.jsx(
      dt,
      {
        className: e,
        noStyle: !0,
        onToggle: this.handleToggle,
        buttonProps: { title: vs },
        dropdown: /* @__PURE__ */ s.jsxs("div", { className: vt.tabbedDropdown, children: [
          /* @__PURE__ */ s.jsx(
            ro,
            {
              className: vt.tabbedDropdownTabs,
              tabs: this.getTabDefinitions(),
              tabsPlacement: "left",
              selectedId: t,
              onChange: this.handleTabChange
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: vt.tabbedDropdownTabsContent, children: this.renderTabItems() })
        ] }),
        children: this.renderIcon()
      }
    ) }) });
  }
  renderTabItems() {
    const { quickResponsesApi: e } = this.props;
    return /* @__PURE__ */ s.jsx(un.Consumer, { children: ({ dropdownOpen: t, closeDropdown: n }) => /* @__PURE__ */ s.jsx(
      Vr,
      {
        dropdownOpen: t,
        triggerClose: n,
        hasSearch: !0,
        pagination: this.getPagination(),
        items: e.items.map(this.normalizeSuggestion),
        itemComponent: Cs,
        onSearch: this.handleTabbedSearchChange,
        onSelect: (o) => this.handleSelect(o, n),
        emptyComponent: pn,
        emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
      }
    ) });
  }
  render() {
    const { languages: e } = this.props;
    return e?.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
  }
}
const Pb = "h-inputRichText-formatSelector--formatSelector__root", Rb = "h-inputRichText-formatSelector--formatSelector__list", Eb = "h-inputRichText-formatSelector--formatSelector__selector", Lb = "h-inputRichText-formatSelector--formatSelector__option", Ab = "h-inputRichText-formatSelector--formatSelector__optionActive", $b = "h-inputRichText-formatSelector--formatSelector__button", wt = {
  root: Pb,
  list: Rb,
  selector: Eb,
  option: Lb,
  optionActive: Ab,
  button: $b
}, Os = [
  {
    name: "noHeading",
    label: "Normal",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "div"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h1",
    label: "Headline 1",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H1>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h2",
    label: "Headline 2",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H2>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h3",
    label: "Headline 3",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H3>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h4",
    label: "Headline 4",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H4>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h5",
    label: "Headline 5",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H5>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "quote",
    label: "Blockquote",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<BLOCKQUOTE>"),
    condition: (i) => i.allowFormatting.includes("format")
  }
], qo = {
  h1: { tag: "<H1>" },
  h2: { tag: "<H2>" },
  h3: { tag: "<H3>" },
  h4: { tag: "<H4>" },
  h5: { tag: "<H5>" },
  noHeading: { default: !0, tag: "div" },
  quote: { tag: "<BLOCKQUOTE>" }
};
class Ob extends D {
  preventDefault = (e) => {
    e.preventDefault();
  };
  renderDropdown() {
    const { editor: e } = this.props;
    return /* @__PURE__ */ s.jsx(un.Consumer, { children: ({ closeDropdown: t }) => /* @__PURE__ */ s.jsx("ul", { className: wt.list, children: Os.map((n) => {
      const o = "condition" in n;
      if (!(!o || o && n.condition(e)))
        return;
      const a = qo[n.name];
      return /* @__PURE__ */ s.jsx(
        "li",
        {
          className: f(wt.option, {
            [wt.optionActive]: this.isActiveFormat(a)
          }),
          children: /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              className: wt.button,
              onClick: () => {
                n.callback?.(e), t();
              },
              children: n.label
            }
          )
        },
        n.name
      );
    }).filter(Boolean) }) });
  }
  isActiveFormat(e) {
    const { formatBlock: t } = this.props;
    return !!(!t && e.default || e.tag === t || e.tag === `<${t.toUpperCase()}>`);
  }
  getCurrentFormatName() {
    return Os.find(
      (e) => this.isActiveFormat(qo[e.name])
    )?.label ?? "Normal";
  }
  render() {
    const { className: e, editor: t, formatBlock: n, ...o } = this.props, r = f(wt.root, e);
    return /* @__PURE__ */ s.jsx(
      dt,
      {
        className: r,
        ...o,
        dropdown: this.renderDropdown(),
        noStyle: !0,
        children: /* @__PURE__ */ s.jsxs("div", { className: wt.selector, children: [
          this.getCurrentFormatName(),
          /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "angle-down" })
        ] })
      }
    );
  }
}
const Bb = "h-inputRichText-stylingMenu--stylingMenu__menu", Wb = "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer", Go = {
  menu: Bb,
  buttonsContainer: Wb
}, Yr = [
  {
    name: "bold",
    label: "Bold",
    icon: "bold",
    keybindings: [[["$metaOrCtrl"], "KeyB"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
    callback: (i) => i.command.run("bold"),
    condition: (i) => i.allowFormatting.includes("bold")
  },
  {
    name: "italic",
    label: "Italic",
    icon: "italic",
    keybindings: [[["$metaOrCtrl"], "KeyI"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
    callback: (i) => i.command.run("italic"),
    condition: (i) => i.allowFormatting.includes("italic")
  },
  {
    name: "orderedList",
    label: "List: ordered",
    icon: "list-ol",
    keybindings: [[["Control", "$controlOrAlt"], "Digit7"]],
    callback: (i) => i.command.run("insertOrderedList"),
    condition: (i) => i.allowFormatting.includes("orderedList")
  },
  {
    name: "unorderedList",
    label: "List: unordered",
    icon: "list-ul",
    keybindings: [[["Control", "$controlOrAlt"], "Digit8"]],
    callback: (i) => i.command.run("insertUnorderedList"),
    condition: (i) => i.allowFormatting.includes("unorderedList")
  },
  {
    name: "inlineCode",
    label: "Inline code",
    icon: "code",
    keybindings: [[["$metaOrCtrl"], "KeyE"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyE"]],
    callback: (i) => i.command.run("inlineCode"),
    condition: (i) => i.allowFormatting.includes("inlineCode")
  },
  {
    name: "blockquote",
    label: "Quote text",
    icon: "quote",
    keybindings: [[["Control", "$controlOrAlt"], "Digit9"]],
    callback: (i) => {
      const e = i.window.getSelection();
      if (!e) return;
      const t = e.anchorNode, o = !!(ct(t) ? t : t?.parentElement)?.closest("blockquote");
      i.command.run("formatBlock", o ? "div" : "<BLOCKQUOTE>");
    },
    condition: (i) => i.allowFormatting.includes("blockquote")
  },
  {
    name: "noFormat",
    label: "Clear formatting",
    icon: "pen-slash",
    keybindings: [[["$metaOrCtrl"], "Backslash"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "Backslash"]],
    callback: (i) => i.command.run("removeFormat")
  }
], Qr = [...Os, ...Yr];
class Hb extends D {
  domRef;
  constructor(e) {
    super(e), this.state = {
      isOpen: !1,
      currentFormat: ""
    }, this.domRef = B(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.selection.onUpdate(() => {
      this.updateCurrentFormat();
    });
  }
  componentDidUpdate(e, t) {
    const { isOpen: n } = this.state, { editorWindow: o } = this.props;
    n !== t.isOpen && o[n ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutside,
      !0
    );
  }
  componentWillUnmount() {
    const { isOpen: e } = this.state, { editorWindow: t } = this.props;
    e && t.removeEventListener("click", this.handleClickOutside, !0);
  }
  updateCurrentFormat() {
    const { editorWindow: e } = this.props;
    this.setState({
      currentFormat: Yg(e)
    });
  }
  handleClickOutside = (e) => {
    const { current: t } = this.domRef;
    t && e.target instanceof Element && e.target !== t && !t.contains(e.target) && this.setState({
      isOpen: !1
    });
  };
  handleClick = (e) => {
    e.preventDefault();
    const { isOpen: t } = this.state;
    this.setState({
      isOpen: !t
    });
  };
  handleToolbarButtonClick(e) {
    return (t) => {
      const { editor: n } = this.props;
      t.preventDefault(), e && (Qr.find(
        (r) => r.name === e
      )?.callback(n), this.forceUpdate());
    };
  }
  styleActive(e) {
    const { editor: t } = this.props;
    if (e === "blockquote") {
      const n = t.window.getSelection();
      if (!n) return !1;
      const o = n.anchorNode;
      return !!(ct(o) ? o : o?.parentElement)?.closest("blockquote");
    }
    return t.command.active(e);
  }
  render() {
    const { className: e, isActive: t, editor: n, editorWindow: o, ...r } = this.props, { isOpen: a, currentFormat: l } = this.state, c = f(e);
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: c, ref: this.domRef, children: [
      a && /* @__PURE__ */ s.jsxs("div", { className: Go.menu, children: [
        n.allowFormatting.includes("format") && /* @__PURE__ */ s.jsx(
          Ob,
          {
            formatBlock: l,
            editor: this.props.editor
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: Go.buttonsContainer, children: Yr.map((d) => {
          const h = "condition" in d;
          if (!(!h || h && d.condition(n)))
            return;
          const p = oo(d.keybindings), m = p ? `${d.label} (${p})` : d.label;
          return /* @__PURE__ */ s.jsx(
            Ee,
            {
              isActive: this.styleActive(d.name),
              onMouseDown: this.handleToolbarButtonClick(d.name),
              icon: d.icon,
              tooltip: m
            },
            d.name
          );
        }).filter(Boolean) })
      ] }),
      /* @__PURE__ */ s.jsx(
        Ee,
        {
          isActive: t,
          icon: "format",
          onClick: this.handleClick,
          tooltip: "Formatting"
        }
      )
    ] });
  }
}
const Mb = "h-inputRichText-suggestions--suggestions__dropdown", zb = "h-inputRichText-suggestions--suggestions__dropdownWithTabs", Vb = "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs", Kb = "h-inputRichText-suggestions--suggestions__dropdownTabs", Ub = "h-inputRichText-suggestions--suggestions__dropdownTabsContent", Gt = {
  dropdown: Mb,
  dropdownWithTabs: zb,
  dropdownWithoutTabs: Vb,
  dropdownTabs: Kb,
  dropdownTabsContent: Ub
};
function qb(i) {
  if (!i)
    return null;
  const { focusOffset: e, anchorOffset: t, anchorNode: n } = i;
  return e !== t || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, e);
}
class Gb extends D {
  dropdownRef;
  tabsRef;
  constructor(e) {
    super(e), this.state = {
      listenForSelectionChange: !0,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: "",
      selectedTab: null,
      selectionMode: "suggestion",
      tabIndex: 0
    }, this.dropdownRef = B(), this.tabsRef = B(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.selection.onUpdate(this.handleSelectionChange), e.events.onBlur(this.handleBlur), e.hotkeys.add([
      {
        keybindings: [[[], "ArrowUp"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(-1)
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(1)
      },
      {
        keybindings: [[[], "Escape"]],
        condition: () => this.hasSuggestions() || this.hasTabs(),
        callback: (t, n) => this.handleEscapeKey(n)
      },
      {
        keybindings: [[[], "Enter"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleEnterKey()
      }
    ]);
  }
  componentDidUpdate(e, t) {
    const { suggestionIndex: n, tabIndex: o } = this.state;
    n !== t.suggestionIndex && this.updateSuggestionScroll(), o !== t.tabIndex && this.updateTabScroll();
  }
  shouldHandleKey() {
    const { selectionMode: e } = this.state;
    return e === "suggestion" && this.hasSuggestions() || e === "tab" && this.hasTabs();
  }
  handleArrowKey(e) {
    const { selectionMode: t } = this.state;
    t === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(e) : t === "tab" && this.hasTabs() && this.tabsNavigate(e);
  }
  handleEscapeKey(e) {
    const { selectionMode: t } = this.state;
    this.shouldRenderDropdown() && e.stopPropagation(), t === "suggestion" && this.hasTabs() ? this.setState({
      selectionMode: "tab",
      tabIndex: this.getSelectedTabIndex()
    }) : this.clearSuggestions();
  }
  handleEnterKey() {
    const { selectionMode: e, tabIndex: t, suggestionTrigger: n } = this.state;
    if (e === "suggestion" && this.hasSuggestions())
      this.expandSuggestion();
    else if (e === "tab" && this.hasTabs()) {
      const o = n?.getTabs?.()[t];
      o && this.handleTabChange(o.id);
    }
  }
  handleBlur(e) {
    const {
      nativeEvent: { relatedTarget: t }
    } = e;
    t === null && this.clearSuggestions();
  }
  hasSuggestions() {
    const { suggestions: e } = this.state;
    return !!e?.length;
  }
  hasTabs() {
    return !!this.state.suggestionTrigger?.getTabs?.().length;
  }
  getSelectedTabIndex() {
    const { suggestionTrigger: e, selectedTab: t } = this.state;
    return this.hasTabs() ? e?.getTabs?.().findIndex((n) => n.id === t) : -1;
  }
  clearSuggestions() {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: "suggestion"
    });
  }
  suggestionsNavigate(e) {
    this.setState(({ suggestionIndex: t, suggestions: n }) => {
      if (n && n.length) {
        let o;
        return e < 0 ? o = t > 0 ? t - 1 : n.length - 1 : o = (t + 1) % n.length, {
          suggestionIndex: o
        };
      }
      return null;
    });
  }
  tabsNavigate(e) {
    this.setState(({ tabIndex: t, suggestionTrigger: n }) => {
      const o = n?.getTabs?.();
      if (o?.length) {
        let r;
        return e < 0 ? r = t > 0 ? t - 1 : o.length - 1 : r = (t + 1) % o.length, {
          tabIndex: r
        };
      }
      return null;
    });
  }
  lookForTriggers(e, t) {
    const { editor: n } = this.props, { selectedTab: o, selectionMode: r } = this.state, a = qb(n.selection.recreate({ focus: !1 }));
    if (a) {
      const l = n.triggers.test(a);
      if (l && n.triggers.isSuggestionTrigger(l.matchedTrigger)) {
        const { match: c, matchedTrigger: d } = l, h = d?.getTabs?.();
        if (h?.length) {
          let p = null;
          if (e ? p = {
            selectionMode: "suggestion",
            selectedTab: e,
            tabIndex: -1
          } : o ? e = o : p = {
            selectionMode: "tab",
            selectedTab: h[0].id,
            tabIndex: 0
          }, p && this.setState(p, () => {
            e || this.lookForTriggers();
          }), !e)
            return;
        } else r !== "suggestion" && this.setState({ selectionMode: "suggestion" });
        Promise.resolve(
          d.getSuggestions(c[1], e, t)
        ).then((p) => {
          this.updateSuggestions(c, d, p);
        });
        return;
      }
    }
    this.clearSuggestions();
  }
  findTriggerPosition(e, t) {
    this.setState(
      {
        listenForSelectionChange: !1
      },
      () => {
        const { onError: n, editor: o } = this.props, r = o.selection.recreate();
        if (r) {
          const { focusOffset: a, anchorNode: l } = r;
          if (l) {
            if (a - e >= 0)
              try {
                r.extend(l, a - e);
              } catch (c) {
                n?.(c);
              }
            if (r?.rangeCount && r?.rangeCount > 0) {
              const c = r.getRangeAt(0).getBoundingClientRect();
              r.collapseToEnd(), setTimeout(() => {
                t(c), this.setState({
                  listenForSelectionChange: !0
                });
              });
            }
          }
        }
      }
    );
  }
  updateSuggestions(e, t, n) {
    const { editor: o } = this.props;
    this.findTriggerPosition(e[0].length, (r) => {
      const a = o.selection.recreate();
      if (!a)
        return;
      const { focusOffset: l } = a, h = new RegExp(t.trigger).exec(e[0])?.[1]?.length ?? 0, u = e[0].length - h;
      this.setState({
        suggestions: n,
        suggestionTrigger: t,
        suggestionPosition: r,
        suggestionIndex: 0,
        suggestionMatchedString: e[1],
        suggestionExtendBy: l - u,
        listenForSelectionChange: !0
      });
    });
  }
  updateSuggestionScroll() {
    const { suggestionIndex: e } = this.state, { current: t } = this.dropdownRef;
    if (t) {
      if (t.infiniteListRef.current)
        t.infiniteListRef.current.scrollToItem(e);
      else if (t.listRef.current) {
        const n = t.listRef.current, r = t.listRef.current.children[e].getBoundingClientRect(), a = n.getBoundingClientRect();
        a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
      }
    }
  }
  updateTabScroll() {
    const { tabIndex: e } = this.state, { current: t } = this.tabsRef;
    if (!(e < 0 || !t) && t.containerRef.current) {
      const n = t.containerRef.current, r = t.containerRef.current.children[0].children[e].getBoundingClientRect(), a = n.getBoundingClientRect();
      a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
    }
  }
  expandSuggestion() {
    const {
      suggestions: e,
      suggestionIndex: t,
      suggestionExtendBy: n,
      suggestionTrigger: o
    } = this.state;
    if (!(!e || !e[t] || !o))
      return o.insertContent(
        e[t],
        o.trigger,
        n
      );
  }
  handleSelectionChange() {
    const { listenForSelectionChange: e } = this.state;
    e && this.lookForTriggers();
  }
  handleSuggestionClick(e) {
    this.setState(
      (t) => ({
        suggestionIndex: t.suggestions ? t.suggestions.indexOf(e) : 0
      }),
      () => {
        this.expandSuggestion();
      }
    );
  }
  calculateSuggestionBoxPosition() {
    const { suggestionPosition: e } = this.state, { editor: t } = this.props;
    if (t.ref.current && e) {
      const n = t.ref.current.getBoundingClientRect();
      return {
        bottom: n.bottom - e.bottom + e.height,
        left: e.x - n.x + e.width
      };
    }
    return {};
  }
  suggestionBoxStyle() {
    const { suggestionPosition: e } = this.state, { editor: t } = this.props;
    if (t.ref.current && e) {
      const n = t.ref.current.getBoundingClientRect();
      return {
        left: `${e.x - n.x}px`,
        top: `${e.y - n.y + e.height / 2}px`,
        //`${suggestionPosition.x}px`,
        height: 1,
        width: e.width,
        position: "absolute"
      };
    }
    return {};
  }
  getPagination() {
    const { suggestionTrigger: e } = this.state;
    if (!e || !e.getPagination)
      return !1;
    const t = e.getPagination();
    return !t || !t.onNext ? !1 : {
      ...t,
      onNext: () => t.onNext?.().then((n) => {
        this.setState({ suggestions: n });
      }) ?? Promise.resolve(void 0)
    };
  }
  handleTabChange(e) {
    this.lookForTriggers(e, 0);
  }
  renderEmptyState() {
    return /* @__PURE__ */ s.jsx(pn, { label: "No suggestions found" });
  }
  renderTabs() {
    const { suggestions: e, suggestionTrigger: t, selectedTab: n, tabIndex: o } = this.state, r = t?.getTabs?.() ?? [], a = !!e?.length;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        ro,
        {
          ref: this.tabsRef,
          className: Gt.dropdownTabs,
          tabs: r,
          tabsPlacement: "left",
          selectedId: n,
          activeId: r?.[o]?.id,
          onChange: this.handleTabChange
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: Gt.dropdownTabsContent, children: a ? this.renderItems() : this.renderEmptyState() })
    ] });
  }
  renderItems() {
    const { suggestions: e, suggestionIndex: t, suggestionTrigger: n, selectionMode: o } = this.state, r = n ? n.suggestionComponent : null;
    return /* @__PURE__ */ s.jsx(
      Xs,
      {
        ref: this.dropdownRef,
        pagination: this.getPagination(),
        items: e || void 0,
        onSelect: this.handleSuggestionClick,
        itemComponent: r,
        activeItem: o === "suggestion" ? e?.[t] : void 0
      }
    );
  }
  shouldRenderDropdown() {
    const { suggestionPosition: e, selectedTab: t, suggestions: n } = this.state;
    return !(!e || !this.hasTabs() && !n?.length || this.hasTabs() && !t);
  }
  render() {
    const { editor: e, onError: t, ...n } = this.props;
    if (!this.shouldRenderDropdown())
      return null;
    const o = f(Gt.dropdown, {
      [Gt.dropdownWithTabs]: this.hasTabs(),
      [Gt.dropdownWithoutTabs]: !this.hasTabs()
    });
    return /* @__PURE__ */ s.jsx("div", { ...n, children: /* @__PURE__ */ s.jsx("div", { style: this.suggestionBoxStyle(), children: /* @__PURE__ */ s.jsx(et, { className: o, isOpen: !0, children: this.hasTabs() ? this.renderTabs() : this.renderItems() }) }) });
  }
}
function Yb({ children: i, className: e }) {
  const t = q(null), [n, o] = V(0), r = () => t.current ? Array.from(
    t.current.querySelectorAll("button:not([disabled])")
  ).filter((l) => l.closest('[role="toolbar"]') === t.current) : [];
  Z(() => {
    const l = r();
    l.length !== 0 && l.forEach((c, d) => {
      d === 0 ? c.setAttribute("tabindex", "0") : c.setAttribute("tabindex", n === d ? "0" : "-1");
    });
  }, [n]);
  const a = (l) => {
    const c = r();
    if (c.length === 0) return;
    const d = document.activeElement;
    if (!t.current?.contains(d)) return;
    let h = n;
    switch (l.key) {
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), l.stopPropagation(), h = h <= 0 ? c.length - 1 : h - 1, o(h), c[h]?.focus();
        break;
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), l.stopPropagation(), h = h >= c.length - 1 ? 0 : h + 1, o(h), c[h]?.focus();
        break;
      case "Home":
        l.preventDefault(), l.stopPropagation(), o(0), c[0]?.focus();
        break;
      case "End":
        l.preventDefault(), l.stopPropagation();
        const u = c.length - 1;
        o(u), c[u]?.focus();
        break;
    }
  };
  return Z(() => {
    const l = t.current;
    if (!l) return;
    const c = (h) => {
      const u = r(), p = h.target, m = u.indexOf(p);
      m !== -1 && o(m);
    }, d = (h) => {
      l.contains(h.relatedTarget) || o(0);
    };
    return l.addEventListener("focusin", c), l.addEventListener("focusout", d), () => {
      l.removeEventListener("focusin", c), l.removeEventListener("focusout", d);
    };
  }, []), /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: t,
      className: e,
      role: "toolbar",
      "aria-label": "Text formatting",
      onKeyDown: a,
      children: i
    }
  );
}
function Yo(i) {
  return i instanceof RegExp ? i.source : i;
}
function Qb(i) {
  return i.replace(/\(/g, "(?:");
}
class Xr {
  storedTriggers;
  constructor() {
    this.storedTriggers = [];
  }
  get excludeTriggersRegex() {
    return this.storedTriggers.map(
      (e) => `(?!${Yo(e.trigger)})`
    ).join("");
  }
  add(e) {
    this.storedTriggers.push(e);
  }
  update(e) {
    const t = this.storedTriggers.findIndex(
      (n) => this.isAddonTrigger(n) && n.id === e.id
    );
    t !== -1 && (this.storedTriggers[t] = e);
  }
  test(e) {
    let t;
    for (let n = 0; n < this.storedTriggers.length; n += 1) {
      const o = this.storedTriggers[n], { trigger: r, allowSpaces: a, minChars: l } = o, c = Qb(
        Yo(r)
      ), d = this.excludeTriggersRegex, h = a ? "." : "\\S";
      if (t = new RegExp(`${c}((?:${d}${h})*)$`, "g").exec(e), t && (!l || t[1].length >= l))
        return {
          match: t,
          matchedTrigger: o
        };
    }
    return null;
  }
  isSuggestionTrigger(e) {
    return "getSuggestions" in e;
  }
  isAddonTrigger(e) {
    return !this.isSuggestionTrigger(e);
  }
}
function Zr(i, e) {
  const t = i.getSelection();
  if (!t || t.rangeCount === 0) return !1;
  let n = t.anchorNode;
  const o = "CODE";
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE && n.tagName === o)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function Xb(i, e) {
  e?.();
  const t = i.getSelection();
  if (!t || t.rangeCount === 0) return;
  const n = t.getRangeAt(0);
  if (Zr(i)) {
    Zb(i, "CODE");
    return;
  }
  const o = n.collapsed, r = i.document.createElement("code");
  if (o) {
    const a = i.document.createTextNode("​");
    r.appendChild(a), n.insertNode(r), n.setStart(r.firstChild, 1), n.setEnd(r.firstChild, 1);
  } else {
    const a = n.extractContents();
    r.appendChild(a), n.insertNode(r), n.setStartAfter(r), n.setEndAfter(r);
  }
  t.removeAllRanges(), t.addRange(n);
}
function Zb(i, e) {
  const t = i.getSelection();
  if (!t || t.rangeCount === 0) return;
  let n = t.anchorNode;
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE) {
      const o = n;
      if (o.tagName === e) {
        const r = o.parentNode;
        if (r) {
          const a = i.document.createDocumentFragment();
          for (; o.firstChild; )
            a.appendChild(o.firstChild);
          r.replaceChild(a, o);
          const l = i.document.createRange();
          l.selectNodeContents(r), l.collapse(!1), t.removeAllRanges(), t.addRange(l);
        }
        return;
      }
    }
    n = n.parentNode;
  }
}
const Tn = 25;
let ke = null, lt = null;
function Jb(i, e) {
  const t = e.document.createElement("div");
  return t.className = `image-resize-handle image-resize-handle-${i}`, t.dataset.handle = i, t;
}
function ex(i, e) {
  const t = e.document.createElement("div");
  return t.className = "image-resize-wrapper", t.contentEditable = "false", i.parentNode?.insertBefore(t, i), t.appendChild(i), ["nw", "ne", "se", "sw"].forEach((o) => {
    const r = Jb(o, e);
    t.appendChild(r);
  }), t;
}
function Jr(i) {
  const e = i.querySelector("img");
  e && i.parentNode && (i.parentNode.insertBefore(e, i), i.remove());
}
function tx(i, e, t) {
  const { startX: n, startWidth: o, handle: r, aspectRatio: a } = i, l = e - n;
  let c = o;
  switch (r) {
    case "se":
    case "ne":
      c = o + l;
      break;
    case "sw":
    case "nw":
      c = o - l;
      break;
  }
  let d = c / a;
  c < Tn && (c = Tn, d = Tn / a);
  const h = Tn / a;
  return d < h && (d = h, c = h * a), { width: c, height: d };
}
function io(i) {
  if (!ke) return;
  i.preventDefault(), i.stopPropagation();
  const { width: e } = tx(
    ke,
    i.clientX,
    i.clientY
  );
  ke.img.style.width = `${e}px`, ke.img.style.height = "auto";
}
function ao(i) {
  if (!ke) return;
  i.preventDefault(), i.stopPropagation();
  const { img: e } = ke, t = e.ownerDocument.defaultView;
  t.document.removeEventListener("mousemove", io), t.document.removeEventListener("mouseup", ao), ke = null;
  const n = new Event("input", { bubbles: !0 });
  e.closest('[contenteditable="true"]')?.dispatchEvent(n);
}
function nx(i, e, t) {
  i.preventDefault(), i.stopPropagation();
  const n = e.ownerDocument.defaultView, o = e.closest(".image-resize-wrapper");
  if (!o) return;
  const r = e.naturalWidth, a = e.naturalHeight, l = r / a, c = e.getBoundingClientRect(), d = c.width, h = c.height;
  ke = {
    img: e,
    originalWidth: r,
    originalHeight: a,
    aspectRatio: l,
    startX: i.clientX,
    startY: i.clientY,
    startWidth: d,
    startHeight: h,
    handle: t,
    wrapper: o
  }, n.document.addEventListener("mousemove", io), n.document.addEventListener("mouseup", ao);
}
function sx(i, e) {
  lt && (Jr(lt), lt = null);
  const t = ex(i, e);
  lt = t, t.querySelectorAll(".image-resize-handle").forEach((o) => {
    const r = o.dataset.handle;
    o.addEventListener(
      "mousedown",
      (a) => nx(a, i, r)
    );
  });
}
function ws() {
  if (lt && (Jr(lt), lt = null), ke) {
    const i = ke.img.ownerDocument.defaultView;
    i.document.removeEventListener("mousemove", io), i.document.removeEventListener("mouseup", ao), ke = null;
  }
}
function ox(i) {
  return i ? i.classList.contains("image-resize-wrapper") || i.classList.contains("image-resize-handle") || i.closest(".image-resize-wrapper") !== null : !1;
}
function Qo(i) {
  if (!i) return i;
  const n = new DOMParser().parseFromString(`<div>${i}</div>`, "text/html").body.firstChild;
  return n ? (n.querySelectorAll(".image-resize-wrapper").forEach((r) => {
    const a = r.querySelector("img");
    a && r.parentNode && (r.parentNode.insertBefore(a, r), r.remove());
  }), n.innerHTML) : i;
}
const ei = "input-rich-text-editor", ti = [
  {
    name: "insertInlineAttachment",
    label: "Insert inline image",
    keybindings: [[["$metaOrCtrl"], "KeyM"]]
  }
], Xo = [
  ...ti,
  ...Qr,
  ...Gr,
  ...Cf
], rx = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, ix = ve({
  command: {
    run: L,
    active: () => !1
  },
  content: {
    insert: L,
    setUiBlocker: L
  },
  hotkeys: {
    add: L,
    updateKeybindings: L
  },
  selection: {
    recreate: () => null,
    getRange: () => null,
    isWithinEditor: () => !1,
    onUpdate: L
  },
  events: {
    subscribe: () => L,
    publish: L,
    onMouseOver: L,
    onBlur: L
  },
  allowFormatting: [],
  triggers: new Xr(),
  ref: B(),
  window,
  history: {
    canUndo: () => !1,
    undo: L,
    takeSnapshot: L,
    reset: L
  }
});
class lo extends D {
  editor;
  editorRef;
  currentSuggestionRef;
  fileInputRef;
  attachmentDropdownButtonRef;
  unsubscribeInlineAttachment;
  isInserting;
  contentInsertionQueue;
  /**
   * Button that can be used in `toolbarAddons` to have same styles as the
   * buitlin buttons.
   */
  static ToolbarButton = Ee;
  /** Context containing props and methods to interact with the editor. */
  static Context = ix;
  static contextType = Yn;
  get effectiveWindow() {
    return this.context ?? window;
  }
  static defaultProps = {
    allowAttachments: !1,
    allowInlineAttachments: !1,
    allowEmoji: !0,
    languages: [],
    onTriggerSend() {
      console.warn("InputRichText: onTriggerSend callback missing in props");
    },
    onToggleSendOnEnter: L,
    sendOnEnter: !1,
    onMount: L,
    onUnmount: L,
    disabled: !1,
    hasAutocompleteSuggestionsFeature: !1
  };
  constructor(e) {
    super(e), this.editorRef = B(), this.currentSuggestionRef = B(), this.fileInputRef = B(), this.attachmentDropdownButtonRef = B(), this.unsubscribeInlineAttachment = L, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
      keyDownHandled: !1,
      keyCommands: Xo,
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: "",
      lastSelection: null,
      hasFocus: !1,
      selectedText: "",
      selectedLink: "",
      showHint: !1,
      pubsub: {},
      uiBlocker: e.uiBlocker,
      undoStack: []
    }, this.editor = {
      command: {
        run: this.commandRun.bind(this),
        active: this.commandActive.bind(this)
      },
      content: {
        insert: this.insertContent.bind(this),
        setUiBlocker: this.setUiBlocker.bind(this)
      },
      hotkeys: {
        add: this.addKeyCommands.bind(this),
        updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
      },
      selection: {
        onUpdate: this.addSelectionUpdateListener.bind(this),
        recreate: this.recreateSelection.bind(this),
        getRange: this.getSelectionRange.bind(this),
        isWithinEditor: this.isSelectionWithinEditor.bind(this)
      },
      events: {
        onMouseOver: this.addMouseOverListener.bind(this),
        onBlur: this.addBlurListener.bind(this),
        subscribe: this.subscribe.bind(this),
        publish: this.publish.bind(this)
      },
      allowFormatting: this.getAllowedFormattingOptions(),
      triggers: new Xr(),
      ref: this.editorRef,
      window: this.effectiveWindow,
      history: {
        undo: this.undo,
        canUndo: this.canUndo,
        reset: this.resetUndoStack,
        takeSnapshot: this.addCurrentContentToUndoStack
      }
    };
  }
  componentDidMount() {
    const e = this.effectiveWindow, { onMount: t } = this.props;
    e.document.execCommand(
      "defaultParagraphSeparator",
      !1,
      "div"
    );
    const { value: n } = this.props;
    n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe(
      "insertInlineAttachment",
      () => {
        this.props.allowInlineAttachments && this.openFileBrowser();
      }
    ), t(), this.updateKeyCommandsKeybindings(this.props.keybindings);
  }
  componentDidUpdate(e) {
    this.editor.window !== this.effectiveWindow && (this.editor.window = this.effectiveWindow);
    const { fileUploadStatuses: t, autocomplete: n, keybindings: o, uiBlocker: r } = this.props, { current: a } = this.editorRef;
    t && t !== e.fileUploadStatuses && a && (Object.keys(t).forEach((l) => {
      this.updateFileLoader(l, t[l]);
    }), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== e.autocomplete?.showAutocompleteSuggestions && this.setState({ showHint: !0 }, () => {
      setTimeout(() => {
        this.setState({ showHint: !1 });
      }, 1e3);
    }), vr(e.keybindings, o) || this.updateKeyCommandsKeybindings(o), e.uiBlocker !== r && this.setUiBlocker(r);
  }
  componentWillUnmount() {
    const { onUnmount: e } = this.props;
    this.unsubscribeInlineAttachment?.(), ws(), e(this.getSanitizedHtml());
  }
  getCommandsWithInputKeybindings() {
    const { keybindings: e } = this.props;
    return Xo.map((t) => ({
      ...t,
      keybindings: e && t.name ? e[t.name] ?? [] : t.keybindings
    }));
  }
  subscribe(e, t) {
    return this.setState((n) => ({
      pubsub: {
        ...n.pubsub,
        [e]: [...n.pubsub[e] ?? [], t]
      }
    })), () => {
      this.setState((n) => Sr(n, e));
    };
  }
  publish(e) {
    this.state.pubsub[e]?.forEach((t) => t(this.editor));
  }
  /**
   * The core update function, that triggers every time the selection is
   * changed, which will also trigger when the contents change.
   *
   * This method handles calling onChange prop.
   *
   * @returns {void | undefined} Description
   * @todo Test if onInput would be a better way of triggering onChange
   */
  handleSelectionChange = () => {
    const { onChange: e, onSelectionChange: t } = this.props, { htmlOld: n, selectionUpdateListeners: o } = this.state, { current: r } = this.editorRef;
    if (r) {
      this.forceUpdate();
      const a = this.extractEditorContent();
      a !== n && (this.setState({
        htmlOld: a
      }), e(a));
    }
    o.forEach((a) => {
      a();
    }), t && t();
  };
  /** Handle any mouse over events on the editor */
  handleMouseOver = (e) => {
    const { mouseOverListeners: t } = this.state;
    t.forEach((n) => {
      n(e);
    });
  };
  /** Handle click events on the editor to select images */
  handleEditorClick = (e) => {
    const t = e.target, n = this.effectiveWindow;
    if (ct(t) && t.tagName === "IMG") {
      e.preventDefault();
      const o = n.getSelection();
      if (o) {
        const r = n.document.createRange();
        r.selectNode(t), o.removeAllRanges(), o.addRange(r), this.handleSelectionChange();
      }
      sx(t, n);
    } else ox(t) || ws();
  };
  /** Handle blur events on the editor */
  handleBlurListeners = (e) => {
    const { blurListeners: t } = this.state;
    t.forEach(
      (n) => {
        n(e);
      }
    );
  };
  handleKeyDown = (e) => {
    if (e.getModifierState(e.key))
      return;
    const { keyCommands: t } = this.state, { sendOnEnter: n, onKeyDown: o } = this.props;
    if (o?.(e), t.some(
      ({ preventDefaultKeybinding: a }) => a && bs(a, e)
    ) && e.preventDefault(), t.some(
      ({ name: a, keybindings: l, condition: c, callback: d }) => {
        if (bs(l, e) && (c === void 0 || c(this.editor)))
          return d?.(this.editor, e), a && this.editor.events.publish(a), !0;
      }
    )) {
      this.setKeyDownHandled(e), e.stopPropagation();
      return;
    }
    if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey && this.editor.allowFormatting.includes("blockquote")) {
      const a = this.effectiveWindow, l = a.getSelection();
      if (!l) return;
      const c = l.anchorNode, h = (ct(c) ? c : c?.parentElement)?.closest("blockquote");
      if (h && this.editorRef.current?.contains(h)) {
        const u = a.document, p = u.createElement("div");
        p.appendChild(u.createElement("br")), h.after(p);
        const m = u.createRange();
        m.setStart(p, 0), m.collapse(!0), l.removeAllRanges(), l.addRange(m), this.setKeyDownHandled(e), this.handleSelectionChange();
        return;
      }
    }
    if (bs([[["$metaOrCtrl"], "Enter"]], e)) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(e), a();
    } else if (e.key === "Enter" && n && !e.shiftKey) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(e), a();
    }
    return null;
  };
  getBlockLevelParent = (e) => {
    const t = this.effectiveWindow;
    let n = ct(e) ? e : e.parentElement;
    for (; !no(n, t); )
      n = n.parentElement;
    return n;
  };
  // Insert actual text direction into the html
  onInput = (e) => {
    const { current: t } = this.editorRef, n = e?.nativeEvent;
    if (!n)
      return;
    this.resetUndoStack();
    const { inputType: o } = n;
    if (o === "insertFromPaste" || !o) {
      Mo(t), Xg(t);
      return;
    }
    const a = document.getSelection()?.anchorNode;
    if (o === "insertText" && a && a.textContent?.length === 1) {
      const l = this.getBlockLevelParent(a);
      if (
        // if the parent element is `ol` or `ul`, and if it has direction, do not change it
        (l.tagName === "UL" || l.tagName === "OL") && l.hasAttribute("dir")
      )
        return;
      l.setAttribute("dir", "auto");
      const c = window.getComputedStyle(l).direction;
      l.setAttribute("dir", c), l.style.textAlign = "";
    }
  };
  handleKeyUp = () => {
    const { keyDownHandled: e } = this.state;
    e || this.handleSelectionChange(), this.setState({
      keyDownHandled: !1
    });
  };
  setKeyDownHandled = (e) => {
    e.preventDefault(), this.setState({
      keyDownHandled: !0
    });
  };
  addKeyCommands = (e) => {
    this.setState(({ keyCommands: t }) => ({
      keyCommands: [...t, ...e]
    }));
  };
  updateKeyCommandsKeybindings = (e) => {
    if (!e)
      return;
    const { keyCommands: t } = this.state;
    Object.entries(e).forEach(([n, o]) => {
      const r = t.findIndex(
        ({ name: a }) => a === n
      );
      r > -1 && o && (t[r].keybindings = o);
    });
  };
  addSelectionUpdateListener(e) {
    this.setState(({ selectionUpdateListeners: t }) => ({
      selectionUpdateListeners: [...t, e]
    }));
  }
  addMouseOverListener(e) {
    this.setState(({ mouseOverListeners: t }) => ({
      mouseOverListeners: [...t, e]
    }));
  }
  addBlurListener(e) {
    this.setState(({ blurListeners: t }) => ({
      blurListeners: [...t, e]
    }));
  }
  handlePaste = (e) => {
    const { onFileDropped: t, allowInlineAttachments: n, sanitize: o } = this.props, r = this.effectiveWindow, { clipboardData: a } = e;
    if (!a)
      return;
    let l = a.getData("text/html");
    const c = a.getData("text/plain"), d = a.files.item(0);
    if (l) {
      e.preventDefault(), this.commandRun("insertHTML", o?.(l));
      return;
    }
    if (c && rx.test(c)) {
      e.preventDefault();
      const h = r.getSelection(), u = h && !h.isCollapsed ? h.toString() : "", p = u && this.editor.allowFormatting.includes("link") ? u : c;
      l = qr(c, p), this.commandRun("insertHTML", l);
      return;
    }
    if (d) {
      if (n && t) {
        const { src: h, uid: u } = Ho(r, d);
        this.insertImageLoader(h, u), t(d, u);
      }
      e.preventDefault();
    }
  };
  commandRun(e, t = null) {
    setTimeout(() => {
      const { hasFocus: n } = this.state, { current: o } = this.editorRef, r = this.effectiveWindow;
      if (o) {
        if (n || this.recreateSelection(), e === "inlineCode") {
          Xb(r, this.addCurrentContentToUndoStack), this.handleSelectionChange();
          return;
        }
        r.document.execCommand(
          e,
          !1,
          // execCommand 3rd expects string | null, TS thinks it needs string | undefined
          t
        );
      }
    });
  }
  commandActive(e) {
    const { hasFocus: t } = this.state, n = this.effectiveWindow;
    return e === "inlineCode" ? !!(t && Zr(n)) : !!(t && Gg(n, e));
  }
  getText = () => {
    const { current: e } = this.editorRef;
    return e && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
  };
  getSanitizedHtml = () => this.props.sanitize?.(this.getText());
  getPlainText = () => {
    const { current: e } = this.editorRef, t = (
      // innerHTML of <div></div> should count as empty
      e && this.hasContent(this.extractEditorContent()) ? e.innerText : ""
    );
    return t ? t.replace(/\n\n/g, `
`).trim() : "";
  };
  setHtml(e) {
    const { current: t } = this.editorRef, n = this.props.sanitize?.(e);
    t && (t.innerHTML = n || "", Mo(t)), this.setState({
      htmlOld: n
    }), this.handleSelectionChange();
  }
  handleInlineUpload = (e) => {
    if (e === null) return;
    const { onFileDropped: t } = this.props, n = this.effectiveWindow;
    e && t && Array.from(e).forEach((r) => {
      if (Qg(r)) {
        const { src: a, uid: l } = Ho(n, r);
        this.insertImageLoader(a, l), t(r, l);
      } else {
        const a = rn();
        this.insertFileLoader(r.name, a), t(r, a);
      }
    });
  };
  handleAttachmentUpload = (e) => {
    const { onAttachmentsFile: t } = this.props, { current: n } = this.attachmentDropdownButtonRef;
    n && n.open(), e && typeof t == "function" && Array.from(e).forEach((r) => {
      const a = rn();
      t(r, a);
    });
  };
  handleDetachAttachmentFile = (e) => {
    const { onDetachAttacmentFile: t } = this.props;
    typeof t == "function" && t(e);
  };
  handleFileSelect = (e) => {
    const t = e.target;
    t?.ownerDocument?.defaultView && t instanceof t.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(t.files), t.value = "");
  };
  openFileBrowser = (e) => {
    e?.preventDefault();
    const { current: t } = this.fileInputRef;
    t && t.click();
  };
  insertImageLoader(e, t) {
    const o = this.effectiveWindow.document.createElement("img");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", t), o.setAttribute("src", e), this.insertContent(o);
  }
  insertFileLoader(e, t) {
    const o = this.effectiveWindow.document.createElement("a");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", t), o.setAttribute("href", "#"), o.innerText = e, this.insertContent(o);
  }
  updateFileLoader(e, { link: t, status: n, filename: o }) {
    const { current: r } = this.editorRef;
    if (r) {
      const a = r.querySelector(`[data-uid="${e}"]`);
      a && (n === "failed" && a.parentElement ? a.parentElement.removeChild(a) : (a.classList.remove(
        "async-loading",
        "async-succeeded",
        "async-failed"
      ), a.classList.add(`async-${n}`), t && a.tagName === "IMG" && (a.src = t, o && (a.title = o)), t && a.tagName === "A" && (a.href = t)));
    }
  }
  handleToggleSendOnEnter = (e) => {
    e.preventDefault();
    const { onToggleSendOnEnter: t } = this.props;
    t();
  };
  handleToggleAutocompleteSuggestions = (e) => {
    e.preventDefault();
    const { autocomplete: t } = this.props;
    t && t.onToggleShowAutocompleteSuggestions();
  };
  isSelectionWithinEditor(e) {
    const { anchorNode: t } = e;
    let { parentElement: n = null } = t || {};
    const o = `.${fe.editor}`;
    let r = t !== null && t.nodeType === Node.ELEMENT_NODE ? t.matches(o) : !1;
    for (; !r && n !== null; ) {
      if (n.matches(o)) {
        r = !0;
        break;
      }
      n = n.parentElement;
    }
    return r;
  }
  insertContent = (e, t) => {
    this.contentInsertionQueue.push(e), t?.getSelection ? this.processContentInsertionQueue(t.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
      this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
    }));
  };
  processContentInsertionQueue = (e) => {
    if (!e || !this.isSelectionWithinEditor(e)) {
      this.contentInsertionQueue = [];
      return;
    }
    if (Zg(e), e?.rangeCount && e?.rangeCount > 0) {
      const t = e.getRangeAt(0);
      if (e.isCollapsed || t.deleteContents(), this.contentInsertionQueue.length === 1)
        t.insertNode(this.contentInsertionQueue[0]);
      else if (this.contentInsertionQueue.length > 1) {
        const n = document.createElement("span");
        this.contentInsertionQueue.forEach((o) => {
          n.appendChild(o);
        }), t.insertNode(n);
      }
    }
    this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
      e.collapseToEnd();
    }), this.handleSelectionChange();
  };
  setUiBlocker(e) {
    this.setState({ uiBlocker: e });
  }
  getSelectionRange() {
    const e = this.effectiveWindow;
    if (e.document.activeElement === this.editorRef.current) {
      const t = e.document.getSelection();
      return t?.rangeCount && t?.rangeCount > 0 ? t.getRangeAt(0) : null;
    }
    return this.state.lastSelection;
  }
  recreateSelection(e) {
    const { current: t } = this.editorRef, { lastSelection: n } = this.state, r = this.effectiveWindow.getSelection();
    return t && (!r || !this.isSelectionWithinEditor(r)) && e?.focus !== !1 && (t.focus(), n && r && (r.removeAllRanges(), r.addRange(n))), r;
  }
  handleFocus = () => {
    const e = this.effectiveWindow;
    this.setState({
      hasFocus: !0
    }), e.document.addEventListener(
      "selectionchange",
      this.handleSelectionChange
    );
  };
  handleBlur = (e) => {
    const t = this.effectiveWindow, n = t.getSelection(), o = () => n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0) : null;
    ws(), this.setState({
      lastSelection: o(),
      hasFocus: !1
    }), t.document.removeEventListener(
      "selectionchange",
      this.handleSelectionChange
    ), this.handleBlurListeners(e);
  };
  focus = () => {
    const { current: e } = this.editorRef, { hasFocus: t } = this.state;
    e && (t || e.focus());
  };
  moveCursorToEnd = () => {
    const { current: e } = this.editorRef, t = this.effectiveWindow;
    if (!e) return;
    const n = t.getSelection();
    if (n) {
      const o = t.document.createRange();
      o.selectNodeContents(e), o.collapse(!1), n.removeAllRanges(), n.addRange(o);
    }
  };
  hasContent(e) {
    return e?.length ? !e.match(/^\s*<br>\s*$|^<div[^>]*>\s*(<br>\s*)?<\/div>$/) : !1;
  }
  isStylingActive() {
    return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList") || this.commandActive("inlineCode");
  }
  getAllowedFormattingOptions() {
    const { allowFormatting: e } = this.props;
    return Array.isArray(e) ? e : e ? Ug : [];
  }
  lastExtractedContent = B();
  extractEditorContent() {
    const { editorContentExtractor: e, sanitize: t } = this.props, { current: n } = this.editorRef, o = n?.innerHTML ?? "";
    if (!e)
      return Qo(o);
    if (o === this.lastExtractedContent.current)
      return this.lastExtractedContent.current;
    const r = e(n);
    return this.lastExtractedContent.current = Qo(
      t?.(r) ?? r
    ), this.lastExtractedContent.current;
  }
  canUndo = () => this.state.undoStack.length > 0;
  undo = () => {
    const { undoStack: e } = this.state;
    if (e.length > 0) {
      const t = e[e.length - 1];
      this.setHtml(t), this.setState({
        undoStack: e.slice(0, -1)
      });
    }
  };
  resetUndoStack = () => {
    this.setState({
      undoStack: []
    });
  };
  addCurrentContentToUndoStack = () => {
    this.setState({
      // To prevent undo stack from growing indefinitely, we only keep a finite amount
      undoStack: [...this.state.undoStack.slice(-50), this.getText()]
    });
  };
  render() {
    const {
      className: e,
      wrapperClassName: t,
      renderQuickResponse: n,
      quickResponsesApi: o,
      sendOnEnter: r,
      placeholder: a,
      allowInlineAttachments: l,
      allowAttachments: c,
      attachmentsDisabled: d,
      attachmentsDisabledTooltip: h,
      textInputDisabled: u,
      allowEmoji: p,
      attachmentsFields: m,
      attachments: g,
      isAttachmentsUploading: b,
      hideSendOnEnterToggle: x,
      languages: C,
      disabled: _,
      status: S,
      onError: v,
      icon: y,
      prefix: w,
      suffix: I,
      id: T,
      autocomplete: F,
      toolbarAddons: H
    } = this.props, { htmlOld: k, uiBlocker: R } = this.state, O = this.effectiveWindow, U = f(fe.root, e);
    return /* @__PURE__ */ s.jsx(lo.Context.Provider, { value: this.editor, children: /* @__PURE__ */ s.jsx(
      Ae,
      {
        status: S,
        icon: y,
        prefix: w,
        suffix: I,
        disabled: _,
        className: f(fe.inputWrapper, t),
        children: /* @__PURE__ */ s.jsxs("div", { className: U, children: [
          /* @__PURE__ */ s.jsxs(
            Tf,
            {
              className: fe.editorWrap,
              onAddInline: this.handleInlineUpload,
              onAddAttachment: this.handleAttachmentUpload,
              attachments: Array.isArray(g) ? g : [],
              allowInlineAttachments: l,
              allowAttachments: c,
              children: [
                /* @__PURE__ */ s.jsx(
                  "div",
                  {
                    id: T,
                    ref: this.editorRef,
                    onPaste: this.handlePaste,
                    onKeyDown: this.handleKeyDown,
                    onInput: this.onInput,
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onMouseOver: this.handleMouseOver,
                    onClick: this.handleEditorClick,
                    className: f(fe.editor, {
                      [fe.editorDisabled]: u
                    }),
                    "data-testid": ei,
                    contentEditable: !u
                  }
                ),
                !this.hasContent(k) && !!a && /* @__PURE__ */ s.jsx("span", { role: "presentation", className: fe.placeholder, children: a })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(Yb, { className: fe.toolbar, children: [
            this.editor.allowFormatting.length > 0 && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                Hb,
                {
                  isActive: this.isStylingActive(),
                  editor: this.editor,
                  editorWindow: O
                }
              ),
              this.editor.allowFormatting.includes("link") && /* @__PURE__ */ s.jsx(nb, { editor: this.editor })
            ] }),
            l && /* @__PURE__ */ s.jsx(
              Ee,
              {
                icon: "upload",
                onMouseDown: this.openFileBrowser,
                tooltip: `Insert inline image (${oo(ti[0].keybindings)})`
              }
            ),
            c && /* @__PURE__ */ s.jsx(
              vf,
              {
                dropdownRef: this.attachmentDropdownButtonRef,
                onAttachFiles: this.handleAttachmentUpload,
                attachments: Array.isArray(g) ? g : [],
                isAttachmentsUploading: b,
                onDetachFile: this.handleDetachAttachmentFile,
                editorWindow: O,
                editor: this.editor,
                disabled: d,
                disabledTooltip: h,
                fixed: !0,
                children: m
              }
            ),
            p && /* @__PURE__ */ s.jsx(Af, { "data-tip": "Emojis", editor: this.editor, fixed: !0 }),
            !!o && !!n && /* @__PURE__ */ s.jsx(
              Fb,
              {
                languages: C,
                renderQuickResponse: n,
                quickResponsesApi: o,
                editor: this.editor,
                sanitize: this.props.sanitize,
                iconName: this.props.quickResponseIcon
              }
            ),
            F && F.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ s.jsx(
              Ee,
              {
                isActive: F.showAutocompleteSuggestions,
                onMouseDown: this.handleToggleAutocompleteSuggestions,
                icon: "autocomplete",
                tooltip: "Autocomplete suggestions"
              }
            ),
            H,
            !x && /* @__PURE__ */ s.jsx(
              Ee,
              {
                isActive: r,
                onMouseDown: this.handleToggleSendOnEnter,
                icon: "enter",
                tooltip: "Send on Enter"
              }
            ),
            F ? /* @__PURE__ */ s.jsxs(
              "span",
              {
                className: f(fe.toolbarHint, {
                  [fe.toolbarHintVisible]: this.state.showHint,
                  [fe.toolbarHintHidden]: !this.state.showHint
                }),
                children: [
                  "Autocomplete",
                  " ",
                  F.showAutocompleteSuggestions ? "ON" : "OFF"
                ]
              }
            ) : null
          ] }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              tabIndex: -1,
              ref: this.fileInputRef,
              type: "file",
              className: fe.fileInput,
              onChange: this.handleFileSelect,
              multiple: !0
            }
          ),
          /* @__PURE__ */ s.jsx(Gb, { editor: this.editor, onError: v }),
          /* @__PURE__ */ s.jsx(df, { editor: this.editor }),
          R && /* @__PURE__ */ s.jsx("div", { className: fe.uiBlocker, children: R })
        ] })
      }
    ) });
  }
}
const ax = "h-textarea--textarea__inputWrapper", lx = "h-textarea--textarea__input", Zo = {
  inputWrapper: ax,
  input: lx
}, cx = "textarea", ni = $(function(e, t) {
  const n = q(null), {
    className: o,
    disabled: r,
    readOnly: a,
    name: l,
    prefix: c,
    suffix: d,
    icon: h,
    status: u,
    height: p = 0,
    style: m,
    autoGrow: g,
    ...b
  } = e, [x, C] = V(p), _ = {
    ...m,
    height: x ? `${x}px` : void 0
  }, S = P(() => {
    if (!n.current)
      return;
    const v = n.current.clientHeight, y = window.getComputedStyle(n.current), w = parseInt(y.lineHeight || "16");
    n.current.style.height = "auto";
    const I = n.current.scrollHeight + w, T = Math.max(
      p,
      Math.min(v, I)
    ), F = I > T ? I : T;
    n.current.style.height = `${F}px`, C(F);
  }, [p]);
  return Z(() => {
    if (g)
      return S(), window.addEventListener("resize", S), () => {
        window.removeEventListener("resize", S);
      };
  }, [g, S]), /* @__PURE__ */ s.jsx(
    Ae,
    {
      className: Zo.inputWrapper,
      status: u,
      disabled: r,
      prefix: c,
      suffix: d,
      icon: h,
      children: /* @__PURE__ */ s.jsx(
        "textarea",
        {
          "data-testid": cx,
          className: Zo.input,
          dir: "auto",
          id: l,
          ...b,
          onChange: (v) => {
            b?.onChange?.(v), g && S();
          },
          ref: n,
          style: _,
          name: l,
          disabled: r,
          readOnly: a
        }
      )
    }
  );
}), dx = "h-fieldRichText--fieldRichText__editorContainer", hx = "h-fieldRichText--fieldRichText__fallbackTextArea", Jo = {
  editorContainer: dx,
  fallbackTextArea: hx
};
class oT extends D {
  static defaultProps = {
    allowFormatting: !0
  };
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        helpIcon: l,
        disabled: a,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Rt,
          {
            fallback: /* @__PURE__ */ s.jsx(
              ni,
              {
                ...t,
                className: Jo.fallbackTextArea,
                disabled: a,
                value: t.value,
                onChange: (p) => t.onChange(p.target.value)
              }
            ),
            children: /* @__PURE__ */ s.jsx("div", { className: Jo.editorContainer, children: /* @__PURE__ */ s.jsx(
              lo,
              {
                disabled: a,
                status: z.getStatus(o),
                ...t,
                ...u,
                hideSendOnEnterToggle: !0,
                onTriggerSend: L
              }
            ) })
          }
        )
      }
    );
  }
}
class rT extends D {
  constructor(e) {
    super(e), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
  }
  getSelectedItems() {
    const {
      input: { value: e },
      items: t
    } = this.props;
    return typeof e == "string" && t?.some((n) => n.id === e) ? [e] : Array.isArray(e) && e.length && t?.some((n) => e.some((o) => o === n.id)) ? e : [];
  }
  handleSelect(e) {
    const {
      input: { onChange: t }
    } = this.props;
    typeof t == "function" && t(e === null ? "" : e.id.toString());
  }
  handleClear() {
    const {
      input: { value: e },
      onClear: t
    } = this.props;
    typeof e == "string" && this.handleSelect(null), typeof t == "function" && t();
  }
  render() {
    const {
      className: e,
      input: t,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      description: l,
      helpIcon: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: o,
        labelFor: t.name,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: c,
        description: l,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Nt,
          {
            ...u,
            id: t.name,
            disabled: a,
            selectedItems: this.getSelectedItems(),
            onSelect: this.handleSelect,
            onClear: this.handleClear,
            status: z.getStatus(n)
          }
        )
      }
    );
  }
}
function mn(i, e) {
  const t = Ks(), n = q(e);
  n.current = e, Z(() => {
    function o(r) {
      n.current?.(r);
    }
    return t.addEventListener(i, o), () => t.removeEventListener(i, o);
  }, [t, i]);
}
function si(i, e = "") {
  return Le.toArray(i).reduce((t, n) => Te(n) ? n.type === Ze ? [
    ...t,
    ...si(n.props.children, n.key)
  ] : [...t, { ...n, key: `${e}${n.key}` }] : t, []);
}
const ns = (i) => G(() => si(i), [i]), ux = "h-selectionList--selectionList__root", px = "h-selectionList--selectionList__disabled", er = {
  root: ux,
  disabled: px
}, At = Wi(
  () => ve({
    list: {
      isMultiple: !1,
      isActive: !1,
      isFocused: !1,
      isDisabled: !1
    },
    item: {
      isActive: !1,
      setActive: L,
      register: L,
      isSelected: () => !1,
      onSelect: L,
      isOnlyVisibleItem: !1
    }
  })
), co = ({ defaultActiveItemIndex: i = 0 } = {
  defaultActiveItemIndex: 0
}) => {
  const [e, t] = V(!1), [n, o] = V(-1), [r, a] = V([]), [l, c] = V({}), d = P(
    ({
      isActivatable: g,
      isLastChild: b,
      isOnlyVisibleItem: x,
      keysTakenOverHandlingFromParent: C
    }, _) => {
      g !== void 0 && a((S) => {
        const v = g ? [...S, _].sort((y, w) => y - w) : S.filter((y) => y !== _);
        return b && o((y) => (v.includes(_) && !S.includes(_) || _ !== y) && v.includes(y) && _ !== v[i] ? y : v[i] ?? v[0] ?? y), v;
      }), x !== void 0 && t(x), C !== void 0 && c((S) => ({
        ...S,
        [_]: C
      }));
    },
    [i]
  ), h = P(
    (g) => "index" in g ? g.index : g.step === "first" ? r[0] : g.step === "last" ? r[r.length - 1] : r[(r.findIndex(
      (b) => b === n
    ) + g.step + r.length) % r.length],
    [r, n]
  ), u = P(
    (g) => {
      o(h(g));
    },
    [h]
  );
  Z(() => {
    (n < 0 || n === void 0) && o(r[i]);
  }, [n, r, i]);
  const p = G(
    () => l[n] ?? [],
    [n, l]
  );
  return G(
    () => ({
      activeItemIndex: n,
      getActiveItemIndex: h,
      activatableItemIndices: r,
      setActiveItem: u,
      handleItemRegister: d,
      isOnlyActiveItemVisible: e,
      keysDelegatedHandlingToItem: p
    }),
    [
      r,
      n,
      h,
      d,
      e,
      p,
      u
    ]
  );
}, tr = ({
  className: i,
  selectedValues: e = [],
  isActive: t,
  isDisabled: n,
  isMultiple: o = !1,
  onChange: r = L,
  equalityFn: a = Object.is,
  tabIndex: l = 0,
  defaultActiveItemIndex: c,
  children: d,
  ...h
}, u) => {
  const [p, m] = V(!1), [g, b] = V({ isActive: !!t, source: "parent" }), x = At(), {
    activeItemIndex: C,
    setActiveItem: _,
    handleItemRegister: S,
    isOnlyActiveItemVisible: v,
    keysDelegatedHandlingToItem: y
  } = co({ defaultActiveItemIndex: c }), w = ns(d), I = P(
    (k) => k !== void 0 && (e || []).some(
      (R) => a(R, k)
    ),
    [a, e]
  ), T = P(
    ({ value: k, meta: R }, O) => {
      _({ index: O }), k !== void 0 && r(o ? {
        selectedValues: I(k) ? e.filter(
          (U) => !a(U, k)
        ) : [...e, k],
        selectedItem: {
          isNode: R?.isNode,
          isSelected: !I(k),
          value: k
        },
        event: R?.event
      } : {
        selectedValues: [k],
        selectedItem: {
          isNode: R?.isNode,
          isSelected: !0,
          value: k
        },
        event: R?.event
      });
    },
    [
      a,
      I,
      o,
      r,
      e,
      _
    ]
  ), F = G(
    () => !n && (g.isActive || p),
    [n, g.isActive, p]
  ), H = (k) => {
    !F || y.includes(k.key) || (k.key === "Enter" ? k.preventDefault() : k.key === "Home" ? (_({ step: "first" }), k.preventDefault()) : k.key === "End" ? (_({ step: "last" }), k.preventDefault()) : k.key === "ArrowDown" ? (_({ step: 1 }), k.preventDefault()) : k.key === "ArrowUp" && (_({ step: -1 }), k.preventDefault()));
  };
  return Z(() => {
    b({ isActive: !!t, source: "parent" });
  }, [t]), mn("keydown", H), /* @__PURE__ */ s.jsx(
    "ul",
    {
      ref: u,
      role: "listbox",
      tabIndex: n || t ? -1 : l,
      ...h,
      className: f(i, er.root, {
        [er.disabled]: n
      }),
      onFocus: () => m(!0),
      onBlur: () => m(!1),
      onMouseLeave: () => {
        g.source === "child" && b({ isActive: !1, source: "self" });
      },
      children: w.map(
        (k, R) => Te(k) && (!v || R === C) && /* @__PURE__ */ s.jsx(
          x.Provider,
          {
            value: {
              list: {
                isFocused: p,
                isMultiple: o,
                isActive: g.isActive,
                isDisabled: n
              },
              item: {
                isActive: F && R === C,
                setActive: () => {
                  b({ isActive: !0, source: "child" }), _({ index: R });
                },
                register: (O) => S(O, R),
                isSelected: I,
                onSelect: (O) => T(O, R),
                isOnlyVisibleItem: v,
                isLastChild: R === w.length - 1
              }
            },
            children: k
          },
          R
        )
      )
    }
  );
}, nr = ({ className: i, label: e, ...t }, n) => {
  const {
    item: { register: o, isLastChild: r }
  } = He(At());
  return Pt(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), Je(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), /* @__PURE__ */ s.jsx(
    Qn,
    {
      ref: n,
      as: "li",
      color: "tertiary",
      padding: "200 250",
      ...t,
      children: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "4", color: "secondary", children: e })
    }
  );
}, oi = Object.assign($(nr), {
  name: nr.name
}), mx = "h-selectionList-subComponents-item--selectionListItem__root", gx = "h-selectionList-subComponents-item--selectionListItem__rootDisabled", fx = "h-selectionList-subComponents-item--selectionListItem__rootActive", bx = "h-selectionList-subComponents-item--selectionListItem__selectionState", xx = "h-selectionList-subComponents-item--selectionListItem__fixedSize", yx = "h-selectionList-subComponents-item--selectionListItem__content", _x = "h-selectionList-subComponents-item--selectionListItem__contentDisabled", it = {
  root: mx,
  rootDisabled: gx,
  rootActive: fx,
  selectionState: bx,
  fixedSize: xx,
  content: yx,
  contentDisabled: _x
}, sr = ({
  value: i,
  isDisabled: e = !1,
  isIndeterminate: t = !1,
  className: n,
  contentClassName: o,
  noFixedSelectionStateSpace: r,
  onActiveStateChange: a,
  onSelectedStateChange: l,
  onSelect: c,
  children: d,
  ...h
}, u) => {
  const {
    list: {
      isMultiple: p,
      isDisabled: m,
      isActive: g,
      isFocused: b
    },
    item: {
      register: x,
      isSelected: C,
      onSelect: _,
      isActive: S,
      isNode: v = !1,
      isLastChild: y = !1,
      setActive: w
    }
  } = He(At()), I = C(i), T = G(
    () => !m && (g || b),
    [g, m, b]
  ), F = G(
    () => !e && S && T,
    [S, e, T]
  ), H = q(null);
  Ft(
    u,
    () => H.current
  );
  const k = P(
    (E) => {
      !e && !m && (c?.({ value: i, meta: { target: E?.target } }), _({
        value: i,
        meta: {
          target: E?.target,
          event: E || void 0
        }
      }));
    },
    [e, m, c, _, i]
  ), R = P(
    (E) => {
      F && E.key === "Enter" && !e && !m && (c?.({
        value: i,
        meta: { target: E.target ?? void 0 }
      }), _({
        value: i,
        meta: { target: E.target ?? void 0, event: E }
      }));
    },
    [F, e, m, c, _, i]
  );
  Z(() => {
    S && T && H.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [S]);
  const O = P(
    () => ({
      isActive: S,
      isSelected: I,
      isLastChild: y,
      isNode: v,
      value: i
    }),
    [S, y, v, I, i]
  ), U = on(S), oe = on(I);
  Xe(() => {
    S !== U && a?.(O()), I !== oe && l?.(O());
  }, [
    O,
    S,
    I,
    a,
    l,
    U,
    oe
  ]), mn("keydown", R), Z(() => (x({ isActivatable: !e, isLastChild: y }), () => x({ isActivatable: !1, isLastChild: y })), [e]);
  const ne = !p && I || p && i !== void 0 || !r;
  return /* @__PURE__ */ s.jsxs(
    "li",
    {
      ref: H,
      role: "option",
      "aria-selected": I,
      "aria-disabled": e,
      onClick: k,
      onMouseMove: w,
      className: f(it.root, n, {
        [it.rootActive]: F,
        [it.rootDisabled]: e
      }),
      ...h,
      children: [
        ne && /* @__PURE__ */ s.jsxs(
          W,
          {
            className: f(it.selectionState, {
              [it.fixedSize]: !r
            }),
            children: [
              !p && I && /* @__PURE__ */ s.jsx(N, { name: "done" }),
              p && i !== void 0 && /* @__PURE__ */ s.jsx(
                hn,
                {
                  checked: I,
                  indeterminate: !I && t,
                  disabled: e,
                  onChange: L,
                  tabIndex: -1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          ie,
          {
            className: f(it.content, o, {
              [it.contentDisabled]: e
            }),
            children: d
          }
        ),
        v && /* @__PURE__ */ s.jsx(N, { name: "angle-right" })
      ]
    }
  );
}, Cx = Object.assign($(sr), {
  name: sr.name
}), vx = "h-selectionList-subComponents-list-backItem--selectionListBackItem__root", wx = "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive", or = {
  root: vx,
  rootActive: wx
}, rr = ({
  className: i,
  content: e,
  onActiveStateChange: t,
  onSelected: n,
  ...o
}, r) => {
  const {
    list: {
      isDisabled: a,
      isActive: l,
      isFocused: c
    },
    item: { register: d, isActive: h, onSelect: u, setActive: p }
  } = He(At()), m = G(
    () => !a && (l || c),
    [l, a, c]
  ), g = G(
    () => h && m,
    [h, m]
  ), b = q(null);
  Ft(
    r,
    () => b.current
  );
  const x = P(() => {
    u({}), n?.();
  }, [u, n]), C = P(
    (S) => {
      !g || a || S.key === "Enter" && x();
    },
    [x, g, a]
  );
  Z(() => {
    h && m && b.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [h]);
  const _ = on(h);
  return Xe(() => {
    h !== _ && t?.({ isActive: h });
  }, [h, t, _]), mn("keydown", C), Pt(() => {
    d({ isActivatable: !0 });
  }), Je(() => {
    d({ isActivatable: !1 });
  }), /* @__PURE__ */ s.jsx(
    "li",
    {
      ref: b,
      role: "navigation",
      className: f(or.root, i, {
        [or.rootActive]: g
      }),
      onClick: x,
      onMouseMove: p,
      ...o,
      children: e || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(N, { name: "angle-left" }),
        /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", children: "Back" })
      ] })
    }
  );
}, ri = Object.assign(
  $(rr),
  {
    name: rr.name
  }
), Sx = "h-selectionList-subComponents-list--selectionListList__list", Ix = {
  list: Sx
}, ir = ({
  parentItem: i,
  children: e,
  backItemProps: t = {},
  listProps: { className: n, ...o } = {},
  onActiveStateChange: r,
  ...a
}, l) => {
  const c = At(), d = He(c), {
    list: {
      isFocused: h,
      isActive: u,
      isDisabled: p
    },
    item: {
      isActive: m,
      onSelect: g,
      isOnlyVisibleItem: b,
      register: x,
      setActive: C,
      isLastChild: _ = !1
    }
  } = d, S = G(
    () => !p && (u || h),
    [u, p, h]
  ), v = ns(e), {
    activeItemIndex: y,
    setActiveItem: w,
    handleItemRegister: I,
    isOnlyActiveItemVisible: T,
    keysDelegatedHandlingToItem: F
  } = co({ defaultActiveItemIndex: 1 }), H = P(
    (E, ye) => {
      w({ index: ye }), g(E);
    },
    [g, w]
  ), k = (E) => {
    !S || !b || F.includes(E.key) || (E.key === "Home" ? (w({ step: "first" }), E.preventDefault()) : E.key === "End" ? (w({ step: "last" }), E.preventDefault()) : E.key === "ArrowDown" ? (w({ step: 1 }), E.preventDefault()) : E.key === "ArrowUp" && (w({ step: -1 }), E.preventDefault()));
  }, R = on(
    b
  );
  Xe(() => {
    b !== R && r?.({
      isActive: b,
      isLastChild: _
    });
  }, [
    b,
    r,
    R
  ]), Z(() => {
    x(b ? {
      keysTakenOverHandlingFromParent: [
        "Home",
        "End",
        "ArrowDown",
        "ArrowUp"
      ]
    } : { keysTakenOverHandlingFromParent: [] });
  }, [b]), mn("keydown", k);
  const O = P(
    ({ value: E, meta: ye }) => {
      ye?.target instanceof HTMLInputElement && ye.target.type === "checkbox" ? g({ value: E, meta: { isNode: !0 } }) : x({ isOnlyVisibleItem: !0 });
    },
    // excluding `register` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), U = P(() => {
    x({ isOnlyVisibleItem: !1 });
  }, []);
  Z(() => {
    b || w({ index: -1 });
  }, [b, w]);
  const oe = G(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: O,
        isNode: !0
      }
    }),
    [O, d]
  ), ne = G(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: U,
        isActive: y === 0,
        setActive: () => {
          C(), w({ index: 0 });
        },
        register: (E) => I(E, 0)
      }
    }),
    [
      y,
      U,
      I,
      d,
      C,
      w
    ]
  );
  return b ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !T && /* @__PURE__ */ s.jsx(c.Provider, { value: ne, children: /* @__PURE__ */ s.jsx(ri, { ...t }) }),
    /* @__PURE__ */ s.jsx("li", { ref: l, ...a, children: /* @__PURE__ */ s.jsx(
      "ul",
      {
        role: "listbox",
        className: f(Ix.list, n),
        ...o,
        children: v.map((E, ye) => {
          const de = ye + 1;
          return Te(E) && (!T || de === y) && /* @__PURE__ */ s.jsx(
            c.Provider,
            {
              value: {
                ...d,
                item: {
                  ...d.item,
                  isActive: m && de === y,
                  setActive: () => {
                    C(), w({ index: de });
                  },
                  register: (tt) => I(tt, de),
                  onSelect: (tt) => H(tt, de),
                  isOnlyVisibleItem: T,
                  isLastChild: ye === v.length - 1
                }
              },
              children: E
            },
            ye
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ s.jsx(c.Provider, { value: oe, children: i });
}, Dx = Object.assign($(ir), {
  name: ir.name
}), kx = "h-selectionList-subComponents-section--selectionListSection__section", Tx = {
  section: kx
}, ar = ({
  title: i,
  children: e,
  listProps: { className: t, ...n } = {},
  onActiveStateChange: o,
  ...r
}, a) => {
  const l = At(), c = He(l), {
    list: {
      isFocused: d,
      isActive: h,
      isDisabled: u
    },
    item: {
      isActive: p,
      setActive: m,
      onSelect: g,
      register: b,
      isLastChild: x = !1
    }
  } = c, C = G(
    () => !u && (h || d),
    [h, u, d]
  ), _ = ns(e), {
    activatableItemIndices: S,
    activeItemIndex: v,
    setActiveItem: y,
    handleItemRegister: w,
    keysDelegatedHandlingToItem: I
  } = co(), T = P(
    (k, R) => {
      y({ index: R }), g(k);
    },
    [g, y]
  ), F = (k) => {
    !C || I.includes(k.key) || (k.key === "Home" ? y({ step: "first" }) : k.key === "End" && y({ step: "last" }), p ? k.key === "ArrowDown" && v !== S[S.length - 1] ? (y({ step: 1 }), k.preventDefault()) : k.key === "ArrowUp" && v !== S[0] && (y({ step: -1 }), k.preventDefault()) : k.key === "ArrowDown" ? y({ step: "first" }) : k.key === "ArrowUp" && y({ step: "last" }));
  }, H = on(p);
  return Xe(() => {
    p !== H && o?.({
      isActive: p,
      isLastChild: x
    });
  }, [p, o, H]), Z(() => {
    const k = [];
    p && (v !== S[S.length - 1] && k.push("ArrowDown"), v !== S[0] && k.push("ArrowUp")), b({ keysTakenOverHandlingFromParent: k });
  }, [S, v, p]), Pt(() => b({ isActivatable: !0 })), Je(() => b({ isActivatable: !1 })), mn("keydown", F), /* @__PURE__ */ s.jsx("li", { ref: a, ...r, children: /* @__PURE__ */ s.jsxs(
    "ul",
    {
      role: "group",
      className: f(Tx.section, t),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(oi, { label: i }),
        _.map(
          (k, R) => Te(k) && /* @__PURE__ */ s.jsx(
            l.Provider,
            {
              value: {
                ...c,
                item: {
                  ...c.item,
                  isActive: p && R === v,
                  setActive: () => {
                    m(), y({ index: R });
                  },
                  register: (O) => w(O, R),
                  onSelect: (O) => T(O, R),
                  isLastChild: x && R === _.length - 1
                }
              },
              children: k
            },
            R
          )
        )
      ]
    }
  ) });
}, jx = Object.assign($(ar), {
  name: ar.name
}), Nx = Object.assign($(tr), {
  name: tr.name,
  Item: Cx,
  BackItem: ri,
  Divider: oi,
  Section: jx,
  List: Dx
}), Fx = "h-inputSelectionList-chip--inputSelectionListChip__root", Px = "h-inputSelectionList-chip--inputSelectionListChip__name", lr = {
  root: Fx,
  name: Px
}, Ss = ({
  onDelete: i,
  className: e,
  disabled: t,
  readOnly: n,
  ...o
}) => {
  const r = G(() => {
    if (!(!i || t || n))
      return (a) => {
        a.stopPropagation(), i();
      };
  }, [t, i, n]);
  return /* @__PURE__ */ s.jsx(
    jt,
    {
      ...o,
      onDelete: r,
      className: f(lr.root, e),
      tagNameClassName: lr.name
    }
  );
}, Rx = "h-inputSelectionList--inputSelectionList__root", Ex = "h-inputSelectionList--inputSelectionList__inputWrapper", Lx = "h-inputSelectionList--inputSelectionList__inputWrapperChild", Ax = "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon", $x = "h-inputSelectionList--inputSelectionList__rootReadOnly", Ox = "h-inputSelectionList--inputSelectionList__titleContainer", Bx = "h-inputSelectionList--inputSelectionList__filterInput", Wx = "h-inputSelectionList--inputSelectionList__placeholder", Hx = "h-inputSelectionList--inputSelectionList__titleBox", Mx = "h-inputSelectionList--inputSelectionList__iconContainer", zx = "h-inputSelectionList--inputSelectionList__iconButton", Vx = "h-inputSelectionList--inputSelectionList__dropdown", Kx = "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip", Ux = "h-inputSelectionList--inputSelectionList__hiddenItemsChip", le = {
  root: Rx,
  inputWrapper: Ex,
  inputWrapperChild: Lx,
  rootHasWrapperIcon: Ax,
  rootReadOnly: $x,
  titleContainer: Ox,
  filterInput: Bx,
  placeholder: Wx,
  titleBox: Hx,
  iconContainer: Mx,
  iconButton: zx,
  dropdown: Vx,
  hiddenItemsTooltip: Kx,
  hiddenItemsChip: Ux
}, qx = "inputSelectionListTestId", cr = ({
  className: i,
  name: e,
  value: t,
  onChange: n,
  prefix: o,
  suffix: r,
  icon: a,
  status: l,
  placeholder: c,
  disabled: d,
  readOnly: h,
  children: u,
  filter: p,
  multiple: m,
  getItemTitleByValue: g,
  tabIndex: b,
  keepOpen: x,
  onToggleDropdown: C,
  onClick: _,
  onBlur: S,
  onKeyDown: v,
  limit: y = Number.POSITIVE_INFINITY,
  clearable: w = !1,
  equalityFn: I = Object.is,
  defaultActiveItemIndex: T,
  valueArrayToStringFn: F = JSON.stringify,
  rootClassName: H,
  dropdownProps: k,
  selectionListProps: R,
  slotBeforeList: O,
  slotAfterList: U,
  ...oe
}, ne) => {
  const E = Ks(), ye = q(null), de = q(null), tt = q(null), ho = q(null), [J, ai] = V(!1);
  Ft(
    ne,
    () => de.current
  );
  const os = G(
    () => p?.value !== void 0 && p.onChange !== void 0 && J,
    [p, J]
  ), li = G(() => {
    if (!t?.length)
      return c;
    if (!m) {
      const M = g(t[0]);
      return typeof M == "object" ? "" : M?.toString();
    }
    return "";
  }, [m, c, g, t]), ci = G(() => os ? m && !!t?.length : !0, [m, os, t?.length]), rs = P(
    (M) => {
      !h && !d && n?.({
        selectedItem: {
          isSelected: !1,
          value: M
        },
        selectedValues: t?.filter((Bt) => !I(Bt, M)) ?? []
      });
    },
    [d, I, n, h, t]
  ), di = G(() => {
    if (!t?.length)
      return /* @__PURE__ */ s.jsx(W, { alignItems: "center", className: le.placeholder, children: c });
    if (m) {
      const M = y < t.length ? t.slice(0, y) : t, Bt = y < t.length ? t.slice(y) : [];
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        M?.map((Wt, is) => /* @__PURE__ */ s.jsx(
          Ss,
          {
            onDelete: () => {
              rs(Wt);
            },
            disabled: d,
            readOnly: h,
            children: g(Wt)
          },
          is
        )),
        !!Bt.length && /* @__PURE__ */ s.jsx(
          se,
          {
            disabled: d,
            requireClick: !0,
            content: /* @__PURE__ */ s.jsx(
              W,
              {
                className: le.hiddenItemsTooltip,
                gap: "100",
                flexWrap: "wrap",
                children: Bt?.map((Wt, is) => /* @__PURE__ */ s.jsx(
                  Ss,
                  {
                    onDelete: () => {
                      rs(Wt);
                    },
                    disabled: d,
                    readOnly: h,
                    children: g(Wt)
                  },
                  is
                ))
              }
            ),
            light: !0,
            children: /* @__PURE__ */ s.jsxs(
              Ss,
              {
                className: le.hiddenItemsChip,
                disabled: d,
                children: [
                  "+ ",
                  Bt.length
                ]
              }
            )
          }
        )
      ] });
    }
    return /* @__PURE__ */ s.jsx(ie, { className: le.titleBox, children: g(t[0]) });
  }, [
    t,
    m,
    g,
    c,
    y,
    d,
    h,
    rs
  ]), he = P(
    (M) => {
      (h || d) && M || (M !== J && C?.(M), ai(M));
    },
    [d, J, C, h]
  ), $t = P(
    ({ target: M }) => {
      ho.current?.contains(M) || (ye.current?.contains(M) && de.current?.focus(), he(!1));
    },
    [he]
  ), Ot = P(
    (M) => {
      Et(M.key) && J && (he(!1), de.current?.focus());
    },
    [J, he]
  ), hi = P(
    (M) => {
      M.relatedTarget && ye.current?.contains(M.relatedTarget) || (he(!1), S?.(M));
    },
    [S, he]
  ), ui = P(
    (M) => {
      J || M.stopPropagation(), he(!0), _?.(M);
    },
    [J, _, he]
  ), pi = P(
    (M) => {
      Zn(M.key) && he(!0), v?.(M);
    },
    [v, he]
  ), mi = P(
    (M) => {
      M.stopPropagation(), he(!J), de.current?.focus();
    },
    [J, he]
  ), gi = P(
    (M) => {
      M.stopPropagation(), de.current?.focus(), !d && !h && n?.({ selectedValues: [] });
    },
    [d, n, h]
  ), fi = P(
    (M) => {
      n?.(M), de.current?.focus(), !x && !m ? he(!1) : tt.current?.focus();
    },
    [m, x, n, he]
  );
  return Z(() => (J ? (E.addEventListener("click", $t), E.addEventListener("keydown", Ot)) : (E.removeEventListener("click", $t), E.removeEventListener("keydown", Ot)), () => {
    E.removeEventListener("click", $t), E.removeEventListener("keydown", Ot);
  }), [$t, Ot, J, E]), Z(() => {
    J && tt.current?.focus();
  }, [J]), Je(() => {
    E.removeEventListener("click", $t), E.removeEventListener("keydown", Ot);
  }), /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": qx,
      ref: ye,
      className: f(le.root, H, {
        [le.rootHasWrapperIcon]: !!a,
        [le.rootReadOnly]: h
      }),
      "aria-expanded": J,
      "aria-haspopup": "listbox",
      role: "combobox",
      children: [
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            ...oe,
            ref: de,
            className: f(i, le.inputWrapper),
            prefix: o,
            suffix: r,
            disabled: d,
            icon: a,
            active: J,
            status: l,
            onClick: ui,
            onBlur: hi,
            onKeyDown: pi,
            tabIndex: d ? -1 : b ?? 0,
            children: /* @__PURE__ */ s.jsxs(W, { className: le.inputWrapperChild, children: [
              /* @__PURE__ */ s.jsxs(W, { gap: "100", flexWrap: "wrap", className: le.titleContainer, children: [
                ci && di,
                os && /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    ...p,
                    ref: tt,
                    className: f(le.filterInput, p?.className),
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    placeholder: li,
                    disabled: d || p?.disabled
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsxs(W, { alignItems: "center", className: le.iconContainer, children: [
                w && !d && !h && !!t?.length && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: le.iconButton,
                    variant: "tertiary",
                    icon: "close",
                    disabled: d,
                    onClick: gi,
                    "aria-label": "Clear"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: le.iconButton,
                    variant: "tertiary",
                    icon: J ? "angle-up" : "angle-down",
                    disabled: d,
                    onClick: mi,
                    "aria-label": J ? "Close" : "Open"
                  }
                )
              ] })
            ] })
          }
        ),
        e && /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "hidden",
            disabled: d,
            name: e,
            value: F(t)
          }
        ),
        /* @__PURE__ */ s.jsx(
          et,
          {
            isOpen: J,
            ...k,
            className: f(k?.className, le.dropdown),
            children: /* @__PURE__ */ s.jsx("div", { ref: ho, style: { width: "100%" }, children: J && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              O,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              /* @__PURE__ */ s.jsx(
                Nx,
                {
                  ...R,
                  equalityFn: I,
                  defaultActiveItemIndex: T,
                  isActive: J,
                  isMultiple: m,
                  selectedValues: t,
                  onChange: fi,
                  children: u
                }
              ),
              U
            ] }) })
          }
        )
      ]
    }
  );
}, Gx = Object.assign($(cr), {
  name: cr.name
}), iT = ({
  className: i,
  input: { value: e, name: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: t,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Gx,
      {
        name: t,
        value: e || [],
        onChange: (g) => {
          n(g.selectedValues);
        },
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Yx = "h-slider--slider__rootWrapper", Qx = "h-slider--slider__rootWrapperNoAnnotations", Xx = "h-slider--slider__root", Zx = "h-slider--slider__rootDark", Jx = "h-slider--slider__rootDisabled", ey = "h-slider--slider__handle", ty = "h-slider--slider__trackWrapper", ny = "h-slider--slider__track", sy = "h-slider--slider__highlight", oy = "h-slider--slider__minValueIndicator", ry = "h-slider--slider__maxValueIndicator", be = {
  rootWrapper: Yx,
  rootWrapperNoAnnotations: Qx,
  root: Xx,
  rootDark: Zx,
  rootDisabled: Jx,
  handle: ey,
  trackWrapper: ty,
  track: ny,
  highlight: sy,
  minValueIndicator: oy,
  maxValueIndicator: ry
};
var Pe = /* @__PURE__ */ ((i) => (i.LowBoundIndicator = "input-slider-low-indicator", i.HighBoundIndicator = "input-slider-high-indicator", i.Handle = "input-slider-handle", i.Value = "input-slider-value", i.TrackBackground = "input-slider-tack-background", i.Track = "input-slider-track", i.Highlight = "input-slider-highlight", i))(Pe || {});
const iy = (i) => {
  i.preventDefault();
}, ay = (i, e, t) => typeof i != "number" && !Array.isArray(i) ? "" : typeof i == "number" ? /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "3", children: [
  e,
  i,
  t
] }) : /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "3", children: [
  e,
  i[0],
  t,
  " - ",
  e,
  i[1],
  t
] });
class ly extends D {
  static defaultProps = {
    min: 0,
    max: 100,
    dark: !1,
    highlightRange: null,
    formatValue: ay,
    hideAnnotations: !1
  };
  constructor(e) {
    super(e), this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    }, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
  }
  sliderRef = B();
  isInterval(e) {
    return Array.isArray(e);
  }
  handleChange(e) {
    typeof e == "number" ? this.props.onChange?.(Math.round(e)) : this.props.onChange?.(
      e.map((t) => Math.round(t))
    );
  }
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */
  handleHandleGrab(e) {
    e.target instanceof Element && this.setState({
      currentIndex: parseInt(
        e.target.getAttribute("data-index") || "",
        10
      )
    });
  }
  handleHandleMove(e) {
    e.preventDefault();
    const { startVal: t, startX: n, sliderWidth: o, currentIndex: r } = this.state, a = t + (e.clientX - n) / o, l = this.getAbsoluteValue(a, r);
    this.handleChange(l);
  }
  handleHandleDrop() {
    window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
  }
  handleKeyDown(e) {
    const { step: t = 1, value: n } = this.props;
    e.preventDefault();
    const o = this.isInterval(n) && e.target instanceof Element ? parseInt(e.target.getAttribute("data-index") || "", 10) : null;
    switch (e.key) {
      case "ArrowRight":
      case "ArrowUp":
        this.increment(t, o);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        this.increment(-t, o);
        break;
    }
  }
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */
  handleSliderMouseDown(e) {
    if (!this.sliderRef.current) return;
    const { value: t } = this.props, { currentIndex: n } = this.state, o = this.sliderRef.current.getBoundingClientRect(), r = (e.clientX - o.left) / o.width;
    this.setState({
      startX: e.clientX,
      // save the current mouse x
      startVal: r,
      // save the current percentage
      sliderWidth: o.width
      // save the slider width
    });
    let a;
    if (this.isInterval(t)) {
      const l = n ?? this.findTheNearestHandle(r, t);
      this.setState({
        currentIndex: l
      }), a = this.getAbsoluteValue(r, l);
    } else
      a = this.getAbsoluteValue(r);
    this.handleChange(a), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
  }
  findTheNearestHandle(e, t) {
    const [n, o] = t.map(
      this.absoluteValueToRelativeValue
    );
    return e > o && e > n ? 1 : e < o && e < n ? 0 : Math.abs(n - e) > Math.abs(o - e) ? 1 : 0;
  }
  getAdjustedStep(e) {
    const { min: t, max: n } = this.props;
    return e / (n - t);
  }
  getAbsoluteValue(e, t) {
    const { value: n, step: o } = this.props;
    let r = An(e, 0, 1);
    if (o) {
      const h = this.getAdjustedStep(o);
      r = Math.round(r / h) * h;
    }
    if (!this.isInterval(n))
      return this.relativeValueToAbsoluteValue(r);
    const [a, l] = n;
    let c = this.relativeValueToAbsoluteValue(r);
    t === 0 && c > l ? c = l : t === 1 && c < a && (c = a);
    const d = [a, l];
    return typeof t == "number" && (d[t] = c), d;
  }
  /**
   * @param ratio Is a number between 0 and 1 and it represents the **relative**
   *   placement of the handle within the slider track.
   */
  relativeValueToAbsoluteValue(e) {
    const { min: t, max: n } = this.props, o = t + (n - t) * e;
    return An(o, t, n);
  }
  /**
   * @param value Is a number between 'min' and 'max' and it represents the
   *   **absolute** value that is derived from the relative placement of the
   *   handle.
   */
  absoluteValueToRelativeValue(e) {
    const { min: t, max: n } = this.props, o = (e - t) / (n - t);
    return An(o, 0, 1);
  }
  increment(e, t) {
    const { value: n } = this.props;
    let o;
    if (this.isInterval(n)) {
      const r = [...n];
      r[t ?? 0] = r[t ?? 0] + e, o = r;
    } else
      o = n + e;
    this.handleChange(o);
  }
  getTrackStyles() {
    const { value: e, min: t } = this.props, n = this.isInterval(e) ? this.absoluteValueToRelativeValue(e[1]) - this.absoluteValueToRelativeValue(e[0]) : this.absoluteValueToRelativeValue(e), o = this.isInterval(e) ? this.absoluteValueToRelativeValue(e[0]) : this.absoluteValueToRelativeValue(t);
    return {
      width: `${n * 100}%`,
      left: `${o * 100}%`
    };
  }
  getHandleStyles(e) {
    const { value: t } = this.props;
    return {
      left: `${(this.isInterval(t) ? this.absoluteValueToRelativeValue(t[e ?? 0]) : this.absoluteValueToRelativeValue(t)) * 100}%`
    };
  }
  getHighlightStyles() {
    const { highlightRange: e } = this.props;
    if (Ce(e)) return {};
    const [t, n] = e.map(this.absoluteValueToRelativeValue);
    return {
      left: `${t * 100}%`,
      width: `${(n - t) * 100}%`
    };
  }
  render() {
    const {
      className: e,
      value: t,
      step: n,
      highlightRange: o,
      min: r,
      max: a,
      dark: l,
      disabled: c,
      onChange: d,
      formatValue: h,
      hideAnnotations: u,
      valuePrefix: p,
      valueSuffix: m,
      onBlur: g,
      onFocus: b,
      children: x,
      ...C
    } = this.props, _ = f(
      be.root,
      { [be.rootDark]: l },
      { [be.rootDisabled]: c },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: f(be.rootWrapper, {
          [be.rootWrapperNoAnnotations]: u
        }),
        children: [
          /* @__PURE__ */ s.jsxs(
            "div",
            {
              ...C,
              className: _,
              ref: this.sliderRef,
              onMouseDown: this.handleSliderMouseDown,
              children: [
                /* @__PURE__ */ s.jsxs(
                  "div",
                  {
                    className: be.trackWrapper,
                    "data-testid": Pe.TrackBackground,
                    children: [
                      !Ce(o) && /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: be.highlight,
                          style: this.getHighlightStyles(),
                          "data-testid": Pe.Highlight
                        }
                      ),
                      /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: be.track,
                          style: this.getTrackStyles(),
                          "data-testid": Pe.Track
                        }
                      )
                    ]
                  }
                ),
                !this.isInterval(t) && /* @__PURE__ */ s.jsx(
                  "button",
                  {
                    tabIndex: 0,
                    role: "slider",
                    type: "button",
                    "aria-valuemin": r,
                    "aria-valuemax": a,
                    "aria-valuenow": t,
                    className: be.handle,
                    onClick: iy,
                    onKeyDown: this.handleKeyDown,
                    style: this.getHandleStyles(),
                    "data-testid": Pe.Handle
                  }
                ),
                this.isInterval(t) && /* @__PURE__ */ s.jsxs(Ze, { children: [
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "0",
                      className: be.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(0),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Pe.Handle
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "1",
                      className: be.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(1),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Pe.Handle
                    }
                  )
                ] }),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    "data-testid": Pe.LowBoundIndicator,
                    className: be.minValueIndicator,
                    children: /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      r,
                      m
                    ] })
                  }
                ),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    className: be.maxValueIndicator,
                    "data-testid": Pe.HighBoundIndicator,
                    children: /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      a,
                      m
                    ] })
                  }
                )
              ]
            }
          ),
          !u && /* @__PURE__ */ s.jsx("div", { "data-testid": Pe.Value, children: h(t, p, m) })
        ]
      }
    );
  }
}
const Bs = dn(ly, {
  fallback: null
}), cy = "h-fieldSlider--fieldSlider__root", dy = {
  root: cy
};
class aT extends D {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(e) {
    const t = new Event("change");
    Object.defineProperty(t, "target", {
      writable: !0,
      value: { value: e, name: this.props.input.name }
    }), this.props.input.onChange(t);
  }
  /**
   * Redux form performs a value check when `blur` happens, so we need to make
   * sure the value is attached to the blur event otherwise it will be set to
   * null
   *
   * @see https://github.com/redux-form/redux-form/issues/2768
   */
  handleBlur(e) {
    const { input: t } = this.props, n = new FocusEvent(
      "blur",
      e
    );
    Object.defineProperty(n, "target", {
      writable: !0,
      value: { value: t.value, name: t.name }
    }), t.onBlur?.(n);
  }
  render() {
    const {
      className: e,
      input: t,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props, p = f(dy.root, e);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: p,
        label: o,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Bs,
          {
            ...t,
            onChange: this.handleChange,
            disabled: a,
            ...u
          }
        )
      }
    );
  }
}
const hy = "h-switch--switch__root", uy = "h-switch--switch__input", py = "h-switch--switch__inner", my = "h-switch--switch__pending", gy = "h-switch--switch__active", Yt = {
  root: hy,
  input: uy,
  inner: py,
  pending: my,
  active: gy
}, dr = {
  input: "Switch-input",
  label: "Switch-label"
};
class fy extends D {
  render() {
    const { id: e, className: t, variant: n, ...o } = this.props, r = e || `switch_${Math.random()}`;
    return /* @__PURE__ */ s.jsxs("div", { className: f(t, Yt.root), "data-testid": e, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...o,
          id: r,
          type: "checkbox",
          className: Yt.input,
          "data-testid": dr.input
        }
      ),
      /* @__PURE__ */ s.jsx(
        "label",
        {
          htmlFor: r,
          className: f(Yt.inner, {
            [Yt.active]: n === "active",
            [Yt.pending]: n === "pending"
          }),
          "data-testid": dr.label
        }
      )
    ] });
  }
}
class lT extends D {
  render() {
    const { input: e, ...t } = this.props, { ref: n, ...o } = e;
    return /* @__PURE__ */ s.jsx(fy, { ...o, ...t });
  }
}
class cT extends D {
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          ni,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...t,
            ...u
          }
        )
      }
    );
  }
}
const dT = ({
  className: i,
  input: { name: e, value: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = P(
    (b) => {
      n(b ?? "");
    },
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: e,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        an,
        {
          selectedItems: t ? [t] : [],
          ...o,
          ...m,
          disabled: c,
          id: e,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, hT = ({
  className: i,
  input: { name: e, value: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = P(
    (b) => {
      n({
        startTime: b.startTime ?? "",
        endTime: b.endTime ?? ""
      });
    },
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: e,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        Lm,
        {
          endTime: t.endTime,
          startTime: t.startTime,
          ...o,
          ...m,
          disabled: c,
          id: e,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, by = "h-inputColorPicker-indicator--inputColorPickerIndicator__root", xy = "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha", yy = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator", _y = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor", jn = {
  root: by,
  rootAlpha: xy,
  indicator: yy,
  indicatorNoColor: _y
}, Cy = ({
  color: i,
  alpha: e,
  className: t,
  ...n
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ...n,
    className: f(jn.root, t, {
      [jn.rootAlpha]: e
    }),
    children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(jn.indicator, {
          [jn.indicatorNoColor]: !i
        }),
        style: { backgroundColor: i }
      }
    )
  }
), vy = "h-inputColorPicker--inputColorPicker__root", wy = "h-inputColorPicker--inputColorPicker__inputContainer", Sy = "h-inputColorPicker--inputColorPicker__input", Iy = "h-inputColorPicker--inputColorPicker__rootReadOnly", Dy = "h-inputColorPicker--inputColorPicker__iconContainer", ky = "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon", Ty = "h-inputColorPicker--inputColorPicker__clearIcon", jy = "h-inputColorPicker--inputColorPicker__colorIndicator", qe = {
  root: vy,
  inputContainer: wy,
  input: Sy,
  rootReadOnly: Iy,
  iconContainer: Dy,
  rootHasWrapperIcon: ky,
  clearIcon: Ty,
  colorIndicator: jy
}, Ny = "inputColorPickerTestId", Fy = $(function({
  className: e,
  name: t = Math.floor(Math.random() * 1e8).toString(),
  value: n,
  onChange: o,
  dropdownProps: r,
  prefix: a,
  suffix: l,
  icon: c,
  status: d,
  placeholder: h,
  disabled: u,
  colorPickerProps: p,
  clearable: m,
  readOnly: g,
  children: b,
  ...x
}, C) {
  const _ = q(null), S = q(null), v = q(null), [y, w] = V(!1);
  Z(() => {
    y ? (window.addEventListener("click", T), window.addEventListener("keydown", F)) : (window.removeEventListener("click", T), window.removeEventListener("keydown", F)), y && I();
  }, [y]), Je(() => {
    window.removeEventListener("click", T), window.removeEventListener("keydown", F);
  });
  const I = () => {
    v.current?.querySelector("input")?.focus();
  }, T = ({ target: U }) => {
    S.current?.contains(U) || w(!1);
  }, F = (U) => {
    Et(U.key) && y && (U.stopPropagation(), w(!1));
  }, H = () => {
    g || w(!0);
  }, k = ({ target: U }) => {
    S.current?.contains(U) || w(!1);
  }, R = () => {
    g || w(!0);
  }, O = ({ key: U }) => {
    Zn(U) && w(!0);
  };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Ny,
      ref: S,
      className: f(qe.root, e, {
        [qe.rootHasWrapperIcon]: !!c,
        [qe.rootReadOnly]: g
      }),
      children: [
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            prefix: a,
            suffix: l,
            disabled: u,
            icon: c,
            active: y,
            status: d,
            children: /* @__PURE__ */ s.jsxs("div", { className: qe.inputContainer, children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  ...x,
                  id: t,
                  name: t,
                  className: qe.input,
                  ref: _,
                  onClick: R,
                  onFocus: H,
                  onBlur: k,
                  onKeyDown: O,
                  disabled: u,
                  placeholder: h,
                  autoComplete: "off",
                  value: n,
                  onChange: Hn(n) ? void 0 : L,
                  readOnly: !0
                }
              ),
              /* @__PURE__ */ s.jsx("div", { className: qe.iconContainer, children: m && n && /* @__PURE__ */ s.jsx(
                K,
                {
                  className: qe.clearIcon,
                  variant: "tertiary",
                  icon: "close",
                  disabled: u,
                  onClick: () => o?.("")
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                Cy,
                {
                  className: qe.colorIndicator,
                  onClick: R,
                  color: n,
                  alpha: p?.alpha
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s.jsx(et, { ...r, isOpen: y, children: /* @__PURE__ */ s.jsx("div", { ref: v, children: /* @__PURE__ */ s.jsx(
          Jn,
          {
            margin: "300",
            ...p,
            color: n,
            onChange: o ?? L,
            children: b
          }
        ) }) })
      ]
    }
  );
}), uT = ({
  className: i,
  input: { value: e, name: t, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: t,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Fy,
      {
        name: t,
        value: e,
        onChange: n,
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Py = "h-fieldAddonDropdown--fieldAddonDropdown__root", Ry = "h-fieldAddonDropdown--fieldAddonDropdown__prefix", Ey = "h-fieldAddonDropdown--fieldAddonDropdown__suffix", Ly = "h-fieldAddonDropdown--fieldAddonDropdown__angleDown", Nn = {
  root: Py,
  prefix: Ry,
  suffix: Ey,
  angleDown: Ly
}, pT = ({
  className: i,
  noArrow: e,
  ...t
}) => zs(t) ? null : /* @__PURE__ */ s.jsx(Ps.Consumer, { children: ({ position: n, disabled: o }) => /* @__PURE__ */ s.jsx(
  to,
  {
    ...Sr(t, "meta"),
    noStyle: !0,
    itemComponent: Mr,
    children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: f(
          Nn.root,
          {
            [Nn.prefix]: n === "prefix",
            [Nn.suffix]: n === "suffix"
          },
          i
        ),
        disabled: o || t.meta.disabled,
        type: "button",
        children: [
          /* @__PURE__ */ s.jsx("span", { children: t.meta.selectedValue }),
          !e && /* @__PURE__ */ s.jsx(
            N,
            {
              name: "angle-down",
              className: f("icon-vertical-fix", Nn.angleDown)
            }
          )
        ]
      }
    )
  }
) }), Ay = "h-countryFlag--countryFlag__flag", $y = "h-countryFlag--countryFlag__ad", Oy = "h-countryFlag--countryFlag__ae", By = "h-countryFlag--countryFlag__af", Wy = "h-countryFlag--countryFlag__ag", Hy = "h-countryFlag--countryFlag__ai", My = "h-countryFlag--countryFlag__al", zy = "h-countryFlag--countryFlag__am", Vy = "h-countryFlag--countryFlag__ao", Ky = "h-countryFlag--countryFlag__aq", Uy = "h-countryFlag--countryFlag__ar", qy = "h-countryFlag--countryFlag__as", Gy = "h-countryFlag--countryFlag__at", Yy = "h-countryFlag--countryFlag__au", Qy = "h-countryFlag--countryFlag__aw", Xy = "h-countryFlag--countryFlag__ax", Zy = "h-countryFlag--countryFlag__az", Jy = "h-countryFlag--countryFlag__ba", e_ = "h-countryFlag--countryFlag__bb", t_ = "h-countryFlag--countryFlag__bd", n_ = "h-countryFlag--countryFlag__be", s_ = "h-countryFlag--countryFlag__bf", o_ = "h-countryFlag--countryFlag__bg", r_ = "h-countryFlag--countryFlag__bh", i_ = "h-countryFlag--countryFlag__bi", a_ = "h-countryFlag--countryFlag__bj", l_ = "h-countryFlag--countryFlag__bl", c_ = "h-countryFlag--countryFlag__bm", d_ = "h-countryFlag--countryFlag__bn", h_ = "h-countryFlag--countryFlag__bo", u_ = "h-countryFlag--countryFlag__bq", p_ = "h-countryFlag--countryFlag__br", m_ = "h-countryFlag--countryFlag__bs", g_ = "h-countryFlag--countryFlag__bt", f_ = "h-countryFlag--countryFlag__bv", b_ = "h-countryFlag--countryFlag__bw", x_ = "h-countryFlag--countryFlag__by", y_ = "h-countryFlag--countryFlag__bz", __ = "h-countryFlag--countryFlag__ca", C_ = "h-countryFlag--countryFlag__cd", v_ = "h-countryFlag--countryFlag__cf", w_ = "h-countryFlag--countryFlag__cg", S_ = "h-countryFlag--countryFlag__ch", I_ = "h-countryFlag--countryFlag__ci", D_ = "h-countryFlag--countryFlag__ck", k_ = "h-countryFlag--countryFlag__cl", T_ = "h-countryFlag--countryFlag__cm", j_ = "h-countryFlag--countryFlag__cn", N_ = "h-countryFlag--countryFlag__co", F_ = "h-countryFlag--countryFlag__cp", P_ = "h-countryFlag--countryFlag__cr", R_ = "h-countryFlag--countryFlag__cu", E_ = "h-countryFlag--countryFlag__cv", L_ = "h-countryFlag--countryFlag__cw", A_ = "h-countryFlag--countryFlag__cy", $_ = "h-countryFlag--countryFlag__cz", O_ = "h-countryFlag--countryFlag__de", B_ = "h-countryFlag--countryFlag__dj", W_ = "h-countryFlag--countryFlag__dk", H_ = "h-countryFlag--countryFlag__dm", M_ = "h-countryFlag--countryFlag__dz", z_ = "h-countryFlag--countryFlag__ec", V_ = "h-countryFlag--countryFlag__ee", K_ = "h-countryFlag--countryFlag__eg", U_ = "h-countryFlag--countryFlag__eh", q_ = "h-countryFlag--countryFlag__er", G_ = "h-countryFlag--countryFlag__es", Y_ = "h-countryFlag--countryFlag__et", Q_ = "h-countryFlag--countryFlag__eu", X_ = "h-countryFlag--countryFlag__fi", Z_ = "h-countryFlag--countryFlag__fj", J_ = "h-countryFlag--countryFlag__fm", eC = "h-countryFlag--countryFlag__fo", tC = "h-countryFlag--countryFlag__fr", nC = "h-countryFlag--countryFlag__ga", sC = "h-countryFlag--countryFlag__gb", oC = "h-countryFlag--countryFlag__gd", rC = "h-countryFlag--countryFlag__ge", iC = "h-countryFlag--countryFlag__gg", aC = "h-countryFlag--countryFlag__gh", lC = "h-countryFlag--countryFlag__gi", cC = "h-countryFlag--countryFlag__gl", dC = "h-countryFlag--countryFlag__gm", hC = "h-countryFlag--countryFlag__gn", uC = "h-countryFlag--countryFlag__gp", pC = "h-countryFlag--countryFlag__gq", mC = "h-countryFlag--countryFlag__gr", gC = "h-countryFlag--countryFlag__gt", fC = "h-countryFlag--countryFlag__gu", bC = "h-countryFlag--countryFlag__gw", xC = "h-countryFlag--countryFlag__gy", yC = "h-countryFlag--countryFlag__hk", _C = "h-countryFlag--countryFlag__hn", CC = "h-countryFlag--countryFlag__hr", vC = "h-countryFlag--countryFlag__ht", wC = "h-countryFlag--countryFlag__hu", SC = "h-countryFlag--countryFlag__id", IC = "h-countryFlag--countryFlag__ie", DC = "h-countryFlag--countryFlag__il", kC = "h-countryFlag--countryFlag__im", TC = "h-countryFlag--countryFlag__iq", jC = "h-countryFlag--countryFlag__ir", NC = "h-countryFlag--countryFlag__is", FC = "h-countryFlag--countryFlag__it", PC = "h-countryFlag--countryFlag__je", RC = "h-countryFlag--countryFlag__jm", EC = "h-countryFlag--countryFlag__jo", LC = "h-countryFlag--countryFlag__jp", AC = "h-countryFlag--countryFlag__ke", $C = "h-countryFlag--countryFlag__kg", OC = "h-countryFlag--countryFlag__kh", BC = "h-countryFlag--countryFlag__ki", WC = "h-countryFlag--countryFlag__km", HC = "h-countryFlag--countryFlag__kn", MC = "h-countryFlag--countryFlag__kp", zC = "h-countryFlag--countryFlag__kr", VC = "h-countryFlag--countryFlag__kw", KC = "h-countryFlag--countryFlag__ky", UC = "h-countryFlag--countryFlag__kz", qC = "h-countryFlag--countryFlag__la", GC = "h-countryFlag--countryFlag__lb", YC = "h-countryFlag--countryFlag__lc", QC = "h-countryFlag--countryFlag__li", XC = "h-countryFlag--countryFlag__lk", ZC = "h-countryFlag--countryFlag__lr", JC = "h-countryFlag--countryFlag__ls", ev = "h-countryFlag--countryFlag__lt", tv = "h-countryFlag--countryFlag__lu", nv = "h-countryFlag--countryFlag__lv", sv = "h-countryFlag--countryFlag__ly", ov = "h-countryFlag--countryFlag__ma", rv = "h-countryFlag--countryFlag__mc", iv = "h-countryFlag--countryFlag__md", av = "h-countryFlag--countryFlag__me", lv = "h-countryFlag--countryFlag__mf", cv = "h-countryFlag--countryFlag__mg", dv = "h-countryFlag--countryFlag__mh", hv = "h-countryFlag--countryFlag__mk", uv = "h-countryFlag--countryFlag__ml", pv = "h-countryFlag--countryFlag__mm", mv = "h-countryFlag--countryFlag__mn", gv = "h-countryFlag--countryFlag__mo", fv = "h-countryFlag--countryFlag__mq", bv = "h-countryFlag--countryFlag__mr", xv = "h-countryFlag--countryFlag__ms", yv = "h-countryFlag--countryFlag__mt", _v = "h-countryFlag--countryFlag__mu", Cv = "h-countryFlag--countryFlag__mv", vv = "h-countryFlag--countryFlag__mw", wv = "h-countryFlag--countryFlag__mx", Sv = "h-countryFlag--countryFlag__my", Iv = "h-countryFlag--countryFlag__mz", Dv = "h-countryFlag--countryFlag__na", kv = "h-countryFlag--countryFlag__nc", Tv = "h-countryFlag--countryFlag__ne", jv = "h-countryFlag--countryFlag__ng", Nv = "h-countryFlag--countryFlag__ni", Fv = "h-countryFlag--countryFlag__nl", Pv = "h-countryFlag--countryFlag__no", Rv = "h-countryFlag--countryFlag__np", Ev = "h-countryFlag--countryFlag__nq", Lv = "h-countryFlag--countryFlag__nr", Av = "h-countryFlag--countryFlag__nu", $v = "h-countryFlag--countryFlag__nz", Ov = "h-countryFlag--countryFlag__om", Bv = "h-countryFlag--countryFlag__pa", Wv = "h-countryFlag--countryFlag__pe", Hv = "h-countryFlag--countryFlag__pf", Mv = "h-countryFlag--countryFlag__pg", zv = "h-countryFlag--countryFlag__ph", Vv = "h-countryFlag--countryFlag__pk", Kv = "h-countryFlag--countryFlag__pl", Uv = "h-countryFlag--countryFlag__pr", qv = "h-countryFlag--countryFlag__ps", Gv = "h-countryFlag--countryFlag__pt", Yv = "h-countryFlag--countryFlag__pw", Qv = "h-countryFlag--countryFlag__py", Xv = "h-countryFlag--countryFlag__qa", Zv = "h-countryFlag--countryFlag__re", Jv = "h-countryFlag--countryFlag__ro", ew = "h-countryFlag--countryFlag__rs", tw = "h-countryFlag--countryFlag__ru", nw = "h-countryFlag--countryFlag__rw", sw = "h-countryFlag--countryFlag__sa", ow = "h-countryFlag--countryFlag__sb", rw = "h-countryFlag--countryFlag__sc", iw = "h-countryFlag--countryFlag__sd", aw = "h-countryFlag--countryFlag__se", lw = "h-countryFlag--countryFlag__sg", cw = "h-countryFlag--countryFlag__sh", dw = "h-countryFlag--countryFlag__si", hw = "h-countryFlag--countryFlag__sj", uw = "h-countryFlag--countryFlag__sk", pw = "h-countryFlag--countryFlag__sl", mw = "h-countryFlag--countryFlag__sm", gw = "h-countryFlag--countryFlag__sn", fw = "h-countryFlag--countryFlag__so", bw = "h-countryFlag--countryFlag__sr", xw = "h-countryFlag--countryFlag__ss", yw = "h-countryFlag--countryFlag__st", _w = "h-countryFlag--countryFlag__sv", Cw = "h-countryFlag--countryFlag__sx", vw = "h-countryFlag--countryFlag__sy", ww = "h-countryFlag--countryFlag__sz", Sw = "h-countryFlag--countryFlag__tc", Iw = "h-countryFlag--countryFlag__td", Dw = "h-countryFlag--countryFlag__tg", kw = "h-countryFlag--countryFlag__th", Tw = "h-countryFlag--countryFlag__tj", jw = "h-countryFlag--countryFlag__tl", Nw = "h-countryFlag--countryFlag__tm", Fw = "h-countryFlag--countryFlag__tn", Pw = "h-countryFlag--countryFlag__to", Rw = "h-countryFlag--countryFlag__tr", Ew = "h-countryFlag--countryFlag__tt", Lw = "h-countryFlag--countryFlag__tv", Aw = "h-countryFlag--countryFlag__tw", $w = "h-countryFlag--countryFlag__tz", Ow = "h-countryFlag--countryFlag__ua", Bw = "h-countryFlag--countryFlag__ug", Ww = "h-countryFlag--countryFlag__us", Hw = "h-countryFlag--countryFlag__uy", Mw = "h-countryFlag--countryFlag__uz", zw = "h-countryFlag--countryFlag__va", Vw = "h-countryFlag--countryFlag__vc", Kw = "h-countryFlag--countryFlag__ve", Uw = "h-countryFlag--countryFlag__vg", qw = "h-countryFlag--countryFlag__vi", Gw = "h-countryFlag--countryFlag__vn", Yw = "h-countryFlag--countryFlag__vu", Qw = "h-countryFlag--countryFlag__ws", Xw = "h-countryFlag--countryFlag__ye", Zw = "h-countryFlag--countryFlag__yt", Jw = "h-countryFlag--countryFlag__za", eS = "h-countryFlag--countryFlag__zm", tS = "h-countryFlag--countryFlag__zw", hr = {
  flag: Ay,
  ad: $y,
  ae: Oy,
  af: By,
  ag: Wy,
  ai: Hy,
  al: My,
  am: zy,
  ao: Vy,
  aq: Ky,
  ar: Uy,
  as: qy,
  at: Gy,
  au: Yy,
  aw: Qy,
  ax: Xy,
  az: Zy,
  ba: Jy,
  bb: e_,
  bd: t_,
  be: n_,
  bf: s_,
  bg: o_,
  bh: r_,
  bi: i_,
  bj: a_,
  bl: l_,
  bm: c_,
  bn: d_,
  bo: h_,
  bq: u_,
  br: p_,
  bs: m_,
  bt: g_,
  bv: f_,
  bw: b_,
  by: x_,
  bz: y_,
  ca: __,
  cd: C_,
  cf: v_,
  cg: w_,
  ch: S_,
  ci: I_,
  ck: D_,
  cl: k_,
  cm: T_,
  cn: j_,
  co: N_,
  cp: F_,
  cr: P_,
  cu: R_,
  cv: E_,
  cw: L_,
  cy: A_,
  cz: $_,
  de: O_,
  dj: B_,
  dk: W_,
  dm: H_,
  do: "h-countryFlag--countryFlag__do",
  dz: M_,
  ec: z_,
  ee: V_,
  eg: K_,
  eh: U_,
  er: q_,
  es: G_,
  et: Y_,
  eu: Q_,
  fi: X_,
  fj: Z_,
  fm: J_,
  fo: eC,
  fr: tC,
  ga: nC,
  gb: sC,
  gd: oC,
  ge: rC,
  gg: iC,
  gh: aC,
  gi: lC,
  gl: cC,
  gm: dC,
  gn: hC,
  gp: uC,
  gq: pC,
  gr: mC,
  gt: gC,
  gu: fC,
  gw: bC,
  gy: xC,
  hk: yC,
  hn: _C,
  hr: CC,
  ht: vC,
  hu: wC,
  id: SC,
  ie: IC,
  il: DC,
  im: kC,
  in: "h-countryFlag--countryFlag__in",
  iq: TC,
  ir: jC,
  is: NC,
  it: FC,
  je: PC,
  jm: RC,
  jo: EC,
  jp: LC,
  ke: AC,
  kg: $C,
  kh: OC,
  ki: BC,
  km: WC,
  kn: HC,
  kp: MC,
  kr: zC,
  kw: VC,
  ky: KC,
  kz: UC,
  la: qC,
  lb: GC,
  lc: YC,
  li: QC,
  lk: XC,
  lr: ZC,
  ls: JC,
  lt: ev,
  lu: tv,
  lv: nv,
  ly: sv,
  ma: ov,
  mc: rv,
  md: iv,
  me: av,
  mf: lv,
  mg: cv,
  mh: dv,
  mk: hv,
  ml: uv,
  mm: pv,
  mn: mv,
  mo: gv,
  mq: fv,
  mr: bv,
  ms: xv,
  mt: yv,
  mu: _v,
  mv: Cv,
  mw: vv,
  mx: wv,
  my: Sv,
  mz: Iv,
  na: Dv,
  nc: kv,
  ne: Tv,
  ng: jv,
  ni: Nv,
  nl: Fv,
  no: Pv,
  np: Rv,
  nq: Ev,
  nr: Lv,
  nu: Av,
  nz: $v,
  om: Ov,
  pa: Bv,
  pe: Wv,
  pf: Hv,
  pg: Mv,
  ph: zv,
  pk: Vv,
  pl: Kv,
  pr: Uv,
  ps: qv,
  pt: Gv,
  pw: Yv,
  py: Qv,
  qa: Xv,
  re: Zv,
  ro: Jv,
  rs: ew,
  ru: tw,
  rw: nw,
  sa: sw,
  sb: ow,
  sc: rw,
  sd: iw,
  se: aw,
  sg: lw,
  sh: cw,
  si: dw,
  sj: hw,
  sk: uw,
  sl: pw,
  sm: mw,
  sn: gw,
  so: fw,
  sr: bw,
  ss: xw,
  st: yw,
  sv: _w,
  sx: Cw,
  sy: vw,
  sz: ww,
  tc: Sw,
  td: Iw,
  tg: Dw,
  th: kw,
  tj: Tw,
  tl: jw,
  tm: Nw,
  tn: Fw,
  to: Pw,
  tr: Rw,
  tt: Ew,
  tv: Lw,
  tw: Aw,
  tz: $w,
  ua: Ow,
  ug: Bw,
  us: Ww,
  uy: Hw,
  uz: Mw,
  va: zw,
  vc: Vw,
  ve: Kw,
  vg: Uw,
  vi: qw,
  vn: Gw,
  vu: Yw,
  ws: Qw,
  ye: Xw,
  yt: Zw,
  za: Jw,
  zm: eS,
  zw: tS
}, nS = 127365, sS = /^[a-z]{2}$/, oS = (i) => sS.test(i) ? String.fromCodePoint(
  ...i.split("").map((e) => nS + e.charCodeAt(0))
) : "", mT = ({
  className: i,
  countryCode: e,
  size: t = 16
}) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ s.jsx(ie, { style: { width: t, height: t }, children: /* @__PURE__ */ s.jsx(
  ie,
  {
    className: f(hr.flag, hr[e], i),
    style: {
      width: 32,
      height: 32,
      transform: `scale(calc(${t} / 32))`
    }
  }
) }) : /* @__PURE__ */ s.jsx("span", { className: i, style: { fontSize: t }, children: oS(e) }), gT = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "bl",
  "mf",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "bq",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "za",
  "zm",
  "zw"
], rS = "h-formGrid--formGrid__root", iS = {
  root: rS
}, aS = "formGridTestId", fT = $(function({ className: e, children: t, ...n }, o) {
  const r = f(iS.root, e);
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-testid": aS,
      className: r,
      ...n,
      ref: o,
      children: t
    }
  );
}), lS = "h-formGrid-field--formField__root", cS = "h-formGrid-field--formField__rootSpan5", dS = "h-formGrid-field--formField__rootSpan4", hS = "h-formGrid-field--formField__rootSpan3", uS = "h-formGrid-field--formField__rootSpan2", pS = "h-formGrid-field--formField__rootSpan1", Dt = {
  root: lS,
  rootSpan5: cS,
  rootSpan4: dS,
  rootSpan3: hS,
  rootSpan2: uS,
  rootSpan1: pS
}, mS = "formFieldTestId", gS = {
  1: Dt.rootSpan1,
  2: Dt.rootSpan2,
  3: Dt.rootSpan3,
  4: Dt.rootSpan4,
  5: Dt.rootSpan5,
  6: void 0
};
class bT extends D {
  static defaultProps = {
    span: 6
  };
  render() {
    const { span: e, className: t, children: n, ...o } = this.props, r = f(
      Dt.root,
      t,
      gS[e]
    );
    return /* @__PURE__ */ s.jsx("div", { "data-testid": mS, className: r, ...o, children: n });
  }
}
const fS = "h-helperField--helperField__root", bS = "h-helperField--helperField__label", xS = "h-helperField--helperField__helpIcon", yS = "h-helperField--helperField__error", _S = "h-helperField--helperField__rootRequired", Qt = {
  root: fS,
  label: bS,
  helpIcon: xS,
  error: yS,
  rootRequired: _S
};
class xT extends D {
  render() {
    const {
      className: e,
      label: t,
      required: n,
      disabled: o,
      errorMessage: r,
      fieldId: a,
      children: l,
      helpIcon: c,
      ...d
    } = this.props, h = f(
      {
        [Qt.root]: !0,
        [Qt.rootRequired]: n
      },
      e
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      !!t && /* @__PURE__ */ s.jsx(
        "label",
        {
          className: Qt.label,
          htmlFor: a,
          id: `${a}-label`,
          children: t
        }
      ),
      !!c?.text && /* @__PURE__ */ s.jsx(
        Ys,
        {
          ...c,
          className: f(Qt.helpIcon, c?.className ?? "")
        }
      ),
      !!r && /* @__PURE__ */ s.jsx("p", { className: Qt.error, children: r }),
      l
    ] });
  }
}
const CS = "h-inputDuration--inputDuration__root", vS = {
  root: CS
}, Is = (i, e = [
  "hours",
  "minutes",
  "seconds"
]) => {
  const t = Math.floor(i / 1e3), n = {};
  let o = t;
  return e.includes("days") && (n.days = Math.floor(t / (24 * 3600)), o = t % (24 * 3600)), e.includes("hours") && (n.hours = Math.floor(o / 3600), o %= 3600), e.includes("minutes") && (n.minutes = Math.floor(o / 60), o %= 60), e.includes("seconds") && (n.seconds = o), n;
}, Ds = (i) => ((i.days ?? 0) * 86400 + (i.hours ?? 0) * 3600 + (i.minutes ?? 0) * 60 + (i.seconds ?? 0)) * 1e3, wS = [
  "hours",
  "minutes",
  "seconds"
], yT = $(
  function(e, t) {
    const n = q(null);
    Ft(t, () => n.current);
    const {
      className: o,
      name: r = "input-duration",
      value: a = 0,
      required: l = !1,
      disabled: c = !1,
      readOnly: d = !1,
      inputParts: h = wS,
      status: u,
      onChange: p,
      onBlur: m
    } = e, [g, b] = V(
      () => Is(a, h)
    );
    Z(() => {
      const v = Ds(g);
      if (a !== v) {
        const y = Is(a, h);
        b(y);
      }
    }, [a, h]);
    const x = P(
      (v, y) => {
        const w = Math.max(0, parseInt(y) || 0);
        if ((v === "minutes" || v === "seconds") && w > 60)
          return;
        const I = { ...g, [v]: w };
        b(I);
        const T = Ds(I);
        p?.(T);
      },
      [g, p]
    ), C = P(() => {
      const v = Ds(g), y = Is(
        v,
        h
      );
      b(y), m?.();
    }, [g, h, m]), _ = (v) => {
      const y = g[v] ?? 0, w = y === 0;
      return {
        type: "number",
        id: `${r}-${v}`,
        name: `${r}-${v}`,
        value: w ? "" : y,
        placeholder: w ? "0" : void 0,
        suffix: {
          type: "custom",
          value: v.charAt(0).toUpperCase() + v.slice(1)
        },
        min: 0,
        step: 1,
        required: l,
        disabled: c,
        readOnly: d,
        status: u,
        "aria-required": l,
        "aria-disabled": c,
        "aria-readonly": d,
        onBlur: C,
        onChange: (I) => x(v, I.target.value)
      };
    }, S = f(o, vS.root);
    return /* @__PURE__ */ s.jsxs("div", { ref: n, className: S, children: [
      h.includes("days") && /* @__PURE__ */ s.jsx(Ye, { ..._("days") }),
      h.includes("hours") && /* @__PURE__ */ s.jsx(Ye, { ..._("hours") }),
      h.includes("minutes") && /* @__PURE__ */ s.jsx(Ye, { ..._("minutes"), max: 60 }),
      h.includes("seconds") && /* @__PURE__ */ s.jsx(Ye, { ..._("seconds"), max: 60 })
    ] });
  }
), Xt = /* @__PURE__ */ new Map();
function SS({
  containerId: i,
  children: e
}) {
  const [t, n] = V(null), o = (a) => {
    const l = Xt.get(i);
    l !== void 0 && Xt.set(i, l + a);
  }, r = () => {
    const a = document.createElement("div");
    return a.id = i, a;
  };
  return Z(() => {
    let a = document.getElementById(i);
    return a || (a = r(), document.body.appendChild(a), Xt.set(i, 0)), n(a), o(1), () => {
      o(-1), Xt.get(i) === 0 && a && (Xt.delete(i), a.remove());
    };
  }, [i]), t ? Zi.createPortal(e, t) : null;
}
const IS = "h-modal--modal__root", DS = "h-modal--modal__rootSkipAnimation", kS = "h-modal--modal__modalContainer", TS = "h-modal--modal__modalContent", jS = "h-modal--modal__rootDisplayed", NS = "h-modal--modal__rootOpened", FS = "h-modal--modal__modal", PS = "h-modal--modal__modalStacked", RS = "h-modal--modal__ghostPanel", ES = "h-modal--modal__ghostLabel", je = {
  root: IS,
  rootSkipAnimation: DS,
  modalContainer: kS,
  modalContent: TS,
  rootDisplayed: jS,
  rootOpened: NS,
  modal: FS,
  modalStacked: PS,
  ghostPanel: RS,
  ghostLabel: ES
}, LS = ve(!1);
class AS extends D {
  rootRef;
  haskeydownEventListner;
  closeTimer;
  static defaultProps = {
    allowEscClose: !0,
    restoreFocus: !0,
    bringInFocusOnTab: !0
  };
  constructor(e) {
    super(e), this.rootRef = B(), this.closeTimer = null, this.state = {
      opened: !1,
      displayed: !1
    }, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
  }
  componentDidMount() {
    const { isOpen: e } = this.props;
    e && this.animateOpening();
  }
  componentDidUpdate(e) {
    const { isOpen: t, allowEscClose: n } = this.props, { isOpen: o } = e;
    n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), t !== o && (t ? this.animateOpening() : this.animateClosing());
  }
  componentWillUnmount() {
    this.cancelAnimation(), this.removeKeyDownEventListener();
  }
  handleKey(e) {
    const { isOpen: t, onClose: n } = this.props;
    t && Et(e.key) && (this.rootRef.current?.querySelector(
      '[role="menu"][aria-expanded="true"]'
    ) || (e.preventDefault(), e.stopPropagation(), this.animateClosing(), n(e)));
  }
  removeKeyDownEventListener = () => {
    window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
  };
  cancelAnimation() {
    const { current: e } = this.rootRef;
    e && e.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  animateOpening() {
    const { skipAnimation: e } = this.props;
    e ? this.setState({ displayed: !0, opened: !0 }) : (this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 })));
  }
  animateClosing() {
    const { skipAnimation: e } = this.props;
    this.removeKeyDownEventListener(), e ? this.setState({ opened: !1, displayed: !1 }) : (this.rootRef.current && this.rootRef.current.addEventListener(
      "transitionend",
      this.onTransitionEnd
    ), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred());
  }
  closeIfNoTransitionOccurred() {
    this.closeTimer = setTimeout(() => {
      this.closeTimer && this.onTransitionEnd();
    }, 400);
  }
  onTransitionEnd() {
    this.setState({ displayed: !1 }), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null), this.rootRef.current && this.rootRef.current.removeEventListener(
      "transitionend",
      this.onTransitionEnd
    );
  }
  render() {
    const {
      className: e,
      isOpen: t,
      children: n,
      onClose: o,
      allowClickOutside: r,
      allowEscClose: a,
      // Stops allowEscClose from being passed in with otherProps
      skipAnimation: l,
      wrapProps: c,
      autoFocus: d,
      restoreFocus: h,
      bringInFocusOnTab: u,
      ...p
    } = this.props, { displayed: m, opened: g } = this.state, b = f(je.root, c?.className, {
      [je.rootDisplayed]: m,
      [je.rootOpened]: g,
      [je.rootSkipAnimation]: l
    });
    return /* @__PURE__ */ s.jsx(SS, { containerId: "modal-container", children: /* @__PURE__ */ s.jsx("div", { ...c, className: b, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: je.modalContainer,
        ref: this.rootRef,
        ...r ? { onClick: o } : {},
        ...p,
        children: g && // fixes an issue with child-components that need to measure boundingClientRect
        /* @__PURE__ */ s.jsx(
          Tr,
          {
            containerRef: this.rootRef,
            autoFocus: d,
            restoreFocus: h,
            bringInFocusOnTab: u,
            children: /* @__PURE__ */ s.jsx("div", { className: je.modalContent, children: /* @__PURE__ */ s.jsx(LS.Consumer, { children: (x) => /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: f(je.modal, e, {
                  [je.modalStacked]: x
                }),
                onClick: (C) => r && C.stopPropagation(),
                children: [
                  x && /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      role: "button",
                      tabIndex: -1,
                      className: je.ghostPanel,
                      onClick: o,
                      children: /* @__PURE__ */ s.jsxs("span", { className: je.ghostLabel, children: [
                        /* @__PURE__ */ s.jsx(N, { name: "arrow-left", size: 12 }),
                        "Go back"
                      ] })
                    }
                  ),
                  n
                ]
              }
            ) }) })
          }
        )
      }
    ) }) });
  }
}
const $S = "h-lightbox--lightbox__lightSource", OS = "h-lightbox--lightbox__closeButton", BS = "h-lightbox--lightbox__downloadButton", WS = "h-lightbox--lightbox__image", HS = "h-lightbox--lightbox__loadingContainer", MS = "h-lightbox--lightbox__navButton", zS = "h-lightbox--lightbox__navButtonPrevious", VS = "h-lightbox--lightbox__navButtonNext", KS = "h-lightbox--lightbox__counter", Ne = {
  lightSource: $S,
  closeButton: OS,
  downloadButton: BS,
  image: WS,
  loadingContainer: HS,
  navButton: MS,
  navButtonPrevious: zS,
  navButtonNext: VS,
  counter: KS
};
class _T extends D {
  render() {
    const {
      className: e,
      src: t,
      alt: n,
      isOpen: o,
      onClose: r,
      showNavigation: a = !1,
      currentIndex: l = 0,
      totalImages: c = 1,
      onPrevious: d,
      onNext: h,
      isLoading: u = !1
    } = this.props, p = c > 1;
    return /* @__PURE__ */ s.jsx(
      AS,
      {
        className: e,
        isOpen: o,
        allowClickOutside: !0,
        onClose: r,
        children: /* @__PURE__ */ s.jsxs("div", { className: Ne.lightSource, children: [
          u ? /* @__PURE__ */ s.jsx("div", { className: Ne.loadingContainer, children: /* @__PURE__ */ s.jsx(Gn, { size: 64 }) }) : t && /* @__PURE__ */ s.jsx(Us, { className: Ne.image, alt: n, src: t }),
          r && /* @__PURE__ */ s.jsx(
            K,
            {
              onClick: r,
              icon: "close",
              variant: "secondary",
              className: Ne.closeButton
            }
          ),
          t && typeof t == "string" && /* @__PURE__ */ s.jsx(
            "a",
            {
              href: t,
              target: "_blank",
              download: !0,
              className: Ne.downloadButton,
              rel: "noreferrer",
              children: /* @__PURE__ */ s.jsx(
                N,
                {
                  name: "cloud-download",
                  className: f("icon-vertical-fix")
                }
              )
            }
          ),
          a && p && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-left",
                variant: "primary",
                size: "large",
                onClick: d,
                className: `${Ne.navButton} ${Ne.navButtonPrevious}`
              }
            ),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-right",
                variant: "primary",
                size: "large",
                onClick: h,
                className: `${Ne.navButton} ${Ne.navButtonNext}`
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { className: Ne.counter, children: [
              l + 1,
              " / ",
              c
            ] })
          ] })
        ] })
      }
    );
  }
}
const US = "h-list-items--item__root", qS = "h-list-items--item__rootWithHoverEffect", GS = "h-list-items--item__rootDense", YS = "h-list-items--item__rootLarge", QS = "h-list-items--item__contentLeft", XS = "h-list-items--item__contentRight", ZS = "h-list-items--item__titles", JS = "h-list-items--item__title", eI = "h-list-items--item__titleSecondary", tI = "h-list-items--item__arrow", Fe = {
  root: US,
  rootWithHoverEffect: qS,
  rootDense: GS,
  rootLarge: YS,
  contentLeft: QS,
  contentRight: XS,
  titles: ZS,
  title: JS,
  titleSecondary: eI,
  arrow: tI
};
class ss extends D {
  static defaultProps = {
    variant: "dense",
    withHoverEffect: !0
  };
  renderTitle() {
    const { title: e, titleSecondary: t } = this.props;
    return e || t ? /* @__PURE__ */ s.jsxs("div", { className: Fe.titles, children: [
      !!e && /* @__PURE__ */ s.jsx(A.Paragraph, { as: "div", variant: "2", className: Fe.title, children: e }),
      !!t && /* @__PURE__ */ s.jsx(
        A.Paragraph,
        {
          as: "div",
          variant: "4",
          subdued: !0,
          className: Fe.titleSecondary,
          children: t
        }
      )
    ] }) : null;
  }
  renderContentLeft() {
    const { contentLeft: e } = this.props;
    return e ? /* @__PURE__ */ s.jsx("div", { className: Fe.contentLeft, children: e }) : null;
  }
  renderContentRight() {
    const { contentRight: e } = this.props;
    return e ? /* @__PURE__ */ s.jsx("div", { className: Fe.contentRight, children: e }) : null;
  }
  renderIcon() {
    const { isLink: e, contentRight: t } = this.props;
    return e && !t ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: f(Fe.arrow, "icon-vertical-fix"),
        name: "angle-right",
        size: 24
      }
    ) : null;
  }
  renderContent() {
    return /* @__PURE__ */ s.jsxs(Ze, { children: [
      this.renderContentLeft(),
      this.renderTitle(),
      this.renderContentRight(),
      this.renderIcon()
    ] });
  }
  getChildrenWithFallback() {
    return this.props.children ?? this.renderContent();
  }
  render() {
    const {
      className: e,
      children: t,
      contentLeft: n,
      contentRight: o,
      title: r,
      titleSecondary: a,
      secondaryTitleBelow: l,
      isLink: c,
      variant: d,
      withHoverEffect: h,
      ...u
    } = this.props, p = f(Fe.root, e, {
      [Fe.rootDense]: d === "dense",
      [Fe.rootLarge]: d === "large",
      [Fe.rootWithHoverEffect]: h
    });
    return /* @__PURE__ */ s.jsx("li", { ...u, className: p, children: this.getChildrenWithFallback() });
  }
}
const nI = "h-list-items--keyValue__root", sI = {
  root: nI
};
class oI extends D {
  static defaultProps = {
    hideIfValueIsEmpty: !0
  };
  isValueEmpty() {
    return !this.props.pair.value;
  }
  render() {
    const { hideIfValueIsEmpty: e, className: t, pair: n, ...o } = this.props, r = f(sI.root, t);
    return e && this.isValueEmpty() ? null : /* @__PURE__ */ s.jsx(
      ss,
      {
        ...o,
        className: r,
        title: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "4", subdued: !0, children: n.key }),
        titleSecondary: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "2", children: n.value }),
        "data-testid": "List-KeyValue"
      }
    );
  }
}
const rI = "h-list-items--text__root", iI = {
  root: rI
};
class aI extends D {
  render() {
    const { children: e, className: t, ...n } = this.props, o = f(iI.root, t);
    return /* @__PURE__ */ s.jsx(
      ss,
      {
        ...n,
        className: o,
        "data-testid": "List-Text",
        children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: e })
      }
    );
  }
}
const lI = "h-list-items--user__root", cI = "h-list-items--user__avatarWrapper", ur = {
  root: lI,
  avatarWrapper: cI
};
class dI extends D {
  getTitle() {
    const { user: e, title: t } = this.props;
    return t || e.display_name || e.name || e.phone_number || e.id;
  }
  getSubTitle() {
    const { user: e, titleSecondary: t } = this.props;
    return t || e.email;
  }
  render() {
    const { className: e, user: t, title: n, titleSecondary: o, ...r } = this.props, a = f(e, ur.root);
    return /* @__PURE__ */ s.jsx(
      ss,
      {
        className: a,
        contentLeft: /* @__PURE__ */ s.jsx("div", { className: ur.avatarWrapper, children: /* @__PURE__ */ s.jsx(kr, { user: t }) }),
        title: this.getTitle(),
        titleSecondary: this.getSubTitle(),
        "data-testid": "<List.User>",
        ...r
      }
    );
  }
}
const hI = "h-list--list__root", uI = {
  root: hI
};
class pI extends D {
  static Item = ss;
  static Text = aI;
  static User = dI;
  static KeyValue = oI;
  render() {
    const { className: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx("ul", { ...t, className: f(uI.root, e) });
  }
}
const CT = dn(pI, {
  fallback: null
}), mI = () => {
  document.exitFullscreen && document.exitFullscreen();
}, gI = (i) => {
  i.requestFullscreen ? i.requestFullscreen() : i.mozRequestFullScreen ? i.mozRequestFullScreen() : i.webkitRequestFullscreen ? i.webkitRequestFullscreen() : i.msRequestFullscreen && i.msRequestFullscreen();
}, fI = (i) => document.fullscreenElement === i;
class bI extends Error {
  status;
  url;
  response;
  constructor(e) {
    super(`NetworkError ${e.status} ${e.url}`), this.status = e.status, this.url = e.url, this.response = e;
  }
}
const xI = {
  fetch: (i, ...e) => fetch(i, ...e).then((t) => {
    if (!(t.status >= 200 && t.status < 300))
      throw new bI(t);
    return t;
  })
}, yI = "h-mediaPlayer--mediaPlayer__root", _I = "h-mediaPlayer--mediaPlayer__controls", CI = "h-mediaPlayer--mediaPlayer__unstyled", vI = "h-mediaPlayer--mediaPlayer__rootFullScreen", wI = "h-mediaPlayer--mediaPlayer__rootHideControls", SI = "h-mediaPlayer--mediaPlayer__control", II = "h-mediaPlayer--mediaPlayer__progress", DI = "h-mediaPlayer--mediaPlayer__progressSlider", kI = "h-mediaPlayer--mediaPlayer__volumeSlider", TI = "h-mediaPlayer--mediaPlayer__timestamp", jI = "h-mediaPlayer--mediaPlayer__videoWrapper", NI = "h-mediaPlayer--mediaPlayer__rootWaiting", FI = "h-mediaPlayer--mediaPlayer__rootAudio", PI = "h-mediaPlayer--mediaPlayer__video", RI = "h-mediaPlayer--mediaPlayer__volume", EI = "h-mediaPlayer--mediaPlayer__volumeMuteControl", LI = "h-mediaPlayer--mediaPlayer__downloadLink", ee = {
  root: yI,
  controls: _I,
  unstyled: CI,
  rootFullScreen: vI,
  rootHideControls: wI,
  control: SI,
  progress: II,
  progressSlider: DI,
  volumeSlider: kI,
  timestamp: TI,
  videoWrapper: jI,
  rootWaiting: NI,
  rootAudio: FI,
  video: PI,
  volume: RI,
  volumeMuteControl: EI,
  downloadLink: LI
};
function AI(i) {
  const e = i >= 3600 ? 8 : 5;
  return Number.isNaN(i) || !Number.isFinite(i) ? "00:00" : new Date(i * 1e3).toISOString().substr(19 - e, e);
}
class vT extends D {
  intersectionObserver;
  static defaultProps = {
    headers: {}
  };
  constructor(e) {
    super(e), this.state = {
      src: void 0,
      playing: !1,
      actuallyPlaying: !1,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 100,
      isFullScreen: !1,
      hideControls: !1,
      isWaiting: !1,
      buffer: null,
      asyncStatus: null
    }, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.handleIntersection = this.handleIntersection.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
  }
  componentDidMount() {
    const { lazy: e } = this.props, { current: t } = this.playerRef;
    t && t.addEventListener("fullscreenchange", this.handleFullscreenChange), e ? this.createIntersectionObserver() : this.loadSrc();
  }
  componentDidUpdate(e, t) {
    const {
      mediaFile: { src: n }
    } = e, {
      lazy: o,
      mediaFile: { src: r }
    } = this.props;
    n !== r && (o ? this.setSrc() : this.loadSrc()), this.tryReloadPlayer(t);
  }
  componentWillUnmount() {
    const { current: e } = this.playerRef;
    e && e.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    ), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
  }
  videoRef = B();
  playerRef = B();
  hideControlsTimeout = void 0;
  controller = new AbortController();
  loadSrc() {
    const {
      mediaFile: { src: e },
      isPrivateFile: t
    } = this.props;
    this.tryStopPlayer(), t ? this.fetchFile() : this.setSrc(e);
  }
  setSrc(e) {
    this.setState({
      src: e
    });
  }
  handleIntersection([e]) {
    const { src: t, asyncStatus: n } = this.state;
    !t && !(n === "loading") && e.isIntersecting && (this.loadSrc(), this.intersectionObserver?.disconnect());
  }
  createIntersectionObserver() {
    const { current: e } = this.playerRef;
    e && (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 }
    ), this.intersectionObserver.observe(e));
  }
  tryStopPlayer() {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    e.currentTime = 0;
    const { playing: t, actuallyPlaying: n } = this.state;
    t && n && (e.pause(), this.setState({ playing: !1, actuallyPlaying: !1 }));
  }
  tryReloadPlayer(e) {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    const { src: n } = this.state;
    n !== e.src && t.load();
  }
  fetchFile(e) {
    const {
      mediaFile: { src: t },
      headers: n,
      filename: o
    } = this.props;
    this.setState({ asyncStatus: "loading" });
    const r = new Headers(n);
    xI.fetch(t, {
      headers: r,
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      signal: this.controller.signal
    }).then((a) => a.blob()).then((a) => {
      const l = window.URL.createObjectURL(a);
      e ? Hi.saveAs(
        a,
        o || decodeURIComponent(t.split("/").pop())
      ) : this.setSrc(l), this.setState({ asyncStatus: "succeeded" });
    }).catch((a) => {
      a && a.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", a), this.setState({ asyncStatus: "failed" }));
    });
  }
  updateProgress() {
    const { current: e } = this.videoRef;
    e && this.setState({
      time: e.currentTime,
      duration: e.duration
    });
  }
  updateBuffer() {
    const { current: e } = this.videoRef, { time: t, duration: n } = this.state;
    if (e) {
      let o = null;
      const r = e.buffered;
      for (let a = 0; a < r.length; a += 1) {
        const l = r.start(a), c = r.end(a);
        l <= t && t <= c && (o = [l / n, c / n]);
      }
      this.setState({
        buffer: o
      });
    }
  }
  handleWaiting() {
    this.setState({
      isWaiting: !0
    });
  }
  handlePlaying() {
    this.setState({
      isWaiting: !1
    });
  }
  handleTogglePlayClick() {
    const { playing: e, actuallyPlaying: t } = this.state, { current: n } = this.videoRef;
    n && (e && t ? (n.pause(), this.setState({
      isWaiting: !1,
      playing: !1,
      actuallyPlaying: !1
    })) : e || (this.setState({
      isWaiting: !0,
      playing: !0,
      actuallyPlaying: !1
    }), n.play().then(() => {
      this.setState({ actuallyPlaying: !0 });
    })));
  }
  startHideControlCountdown() {
    this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({
      hideControls: !1
    }), this.hideControlsTimeout = setTimeout(() => {
      this.setState({
        hideControls: !0
      });
    }, 2e3);
  }
  handleFullscreenChange() {
    const { current: e } = this.playerRef, t = fI(e);
    this.setState({
      isFullScreen: t
    }), t ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
  }
  handleFullscreenToggle() {
    const { current: e } = this.playerRef, { isFullScreen: t } = this.state;
    e && (t ? mI() : gI(e));
  }
  handleEnded() {
    this.setState({
      playing: !1
    });
  }
  handleError() {
    this.props.onError && this.props.onError();
  }
  seek(e) {
    const { current: t } = this.videoRef, { duration: n } = this.state;
    t && e && !Number.isNaN(e) && (t.currentTime = n * e);
  }
  handleVolume = (e) => {
    const { current: t } = this.videoRef;
    !t || typeof e > "u" || !Number.isFinite(e) || this.setState({ volume: e }, () => {
      this.setPlayerVolume(e);
    });
  };
  handleMute() {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    const { volume: t, prevVolume: n } = this.state, o = t === 0, r = o ? n : 0;
    this.setState(
      {
        volume: r,
        prevVolume: o ? n : t
      },
      () => {
        this.setPlayerVolume(r);
      }
    );
  }
  setPlayerVolume(e) {
    const { current: t } = this.videoRef;
    t && (t.volume = e / 100);
  }
  render() {
    const {
      className: e,
      mediaFile: { type: t },
      headers: n,
      isPrivateFile: o,
      width: r,
      controls: a,
      noControlsStyle: l,
      ...c
    } = this.props, {
      src: d,
      playing: h,
      duration: u,
      time: p,
      volume: m,
      hideControls: g,
      isFullScreen: b,
      isWaiting: x,
      buffer: C,
      asyncStatus: _
    } = this.state, S = a?.play ?? !0, v = a?.download ?? !0, y = a?.progress ?? !0, w = a?.volume ?? !0, I = a?.maximize ?? !0, T = S || v || y || w || I, F = typeof t == "string" && t.startsWith("audio"), H = !d || _ === "loading", k = b ? "primary" : "secondary", R = f(
      ee.root,
      {
        [ee.rootFullScreen]: b,
        [ee.rootHideControls]: g,
        [ee.rootWaiting]: h && x,
        [ee.rootAudio]: F
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...c,
        className: R,
        ref: this.playerRef,
        style: { width: r },
        children: [
          /* @__PURE__ */ s.jsx("div", { className: ee.videoWrapper, children: !!d && /* @__PURE__ */ s.jsx(
            "video",
            {
              className: ee.video,
              ref: this.videoRef,
              onDurationChange: this.updateProgress,
              onTimeUpdate: this.updateProgress,
              onWaiting: this.handleWaiting,
              onPlaying: this.handlePlaying,
              onProgress: this.updateBuffer,
              onEnded: this.handleEnded,
              onError: this.handleError,
              children: /* @__PURE__ */ s.jsx("source", { src: d })
            }
          ) }),
          T && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: f(ee.controls, {
                [ee.unstyled]: l
              }),
              children: [
                S && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    onClick: this.handleTogglePlayClick,
                    className: ee.control,
                    disabled: H,
                    icon: h ? "pause" : "play",
                    variant: k
                  }
                ),
                v && (o ? /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: k,
                    className: ee.control,
                    disabled: H,
                    children: /* @__PURE__ */ s.jsx(
                      "a",
                      {
                        href: d,
                        download: !0,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: ee.downloadLink,
                        children: /* @__PURE__ */ s.jsx(N, { name: "download" })
                      }
                    )
                  }
                ) : /* @__PURE__ */ s.jsx(
                  K,
                  {
                    icon: "download",
                    variant: k,
                    className: ee.control,
                    disabled: H,
                    onClick: () => this.fetchFile(!0)
                  }
                )),
                y && /* @__PURE__ */ s.jsxs("div", { className: ee.progress, children: [
                  /* @__PURE__ */ s.jsx(
                    Bs,
                    {
                      hideAnnotations: !0,
                      className: ee.progressSlider,
                      min: 0,
                      max: u,
                      value: p,
                      onChange: (O) => !Array.isArray(O) && this.seek(O / u),
                      dark: b,
                      highlightRange: C?.map((O) => O * u)
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: ee.timestamp, children: AI(u) })
                ] }),
                w && /* @__PURE__ */ s.jsxs("div", { className: ee.volume, children: [
                  /* @__PURE__ */ s.jsx(
                    N,
                    {
                      className: ee.volumeMuteControl,
                      name: m === 0 ? "volume-off" : "volume-up",
                      onClick: this.handleMute
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    Bs,
                    {
                      hideAnnotations: !0,
                      className: ee.volumeSlider,
                      value: m,
                      onChange: (O) => !Array.isArray(O) && this.handleVolume(O),
                      dark: b
                    }
                  )
                ] }),
                I && !F && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    variant: k,
                    onClick: this.handleFullscreenToggle,
                    className: ee.control,
                    icon: "expand"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
}
const $I = "h-modalBody--modalBody__root", OI = {
  root: $I
};
class wT extends D {
  render() {
    const { className: e, children: t, ...n } = this.props, o = f(
      {
        [OI.root]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: t });
  }
}
const BI = "h-modalFoot--modalFoot__root", WI = "h-modalFoot--modalFoot__confirm", HI = "h-modalFoot--modalFoot__confirmSecondary", MI = "h-modalFoot--modalFoot__cancel", Fn = {
  root: BI,
  confirm: WI,
  confirmSecondary: HI,
  cancel: MI
};
class zI extends D {
  static defaultProps;
  render() {
    const {
      className: e,
      confirmOnClick: t,
      confirmSecondaryOnClick: n,
      cancelOnClick: o,
      confirmName: r,
      confirmSecondaryName: a,
      cancelName: l,
      confirmProps: c,
      confirmSecondaryProps: d,
      cancelProps: h,
      children: u,
      ...p
    } = this.props, m = f(
      {
        [Fn.root]: !0
      },
      e
    ), g = f(
      {
        [Fn.cancel]: !0
      },
      h?.className
    ), b = f(
      {
        [Fn.confirm]: !0
      },
      c?.className
    ), x = f(
      {
        [Fn.confirmSecondary]: !0
      },
      d?.className
    );
    return /* @__PURE__ */ s.jsxs("div", { ...p, className: m, children: [
      u,
      n && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "secondary",
          ...d,
          className: x,
          onClick: n,
          children: a
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "tertiary",
          ...h,
          className: g,
          onClick: o,
          children: l
        }
      ),
      t && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "primary",
          ...c,
          className: b,
          onClick: t,
          children: r
        }
      )
    ] });
  }
}
zI.defaultProps = {
  confirmName: "Save",
  cancelName: "Cancel",
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};
const VI = "h-modalHead--modalHead__root", KI = "h-modalHead--modalHead__top", UI = "h-modalHead--modalHead__title", qI = "h-modalHead--modalHead__buttons", GI = "h-modalHead--modalHead__caption", Zt = {
  root: VI,
  top: KI,
  title: UI,
  buttons: qI,
  caption: GI
}, ST = ({
  className: i,
  title: e,
  children: t,
  onClose: n,
  secondaryButton: o,
  buttonsClassName: r,
  buttonsSlot: a,
  ...l
}) => {
  const c = f(
    {
      [Zt.root]: !0
    },
    i
  );
  return /* @__PURE__ */ s.jsxs("div", { ...l, className: c, children: [
    /* @__PURE__ */ s.jsxs("div", { className: Zt.top, children: [
      /* @__PURE__ */ s.jsx(A.Heading, { className: Zt.title, children: e }),
      /* @__PURE__ */ s.jsxs("div", { className: f(Zt.buttons, r), children: [
        a,
        typeof o?.onClick == "function" && /* @__PURE__ */ s.jsx(se, { content: o?.tooltipContent, children: /* @__PURE__ */ s.jsx(
          K,
          {
            icon: o?.icon,
            variant: "tertiary",
            onClick: o?.onClick
          }
        ) }),
        typeof n == "function" && /* @__PURE__ */ s.jsx(
          K,
          {
            icon: "close",
            iconSize: 24,
            variant: "tertiary",
            onClick: n
          }
        )
      ] })
    ] }),
    !!t && /* @__PURE__ */ s.jsx(
      A.Paragraph,
      {
        variant: "2",
        color: "secondary",
        className: Zt.caption,
        children: t
      }
    )
  ] });
}, YI = "h-page-body--pageBody__root", QI = {
  root: YI
}, XI = $(function({ children: e, className: t, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    pe.Row,
    {
      ...n,
      ref: o,
      className: f(QI.root, t),
      scrollable: !0,
      noMinHeight: !0,
      noHorizontalPadding: !0,
      noVerticalPadding: !0,
      children: e
    }
  );
}), ZI = "h-page-head--pageHead__root", JI = {
  root: ZI
}, eD = $(function({ className: e, title: t, controls: n, ...o }, r) {
  return /* @__PURE__ */ s.jsxs(
    pe.Row,
    {
      ...o,
      ref: r,
      as: "header",
      className: f(JI.root, e),
      slottable: !0,
      borderBottom: !0,
      children: [
        /* @__PURE__ */ s.jsx(pe.Slot, { placement: "start", children: /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-2", as: "h1", children: t }) }),
        n && /* @__PURE__ */ s.jsx(pe.Slot, { placement: "end", children: /* @__PURE__ */ s.jsx(W, { alignItems: "center", gap: "200", children: n }) })
      ]
    }
  );
}), tD = "h-page-section--pageSection__root", nD = "h-page-section--pageSection__head", sD = "h-page-section--pageSection__callout", oD = "h-page-section--pageSection__content", Pn = {
  root: tD,
  head: nD,
  callout: sD,
  content: oD
}, rD = $(function({
  children: e,
  className: t,
  title: n,
  titleMeta: o,
  controls: r,
  callout: a,
  ...l
}, c) {
  const d = !!(n || o || r);
  return /* @__PURE__ */ s.jsxs(
    pe.Row,
    {
      ...l,
      ref: c,
      as: "section",
      className: f(Pn.root, t),
      noMinHeight: !0,
      children: [
        d && /* @__PURE__ */ s.jsxs(
          pe.Row,
          {
            className: Pn.head,
            slottable: !0,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: [
              (n || o) && /* @__PURE__ */ s.jsx(pe.Slot, { placement: "start", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsxs(W, { alignItems: "center", gap: "200", children: [
                n && /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-3", as: "h2", children: n }),
                o && /* @__PURE__ */ s.jsx(W, { alignItems: "center", gap: "200", children: o })
              ] }) }),
              r && /* @__PURE__ */ s.jsx(pe.Slot, { placement: "end", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsx(W, { alignItems: "center", gap: "200", children: r }) })
            ]
          }
        ),
        a && /* @__PURE__ */ s.jsx(
          pe.Row,
          {
            className: Pn.callout,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: a
          }
        ),
        /* @__PURE__ */ s.jsx(
          pe.Row,
          {
            className: Pn.content,
            size: 1,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: e
          }
        )
      ]
    }
  );
}), iD = $(function({ children: e, className: t, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    pe.Row,
    {
      ...n,
      ref: o,
      className: t,
      borderBottom: !0,
      noVerticalPadding: !0,
      noMinHeight: !0,
      children: e
    }
  );
}), pr = ({ children: i, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(yd, { ...t, ref: n, as: "article", className: e, children: /* @__PURE__ */ s.jsx(pe, { children: i }) }), IT = Object.assign($(pr), {
  name: pr.name,
  Head: eD,
  Body: XI,
  Section: rD,
  Tabs: iD
}), aD = "h-radio--radio__radio", lD = "h-radio--radio__radioDisabled", cD = "h-radio--radio__radioChecked", dD = "h-radio--radio__input", Rn = {
  radio: aD,
  radioDisabled: lD,
  radioChecked: cD,
  input: dD
}, DT = $(function(e, t) {
  const { id: n, checked: o, disabled: r, className: a, labelProps: l, ...c } = e, d = f(
    Rn.radio,
    { [Rn.radioChecked]: o },
    { [Rn.radioDisabled]: r },
    a
  ), h = n || `radio_${Math.random()}`;
  return /* @__PURE__ */ s.jsx(
    "label",
    {
      ...l,
      className: d,
      htmlFor: h,
      "data-testid": "radio",
      children: /* @__PURE__ */ s.jsx(
        "input",
        {
          ...c,
          ref: t,
          id: h,
          onChange: c.onChange || L,
          checked: o,
          disabled: r,
          type: "radio",
          className: Rn.input,
          "data-testid": "input"
        }
      )
    }
  );
}), hD = "h-reverseScroll--reverseScroll__root", uD = "h-reverseScroll--reverseScroll__column", pD = "h-reverseScroll--reverseScroll__row", mD = "h-reverseScroll--reverseScroll__scrollHandle", Jt = {
  root: hD,
  column: uD,
  row: pD,
  scrollHandle: mD
}, gD = "reverse-scroll", kT = $(function({
  children: e,
  className: t,
  direction: n = "column",
  ...o
}, r) {
  const a = q(null), l = q(null), c = q(null), d = ns(e), h = G(
    () => d.reverse(),
    [d]
  ), u = (b) => c.current?.scrollIntoView(b), p = (b) => l.current?.scrollIntoView(b), m = (b) => a.current?.children[1]?.scrollIntoView(b), g = (b) => a.current?.children[a.current.children.length - 2]?.scrollIntoView(b);
  return Ft(r, () => ({
    rootElem: a.current,
    scrollToEnd: u,
    scrollToStart: p,
    scrollToFirstChild: g,
    scrollToLastChild: m
  })), /* @__PURE__ */ s.jsxs(
    "div",
    {
      ...o,
      "data-testid": gD,
      ref: a,
      className: f(t, Jt.root, {
        [Jt.row]: n === "row",
        [Jt.column]: n === "column"
      }),
      children: [
        /* @__PURE__ */ s.jsx("div", { ref: c, className: Jt.scrollHandle }),
        h,
        /* @__PURE__ */ s.jsx("div", { ref: l, className: Jt.scrollHandle })
      ]
    }
  );
}), fD = "h-removableCard--removableCard__root", bD = "h-removableCard--removableCard__close", xD = "h-removableCard--removableCard__title", yD = "h-removableCard--removableCard__titleIcon", en = {
  root: fD,
  close: bD,
  title: xD,
  titleIcon: yD
};
class TT extends D {
  render() {
    const { icon: e, title: t, children: n, onRemove: o, className: r, ...a } = this.props, l = f(
      {
        [en.root]: en.root
      },
      r
    );
    return /* @__PURE__ */ s.jsxs(
      ie,
      {
        padding: "300",
        background: "neutral.100",
        borderRadius: !0,
        ...a,
        className: l,
        children: [
          /* @__PURE__ */ s.jsx(
            ie,
            {
              as: "button",
              "aria-label": "Remove",
              className: en.close,
              onClick: o,
              children: /* @__PURE__ */ s.jsx(N, { name: "close" })
            }
          ),
          /* @__PURE__ */ s.jsxs(
            W,
            {
              alignItems: "flex-start",
              justifyContent: "flex-start",
              className: en.title,
              children: [
                e && /* @__PURE__ */ s.jsx(N, { name: e, className: en.titleIcon }),
                t
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(ie, { margin: "300 0 0 0" }),
          n
        ]
      }
    );
  }
}
const mr = ({
  colorMode: i = "light"
}) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${i}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${i};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, _D = "h-sandboxIframe--sandboxIframe__frame", CD = {
  frame: _D
};
class ii extends D {
  frameRef;
  static defaultProps;
  constructor(e) {
    super(e), this.state = {
      iframeHeight: 0
    }, this.frameRef = B(), this.handlePostMessage = this.handlePostMessage.bind(this);
  }
  componentDidMount() {
    this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
  }
  componentDidUpdate(e) {
    const { content: t, headContent: n, colorMode: o } = this.props;
    (e.content !== t || e.headContent !== n || e.colorMode !== o) && this.buildSandbox();
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handlePostMessage);
  }
  static defaultSandboxParams = "allow-scripts allow-popups allow-forms";
  buildSandbox() {
    const { content: e, headContent: t = "", colorMode: n = "light" } = this.props, { current: o } = this.frameRef;
    if (o) {
      let r = "";
      e.indexOf("</body>") !== -1 ? r = e.replace(
        "</body>",
        `${mr({ colorMode: n })}</body>`
      ) : r = `<html><head><meta charset="utf-8" /><base target="_parent" />${t}</head><body>${e}${mr(
        { colorMode: n }
      )}</body></html>`, o.src = `data:text/html;base64,${window.btoa(
        unescape(encodeURIComponent(r))
      )}`;
    }
  }
  handlePostMessage(e) {
    const { current: t } = this.frameRef;
    if (t && e.source === t.contentWindow) {
      const { data: n } = e;
      typeof n == "object" && n !== null && n.event === "heightChange" && typeof n.value == "number" && this.setState({
        iframeHeight: n.value
      });
    }
  }
  render() {
    const {
      className: e,
      content: t,
      headContent: n,
      sandbox: o,
      colorMode: r,
      ...a
    } = this.props, { iframeHeight: l } = this.state, c = f({}, e);
    return /* @__PURE__ */ s.jsx("div", { ...a, className: c, children: /* @__PURE__ */ s.jsx(
      "iframe",
      {
        title: "message",
        sandbox: o ?? ii.defaultSandboxParams,
        allowFullScreen: !0,
        scrolling: "no",
        frameBorder: "no",
        style: { height: `${l}px` },
        className: CD.frame,
        ref: this.frameRef
      }
    ) });
  }
}
const vD = "h-scrollbar--scrollbar__track", wD = "h-scrollbar--scrollbar__handle", gr = {
  track: vD,
  handle: wD
};
class jT extends D {
  constructor(e) {
    super(e), this.state = {
      size: 0,
      progress: 0,
      offset: 0
    }, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
  }
  componentDidMount() {
    const { container: e } = this.props;
    e.current && e.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
  }
  componentWillUnmount() {
    const { container: e } = this.props;
    e.current && e.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
  }
  updateSize = () => {
    const { container: e } = this.props;
    if (e.current) {
      const { current: t } = e;
      this.setState({
        size: t.offsetHeight / t.scrollHeight,
        progress: t.scrollTop / t.scrollHeight
      });
    }
  };
  handleTrackClick(e) {
    const { container: t } = this.props, { size: n } = this.state;
    if (this.setState({
      offset: n / 2
    }), t.current) {
      const o = t.current.getBoundingClientRect();
      let r = (e.clientY - o.top) / t.current.offsetHeight - n / 2;
      r < 0 && (r = 0), r + n > 1 && (r = 1 - n), t.current.scrollTop = r * t.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
    }
  }
  handleHandleClick(e) {
    const { size: t } = this.state;
    if (e.stopPropagation(), !(e.target instanceof Element)) return;
    const n = e.target.getBoundingClientRect();
    this.setState({
      offset: (e.clientY - n.top) / n.height * t
    }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
  }
  handleDrag(e) {
    e.preventDefault();
    const { container: t } = this.props, { size: n, offset: o } = this.state;
    if (t.current) {
      const r = t.current.getBoundingClientRect();
      let a = (e.clientY - r.top) / t.current.offsetHeight - o;
      a < 0 && (a = 0), a + n > 1 && (a = 1 - n), t.current.scrollTop = a * t.current.scrollHeight;
    }
  }
  handleDrop() {
    window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
  }
  render() {
    const { className: e, thumbClassName: t, trackClassName: n, ...o } = this.props, { size: r, progress: a } = this.state, l = f(e);
    return /* @__PURE__ */ s.jsx("div", { ...o, className: l, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(gr.track, n),
        onMouseDown: this.handleTrackClick,
        children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: f(gr.handle, t),
            onMouseDown: this.handleHandleClick,
            style: {
              height: `${r * 100}%`,
              top: `${a * 100}%`
            }
          }
        )
      }
    ) });
  }
}
const SD = "h-scrollShadow--scrollShadow__wrapper", ID = "h-scrollShadow--scrollShadow__content", fr = {
  wrapper: SD,
  content: ID
}, NT = ({
  className: i,
  children: e,
  ...t
}) => {
  const n = f(fr.wrapper, i);
  return /* @__PURE__ */ s.jsx("div", { className: n, ...t, children: /* @__PURE__ */ s.jsx("div", { className: fr.content, children: e }) });
}, DD = "h-searchInput--searchInput__root", kD = "h-searchInput--searchInput__input", TD = "h-searchInput--searchInput__inputButton", En = {
  root: DD,
  input: kD,
  inputButton: TD
}, jD = 275, br = 300, FT = ({
  className: i,
  initialSearch: e,
  maxWidth: t = jD,
  placeholder: n,
  onChange: o,
  onSubmit: r,
  onToggle: a,
  ...l
}) => {
  const c = q(null), [d, h] = V(!!e), [u, p] = V(!1), [m, g] = V(e ?? "");
  Qi(
    () => {
      u && (h(!1), p(!1), g(""));
    },
    br,
    [u]
  ), Xe(() => {
    a?.(d), d && requestAnimationFrame(() => c.current?.focus());
  }, [d]);
  const b = P(() => {
    h(!0);
  }, []), x = P(() => {
    p(!0);
  }, []), C = P(
    (y) => {
      y.preventDefault(), r(m);
    },
    [r, m]
  ), _ = P(
    (y) => {
      const {
        target: { value: w }
      } = y;
      g(w), o?.(w);
    },
    [o]
  ), S = P(
    ({ key: y }) => {
      y === "Enter" && b();
    },
    [b]
  ), v = P(
    ({ key: y }) => {
      (y === "Esc" || y === "Escape") && x();
    },
    [x]
  );
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: f(En.root, i),
      style: {
        "--max-width": `${d && !u ? t : 32}px`,
        "--transition-delay": `${br}ms`
      },
      ...l,
      children: d ? /* @__PURE__ */ s.jsx("form", { onSubmit: C, children: /* @__PURE__ */ s.jsx(
        Ye,
        {
          className: En.input,
          ref: c,
          onChange: _,
          placeholder: n ?? "Search...",
          type: "search",
          value: m,
          prefix: {
            type: "button",
            button: {
              icon: "search",
              onClick: C,
              className: En.inputButton
            }
          },
          suffix: {
            type: "button",
            button: {
              icon: "close",
              onClick: x,
              className: En.inputButton
            }
          },
          onKeyDown: v
        }
      ) }) : /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "search",
          variant: "secondary",
          onClick: b,
          onKeyDown: S,
          "data-testid": "search-input-button"
        }
      )
    }
  );
}, ND = "h-selectOption--selectOption__root", FD = "h-selectOption--selectOption__checkbox", PD = "h-selectOption--selectOption__content", ks = {
  root: ND,
  checkbox: FD,
  content: PD
}, PT = (i) => {
  const e = f(ks.root);
  return /* @__PURE__ */ s.jsxs("label", { className: e, children: [
    /* @__PURE__ */ s.jsx(
      hn,
      {
        ...i,
        className: f(ks.checkbox, i.className)
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: ks.content, children: i.name })
  ] });
}, RD = "h-simpleProgressBar--simpleProgressBar__container", ED = "h-simpleProgressBar--simpleProgressBar__progressBar", LD = "h-simpleProgressBar--simpleProgressBar__progressBarFill", Ts = {
  container: RD,
  progressBar: ED,
  progressBarFill: LD
}, AD = "simpleProgressBarId";
function RT({
  progress: i,
  base: e = 100,
  progressColor: t = "purple.500",
  backgroundColor: n = "neutral.200",
  tooltipContent: o,
  tooltipProps: r,
  ...a
}) {
  const [l, c] = V(0), d = 4;
  Z(() => c(i), [i]);
  const h = e >= l ? l / e : 1, u = () => d / h, p = {
    backgroundColor: sn(n)
  }, m = {
    transform: `scaleX(${h})`,
    borderTopRightRadius: `${u()}px ${d}px`,
    borderBottomRightRadius: `${u()}px ${d}px`,
    backgroundColor: sn(t)
  };
  return /* @__PURE__ */ s.jsx(
    W,
    {
      "test-id": AD,
      "align-items": "center",
      "justify-content": "center",
      className: Ts.container,
      ...a,
      children: /* @__PURE__ */ s.jsx(
        se,
        {
          disabled: !o,
          content: o,
          wrap: "none",
          ...r,
          children: /* @__PURE__ */ s.jsx("div", { className: Ts.progressBar, style: p, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: Ts.progressBarFill,
              style: m
            }
          ) })
        }
      )
    }
  );
}
const $D = "h-tabsWithContent--tabsWithContent__container", OD = "h-tabsWithContent--tabsWithContent__containerTop", BD = "h-tabsWithContent--tabsWithContent__containerLeft", WD = "h-tabsWithContent--tabsWithContent__containerRight", HD = "h-tabsWithContent--tabsWithContent__containerBottom", MD = "h-tabsWithContent--tabsWithContent__childrenContainer", St = {
  container: $D,
  containerTop: OD,
  containerLeft: BD,
  containerRight: WD,
  containerBottom: HD,
  childrenContainer: MD
};
class Ws extends ge {
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(e) {
    super(e), this.state = { activeTab: e.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
  }
  handleTabChange(e) {
    this.ensureTabIsValid(e) && (this.setState({ activeTab: e }), this.props.onChange?.(e));
  }
  ensureTabIsValid(e) {
    return this.props.tabs.some((t) => t.id === e);
  }
  getActiveChildIndex() {
    return this.props.tabs.findIndex(({ id: e }) => e === this.state.activeTab);
  }
  render() {
    const {
      className: e,
      tabsClassName: t,
      tabClassName: n,
      tabSelectedClassName: o,
      childrenWrapperClassName: r,
      tabs: a,
      children: l,
      tabsPlacement: c
    } = this.props, { activeTab: d } = this.state, h = Le.toArray(l);
    if (h.length !== a.length) {
      const g = `${Ws.name}: Number of tabs don't match the number of children.`;
      console.warn(g);
    }
    const u = this.getActiveChildIndex();
    if (u === -1) {
      const g = `${Ws.name}: The selected tab does not exist in tabs array!`;
      console.warn(g);
    }
    const p = f(e, St.container, {
      [St.containerTop]: c === "top",
      [St.containerLeft]: c === "left",
      [St.containerBottom]: c === "bottom",
      [St.containerRight]: c === "right"
    }), m = f(
      r,
      St.childrenContainer
    );
    return /* @__PURE__ */ s.jsxs("section", { className: p, children: [
      /* @__PURE__ */ s.jsx(
        Cb,
        {
          className: t,
          tabClassName: n,
          tabSelectedClassName: o,
          tabs: a,
          onChange: this.handleTabChange,
          selectedId: d,
          tabsPlacement: c
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: m, children: h[u] })
    ] });
  }
}
const zD = "h-tagsInput--tagsInput__root", VD = "h-tagsInput--tagsInput__wrapper", KD = "h-tagsInput--tagsInput__input", UD = "h-tagsInput--tagsInput__inputIsHidden", qD = "h-tagsInput--tagsInput__placeholder", GD = "h-tagsInput--tagsInput__placeholderText", YD = "h-tagsInput--tagsInput__iconBox", QD = "h-tagsInput--tagsInput__iconText", XD = "h-tagsInput--tagsInput__tag", ZD = "h-tagsInput--tagsInput__tagIsActive", JD = "h-tagsInput--tagsInput__tagButton", xe = {
  root: zD,
  wrapper: VD,
  input: KD,
  inputIsHidden: UD,
  placeholder: qD,
  placeholderText: GD,
  iconBox: YD,
  iconText: QD,
  tag: XD,
  tagIsActive: ZD,
  tagButton: JD
};
function xr(i = [], e) {
  switch (e) {
    case "asc":
      return i.sort();
    case "desc":
      return i.sort().reverse();
    default:
      return i;
  }
}
const ek = 255, ET = ({
  className: i,
  disabled: e,
  limit: t,
  placeholder: n,
  selectedTags: o,
  sortDirection: r,
  onChange: a
}) => {
  const l = q(null), c = q(null), [d, h] = V(""), [u, p] = V(
    xr(o, r)
  ), [m, g] = V(""), [b, x] = V(!1);
  Dr(l, () => x(!1)), Xe(() => a(u), [u, a]), Xe(() => {
    c.current && b && c.current.focus();
  }, [c.current, b]);
  const C = (I) => {
    h(I.target.value ?? "");
  }, _ = (I) => {
    const T = u.indexOf(m);
    switch (I.key) {
      // Creates a new tag from the given input text.
      case "Enter":
        !m && d && p((F) => {
          const H = Array.from(/* @__PURE__ */ new Set([...F, d]));
          return h(""), xr(H, r);
        });
        break;
      // If there is no input text left, it will select the last tag.
      // If there is already a tag selected, it will remove that from the list.
      case "Backspace":
        !m && d.length === 0 && g(u[u.length - 1]), m && (S(m), g(""));
        break;
      // If there is a tag selected, it will select the previous one.
      case "ArrowLeft":
        m && T > 0 && g(u[T - 1]);
        break;
      // If there is a tag selected, it will select the next one.
      case "ArrowRight":
        m && T < u.length - 1 && g(u[T + 1]);
        break;
      default:
        m && g("");
    }
  }, S = (I) => {
    p((T) => {
      const F = [...T];
      return F.splice(F.indexOf(I), 1), F;
    });
  }, v = b ? u.length : t || u.length, y = v < u.length, w = u.slice(0, v);
  return /* @__PURE__ */ s.jsx(
    Ae,
    {
      ref: l,
      className: f(xe.root, i),
      onClick: () => x(!0),
      disabled: e,
      children: /* @__PURE__ */ s.jsxs("div", { className: xe.wrapper, "data-testid": "tags-wrapper", children: [
        w.map((I) => /* @__PURE__ */ s.jsx(
          jt,
          {
            className: f(xe.tag, {
              [xe.tagIsActive]: I === m
            }),
            onDelete: () => S(I),
            "data-testid": "tag",
            children: I
          },
          I
        )),
        !b && y && /* @__PURE__ */ s.jsxs(
          jt,
          {
            className: f(xe.tag, xe.tagButton),
            "data-testid": "tag",
            children: [
              "+",
              u.length - v
            ]
          }
        ),
        !b && !u.length && !d && /* @__PURE__ */ s.jsx(W, { className: xe.placeholder, alignItems: "center", gap: "200", children: n ? /* @__PURE__ */ s.jsx(A.Paragraph, { className: xe.placeholderText, variant: "2", children: n }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(A.Paragraph, { className: xe.placeholderText, variant: "2", children: "Type words or phrases and add with" }),
          /* @__PURE__ */ s.jsxs("div", { className: xe.iconBox, children: [
            /* @__PURE__ */ s.jsx(N, { name: "enter", color: "neutral.500" }),
            /* @__PURE__ */ s.jsx(A.Paragraph, { className: xe.iconText, children: "enter" })
          ] })
        ] }) }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            className: f(xe.input, {
              [xe.inputIsHidden]: !b
            }),
            onChange: C,
            onKeyDown: _,
            maxLength: ek,
            ref: c,
            type: "text",
            value: d,
            "data-testid": "tag-input"
          }
        )
      ] })
    }
  );
}, tk = "h-textWithHighlight--textWithHighlight__highlight", nk = {
  highlight: tk
}, sk = ({
  text: i,
  highlight: e,
  className: t,
  highlightClassName: n,
  ignoreCase: o = !0
}) => {
  if (!e?.trim())
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const r = new RegExp(
    Vs(e.trim()),
    o ? "ig" : "g"
  ), a = i.match(r), l = i.split(r);
  return /* @__PURE__ */ s.jsx("span", { className: t, children: l.map((c, d) => /* @__PURE__ */ s.jsxs("span", { children: [
    c,
    a?.[d] && /* @__PURE__ */ s.jsx("em", { className: f(nk.highlight, n), children: a[d] })
  ] }, d)) });
}, ok = qn(sk);
ok.name = "TextWithHighlight";
const rk = "h-timestamp--timestamp__timestamp", ik = "h-timestamp--timestamp__print", ak = "h-timestamp--timestamp__screen", js = {
  timestamp: rk,
  print: ik,
  screen: ak
}, lk = 1e4;
class LT extends ge {
  interval;
  static defaultProps = {
    refreshRate: lk
  };
  constructor(e) {
    super(e);
    const { relative: t, counter: n, initialFormat: o } = e;
    let r = o ?? "absolute";
    t ? r = "ago" : n && (r = "counter"), this.state = {
      format: r,
      pristine: !0
    }, this.handleClick = this.handleClick.bind(this), this.interval = null;
  }
  componentDidMount() {
    const { format: e } = this.state;
    (e === "ago" || e === "counter") && this.startTicker();
  }
  componentDidUpdate(e) {
    const { relative: t, initialFormat: n } = this.props, { pristine: o } = this.state;
    t !== e.relative && o && this.setState({
      format: t ? "ago" : "absolute"
    }), n && n !== e.initialFormat && this.setState({ format: n });
  }
  componentWillUnmount() {
    this.stopTicker();
  }
  startTicker() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, this.props.refreshRate ?? 0);
  }
  stopTicker() {
    this.interval && clearInterval(this.interval);
  }
  handleClick(e) {
    const { onClick: t } = this.props, { format: n } = this.state;
    let o = this.state.format;
    n === "ago" ? (o = "full", this.stopTicker()) : n === "full" ? o = "absolute" : n === "absolute" && (o = "ago", this.startTicker()), this.setState({
      pristine: !1,
      format: o
    }), t?.(o, e);
  }
  getTimeString(e) {
    let { time: t } = this.props;
    const { isSecondsDisplayed: n, customFormatters: o } = this.props;
    let r = "";
    if (typeof t == "number") {
      const l = /* @__PURE__ */ new Date();
      l.setTime(t * 1e3), t = l;
    }
    const a = j(t).utc().local();
    if (e === "counter") {
      const l = j(t).utc(), d = j().utc().diff(l) / 1e3, h = Math.floor(d / 3600), u = Math.floor(h / 24), p = h % 24, m = h * 60 * 60, g = Math.floor((d - m) / 60), b = g * 60, x = Math.floor(
        d - m - b
      );
      r = [
        p.toString().padStart(2, "0"),
        g.toString().padStart(2, "0"),
        x.toString().padStart(2, "0")
      ].join(":"), u > 0 && (r = `${u} ${u === 1 ? "DAY" : "DAYS"} ${r}`);
    } else if (e === "full") {
      const l = o?.full ?? (n ? "MMM Do YYYY, hh:mm:ss A" : "lll");
      r = a.format(l);
    } else if (e === "absolute")
      if (j().diff(j(t), "hours") > 12) {
        const l = o?.absolute ?? `D MMMM LT${n ? "S" : ""}`;
        r = a.format(l);
      } else {
        const l = o?.absolute ?? `LT${n ? "S" : ""}`;
        r = a.format(l);
      }
    else
      r = du(a);
    return r;
  }
  render() {
    const {
      className: e,
      relative: t,
      time: n,
      refreshRate: o,
      counter: r,
      customFormatters: a,
      isSecondsDisplayed: l,
      initialFormat: c,
      onClick: d,
      ...h
    } = this.props, u = f(
      {
        [js.timestamp]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          ...h,
          ...Xn(this.handleClick),
          className: f(u, js.screen),
          children: this.getTimeString(this.state.format)
        }
      ),
      /* @__PURE__ */ s.jsx("span", { className: f(u, js.print), "aria-hidden": !0, children: this.getTimeString("full") })
    ] });
  }
}
const ck = "h-token--token__root", dk = "h-token--token__select", hk = "h-token--token__label", uk = "h-token--token__rootReadonly", pk = "h-token--token__rootPrimary", mk = "h-token--token__rootWithError", gk = "h-token--token__value", fk = "h-token--token__icon", Be = {
  root: ck,
  select: dk,
  label: hk,
  rootReadonly: uk,
  rootPrimary: pk,
  rootWithError: mk,
  value: gk,
  icon: fk
};
class AT extends D {
  render() {
    const {
      onDelete: e,
      id: t,
      label: n,
      options: o,
      valueLabel: r,
      primary: a,
      input: l,
      meta: c,
      defaultOption: d,
      className: h,
      ...u
    } = this.props, p = f(
      {
        [Be.root]: !0,
        [Be.rootPrimary]: a,
        [Be.rootWithError]: c?.error,
        [Be.rootReadonly]: !o && !e
      },
      h
    );
    let m = r;
    if (!m && l && o && o.length) {
      const g = o.filter(({ value: b }) => l.value === b);
      g.length && (m = g[0].label);
    }
    return !m && d && (m = d), /* @__PURE__ */ s.jsxs("div", { ...u, className: p, children: [
      !!o && /* @__PURE__ */ s.jsxs("select", { ...l, className: Be.select, id: t, children: [
        !!d && /* @__PURE__ */ s.jsx("option", { disabled: !0, hidden: !0, value: "", children: d }),
        o.map((g) => /* @__PURE__ */ s.jsx("option", { value: g.value, children: g.label }, g.value?.toString()))
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: Be.label, htmlFor: t, children: [
        n,
        /* @__PURE__ */ s.jsx("span", { className: Be.value, children: m }),
        !!o && /* @__PURE__ */ s.jsx(N, { className: Be.icon, name: "angle-down" }),
        !!e && /* @__PURE__ */ s.jsx("span", { ...Xn(e), children: /* @__PURE__ */ s.jsx(N, { className: Be.icon, name: "close", onClick: e }) })
      ] })
    ] });
  }
}
const bk = "h-skeleton--skeleton__root", xk = "h-skeleton--skeleton__rootAnimationPulse", yk = "h-skeleton--skeleton__rootAnimationWave", Ns = {
  root: bk,
  rootAnimationPulse: xk,
  rootAnimationWave: yk
};
function yr({ className: i, animation: e = "pulse", ...t }, n) {
  const o = f(
    {
      [Ns.root]: !0,
      [Ns.rootAnimationPulse]: e === "pulse",
      [Ns.rootAnimationWave]: e === "wave"
    },
    i
  );
  return /* @__PURE__ */ s.jsx(ie, { className: o, ...t, ref: n });
}
const $T = Object.assign($(yr), {
  name: yr.name
}), _k = "h-breadcrumbs--breadcrumbs__root", Ck = "h-breadcrumbs--breadcrumbs__list", vk = "h-breadcrumbs--breadcrumbs__item", wk = "h-breadcrumbs--breadcrumbs__separator", Ln = {
  root: _k,
  list: Ck,
  item: vk,
  separator: wk
}, OT = $(function({
  className: e,
  children: t,
  as: n,
  separator: o = /* @__PURE__ */ s.jsx(N, { name: "angle-right" }),
  "aria-label": r = "breadcrumb",
  ...a
}, l) {
  const c = n ?? "nav", d = Le.toArray(t).filter(Boolean);
  return /* @__PURE__ */ s.jsx(
    c,
    {
      ...a,
      ref: l,
      className: f(Ln.root, e),
      "aria-label": r,
      children: /* @__PURE__ */ s.jsx("ol", { className: Ln.list, children: d.map((h, u) => {
        const p = u === d.length - 1, m = typeof h == "string" || typeof h == "number" ? /* @__PURE__ */ s.jsx("span", { children: h }) : h;
        return /* @__PURE__ */ s.jsxs(Ze, { children: [
          /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Ln.item,
              "aria-current": p ? "page" : void 0,
              children: m
            }
          ),
          !p && /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Ln.separator,
              "data-testid": "breadcrumbs-separator",
              "aria-hidden": "true",
              children: o
            }
          )
        ] }, u);
      }) })
    }
  );
});
export {
  lf as AddonTriggerContext,
  cf as AddonTriggerEvents,
  Lk as Attachment,
  kr as Avatar,
  ip as AvatarSelectItem,
  $k as Badge,
  Ok as Banner,
  ie as Box,
  OT as Breadcrumbs,
  X as Button,
  Bk as ButtonGroup,
  bo as ButtonList,
  Yk as CheckableAvatarSelectItem,
  Zs as CheckableBaseItem,
  Uk as CheckableSelectItem,
  Gk as CheckableTagSelectItem,
  hn as Checkbox,
  Dp as Chip,
  Hk as CollapseCard,
  Mk as Collapsible,
  Jn as ColorPicker,
  pe as Column,
  yd as Columns,
  $d as CopyToClipboard,
  zk as CopyToClipboardButton,
  mT as CountryFlag,
  Vk as DataTable,
  Zm as DatePicker,
  tn as DatePickerOld,
  Vm as DateRangePicker,
  gp as DeselectItem,
  Zk as Dialer,
  Qn as Divider,
  et as Dropdown,
  dt as DropdownButton,
  un as DropdownButtonContext,
  Xs as DropdownInfinite,
  Ao as DropdownItem,
  to as DropdownSelect,
  Vr as DropdownSelectContainer,
  Jk as DropdownSelectMultiple,
  Mi as EMOJIS,
  HT as EmojiPicker,
  pn as EmptySelectItem,
  dh as EmptyState,
  Rt as ErrorBoundary,
  Ra as ErrorBoundaryContext,
  pT as FieldAddonDropdown,
  ts as FieldAlert,
  eT as FieldButton,
  uT as FieldColorPicker,
  tT as FieldDatePicker,
  nT as FieldDateRangePicker,
  Qs as FieldLabel,
  oT as FieldRichText,
  rT as FieldSelect,
  iT as FieldSelectionList,
  aT as FieldSlider,
  lT as FieldSwitch,
  Ls as FieldText,
  cT as FieldTextarea,
  dT as FieldTimePicker,
  hT as FieldTimeRangePicker,
  z as FieldWrapper,
  W as FlexBox,
  Tr as FocusScope,
  bT as FormField,
  fT as FormGrid,
  Ys as HelpIcon,
  xT as HelperField,
  N as Icon,
  K as IconButton,
  Us as Image,
  Fy as InputColorPicker,
  Ng as InputDatePicker,
  ln as InputDateRangePicker,
  yT as InputDuration,
  lo as InputRichText,
  Gx as InputSelectionList,
  Ye as InputText,
  Ae as InputWrapper,
  _T as Lightbox,
  CT as List,
  CT as ListV2,
  vT as MediaPlayer,
  AS as Modal,
  wT as ModalBody,
  zI as ModalFoot,
  ST as ModalHead,
  LS as ModalStackContext,
  Rk as NavigationButton,
  IT as Page,
  nh as Pagination,
  SS as Portal,
  Hr as Presets,
  DT as Radio,
  TT as RemovableCard,
  kT as ReverseScroll,
  ii as SandboxIframe,
  NT as ScrollShadow,
  jT as Scrollbar,
  FT as SearchInput,
  nm as Select,
  Mr as SelectItem,
  PT as SelectOption,
  Nx as SelectionList,
  Wd as SimplePagination,
  RT as SimpleProgressBar,
  $T as Skeleton,
  Bs as Slider,
  Gn as Spinner,
  fy as Switch,
  me as Table,
  es as TableContext,
  Cb as Tabs,
  Ws as TabsWithContent,
  jt as Tag,
  Xk as TagDeselectItem,
  qk as TagSelectItem,
  Qk as TagSelectSuggestion,
  ET as TagsInput,
  A as Text,
  ok as TextWithHighlight,
  ni as Textarea,
  an as TimePicker,
  Lm as TimeRangePicker,
  LT as Timestamp,
  AT as Token,
  se as Tooltip,
  Yn as WindowContext,
  Ek as WindowProvider,
  MT as addSvgIconsToDocument,
  ll as badgeTestId,
  gd as colorPickerTestId,
  gT as countryCodes,
  Kk as datepickerDisableWeekends,
  zT as defaultElementType,
  oo as formatShortcut,
  Ug as formattingOptions,
  At as getSelectionListContext,
  VT as iconMeta,
  Xo as inputRichTextCommands,
  qx as inputSelectionListTestId,
  gD as reverseScrollTestId,
  Ks as useWindowContext,
  dn as withErrorBoundary
};
//# sourceMappingURL=index.js.map
